import React, {useEffect, useState} from "react";
import "./CaseInsideTable.css";
import ColorChangingBox from "./Countdown";
import {useLocation, useNavigate} from "react-router-dom";
import AddressingPopup from "../../dashboard/components/addressingpopup/AddressingPopup";
import {jwtDecode} from "jwt-decode";
import "../../components/ConfirmationModal/ConfirmationModal.css";
import UploadSingleFile from "./UploadSingleFile";
import {Add, DescriptionOutlined, MergeType, Visibility, VisibilityOff} from '@mui/icons-material';
import {
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Paper,
    Snackbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography,
} from '@mui/material';
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CustomAlert from "../ConfirmationModal/CustomAlert";
import EditCaseDocument from "../../dashboard/components/addDocumnetToCase/editCaseDocument";
import CaseFilesInternal from "../../enums/CaseFilesInternal";
import CaseFileDeclined from "../../enums/CaseFileDeclined";
import caseFileDeclined from "../../enums/CaseFileDeclined";
import CaseFilesStatus from "../../enums/CaseFilesStatus";
import CaseStatus from "../../enums/CaseStatus";
import caseStatus, {findStatusTitleById, findStatusTitleByIdForInternalUser} from "../../enums/CaseStatus";
import FilesPopup from "./FilesPopup";
import UploadMissingFiles from "./UploadMissingFiles";
import axios from "axios";
import CaseDetails from "./CaseDetails";
import PermitTypeDisplay from "./PermitTypeDisplay";
import ReturnCaseManagerButton from "./ReturnCaseManagerButton";
import {
    FaArrowDown,
    FaArrowUp,
    FaBell,
    FaEdit,
    FaExchangeAlt,
    FaFileAlt,
    FaFileSignature,
    FaInfoCircle,
    FaTimes
} from "react-icons/fa";
import MakeDecision from "./MakeDecision";
import CaseFilesPostPoned from "../../enums/CaseFilesPostPoned";
import LoaderCustomFixed from "../ConfirmationModal/LoaderCustomFixed";
import DeclineDaysExtension from "./declineDaysExtension";
import AdditionalDocumentEnum from "../../enums/AdditionalDocumentEnum";
import UploadAdditionalFiles from "./UploadAdditionalFiles";
import DeclineInputField from "./DeclineInputField";
import RequireCaseCancellation from "./RequireCaseCancellation";
import LocationProps from "../../enums/LocationProps";
import ChildrenCaseRegistration from "./ChildrenCaseRegistration";
import BoundCases from "./boundCases";
import isCaseParentIdRejected from "../../enums/isCaseParentIdRejectedEnum";
import isCaseParentIdRejectedEnum from "../../enums/isCaseParentIdRejectedEnum";
import {
    MdCancel,
    MdCheckCircle,
    MdDeleteForever,
    MdOutlineExpandLess,
    MdOutlineExpandMore,
    MdOutlineTimer,
    MdQuestionAnswer
} from "react-icons/md";
import UploadConditionalDocumentPopup from "./UploadConditionalDocumentPopup";
import DeclinedInternal from "../../enums/declinedInternalEnum";
import declinedInternalEnum from "../../enums/declinedInternalEnum";
import {IoArrowBackCircleSharp, IoCheckmarkCircle, IoPersonRemoveSharp, IoSend} from "react-icons/io5";
import CaseDocumentInternalFlowStatusEnum from "../../enums/CaseDocumentInternalFlowStatusEnum";
import AddNewCaseViewerEnum from "../../enums/AddNewCaseViewer";
import AddressingPopupViewer from "../../dashboard/components/addressingpopup/AddressingPopupViewer";
import {FiAlertTriangle} from "react-icons/fi";
import DocumentPopup from "../../dashboard/components/addDocumnetToCase/DocumentPopup";
import {CgSandClock} from "react-icons/cg";
import CaseUserStatus from "../../enums/CaseUserStatus";
import ReturnCommentPopup from "./ReturnCommentPopup";
import {TiFlowSwitch} from "react-icons/ti";
import DocumentPopupInternalFiles from "../../dashboard/components/addDocumnetToCase/DocumentPopupInternalFiles";
import approverStatusEnum from "../../enums/approverStatusEnum";
import ReturnCommentPopupFlow from "./ReturnCommentPopupFlow";
import ReturnCommentPopupFlowHeadOfDepartment from "./ReturnCommentPopupFlowHeadOfDepartment";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import {AiOutlineUserSwitch} from "react-icons/ai";
import ChangeCaseUserPopup from "./changeCaseUserPopup";
import UploadMissingFilesExpert from "./UploadMissingFilesExpert";
import ExpertFilesPopup from "../../dashboard/components/addDocumnetToCase/ExpertFilesPopup";
import {RiFolderForbidFill} from "react-icons/ri";
import MergeCaseDialogByCaseId from "./MergeCaseDialogByCaseId";
import UploadInspectionFile from "./UploadInspectionFile";
import UploadCertificateFile from "./UploadCertificateFile";
import CaseFileDialog from "../../dashboard/apiTables/CaseFileDialog";
import CaseHistory from "./CaseHistory";
import ConditionalIcon from "./ConditionalIcon";
import ChatComponent from "../layout/header/ChatComponent";
import NomenclatureEnum from "../../enums/nomenclatureEnum";
import CaseCancelPopup from "../../dashboard/components/addDocumnetToCase/CaseCancelPopup";
import CaseCancelForBuilding from "./CaseCancelForBuilding";
import DeclineRequestStatusEnum from "../../enums/declineRequestStatusEnum";
import ChangeCaseViewerPopup from "./changeCaseViewerPopup";
import UserDataPopup from "./userDataPopup";
import DeclineBox from "./DeclineBox";
import AnswerToMergeCase from "./AnswerToMergeCase";
import AddressingPopupHeadOFDepartment
    from "../../dashboard/components/addressingpopup/AddressingPopupHeadOFDepartment";
import AddrerssingPopupForHeads from "../../dashboard/components/addressingpopup/AddrerssingPopupForHeads";
import DocumentsLoader from "./DocumentsLoader";
import UploadExplosionFile from "./UploadExplosionFile";
import OrderDecisionEnum from "../../enums/orderDecisionEnum";
import {LiaFileSignatureSolid} from "react-icons/lia";
import VisagersPopup from "./VisagersPopup";
import VisagedFilesPopup from "./VisagedFilesPopup";
import RequestToRemoveObject from "./RequestToRemoveObject";
import RemoveObjectDoc from "../../dashboard/components/addDocumnetToCase/RemoveObjectDoc";
import PDFAlert from "./PDFAlert";
import AdministrationFilePopup from "./AdministrationFilePopup";
import dummyFiles from "../../dashboard/components/addDocumnetToCase/base64";
import htmlEnums from "../../enums/htmlEnums";
import UploadInsideFile from "./UploadInsideFile";
import EditInspectFile from "./EditInspectFile";
import EditCertificateFile from "./EditCertificateFile";
import HideCaseRequest from "./HideCaseRequest";
import HideCasePopup from "../../dashboard/components/addDocumnetToCase/hideCasePopup";
import CaseDetailsForUser from "./CaseDetailsForUser";
import departmentEnums from "../../enums/departmentEnums";
import CreateDateEditPopup from "../../enums/CreateDateEditPopup";


function formatDateNotification(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`;
}

const getUserPermissions = () => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken.CanEditObjectRegister === "True" ? "canEdit" : "cannotEdit";
        } catch (error) {
            return "cannotEdit";
        }
    }
    return "cannotEdit";
};

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const CaseInsideTable = ({geoIds}) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const navigate = useNavigate()
    const urlParams = new URLSearchParams(window.location.search);
    const caseIdMain = urlParams.get("id");
    const [roleId, setRoleId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [caseManager, setCaseManager] = useState(null);
    const [rewriteUserId, setRewriteUserId] = useState(null);
    const [loggedUserDepartment, setLoggedUserDepartment] = useState('');
    const [permission, setPermission] = useState(null);
    const [caseData, setCaseData] = useState(null);
    const [showUploadPopup, setShowUploadPopup] = useState(false);
    const [showUploadInsideFilePopup, setShowUploadInsideFilePopup] = useState(false);
    const [showUploadExplosionPopup, setShowUploadExplosionPopup] = useState(false);
    const [inspectFileData, setInspectFileData] = useState(null);
    const [showUploadPopupInspection, setShowUploadPopupInspection] = useState(false);
    const [showEditPopupInspection, setShowEditPopupInspection] = useState(false);
    const [showUploadPopupAdmin, setShowUploadPopupAdmin] = useState(false);
    const [showUploadPopupCertificate, setShowUploadPopupCertificate] = useState(false);
    const [showEditPopupCertificate, setShowEditPopupCertificate] = useState(false);
    const [certificateFileData, setCertificateFileData] = useState(null);
    const [showRemoveFromObjectRegisteryPopup, setShowRemoveFromObjectRegisteryPopup] = useState(false);
    const [showUploadPopupExpert, setShowUploadPopupExpert] = useState(false);
    const [documentTypes, setDocumentTypes] = useState({});
    const [caseManagers, setCaseManagers] = useState([]);
    const [caseChatUsers, setCaseChatUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [caseDeleteModalOpen, setCaseDeleteModalOpen] = useState(false);
    const [caseViewerManagers, setCaseViewerManagers] = useState([]);
    const [caseViewerManagersWithDepId, setCaseViewerManagersWithDepId] = useState([]);
    const [flowData, setFlowData] = useState([]);
    const [caseFiles, setCaseFiles] = useState([]);
    const [caseHistory, setCaseHistory] = useState([]);
    const [caseFilesAreFetched, setCaseFilesAreFetched] = useState(false);
    const [requester, setRequester] = useState(null);
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [isConfirmationModalOpenForDeny, setIsConfirmationModalOpenForDeny] = useState(false);
    const [isConfirmationModalOpenForConditionalFinish, setIsConfirmationModalOpenForConditionalFinish] = useState(false);
    const [currentFile, setCurrentFile] = useState(null);
    const [currentFileForInternalVisage, setCurrentFileForInternalVisage] = useState(null);
    const [fileForInternalFlow, setFileForInternalFlow] = useState(null);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [isSendAllConfirmationModalOpen, setIsSendAllConfirmationModalOpen] = useState(false);
    const [caseManagersForVisage] = useState([]);
    const [selectedDocuments, setSelectedDocuments] = useState({});
    const location = useLocation();
    const [declinedDocCount, setDeclinedDocCount] = useState(0);
    const [conditionDocCount, setConditionDocCount] = useState(0);
    const [caseDetails, setCaseDetails] = useState([]);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [showFilesPopup, setShowFilesPopup] = useState(false);
    const [caseUserDeleteModalOpen, setCaseUserDeleteModalOpen] = useState(false);
    const [currentFileCaseUserId, setCurrentFileCaseUserId] = useState(null);
    const [selectedFilesPopupDocuments, setSelectedFilesPopupDocuments] = useState({});
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [managerToEdit, setManagerToEdit] = useState(null);
    const [isApproveModalOn, setIsApproveModalOn] = useState(false);
    const [isApproveModalOnInternal, setIsApproveModalOnInternal] = useState(false);
    const [isUpdateModalOpenForCondition, setIsUpdateModalOpenForCondition] = useState(false);
    const [isConditionalDeadlineOpen, setIsConditionalDeadlineOpen] = useState(false);
    const [isUpdateModalOpenPostPone, setIsUpdateModalOpenPostPone] = useState(false);
    const [isUpdateModalOpenToApprove, setIsUpdateModalOpenToApprove] = useState(false);
    const [showConfirmationButton, setShowConfirmationButton] = useState(false);
    const [isModalOpenedToSendCaseToHeadInternalFlow, setIsModalOpenedToSendCaseToHeadInternalFlow] = useState(false);
    const [isModalToAnswerAnotherDepartment, setIsModalToAnswerAnotherDepartment] = useState(false);
    const [isConfirmModalOpenForSendingToAnotherDep, setIsConfirmModalOpenForSendingToAnotherDep] = useState(false);
    const [requesterId, setRequesterId] = useState('');
    const declineRequestStatus = caseData ? caseData.declineREquestStatus : null;
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [isConfirmationModalVisible, setIsConfirmationModalVisible] = useState(false);
    const [isConfirmationModalVisibleExpert, setIsConfirmationModalVisibleExpert] = useState(false);
    const [fileDataToProcess, setFileDataToProcess] = useState(null);
    const [fileDataToProcessExpert, setFileDataToProcessExpert] = useState(null);
    const options = ["დოკუმენტები", "განაცხადის მენეჯერები", "დამატებითი ინფორმაცია", "შიდა მიმოწერა", "განაცხადის ისტორია"];
    const [selectedOption, setSelectedOption] = useState(options[0]);
    const [showUploadMissingFiles, setShowUploadMissingFiles] = useState(false);
    const [showUploadMissingFilesExpert, setShowUploadMissingFilesExpert] = useState(false);
    const [conditioalFilesPopup, setConditioalFilesPopup] = useState(false);
    const [isLoadingCaseData, setIsLoadingCaseData] = useState(true);
    const [isLoadingCaseDataInitial, setIsLoadingCaseDataInitial] = useState(true);
    const [isDeleteConfirmModalOpen, setIsDeleteConfirmModalOpen] = useState(false);
    const [fileToDelete, setFileToDelete] = useState(null);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [isCaseCreateDatePopupOpen, setIsCaseCreateDatePopupOpen] = useState(false);
    const secretFileExist = caseFiles.some(file => file.isSecretDoc === 1 || file.isSecretDoc === 2 || file.name === "ნებართვის გასაიდუმლოების მოთხოვნა")
    const removeOrderFileExists = caseFiles.some(file => file.decline === 17)
    const [showSuccessAlertMergeRequest, setShowSuccessAlertMergeRequest] = useState(false);
    const caseIsActive = caseManagers.length > 0 && caseManagers[caseManagers.length - 1].toUserId === currentUserId && caseData && caseData.finished === false;
    const isCurrentUserIdPresent = caseManagers.some(caseManager => caseManager.toUserId === currentUserId && !caseManager.isReturned);
    const caseMustBeActive = caseManagers.length > 0 &&
        caseData &&
        caseData.finished === false &&
        isCurrentUserIdPresent;

    const canHideDocs = caseManagers.length > 0 &&
        caseData &&
        isCurrentUserIdPresent;

    const caseMustBeActiveForInternalFile = caseManagers.length > 0 &&
        caseData &&
        isCurrentUserIdPresent;

    const caseMustBeActiveForRegistery = caseManagers.length > 0 &&
        caseData &&
        isCurrentUserIdPresent;

    const caseMustBeActiveForUploadBuilidngFile = caseManagers.length > 0 &&
        caseData &&
        (caseData.status === CaseStatus.Approved.id || caseData.status === CaseStatus.ConditionalEnded.id) &&
        isCurrentUserIdPresent;

    const caseMustBeActiveForCancel = caseManagers.length > 0 &&
        caseData &&
        (caseData.status === CaseStatus.Approved.id || caseData.status === CaseStatus.ConditionalEnded.id) &&
        isCurrentUserIdPresent;

    const caseMustBeActiveToMakeItSecret = caseManagers.length > 0 &&
        caseData &&
        isCurrentUserIdPresent &&
        caseFiles.length !== 0 &&
        secretFileExist

    const caseMustBeActiveToRemoveOrder = caseManagers.length > 0 &&
        caseData &&
        isCurrentUserIdPresent &&
        caseFiles.length !== 0 &&
        (caseData.status === CaseStatus.Approved.id || caseData.status === CaseStatus.ConditionalEnded.id) &&
        removeOrderFileExists

    const isCurrentUserIdPresentViewer = caseViewerManagers.some(caseViewerManager => caseViewerManager.toUserId === currentUserId &&
        caseViewerManager.approver &&
        caseViewerManager.caseFileId === null
    );
    const isCurrentUserIdPresentViewerForInternalFile = caseViewerManagers.some(caseViewerManager => caseViewerManager.toUserId === currentUserId &&
        caseViewerManager.approver &&
        caseViewerManager.caseFileId !== null
    );
    const caseMustBeActiveForViewer = caseManagers.length > 0 &&
        caseData &&
        isCurrentUserIdPresentViewer;
    const caseMustBeActiveForViewerForInternalFile = caseManagers.length > 0 &&
        caseData &&
        caseData.finished === false &&
        isCurrentUserIdPresentViewerForInternalFile;
    const [dateTime, setDateTime] = useState('');
    const [barcode, setBarcode] = useState('');
    const [isLoadingCaseFiles, setIsLoadingCaseFiles] = useState(true);
    const [isLoadingCaseFilesForInitialLoading, setIsLoadingCaseFilesInitialLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [isMerging, setIsMerging] = useState(false);
    const [isEndDeclinationModalOpen, setIsEndDeclinationModalOpen] = useState(false);
    const [isAddDocumentModalOpen, setIsAddDocumentModalOpen] = useState(false);
    const [isCaseCancellationModalOpen, setIsCaseCancellationModalOpen] = useState(false);
    const [caseIsCompleted, setCaseIsCompleted] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editModalIsOpen, setEditModalIsOpen] = useState(false);
    const [documentToChangeId, setDocumentToChangeId] = useState(null);
    const [isModalOpenDeny, setIsModalOpenDeny] = useState(false);
    const isReuploadble = caseData && caseData.finished && roleId === 'USER' && caseData.status === caseStatus.Declined.id;
    const [caseGeography, setCaseGeography] = useState({});
    const [isDenyButtonDisabledGeo, setIsDenyButtonDisabledGeo] = useState(false);
    const [open, setOpen] = useState(false);
    const [openBoundCases, setOpenBoundCases] = useState(false);
    const [openCaseDetailsPopup, setOpenCaseDetailsPopup] = useState(false);
    const [openChangeCaseUserPopup, setOpenChangeCaseUserPopup] = useState(false);
    const [internalFileToEditManager, setInternalFileToEditManager] = useState(null);
    const [openChangeCaseUserPopupInternalFlow, setOpenChangeCaseUserPopupInternalFlow] = useState(false);
    const [openChangeCaseUserViewerPopup, setOpenChangeCaseUserViewerPopup] = useState(false);
    const [hasConditionalDeadline, setHasConditionalDeadline] = useState(false);
    const [permitTypeTitle, setPermitTypeTitle] = useState('');
    const [hasOrderDate, setHasOrderDate] = useState(false);
    const [hasExtention, setHasExtention] = useState(false);
    const [caseDataForDocument, setCaseDataForDocument] = useState(null);
    const [inspectFileDepartmentId, setInspectFileDepartmentId] = useState(null);
    const [orderDepartment, setOrderDepartment] = useState(null);
    const [caseCanBeCanceled, setCaseCenBeCanceled] = useState(false);
    const [departmentID, setDepartmentID] = useState(null);
    const [documentTypesForEditor, setDocumentTypesForEditor] = useState([]);
    const [daysForCancel, setDaysForCancel] = useState(null)
    const [conditionalDeadlineFromDocState, setConditionalDeadlineFromDocState] = useState(null)
    const isDenyButtonDisabled = !caseFiles.some(file => file.decline === CaseFileDeclined.DeclinationDocument && file.activeUserId === userId && file.isDocumentSigned === true)
    const isConditionButtonDisabled = !caseFiles.some(file => file.decline === CaseFileDeclined.ConditionalFileAct)
    const declinePendingDocExists = caseFiles.some(file => file.decline === caseFileDeclined.CaseFileIsPending)
    const isPostPoneButtonDisabled = !caseFiles.some(file => file.postpone === CaseFilesPostPoned.RequestPostPone && file.isDocumentSigned === true)
    const DisablePostPoneButton = caseFiles.some(file => file.postpone === CaseFilesPostPoned.RequestPostPone && file.internal === false)
    const isDenyButtonDisabledDetail = !caseDetails.some(detail => detail.declined === DeclineInputField.DeclinedInProgress)
    const isDenyButtonDisabledParentId = caseData ? caseData.isRejectedCaseParentId === isCaseParentIdRejected.prepareDeclination : false;
    const DisableDenyButton = caseFiles.some(file => file.decline === CaseFileDeclined.DeclinationDocument && file.internal === false);
    const DisableDenyButtonAfterSent = caseFiles.some(file => file.decline === CaseFileDeclined.DeclinationDocument && file.status === CaseFilesStatus.Sent);
    const declineDaysExtension = caseFiles.some(file => file.decline === CaseFileDeclined.ExtendDaysDocumentActive);
    const extendDaysApproved = caseFiles.some(file => file.decline === CaseFileDeclined.ExtendDaysApproved && file.status === CaseFilesStatus.SentForVisage && file.isDocumentSigned === true);
    const extendDaysDeclined = caseFiles.some(file => file.decline === CaseFileDeclined.ExtendDaysDeclined && file.status === CaseFilesStatus.SentForVisage && file.isDocumentSigned === true);
    const caseCanceled = caseFiles.some(file => file.decline === CaseFileDeclined.CaseCancellationDocument && file.status === CaseFilesStatus.SentForVisage && file.isDocumentSigned === true);
    const caseCancelDecline = caseFiles.some(file => file.decline === CaseFileDeclined.CaseCancellationDocumentDeclined && file.status === CaseFilesStatus.SentForVisage && file.isDocumentSigned === true);
    const makeExtensionImpossible = !caseFiles.some(file => file.decline === CaseFileDeclined.ExtendDateDocumentInActive);
    const explosionFileExists = caseFiles.some(file => file.decline === CaseFileDeclined.explosionFile);
    const disabledBecauseSecretOrderExist = caseFiles.some(file => file.decline === CaseFileDeclined.secretDocument);
    const extendFileExists = caseFiles.some(file => file.decline === CaseFileDeclined.ExtendDaysApproved || file.decline === CaseFileDeclined.ExtendDaysDeclined);
    const conditionalFileExists = caseFiles.some(file => file.decline === CaseFileDeclined.ConditionalFileAct && file.status === CaseFilesStatus.SentForVisage);
    const disablePostponeDocCreation = caseFiles.some(file => file.postpone === CaseFilesPostPoned.RequestPostPone || file.postpone === CaseFilesPostPoned.AcceptedPostPone)
    const hideRequireCaseCancellationButton = !caseFiles.some(file => file.decline === CaseFileDeclined.RequireCaseCancellation)
    const cancelDocExists = caseFiles.some(file => file.decline === CaseFileDeclined.RequireCaseCancellation)
    const hideMakeCaseSecretButton = !caseFiles.some(file => file.isSecretDoc === 1 || file.isSecretDoc === 2)
    const hideCancelButton = !caseFiles.some(file => file.decline === CaseFileDeclined.CaseCancellationDocumentDeclinedSent)
    const hideRequireCaseCancellationButtonInternal = !caseFiles.some(file => file.decline === CaseFileDeclined.CaseCancellationDocument || file.decline === CaseFileDeclined.CaseCancellationDocumentDeclined)
    const disableAdditionalFileRequest = caseFiles.some(file => file.isRequestedAdditionalDocument === AdditionalDocumentEnum.RequestAdding)
    const disableAdditionalFileRequestForHead = caseFiles.some(file => file.isRequestedAdditionalDocument === AdditionalDocumentEnum.RequestAdding && file.internal === CaseFilesInternal.Yes && file.status === CaseFilesStatus.SentForVisage && file.isDocumentSigned === true)
    const [prolongationInfo, setProlongationInfo] = useState({prolongationDays: null, prolongationRequestDate: null,});
    const hasDeclinedAndSharedFile = caseFiles.some(file => (file.decline === CaseFileDeclined.DeclinationDocument || file.decline === CaseFileDeclined.DeclinationDocumentApproved) && file.shared === true);
    const hasReuploadedDeclinedFiles = caseFiles.some(file => file.decline === CaseFileDeclined.ReuploadedFile)
    const orderFileExists = caseFiles.some(file => file.approvalDocument === true && file.status === CaseFilesStatus.SentForVisage && file.orderDecision === OrderDecisionEnum.Decline.id)
    const [visibility, setVisibility] = useState({})
    const token = localStorage.getItem('jwtToken');
    const decoded = jwtDecode(token);
    const USER_ID = decoded.UserId;
    const declinedDocHasAnswer = caseFiles.some(file => file.decline === CaseFileDeclined.ReuploadedFileAccepted || file.decline === CaseFileDeclined.ReuploadedFileDeclined)
    const filteredRecords = caseViewerManagers.filter(record => record.status === AddNewCaseViewerEnum.SentToAnotherDepartment && record.toUserId === USER_ID);
    const [departments, setDepartments] = useState([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isObjectRegisteryDialogOpen, setIsObjectRegisteryDialogOpen] = useState(false);
    const [isDialogOpenExpert, setIsDialogOpenExpert] = useState(false);
    const [returnComment, setReturnComment] = useState("");
    const [returnCommentExpert, setReturnCommentExpert] = useState("");
    const [ownerIdentificationTemplateString, setOwnerIdentificationTemplateString] = useState("");
    const [exploitationIdentificationTemplateString, setExploitationIdentificationTemplateString] = useState("");
    const [fileToProcess, setFileToProcess] = useState(null);
    const [objectsOfRegistery, setObjectsOfRegistery] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const [activeUserFullData, setActiveManagerFullData] = useState(null);
    const [showMissingFilesPopup, setShowMissingFilesPopup] = useState(true);
    const [isMergeDialogByCaseIdOpen, setIsMergeDialogByCaseIdOpen] = useState(false);
    const [isMergeRequestDialogByCaseIdOpen, setIsMergeRequestDialogByCaseIdOpen] = useState(false);
    const [isUpdateCaseRegisterModalOpen, setIsUpdateCaseRegisterModalOpen] = useState(false);
    const [isLoadingMergeProcess, setIsLoadingMergeProcess] = useState(false);
    const userPermistion = getUserPermissions();
    const [approvalDocumentExists, setApprovalDocumentExists] = useState(false);
    const [isObjectInRegistery, setIsObjectInRegistery] = useState(null);
    const [approvalDocWasChecked, setApprovalDocWasChecked] = useState(false);
    const [selectedCertificateId, setSelectedCertificateId] = useState(null);
    const [notificationsFetched, setNotificationsFetched] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [latestNotification, setLatestNotification] = useState([]);
    const declinationDocExist = (caseFiles.some(file => file.decline === CaseFileDeclined.DeclinationDocument));
    const query = useQuery();
    const caseId = query.get('id');
    const [deletedFiles, setDeletedFiles] = useState([]);
    const [isChatOpen, setIsChatOpen] = useState(false)
    const [groupId, setGroupId] = useState([])
    const [userDialogOpen, setUserDialogOpen] = useState(false);
    const [isVisagersPopupIsOpen, setIsVisagersPopupIsOpen] = useState(false);
    const [isVisagersFilesPopupIsOpen, setIsVisagersFilesPopupIsOpen] = useState(false);
    const [visageFileId, setVisageFileId] = useState(null);
    const [disableCaseFinishButtonForExplosion, setDisableCaseFinishButtonForExplosion] = useState(false);
    const [rewriteRequestUserDialogOpen, setRewriteRequestUserDialogOpen] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [initialLoadingForDocTypes, setInitialLoadingForDocTypes] = useState(true);
    const [docTypesAreLoading, setDocTypesAreLoading] = useState(true);
    const [canUploadDocumentForBuilding, setCanUploadDocumentForBuilding] = useState(false);
    const [animate, setAnimate] = useState(false);
    const [openObjectRegistryIdDialog, setOpenObjectRegistryIdDialog] = useState(false);
    const [newObjectRegistryId, setNewObjectRegistryId] = useState('');
    const [visagedFileIdString, setVisagedFileIdString] = useState("");
    const [isAddressRejected, setIsAddressRejected] = useState(false);
    const [objectOwner, setObjectOwner] = useState(null);
    const [userAddress, setUserAddress] = useState('');
    const [declinedDetails, setDeclinedDetails] = useState({});
    const [isCadastralCodeRejected, setIsCadastralCodeRejected] = useState(false);
    const signImage = "data:image/png;base64,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"
    const containerClass = `table-content-container ${animate ? 'table-content-container-animate' : ''}`;
    const fileForDev = "JVBERi0xLjcKJafj8fEKMiAwIG9iago8PAovVHlwZSAvQ2F0YWxvZwovUGFnZXMgNCAwIFIKL01hcmtJbmZvIDUgMCBSCi9TdHJ1Y3RUcmVlUm9vdCA2IDAgUgovTGFuZyAoZW4tVVMpCi9BY3JvRm9ybSA3IDAgUgo+PgplbmRvYmoKMTYgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCAxMAo+PgpzdHJlYW0NCnicK+QCAADuAHwNCmVuZHN0cmVhbQplbmRvYmoKMTcgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCAxMAo+PgpzdHJlYW0NCnicK+QCAADuAHwNCmVuZHN0cmVhbQplbmRvYmoKMTggMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCAxMAo+PgpzdHJlYW0NCnicK+QCAADuAHwNCmVuZHN0cmVhbQplbmRvYmoKMTkgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCAyMDY1Mwo+PgpzdHJlYW0NCnic7X1bjyU5ct57/4p6tGTobPJOAgsBPb0zgh8MWPYCevGLMNbKMHIEa2UD/vkOXuLC2zknq6p7ekelwarr44lgZpLB+EhmBPO4aZPK/70c8N/fHBJHq28xvvz8y6d//ZR/1TbaF+OUefnzP336h7/+9C9Qrm/e6uS0Lvo9AkX1kv/7r3/X/vjzP3/63d+Zl3/+t1JfsseLMubI1f1pUfL38B9c4TA3dwSjX4KLN6eDji8m3I5DGf7LynsytyMaa60qd8FoVRPc43EzyYPszSoV8z86uHzLy3J+AnXz2r2o43bkf39h7OKh4J6gMQ5rk35R+U9XflQvP39KN2tC+fuEv5NzR8wAFEsx63NJucLPn1qBvcH/O9v1OoCi56f/+SncIvzioT/hcinCDWKJOpwNBzTCLcWj/OVfIpSmIufhQvEWE1RUfsk3eajkzGEApZvSsg7EeJX8eLkEekW5UsNJJcpap0GG6ws3+IEvVmC+Ot5LKTg/8Y2WgvocXB9ivOLP07Nze8RbGNoj3jw8i09BtAcYh2iRjGSbZCxbJeP6jFwX4jC0S7q5oV0SDBlb6uEa0y3IdilQtkuqnc43XArq83B9iN3QLnxXuV1csSlpJ1iCfexuluzEwROynXgYIWwnHq6USo940PadnSBmO6kl0k6wBPuV6yvdzhdrdsL30uyEb7QU1Ofg+hCznYzPzu0h7QRLsG/5Mrnn+S6qnfBtVjvhp8i4PiPXhTgM7SLtBEuwX7nG0u18wWYnfEfNTviGS0F9Hq4PsRvapbcTPfkTPfgTXczRA3V4cLrZVquVmGrIxUZssfFqI3bwJXbyJXbyJXbwJVxf6XK8VLMQvItmH3yDpUAPfkRPfmR8Zm4HaR968CN8mdzjeA/VOvAGq23w3WdsBx9iJx9iJx9iBx/CNZauxss1y8B7aXbBN1oK9OA/9OQ/xmfP7dHoTN8KCebn0LW185/qZpQAyh5epdIwxlUTVdnR5lpV8U+VJotvQ6tWtbeEdsOl6qyk6Zr2Fvq/6QYaojosDRIFf1dGrv2j2h0YaIjcdgpasVM1N3F1ww/cSJ5QZX9db7b+4qGxdUOmPvfPROT1RonkO9iECWNVOIEoV5Fd8TN0Dc6grNI3c4BVzTMomDddmUGtanr9DAoclbJe5T4+btAV0LqhjKcQfPAwAwLPFy2UtueDgQg9ECqw1aR17X0fYoJHuSWd/wXN0pvxdgR15LGk0MSrYAGthuZEa9XpprXJU2BxbXCw0ZmYTYVvMztq+EPl21QKpl1Bp8Ix8TiyRCssssvnzB2UebLY0S9QW/Q62Xq56uOKNWXdWt4K2l03BPYaw+EKw2IFzVY8W5i7KVOlWlGzeNZuBa3yhvjaXEG7O7pzaWevXCMct2wb9X/FaBiyrQTwh2BK4GGO8sdZ/8g+sPyU/4gKHFr0FiWtgKeEg3CB/pZCAING5STx2eFRvkzmoDrvkkL9ZCU+OzzKFwz1Oess3nxKEp8dHuV18QtQoTUqYgXqsLLg7AsmlVoAlQJWnupIpUBzHaJgUikFYPdJH9ZRHcrKgrMvmFRqAVR6pAPWnlhHkgVnXzCplAKtgPtCdlCtDm1lwdkXTCq1AAZV9MZzHUkWnH3BpFIKjCqk2SowltApUC9ZUR7QxhtNqkkWnH3BpFIKLNQIA41GBMx0ZMHZF0wqtQAqtQcbtrJJFpx9waRSChxUCkOejFs5KwvOvmBSqQVQKdhZILtySRacfcGkUgo8VHp4NGeow1tZcPYFk0ot8ODCnbBvn0oB3YbAk0IpCOoWcvtgBcEKfHZ4lK8YKgTPQw8RksBnh0f5gsHzBa8M2SQ4RsZnh0f5iv2NDTqmG9szgk6sAHB3wURPauAOGZ8dHuUrhsrA2VKjgztkfHZ4lM9Yg6sLYCCq6YO3Efjs8ChfMdQHHsqSfhL47PAoXzC4OJ/9JOqDD2R8dniUrzhPR8Dvkn4S+OzwKF8wuDYPN4Ttp8H3MT47PMpXDPW5RDarwe8xPjs8yhcMvs3bQOwKCyqBzw6P8hVDfeDZAukngc8Oj/IF2zbJrtrg9RCdAvWSFUE94FcNaSaBzw6P8gWDG/OHJhLSzgp8dniUrxgW+9CMZLfg4xifHR7lCwb35cD70P2Df2N8dniUrxjqy4ZE+kngs8OjfMHguxwUUL+Db2N8dniUrxjqg2FE/Q6+jfHZ4VG+YPBdzrCv1eDbGJ8dHuUrhvo03BXpJ4HPDo/yBYMfc4p9LcymBT47PMpX7G+sm26sV/+WMvlvA37LRvazBvwa47PDo3zF/paHXSL9JPDZ4VG+YPBb1rOfNeDXGJ8dHuUrhvqgAw3pJ4HPDo/yBYPfspb9rAG/xvjs8ChfMdRn2M8anQQ+OzzKFwx+ywKZoL0a8GsZI09IPMpXDPUd7GcN+DXGZ4dH+YLBexmYwiJPwapd4LPDo3zFebHryV4N+DfGZ4dH+YLBfxmaHBjwboZmB4x6yYqgHnDYrJkEPjs8yhcMfsvkaSvqg19jfHZ4lK8Y6rPsZw34NcZnh0f5gsFvgW3QpNCAX2N8dniUrzgvp9nPGvBrjM8Oj/IFg98yB/tZA36N8dnhUb5if5MTdAN+Tc7PJR7lCwa/pcWc1oBf02JOK/EoXzHUJ+a0BvybFnNaiUf5jC34MS3mtBb8nBZzWolH+Yr9TbNyumnWbKATKwB8lxZzWgu+TYs5rcSjfMVQmZjTWpUEPjs8yhcMvkuLOa0F36bFnFbiUb5iqE8s1C34NrlOl3iULxh8lxJzWgu+TYk5rcSjfMX+psSc1oJvU2JOK/EoXzD4LhUOslkLvo3x2eFRvmKoT8xpLfg2Jea0Eo/yBbu8J8y+FnhI4LPDo3zFUJ9hX2vBxzE+OzzKFww+TLHRekvoFKiXrAjqUexrLfg2xmeHR/mCwXepg32tBd/G+OzwKF+xvx1iTmvBtx1iTivxKF8w+K4jsK+14NsYnx0e5SuG+sSc1oJvO8ScVuJRvmDwXYeY01rwbYeY00o8ylcM9YmdPgu+7RA7fRKP8hk78F2HmNM68G2HmNNKPMpXDPVp9rUOPBzjs8OjfMF5Z1vMaZ2yAp8dHuUr9qRJ96xS92v+a47/UJmGD2jP9OYAEFHVRwTIRwTIRwTIRwTIRwTIRwTIRwTIRwTIbzECxIWYX2O51RzqYgjIsqqPGJCPGJBvEgOSXwmVGJD8x1n/MC9n/Sn/QWEdTdIKeEo4CBdIMR1NOUl8dniUz5hjOqo+x3xUfYlH+YIppqPpJ4nPDo/y5qUL6KgViJCPWkNXMKnUAgrowDoo5APrEAWTSinggI5WB4d8tDpkwaRSCyigA+tIsuDsCyaVUsABHa0ODvlodciCSaUWUEAH1pFkwdkXTCqloEV2tApa1EfTJtRLVkQBHaiaZMHZF0wqpYADOlodHPLR6pAFk0otoIAOrCPJgrMvmFRKAQd0tDo45KPVIQsmlVpAAR1YR5IFZ18wqZQCDuhodXDIR6tDFkwqtYBCOrAOjPnAKhhPCqWAYjpaBRTz0SoQeJSvGGM6UD8JfHZ4lC+YYjqaPsV8NH2BR/mKS3AHKqcb2zOCTqwAiuloahTz0TQFHuUrxpgO1E8Cnx0e5TPmmI6qzzEfVV/iUb5ijOlA/STw2eFRvmCK6Wj6FPPR9AUe5SvGmA7UTwKfHR7lC6aYjqZPMR9NX+BRvmKM6UD9JPDZ4VG+YIrpaPoU89H0BR7lK8aYDtRPAp8dHuULbpEdTbtFfTRdQr1kRRjTgZpJ4LPDo3zBFNPR9Cnmo+kLPMpXjDEdqJ8EPjs8yhdMMR1Nn2I+mr7Ao3zFGNOB+kngs8OjfMEU09H0Keaj6Qs8yleMMR2onwQ+OzzKF0wxHU2fYj6avsCjfMUY04H6SeCzw6N8wRTT0fQp5qPpCzzKV5zjO1A33Viv/i1l8t8c01F1OOaj6kk8yleMMR2onwQ+OzzKF0wxHU2fYj6avsCjfMUY04H6SeCzw6N8wRTT0fQp5qPpCzzKV4wxHaifBD47PMoXTDEdTZ9iPpq+wKN8xRjTgfpJ4LPDo3zBFNPR9Cnmo+kLPMpXjDEdqJ8EPjs8yhfcIjuadov6aLqEesmKMKYDNZPAZ4dH+YIppqPpU8xH0xd4lK8YYzpQPwl8dniUL5hiOpo+xXw0fYFH+YoxpgP1k8Bnh0f5gimmo+lTzEfTF3iUrxhjOlA/3eT8XOJRvmCK6Wj6FPPR9AUe5SvGmA7UTwKfHR7lM+aYjqrPMR9VX+JRvuIS3IHK6aZZs4FOrACK6WhqFPPRNAUe5SvGmA7UTwKfHR7lC6aYjqZPMR9NX+BRvmKM6UD9dJPrdIlH+YIppqPpU8xH0xd4lK8YYzpQPwl8dniUL5hiOpo+xXw0fYFH+YoxpgP1k8Bnh0f5gimmo+lTzEfTF3iUrxhjOlA/CXx2eJQvuEV2NO0W9dF0CfWSFWFMB2omgc8Oj/IFU0xH06eYj6Yv8ChfMcZ0oH4S+OzwKF8wxXQ0fYr5aPoCj/IVY0wH6ieBzw6P8gVTTEfTp5iPpi/wKF8xxnSgfhL47PAonzHHdFR9jvmo+hKP8hVjTAfqJ4HPDo/yBVNMR9OnmI+mL/AoX7EnTbpnlbpf819zDIjO2wIH/DmFgMB69VIICNf0EQHyEQHyEQHyEQHyEQHyEQHyEQHyEQHy244AmWZQFADy3AxqVdNH/MdH/Mc3if8AS6/xH/mPs/6ROaX8lP+gkI4maQU8JRyEC6R4jqacJD47PMqXSTLFc1R9jveo+hKP8gVTPEfTTxKfHR7l/UsXzFErEOEetYauYFKpBRTMgXVQuAfWIQomlVLAwRytDg73aHXIgkmlFlAwB9aRZMHZF0wqpYCDOVodHO7R6pAFk0otoGAOrCPJgrMvmFRKQYvqaBW0iI+mTaiXrIiCOVA1yYKzL5hUSgEHc7Q6ONyj1SELJpVaQMEcWEeSBWdfMKmUAg7maHVwuEerQxZMKrWAgjmwjiQLzr5gUikFHMzR6uBwj1aHLJhUagGFc2AdGO+BVTCeFEoBxXO0Cijeo1Ug8ChfMcZzoH4S+OzwKF8wxXM0fYr3aPoCj/IVl8AOVE43tmcEnVgBFM/R1Cjeo2kKPMpXjPEcqJ8EPjs8ymfM8RxVn+M9qr7Eo3zFGM+B+kngs8OjfMEUz9H0Kd6j6Qs8yleM8RyonwQ+OzzKF0zxHE2f4j2avsCjfMUYz4H6SeCzw6N8wRTP0fQp3qPpCzzKV4zxHKifBD47PMoX3KI6mnaL+Gi6hHrJijCeAzWTwGeHR/mCKZ6j6VO8R9MXeJSvGOM5UD8JfHZ4lC+Y4jmaPsV7NH2BR/mKMZ4D9ZPAZ4dH+YIpnqPpU7xH0xd4lK8Y4zlQPwl8dniUL5jiOZo+xXs0fYFH+YoxngP1k8Bnh0f5gimeo+lTvEfTF3iUrzjHdqBuurFe/VvK5L85nqPqcLxH1ZN4lK8Y4zlQPwl8dniUL5jiOZo+xXs0fYFH+YoxngP1k8Bnh0f5gimeo+lTvEfTF3iUrxjjOVA/CXx2eJQvmOI5mj7FezR9gUf5ijGeA/WTwGeHR/mCKZ6j6VO8R9MXeJSvGOM5UD8JfHZ4lC+4RXU07Rbx0XQJ9ZIVYTwHaiaBzw6P8gVTPEfTp3iPpi/wKF8xxnOgfhL47PAoXzDFczR9ivdo+gKP8hVjPAfqJ4HPDo/yBVM8R9OneI+mL/AoXzHGc6B+usn5ucSjfMEUz9H0Kd6j6Qs8yleM8RyonwQ+OzzKZ8zxHFWf4z2qvsSjfMUlsAOV002zZgOdWAEUz9HUKN6jaQo8yleM8RyonwQ+OzzKF0zxHE2f4j2avsCjfMUYz4H66SbX6RKP8gVTPEfTp3iPpi/wKF8xxnOgfhL47PAoXzDFczR9ivdo+gKP8hVjPAfqJ4HPDo/yBVM8R9OneI+mL/AoXzHGc6B+Evjs8ChfcIvqaNot4qPpEuolK8J4DtRMAp8dHuULpniOpk/xHk1f4FG+YoznQP0k8NnhUb5giudo+hTv0fQFHuUrxngO1E8Cnx0e5QumeI6mT/EeTV/gUb5ijOdA/STw2eFRPmOO56j6HO9R9SUe5SvGeA7UTwKfHR7lC6Z4jqZP8R5NX+BRvmJPmnTPKnW/5r8W8R8eTMv7EN4e/0E1fcR/fMR/fMR/fMR/fMR/fMR/fMR/fMR//MbjP8YZ1OvjP95hBvUR//ER/1GsR+V3tDDx9TbUL0aORSIOJMJ4LGYS4nHLH6u0Gd+czkmAuQjWa2DeKeZFUyuL0PqmlDlfQpaKcrB5UZu3lo7gUhF0SUVfilyAPitl4IciOOMjz62hG5uyAnvQpRScdaYNWLUma2wuK4FRIZYyDwsaVcpgALnSc3kvz2XugsII7iYVwUOX+sCeY0kbBx5w+UsiUJL/KDcNhfCrsVBqikKOlQ+lElPKcr21DK6WT/CHMriDUJTzOA8+lUK41XKV/LrE5yPrYdEIj5RnwXm5Dc1lSxk8PNhy1na5SQ5XSl3SR07HcLnlSuPY3JrlIBab29jXMmj36qKh9KhHs5cglBhKwmbuNN3KUr12vpOqoW82WN//qnLMS/4UlagFGtYkrYbrgR1oaN/uzrL/yX+JJ/A5nCXa2D+rzy8ZTD6WklvFR7gLrYxsPShzzpUur81cOglKwdvlY+Bbh0D/+nALqvVH6zcoAu+rbN/DPocVqdbv1RKgCIjoUNJeyvZzLMrVsHRTPpw3lkwQzNJnj5QHCZqqLmX+iMmRUddLwzTxCElaPxRp55UXgwSKlDM+0WhqqodTWslhV4YWjssKquhL3ryFvg0vUs+Vrg3dBVzpWrwC3oktXVvvrt1wfqmSp3n0YCaZ3LFONd3aBLkUOlbrF24quEDpWNmouax2bG3U2vy5FDo250FRL+V9bOhYF0R/5rL6V9ZuHQ+2lVVyYjjZRy7LVUdhSbkMbkLbZknV5nIp3K59YdPMO/L5qYIw4lxWn78OgWruuTS3k3nhYVH280t78gDKZdDyoTw1DbVcmvuoZAe1IWlizdbJ/2ZZHMi1HIe61ESn0F8D3Ye8G3Qz8q7RIfXPh65LtAS5uNZgJghfiE2rmjOsXhM7wb2wdxWdhW6461T01qL30acLIyHn35kT0QQann9BOolooCoh8eQ5TTVlGxvxAEUlLWy+ElkxJxoZjfKGMSTIkUab4FAclI1gK7HHA+m2/VUHNExymgPmEZ/LqgOWRJtLqwMmH5KL8lNE4WpyWfW/kmhzafa/7L2gXVNtwSiJNi2JNqVGiMJzptQcMDvYVPvY9544Lbg2Lbg2heaAJdemBdemarAdq6Ri2gPVpjIGlJJElRZUm5ZUm2zrD0GSqYxQYySZJqLatKDatKDatKTatKDatKDauKTauKDauKDauKTauKDaOFNtXFJtnKk2Lqg2Lqk2Lqg2Lqg2FkaKbNb10jPVxkpwcjpaiZDnrU0TfKpy3QTXzvNg4lvxIw1wroP9AF9Megy6KXYtE+nSI3akGxekGxekG5ekGxekGxekG5ekG2fSjQvSjUvSjTPpxgXpxiXppgXppgXppiXppgXppo50E5EuDelajoNeatrmhPtrLEiXHI686+aZ+sdDFyYaIi04l3xix7lpwblpwbnkj7tOJcctur86+KSlmVQqKBYqDKqShmPT8y9MLky7TEOSdiVhNauXtIZjQxIgDyJJlTjcKpe28YgU2whXE+HqaX1biob1bS5Dshe0q3lagLSrefJAtKtxmtHRrp5pNypsQabdXJZpN3S0m0tH2s1lA+1GtVjh5sKRdaOaWTeX5VmdJN1cNpJuVDPp5rKJdKOaSTeXjaQLnmpBurl0JN2oZtKNCkkXnmci3ahm0s1lM+lGlX2KSa67s+J7vFyhx5KuEY3rn/Uo/uzwslGO4vZk0x3FPZqOcXMhjDOXBOPGo7jbwuzUZ0dxzMfQu0d14WKfIxeNlJvLqtOQlJtLR8qNR2GZ/OFXotxcNlNuLh0oNxcNq9tcNK1uc+G4uo3HxLnxQM6VP9IYn1e68mLSXcwrXXHz5H5WpMvNwaTLzcak2xp4IN3SFdAUTnhT7jH2uty30j+zFbAnZ2th1kWz4vWYbXYF93YEZt1mpUou8Jo9Z8oWtNQsP0j+qiOkZ10eS5IRedQxd/LozOwaFbIuj+laPrNu8w8D67InkXczsy65pv7xZtZlX8esSz5Rki47TyZddrKiq9RiocteW/Q+eXdhJcQDnT2pBefqBefq1VJXshUavZ6Xuo39Rs7VC87V01IXubYxryXmtTPz2gXz2iXz2pl57WLBa5fMa3ErQDCvmXeWc9m84M2lw85yLup3lqNZ8a5Z8K5Z8K5Z8K5Z8K6ZN5Zz2byxDOQ0bSznsjxc5Joymkq8AxGautvUUaap+1FKUqsh4jUL4jUL4jVL4jXzajeXVfcjnkCjo+qeVaNLE62i0fOJ1tMr6tUL6tUL6tVL6tUz9Wr098Jc9Gq1m0sn6tUL6tWVldim66ULe+XXQmLeOS53c8m03M2F43IXCGOeFhP16pl69bzclReTXmNa7sp7Jy+ED9lRr15Qr15Qr15Sr15Qr15Qr15Sr15Qr15Qr15Sr56pVy+oVy+p1yyo1yyo1yyp1yyo13TUa4h6aVTXchz3UrN4COeGaxRfEmx3N/MuM3un/vnmXWb2d4J7zYp7zYJ7zYJ7zYp7zbTJTO5dGIlZbTIzYwjmtfMmM3NQx7x2Xu3axWrXLpnXLpjXzsxrO+b1xLx+Zl6/YF6/ZF4/M69frHn96p1uLp2Y1y2Y1y2Z183M60oHtl3H6nFd6ejQb0TmUvhZd07cFdNRXnKvKzZmevJ11RjlZml0C/J1S/J1C/J1C/J1y1Wvm9/qgmnP5OuIfN2CfN2CfN2SfN2CfN281RztknztgnztgnztinztgnztgnztknztTL52Qb52Sb52Qb52Qb52ue6187rXzuteu1r32sW614q3ug1UUTm2F2tdu1zr2sVa105rXbtc69oF4doF4dol4doF4doF4dol4doF4doF4dol4dqZcO2CcO2ScN28w8zjQlCcWxKuWxCu6wjXEeG6jnDdgnAdTsn7a6D/kHezIFy3JFy3IFzycYJw3YpwyWsKwiXvKvqK/HDXq+SwRf+7mXLdknLdgnL9gnKJfDrK9fNi1y8Wu371XlcSJI03P1Oul5R7/8wdlxdzunymFfo0/3W2v8phneXX8ld+2a9C9tNNOgh8dniUrzjl1JTsQqt+1AKfHR7lC86pPpkIUT0wPCUchCssaT6JlKHfGJ8dHuULzu9coFHp3vOLEMJnh0f5imHMwMO4pu+BGhifHR7lS1R4ZjFdOLnpB4HPDo/yFef0spA3+au+0gKfHR7lC1ZQn3OK7l8Fgc8Oj/IVQ31BW436Wgt8dniUL1gXFvd0/7AKYnx2eJSvOKc3+oS262Hhwfjs8ChfMCw3tLaK7h9m+4zPDo/yFUN9Vhkcad5qgc8Oj/IFW6jP5VGN+kHgs8OjfMU5pdZFtF8PPMD47PAoXzB4f53MQfcPzpfx2eFRvuKc0nwAOTZ9rwU+OzzKF5xTuvMNkX4Q+OzwKF9xTum2kew3aIHPDo/yBeeUbq8Pun/wdYzPDo/yFUN9QIQG9cHXMT47PMoXnFO6k3d0//ldOOGzw6N8xcDEykSy3/ymmfDZ4VG+4MxUuUNIPwh8dniUrxjqK1Oiqh/A3zE+OzzK6/J7OUrCadIPAp8dHuUrhvqiDmi/Ie/5Ez47PMoXnHf6STfcHOnVv6VM/TtnUjBXBvBvTnClxKN8wbocVUJcGcC/OcGVEo/yFUN9LkdVN32jBT47PMoXXLZXmC+DCQKfHR7lK4b6BF8G8G9O8KXEo3zB+ZgewZcwpxH47PAoXzHM23TeKWj64N8Ynx0e5QvOR/UIvgzg37zgS4lH+YrzvJH5Mngt8NnhUb5gn49oYr7MoaVe8KXEo3zF+Ygo7j5wb7L3GA7CBeYjyQRX5vDJILhS4lG+4nw8F3NlAN8WBFdKPMoXnI8kE1xZInwEV0o8yleckzyYK3NUTRBcKfEoX3A+nkxwZQ5lCYIrJR7lK85nwjFXRvBtQXClxKO8Lr/bWxRcmV+2RsGVEo/yFcNaSnBlfr8ZBVdKPMoXrPIuDHNleasouFLiUb7ifFQhc2UEXxcFV0o8yhecj2oUXJl3vAHrQPqMR/mKoT7BlXmTOQqulHiULxh8WRJcmXd2k+BKiUf5isuxmcSVsKoX+OzwKF+wLTtjxJV5AyIJrpR4lK845dNGiSvzmj8JrpR4lC/Y5bNTmSvzQjsJrpR4lC/YH6jp6Zm96X7Nf/3pyVygHKNsbeqSgPJxHTUMnQOdrTvKxpVIAspFFEyJOUD5aI4hBygXTTlATosYTsoBgtIW7ck5QM5gVCjnAEFZ3rKoMfO4X+xM2f3zIgcoT5SjK7Hr+Ko2c8mcBJR3WsYkICibkoCgbE4CgsIpCSifMDImATm/SgIq58wNSUBQNiUB5SM45yQgKM0bvV4mAbmW/uPqfdJGsesSf4QmbRF316AtYnE3tEXMd82JP/L5OPGHW4ITf7jFOPFHNC3n/XAfUN4PdxXn/chO5bwf7n1O/GEj4cQfaU2c+MN2x4k/bJ+c+CMtGfNohMlTug2PDMrLkSOIEnh4pOXhxEOxoioKf8Ux8cdmz+XyRp64gA2la+2LTPzJx+8MiT+5aEj8sdZxtgQ3Qd5Uho71IvEnHw9UO1Y0qrVlwxYbtTV/PkhoSPyx1kyJP7lsSvyx2bUPiT+5rMW/siVZzZGybHNQ2mJq2TbzEb3lsYQV51MroQH0i8z8yaWlocSwgKIx8accjDQl/uTS3EdBJP6UMvi/+rnFLCXTf+SvNNRFLeQUuuuR+xB3Rm6mPYBMAsJH7ZOAsFFkEpBoPPaFspnZa3KHsHfljiM3LDuY3DVbAjl1Nhj2/tW0hiQgNEKZBCSMlZKAOrOmJCC2f0oCEqOEkoC68cTcyCNPcGjkJKA6bjEJqNJt+6t1OIc20/DnGGjhJjhYmtwJh1Sz1xE5QMI9iRwgdmScA8QOLy2JlnOA2IlyDhA7W04Ckm45Lbg2LbiWk4AEIaQF13ISEDMMJQFJKuIkICattKDatKRaTgJiwuQkINfSfyrVpo5q04Jq05Jq04Jq04Jq45Jq44Jq44Jq44pq44Jq40y1cUm1cUG1cUG1cUm1cUG1cUG1nPjTTRpnqsUcGzEHxeCkbq6KUUxiTmsXU1/iW/FrHBN/5Nini3VeAm9KuJOJdPkRO++0IN24IN24JN24IN24IN24JN04k25ckG5ckm5ckG5ckG5ckm6aSTctSDctSTctSDctSDcR6fJgFr/SoBe1YDhyf70F6bLDYdIlzyQ5l10Yc25acC77RNnKacG5acG57I9lB7PnZlOgJCBhMpQE1NEuJQEx7Qp2IXMVPCQMWzAWjgDBazROBAGKASWYkoZe5dLISUCCcDURrp7Xt5wFxLRLSUCSdilemmmXoqoF7XIOkKRdPdOuyAEi5ydygISbFDlA5FBFDhA5Xk4CEh5aJAGRLxdJQOTyOQmIqUEkARGHiCQg4hpOAhKkJJKAiL5EEhDRnEgCEoQokoCIOkUSkGvpP67epiRdkfgjNFekKxJ/xN1Q4g/fNSf+yOfjxB9uCEz84eaixB/RrJz3w83PeT/cTZz3IzuU836454+ZckXij7SlY6ZckfjD1nmsKJdyZ+Q8c1rdci5ON22dVrec2iNnwci58tc4Jv7Igb9a6Yq7Es5kJF3xkJ1vouYQXmwmXU78kaTLiT/sQUWXkacVnSt8sjAD8t7CXMjLc+KP5ANO/GHm4MwfZl3O/JGsy5k/xLqc+MPcJsaSYEEx6ogvxbgkXo0KWVeMZvHrzLqcBNRfb2Zd4XGIddk1CdYVPoxYV/g6bjvyibKR1Uy6wslyt6nFQle4bbYEdu9sMUwEgnMFZTDn6gXn6tVSV9AVDQA9L3U5CagbUHrBuXpa6iLXchJQY167YF47M69dMa+dmdcuFrx2ybycA8S+zcw7yyIHSHpLM+0scw4Qe1+z4l2z4F2z4F2z4F2z4F0zbyyLJCBJTGbeWBZJQEx1nAQkSZGTgJg+OQnItfSfSrymI16zIF6zJF4zr3ZF4g/fNSf+yOfjxB9uCU784RbTC+rVC+rVC+rVS+rVC+rlxB+2Eb1a7YrEHzY7vaBeTvzpppCYPCMnm+Nyl3NxuqnrtNzl1B45Eybq1TP16nm5Ky7WeYppuSvunT0PPWTnohbUqxfUq5fUqxfUqxfUq5fUqxfUqxfUq5fUqxfUqxfUq5fUa2bqNQvqNUvqNQvqNQvqNUS9PJ7FrzTuRS2YBNRfD5OA5J3Nu8zCO0nuNfMus/B33Hhmxb1mwb1mwb1mxb1m2mRm/84GY1abzIIymHntvMksSEiatZ1Xu3ax2rVL5rUL5rUz89qOeT0xr18wr5+Z16+Y18/M6xdrXr96pytygNi1uQXzuiXzupl5OQeIvS8nAUk/zUlA7NE5CYg9PycBCYrgJCCmErcgX7ckX7cgX7cgX7dc9br5ra5IAnIt/aeSr+vI1y3I1y3J1y3I181bzSLxRz6fXZCvXZCvXZCvXZCvXZCvXZKvXZCvXZCvXZKvXZCvXZCvXa577bzutfO6167WvXZe91r5VrehKirH82Kta5drXbtY69pprWuXa127IFy7IFy7JFy7IFy7IFy7JFy7IFy7IFy7JFy7IFy7IFy7JFw37TCLccG05paE6xaE6xaE64hw3YJw3YJwKQmovx75D3FnC8J1S8J1C8JlH8eN51aEy16T+4O9K/cb+2HZw+yx2RbcTLluSbluQbl+QbnMPtKw/bzY9YvFrl+91xX8yGPPz5TrJeU+kQQEHN6SgOCvlgQETdaSgOpfnNTTpIPAXRLQJF8xJfVUfU76qfoCj/IFU15PUw8MZRLQKFwhJfVUZU76qdoCj/IFc1JP0w8Cd0lAk3zFlNRT9EXST9GXeJS3L11ST9MPAndJQJN8xZTUU/U56afqCzzKF8xJPU0/CNwlAU3yFVNST9XnpJ+qL/AoXzAn9TT9IHCXBDTJV0xJPVWfk36qvsCjfMGc1NP0g8BdEtAkXzEl9VR9Tvqp+gKP8gVzUk/TDwJ3SUCTfMWU1FP1Oemn6gs8yhfMST1NPwjcJQFN8hVTUk/V56Sfqi/wKF8wJ/U0/SBwlwQ0yVdMST1Vn5N+qr7Ao3zBnNTT9IPAXRLQJF8xJfVUfU76qfoCj/IFc1JP0w8Cd0lAk3zFlNRT9Tnpp+oLPMoXzEk9TT8I3CUBTfIVU1JP0RdJP0Vf4lHevnRJPU0/CNwlAU3yFVNST9XnpJ+qL/AoX3BN8Gm64eZIr/4tZerflNRTdTjpp+oJPMoXzEk9TT8I3CUBTfIVU1JP1eekn6ov8ChfMCf1NP0gcJcENMlXTEk9VZ+Tfqq+wKN8wZzU0/SDwF0S0CRfMSX1VH1O+qn6Ao/yBXNST9MPAndJQJN8xZTUU/U56afqCzzKF8xJPU0/CNwlAU3yFWNeT1WnrJ+qzXAQLpCTeppyELhLAprkK6aknqrPST9VX+BRvmBO6mn6QeAuCWiSr5iSeqo+J/1UfYFH+YI5qafpB4G7JKBJvmJK6in6Iumn6Es8ytuXLqmn6QeBuySgSb5iSuqp+pz0U/UFHuUL5qSeph8E7pKAJvmKKamn6nPST9UXeJQvmJN6mj4l/TR9xqN8xZTUU/U56afqCzzKF8xJPU0/CNwlAU3yFVNST9XnpJ+qL/AoXzAn9TT9IHCXBDTJV0xJPVWfk36qvsCjfMGc1NP0g8BdEtAkX3BO86manp7Zm+7X/NeVJCB3qC4JKH/rdEwCcocek4ByUd3KlFlALh/jU17QcxpQLqsv6DkNqHxgdUoDyqVjGpDL0R9DGlAuo2PkMWI8Fw5pQPmzq0MaUC6a04AcjPsxDSiXtfPwKfQ9l9HJ+RQkn0vHPCCXwzfKC3oOu89leUe1fP+IAvRzaX1NwIH8uSxvWsjvfuSyOQ8ol44fAypl9DEgd9S8I9ypkr/ijpasBfe++uvhLpm8M9xME09A2RTds1LehWgVys8QrUeZHF07U86H6BFMDREdRzkkXRdTtomwBcpKESZD+SudbVGmi7BCyogR1kq5M51dY46NGACUiiMGCiXttCHVZwXx0CvDS4msoDxya1aQO47WuyItKIdqlt4VaUF57l96t0sLSrH1LqcFQVHtXJEXBOScO9e9dHlBeXlSdl9FXlDypXNlWlAOeS3buV1aUPJlN1DLtKDkyqahlWlBUJb/qveNEcr5UB9QcTItCMpq1SItCMryTcSXLi2ofmK6TwtKZk4LgrJFWlA+jWj4IFAugwbVMi0IimrLd2lBUDp+D8imlhCUqm+hhKDUpQIJTXqTVK8xpgLxzdCWsbhn2jJuTzdkArV26DKBuL04E6i27JgJxH3AmUDcV5QJJPuUMoG48ykTiG2EM4GkNXEmEJkdJwKxdXIikLRjTgRii+dMIB4YnAkkhxBnAvFgE0RKg7LRLKcCVdJtf02pQDTmORJa0i3HTLMX4dBq9jYchC3dEodrCwdGyUDC0aUl3VIykHCeFFIunCwFn3fuOC0YNy0YlwLfOyZIC8alUHrBLRhz35EQBecLukoLwk1LwqXEAEGVlEAgKDUR4aYF4aYF4aYl4aYF4aYF4cYl4cYF4cYF4cYl4cYF4caZcOOScOOCcOOCcOOScOOCcOOCcClvpp9IzoSLWThyYorxS5JvKa9HTHXtYkZMrCt+5WFO0VLCHVC0VOc4MFpKeJiZejk7qHNZC+qNM/XGJfXGBfXGBfXGJfXGmXrjgnrjknrjgnrjgnrjknrTgnrTTL1pSb1pQb2po95E1MtpQalLCBKaFJosqTfN1Mv5QOKeMTJZMi/nAzHzpgXzcj6QZN60YN60YF7OB5J9yvlA3PucD8RWwvlA0p44HwgNT6QDkX2KdCBhySIdiGxe5APR0BD5QGIMiXwgGm2VUHE8ItFyQlCjXT2vdTkhiMmXEoI68qXgaUG+FGMtyJeisTvy1TP5cnw3Oz2OBJfukWPG2ZFybDk7XApCl56Zo9XZh3NUO7t6Cn+XnMBx8sweHE/PLEOB95KOOEKfiYsj+ZngOCdIUiFnBzBpchYBk2tUSL2cgSB/namXcxr662F+kLwzzA8ST0D5Qd2zUn6QaJSWHySaDvODujamjA/RGZQZIjqNcki67qVsE2EHx0y8nCDUWdYxEy9nxAhbPVbESzk2cu45r3Q5aUcwL2f3iFnvzLzxQOaVv/JIn1e9IkWo8xrzqpdThIQbWlGvyBESrm2iXpEiJFylSBEipypShMj5ihQh4aZFihA5dJEiRI5fpAgJ7hUpQkQmIkWIuFekCAnuFSlCxGMiRwjpTqQICe4VKULEoCJFKLXkoFS9jORekRYkNFfcK9KC+GZm7uWsIMG9IiuIuFdkBXFzUVaQoF6RFcQ9oGbq5awg2aVqZl6RFcRGwllB0pzUzLx6wbx6tewVSUFs8npe9oqsIDmG9IJ59bzsRcbltKDGv3bBv3bmX7vkX7vgX7tY/Nol/1L0tvBpZt5r5njwzkuaaa+ZwsuF1zUr9jUL9jUL9jUr9jUL9jXzVjPH3neUZOatZs4MEiRHmUEdHVKGgCBOyiQQBGuIfs2Cfs2Cfs2Sfs288uVECfEElFLRPSslX4hWoSQN0Xp6RcB6QcB6QcB6ScB6QcCUmyIsRq9WvpzvIoxQLwiYMmj6aSWm2sgJ6LT05dQdScB6WvpyJpCcIBMB6wUB63npKxKFOucxLX1FopDwRpQp1PmtBQHrmYD1koD1goD1goD1koD1goD1goD1koD1goD1goD1koDNgoDNTMBmScBmQcCmI2BDBMwpQqlLDhKalBwkCZiTg/hm5n1nkRskGdjM+84iN4jby6wY2CwY2CwY2KwY2EzbzpwbxDZiVtvOIjeIzM7O284iNUjasV2sfO1i5WuX/GsX/GsX/Gsl/0JNCQr6f2rI8lz+538uyUSNr/2Cr/3M137J137B136xXvard8Mc+i1coFvwtVvytZv5moLThZemMPbOn1PAu/D8FBgvGILSiTouoVh7QTpuQdluSdluQdluQdluuWJ289thzkUQpOyIst2Cst2Cst2Sst2Cst28Wc1JGd2z2gVl2wVl2xVl2wVl2wVl2yVl2wVl2wVl2yVl2wVl2wVl2+Wa2c5rZrtYM9vVmtnOa2Yr3w43VEU7j7BYJ9vlOtku1sl2Xifb5TrZLmjazjRtlzRtFzRtFzRtlzRtFzRtFzRtlzRtFzRtFzRtlzTt5j1qkV9EzOiWNO0WNO06mnZE066jabegaU4pkjTNKUV8Mwuadkuadgua5owibi+3omnOKOIu4Iwi7irOKJKdyhlF3P1uJmq3JGo3E7VfEDUnFElL9ouFsl8slP3q/bDIKOLh5hdE7SVR/z3896+fVPYBMMmAWTG4OnVTBtq2zIqgY4z468//9Okf/vrTv4AKdD5Mz/JFDviP0bKqn3/5lB/YZ8q30H75Hw0erMwIFuUwI/jd35mXf/63T+qW3b7KH0iDf39h7OKhcsdml2ShyVT+05Uf87Pldgnl7/NTbg1w9xmAYilmfS45KsG0AnuD/3e263UARU9owBzB6F7AnUPjBLCPX6hEHcCJh37JMXZH+QtcO5SmIldsBWY/UFH5Jd/koZIzhwGUbkrLOhDjVfLj5ZKcp+VKDSeVqEwYIMP15YySF75YgfnqeC+l4PzEN1oK6nNwfYjxij9Pz87tAbw8tAcMNHgWn1810WXAJ4oWyUi2ScayVTKuz8h1IQ5Du+QY/L5dYKxaW+rhGnO0sGiXAmW7pNrpfMOloD4P14fYDe3Cd5XbxRWbknaCJdjHwHZkJ5nm2E5KZjTZCfgauH9dfvPFHrkOxGwntUTaCZZgv3J9pdv5Ys1O+F6anfCNloL6HFwfYraT8dm5PaSdYAn2LV8m9zzfRbUTvs1qJ/wUGddn5LoQh6FdpJ1gCfYr11i6nS/Y7ITvqNkJ33ApqM/D9SF2Q7v0dqInf6IHf6KLOfqUoP9NsdVqJaYacrERW2y82ogdfImdfImdfIkdfAnXV7ocL9UsBO+i2QffYCnQgx/Rkx8Zn5nbQdqHHvwIXyb3ON5DtQ68wWobfPcZ28GH2MmH2MmH2MGHcI2lq/FyzTLwXppd8I2WAj34Dz35j/HZc3s0OtO3QoL5OXRt7fynuhklgLIwn0qlYWDOUqpQ2dHmWstL+EaTxbehVavaW0K74VJ1VtJ0TXsL/d90Aw1RHZYGCcxfGiPX/lHtDkyen/l8fdPfvLmJqxt+4EbyhCr763qz9Rfv8wvQikx97p+JyOuNEsl3sAkTxqpwAlGuIrtCzqHyNEjb/OVxp+REKee0a7AWXSZKPSrzons53W0WlJO3fYgttTv/dba/0svZfi1/Uao2SgeBzw6P8hVjqnbTp1Tupi/wKF8wZmujemB4SjgIV4ip2k2ZUrmbtsCjfMGUqo36QeCzw6N8xZiqXfU5lbvqSzzKpxeZqo36QeCzw6N8xZiq3fQplbvpCzzKF0yp2qgfBD47PMpXjKnaTZ9SuZu+wKN8wZSqjfpB4LPDo3zFmKrd9CmVu+kLPMoXTKnaqB8EPjs8yleMqdpNn1K5m77Ao3zBlKqN+kHgs8OjfMWYqt30KZW76Qs8yhdMqdqoHwQ+OzzKV4yp2k2fUrmbvsCjfMGUqo36QeCzw6N8xZiq3fQplbvpCzzKF0yp2qgfBD47PMpXjKnaTZ9SuZu+wKN8wZSqjfpB4LPDo3zFmKrd9CmVu+kLPMoXTKnaqB8EPjs8yleMqdpVn1O5q77Eo3x6kanaqB8EPjs8yleMqdpNn1K5m77Ao3zBJW0bdcPNkV79W8rUvzFVu+lQKnfTE3iUL5hStVE/CHx2eJSvGFO1mz6lcjd9gUf5gilVG/WDwGeHR/mKMVW76VMqd9MXeJQvmFK1UT8IfHZ4lK8YU7WbPqVyN32BR/mCKVUb9YPAZ4dH+YoxVbvpUyp30xd4lC+YUrVRPwh8dniUr7hlazd1zOVu2gwH4QIpVRuVg8Bnh0f5ijFVu+lTKnfTF3iUL5hStVE/CHx2eJSvGFO1mz6lcjd9gUf5gilVG/WDwGeHR/mKMVW76nMqd9WXeJRPLzJVG/WDwGeHR/mKMVW76VMqd9MXeJQvmFK1UT8IfHZ4lK8YU7WbPqVyN32BR/mCKVUb9TGVG/UZj/IVY6p206dU7qYv8ChfMKVqo34Q+OzwKF8xpmo3fUrlbvoCj/IFU6o26geBzw6P8hVjqnbTp1Tupi/wKF8wpWqjfhD47PAoX7A/UNPTM3vT/Zr/Wr0fSJkXPCzp3/5+gKr6eD/w8X7g4/3Ax/uBj/cDH+8HPt4PfLwf+Hg/wO8Hyh95IlT+4JnPD3/89Lv/8vL733/63X/+8p/+8HJ8+tu/ffnhD18+/e4nuER8+eOfPtWp19/koxFgUqJe/vjLp98fhzd/+/LH//VJmxzlkoN2jpc//o/8g/oBf/DBHkHTD7ZqmOMWHfSXpR98qBoweo2G58dyl2o5+EAFK3ZPP+gfyw85dycfUAzDC3856jVg3EF/G762+0OtKluHzZvldFOf6w8eJoaHuLb5ARVgAGfLoWv/gDcLT3dE/uGwWJMJ8BR8tyrQJcB1u0Q/hB+xpaLO0UxDC/74n798+vGPT56KNHSjkt2o0tSNOrVu1A6bUsN8HdbWdBc/fsZfooqHiXzfP9TGdKVplOj67Q+tW+zNQAcrP3YLLFO1CodlhR9960cFPk+LNou6aoAReVhei56MP+1++eEz/mJgfFnlHt5X6zJlQAPu62BbTQnr8hoWcpqv8pPDX6BX4CpqoQOLJ3iaJxrsyw/ULR7oNLJh/iHgL977I+8lPL7MHz73BqVVytajfb79m85ZDMWqFuWzaWkyrf/2v//xX0r555//z//9x/OP//T//s/Lf/iPf8WmB75Sd6aXTF64ZdPL97Ku4L//B6oBuh88hfGt+bMOLEAPWMJjU8GsWSsfvF/CzQX+ii4QMvspkt/f1N+QynADWQX8E3hkj7YwVPrUPf2NuKVOfFF/zO97jHq6vukRv3J9DiYW+sjpAyQBVjdYkbljJcbpuliupmJvML3wFr05sERQPqlm+Nncgepo9Oa3MwbIuvWPLxuGMBo2v6aQkrHUc/CLjshZ4JYMdLR3dGWXQtTopsYrQ2Ve5ylahQbGEXgBazcQHAtM38iODxuVUsu7XLegfTDOfHHxwyPBTMmrCLPKJYQHjEknvMeh7YZbztvQMXrjlhAaBzyqtX6D80s/d4QYlnXfb7v8AkhZ5w3dJkwzxK+dfQQwTmNyPP0TVV3plbH7hwa4f6Gp8d5g4sPwe4vFDyY8tB2sXYNRxJ/DXa6t1N0b5/kslGhhltmM9few3kmN+OFPHw3xnjaV3odbgh8+V0Ic2ht++IPZ/LDTMG1OO7TgHQ0XfsAftMuZX60cWqVO7W7gL1zSTN+xMn7eLgqefCRcwtv2fF2jwk0dof3Q9ePv8yuwNnnJXiky3ev4uWl07urOY6ifYjdBeBnXCjBl1PUrGi9lzfGnsZu9nG9qPc43dS76RcxtYWYVDqB2sQoI9R7yq9U8E7U8E3WeftHHPE9e1NVWDvl1BSxObORZWls6gCnD7A+cxhOV2dozOTkfZmnWi2miwl+OABc10yJoPSYCN5Z/UdMaSzvfGgsfXN1cCRHgJvnpSzOjGPP2Nz9fmzjDQI4meVb4zJNDMEjDA4ummuCgE5gqzye/WJpQB5XExWnWDBdO+XipcdoMvAlX157bsE3bU8nBMN49vF9WgFW6EXd14KhOVqUo1xgWLw7OAh4yPn4QukgAb5NPknvYvG3CnhcMIXke8MfnL/gDuLDgxXz9Rxrw0O5ihdme/C2rvNg5VzsZUkCvGny7iSMvjQw9D/oQdwsaJv9x4fHiEZXnDtM/HdjMMAeMhpdG6MEiOKoANU/OENyO9SaJhaQlo3Q6wUNS46DTy1l4+YNV5vHlTVuxx1t0VnNfMg2MT7J/RLx4OJwSK3m4/fYD+LOYt9pe/ehKxeajU07Ni29p952KCbZ1rskUZB73lHb6HReKia0zTBNU95L3NYt1uuOndp8umKAcbansf7A4DOHS5mDqg+5qzao9NLENXNWP7QebUlQ8cPcaqmuLcX/luPNwyh63vB8pntGnu7Wpe7Xl4Nq+Npwl5egMa/K3qqZZkoUZoU+Tkeic8eXKK9B+eMw/7DR4lqQDUFUIo8bmGXX3jGZ0Vka1h0OvkDMYYWSkySnAUzsXtJ6GhroZGFiJt/3QJ5Q1dcoHAAwTHphUmUxI/Aw/0WzLJuvYj5sfPNqJiZ49FY9w77z2TsxabHuMsr8uhjjN9FxQMNXQc8OCuI1i7Fu6NqiInSWeAsJM+WDvwi7hgB+UcAm7BkFfYYEIAqwAn6hq2xt3rcDcsYLk6i69e8nJfm0K9LAVc0fxLrP5bGlCAevNuJhgD83OBPHkE24bcX+J5ldhVeOTFx24tR4dsWd9AsOI0yCb7pYt1x8hCet5wtYHja29bS++v8aucbdPzjadd16OYyLZedxsjXrXgTTr0TlVXlybRoED6zHs2rZDc/8YVFUM7lCiZxM+ho8qT1UePvj2MaLBBnEwt+Q2p/XfaJ+7S2+f4rrtXLeEnWft2hyacDMEDn5l0fdSUJvnuzoyREVPDuR51laoSR9x4yssO9zeDMQ7gX23du1hBIVvH2NXVf8Y8dgMJRMeO6pdi+xacNsZW2oadi1GprF3mCZn1dcUemIavN9Nbe453oKhU2rbNsvlUb6f3dyZeuAsMAQLA509xg8KB4gGyxKssvX4l1nzHX3JddpUEReBOimtE92uCrjvFlMIkfd9eCGWYwDM8fg5voIFz03S5vEXrrGdPF6ebrrw5d5I8M+NBNrR/exay/u8K6Met8p+irOzuf0k9csf2jNGk+POw2O7vm5zgXYFnM2hNo947frM4MFUexo4e9u93IJbS9ytPfYWenWxct1y97OxncZ2DrV1iO83h7r+GKoFn6RbiD6FxzPBLXdcNdpv79Ufr1mfunQ85Mzxuuu+OKVk3jfJAtU8nkD1wyKY72cCFe5NoLyvwXXk5x/Mn+JzrAET5Dp/2lvudYO7vhuyG08793m97V+9r/K8s/8mE67vZYFon+rwV0550lPGayk2kl7yeheAPR5v/e17ZMuBl+mXLBG6z+rwxBT/sjWYz+0d7nEzWucN1McX2f7wBQfnEbQN6Yn9uqvc9RvZauJN/xyrotTrG+T65uIrrGq39/AGi356AbEdZs9tiGxXgc5PsRTvsArczQB2+1/b/Z7tLGZf1eU9xN6gtd443cdTqN6krOY3vLsp1K6i3YU7evf5HOaHw/u5cb+Y1tWBPz3cmmj0cXfPytxSPdMTieb+nEur52hLhQd7Vr/5dw5bptt7scu3+4rZytWZoHOq2VyKumvcV8ymt/T7fs71/qxL33thLMzXmD7IZVzSPtyQuMPNTxPLdXO4vKr9FhO46537xAuwZ2/3jtO4vAW+V7k+E/0W84y3vGAc2nfnNl7h/a77sm2kwmZFvd+Yuz4N7ujLmUWA1LPzpSdb5Kmqnupx+XqTY4q9CVEFu37yJ+Ymcnljo/OzhVi41SRmWJ9xCPQLhv0bxueI064i4n6Tc1rsvA2l3Yt+ycf594z2YHp37wWn4EeLL2K+wXbQ9X32bZ9sf7j8VmDrv3/VV3z7ydru4tejva7HQl2n+cut/i12rp4LlXjTu6Zh8jrnTIzD1d2P+s9JCn1K7hSQ/yPlsYaUkhZB5tuw9O0P2xh+TMlVN5W/psv0cz1Uv2Xkzj+0hNx0O5wB8lvkCT+fWZAwWjTkFAme9mM+bsqpVSknzA8a5XwdmBk6+7i1tjkSmI173HLOjhWX319lzMZ9ReC/9vcj/506mtNv4Q05dQseiE1GUbsZ5414VEfJEgoGiD1o1rAP42/b3bkRbEzOT35mCjTfx/e3kRtvEVyfuF9erLkjWq0ntxFvShtrDc9ydgkBCW8q5KdYbXOMsfd2SNV4W/50uB8X7zA3/07MukYvbWBqx1He3yYufvMD2sejBGJzA4eeDh6Qzv1IzQvdq3M28mx0o9I+aWD3RL960oCOd3peH7olQ5IB3E8a0PfyK7TxY21/iUkD5t6GaPZzOLn9SBr4DScNmOc2snPDv9IYtmFRl1/47+OlHrwh/L5e5H79IITvdOPwW2yrfYepK+/Zf68IAtgNmn08+nMv5I7VBHL5Qu5CbG7X6GJ/6VcLCWNmB8aInt9nbh3hNk4aVp84OQZx7RYnHTy3K3k/tszce7djfT7Xq/Po93fCzHNJZQ5mj+1F525P9tHG6PNDc8uy2822V7yxeByV8Tqjfuqd6XZ+8T3MuB7sqh/6SgoejNskYse3D/huLz++RQDLOwaVf+uooZiOx77yrWFDMq9sm/y0eznxqyWc7UNbtq9LHiWibXzu3fSq/I0G1/ncBx78ufQqfxyP3mVsX8RfznC6/mryehLFe6a6bPfb9y7xXviFeS7PJ39t+SPPp1nWd5Pns41APr64pmGN9YE973ZG+H78uJsSvWMO9ba7vx/y+sYhr99POoE4xfV6EMAujXp/FkPnQ2TIwo7vXpGrvQ9OuDwB/xVnJe+W2305kHnb4vtmMvfiK8y9lCWnjtvAWQ8mJc/lLHmjH+UsbQfh9lX/1QSkre95xbrnepLKzh1/izDg91wSfQO++RoZJG9e5DtfZ4L6FmO+9XeLwpMHH2xzVK+awjcgwetNuA2Re/d5+XPJaN7iy5DdYRCv2I95Yr953Dj7gYNGntzTfsXE/EecuhoXwWweXuP68nE/2A7cex2OcL8+oX7HVw/bl1C7QXh9KfZ+qaLvmZ+3XbNfdbv76f/1PI7Lm8dPtWH+XMXjmejlE4uuB+Lu8rWeOOLo2T27t3KBnDZ3veHNxls8EbL83BE/wiVcn7Hz41kf+c1RHzv6zGbeQ/vYnDF/PyEttIQ0Ipv7E2r73Ht87+2DXb7reXqvOPhkZ3Lf5eL8t7EZ8/VeHX/3M/C7cz77XCqcj8fDOd/VxdL+US4H6H8n6WhfcS/x8trnctzRK6z68oFzX67uMVxn5/c8oGrn+V5xu9vFynZX4lvsx/yaRwm+IuFtO/G6PFV7vxCc52IVnpmRPfkeUc52L4dP7qOeHh2NsKGPe/Ex1qlbOMosDunjwSzuubwzcPFtW/Rycv1X2H+YMhq/RbTNt9h7vZxxd/0Yvq+xwfp8JvX1fnq384G+RcbknZeGu9M43pHwrq9Y3riXIZzZ9dzhrdt/x8U+T/YPl/xyJ/PSdq19LrIlM0xd836JaPA+HPI6V1dyeIIH3HAIsE76Gluv1ydG26e4fH7tO54DxsvOPGtYfo5lG23z7HLizvzu32s06jsmFT88x+bCKLgcnnN5j7y/duAo6+3O6K93iNYuoPAVh2dc3g/en+B13Q7ea4P89VfYEMS9ODsLDKEkPTyYmt+LfxBko9t27SumXa/YYd07jO/Tx1z/vMv1oIXrR63trvGeb8+s2jDR1deG16/9dYzh7Wdr/hb31eVpbtu59nP76ldfsH7ThKwHM/PnwruCxbdRtlro9AmJd8yPvTMKfs3Q54/AqLcHRl2nle0DvptTetdT1i8nWPyq+y5P5WR1X526PHvdbUZz+m8+40QcWPID0i9c9pBp68+ZzjPriP1+/vXIgcs74bsGkedXH8mz2f7Qnbsy+u97gXA5h1TlL7mz/74/dXb3Ih0EG/ijTZ0fT3ffmt19OTvgFcdevd/e7v6utkHOdNrgYO/fwvm85ZOMz+67Xo8Uebxp/+ZIuOsJoc9lAfzlBmRePcnNqfsnuQX8TC99H17dkk9J800+89H1YF0SOTPb49f2B41dr+sVp8K95gS0/cFwlz+vvj187mt+d93p+8evRd0OaGdjTLDo8rz7iMYIt+cDhzntv4i+PX0NlyWgkunG8YfBt199xx+AcPN5FBwehKc/vM9BZ87cP+gs2uO7Puhsd8LYtz7o7PKNf8NT4DaTKfvgoDNfpmZkAPcPOnPuwUFnQ21/iQeduXu7wNmj4Lzz46Cz3/BBZ+65/fsY8NS7f6dfR7+eSvKKnY5H79WnL2NsJ++XD936bew6P/4gR25A/zBW62ivJSK4vGD1wuNZuB0v8iy6jZRgF0fYvvnMuetbak8twrvPVb5f/OM3TOoZtvPZlG2E3n5Lrs/VfaVXnIXzfp932IY9qS/4YsVYL7/BDTeIluP60KPtN6rvf23A3XvBYVNeB/sYmU0ebJA9l3cakxuXPsM6fP/i9fL3ji7HV+43B3Y+6fIe1Xab4decp1xvqeOzalMLr48QI/lQnF1X+zUmre0X/K5/2n4vdOA3eDVw/dTEO1tLH6fO9RHs73ZoyfsfdPbxAueVRPveIVH+3rsYd8QSEkVEc5+2/HM5p0mpBx9B/Hd1fsVXPFfOP5fLmHT4d3KunPh8Rknpf+b7a7vV25a1t9Z7OX32669Nr58s+5d5fPtXG/2vmHVcP8z3aiDm9byjq4eYdJc26vimy7r3C7i+vPJ+8vh7eb7a5SC+x58SHOdzXzZbFPt5ymO+fOOXpd99nnL/c3625VUSlT2YqTyXV5ls+zrg9TF7/SvHuyG4926X03jec8v2FfOh66cY/KpR629JF3xzqPn1r+c98eTj/vOjrK5H082H4Rv+wYf4UmxLgaPZcrzBpCwJ34ZfcPMwyzLJaxHYsItG4FCMGKAuURWFKViTDMe+7UMh+BrZkrmBtkEd+4/Xvf1DdP7Bh+hgRovh09/gS3S7qtiPxWQPPb+UnT/5RmY4/rDTQM8X8pfrkjKLCc6gsX0MfOGRYADmb+DxXCKiRYb8Bl5M7y9fHEfmVNX+m327a2x/2D9gW6bkE1mtUzpNs6Xpw4CvePT2IO8TzOIffLUPppvmYTQLekkYhzrwi6xvE82y0fhuolm+g1CfzcTs0Wf7YgKqEBZwP5zFP/pu31jdX2I8S3jw4T6Y+ZuPgJbNVPm3E9ASntt9hXb5izz+4Poy6D1PR323D2y/4qzTyxtrlw+3vb5tuF3obJcUu03Rb7GQe7+j7TjcHpq8O7Lk6hvA668Gr9vUK15FP3ea4TPbd/uvQmxPkNm+TtwFSnUPGOI80/rmH4Xafg1m/0r08acJh7Ntn8w9Ek1+/bnvh7uEu98UjLodoctcc387Ljz3UUF1hJbt8ZYTGDcHvEynlm2dxnZr71fN/Lr8Ma6rh5a940dyf91TwK42yJ7TXp9a9uxs4fLbtusHMl0/DOodj2v/WoeiifCOh+9+7k7pnjoxfRvZuSW0XVDpr/rNou3tPtz2dcC8WseXvLtkXv78T5/+NLl48cbFgmz//qaoawy0b+/o7U1Zf1jFW1nN6ysD/hJ+4V3KQ//Y7tznxCo+L+IwrTJ9C1HDQtg98Uu7AdrM8nW3Sv5TNrMW5bktwvGiYXX7S20V+N/5yRv+K5ZfT2iiN26TBXdnP9iFfJ2jrfR22WnoLeJNwyQrhsnc3A3cV1L8EhKnYvEW8i5jnNaM027idvdzmBNcbWeg99bO3mLrwtigv/y7tfO9fXfv4k0VvyJaG98zHC4e6ZheWk3bvTjqc7SVsVYcnWipf2B4+ZTm/rEmRs2fK7iaBfnGTgjNnH/5lB1lbfro+K/364Rw7+WHdbcA3t1wJ2ytbru5TXtd4BC8j+aJ5E4mWwsmb8R7sraRCt3jYjjm/JR4y8sYO03QZwvYvjugic/wnmVbFbr3N/g1GOTNr+UsX/Bm4PPxr1B+fY+ujo/8Wkqv9WsiAMzbmJx8dYdf68wp12LU4sB5rZsyqTVbdv21sWDw01/63Zot3XNTNgfKlhGCjUdNocBQvBYmt33tdp0UtoPN/PQmtwOPVxs1KGzKCNMB/Mu9V6PG457b0aq9QOBG3b5t270vpVB+Dc3tXRI+gUL5k7XioNStc9lntG+c/2jay3kdcNWdeV1UD+Z1xuMr/v2E62hvnx30BnQeL8kOS784Zw/rxYzP4y9WayBa1vEBf8mbXo53Qeg69pZgnujErs2+NkVzzgCLIMMdOkwTx3a5d2xBaZdkhnE4uaT96+Htm1tKDDMe6EXzeGs7DTG/uVUiImA72B8y0vu8641347qgneyBzl6jDeeNvvA4QukrLC6fjXuJ9kHvw3geJ4sqBmPDG+IPrgcmfKs+vncud2kN9BF/UX18b1lQniqF/hNBMFyDi45Xp/vJ3eXhug2i2VtFes+YjXj3c8DQGk6ZftI2fdv98idWvutou7ucCnZwj1PjA07N/2unHm3ZSRELAmvCzICj3ZgfwwH8yKOezlCyZU3hojisxuJ1YAp2iFGDgXvwizHwi4iR2+7J2M9E9ym/zBfZgF3bjc2S7gQT5iaBBsBmoaUc1J/08UTU4PacpM80qcrHOhnD04n9oUvbgMJH8YEe1p4BfuE+2QYtbs+Pwp7XN+CQpDnB9s4Nf+bjq7J/FQ1GNwZzze5R9pVtf9E24D3DskgcbPWKs7C2LbnvyMvnWm278RX3e/22njlsLEe4WjFOt1fpK9PsyHoD0+K4O3sv2iQddwZjdKntx/CQPMy92u4d81aGtm6hrUebIeTlEjSxmNz/+JlMGJ5di4Zs6RHKlWhd8ejXQ4i3nbULCH5F714f8defIzlacwwnye3dCg24EKEusRTbV7bvk62hXg653rbwo3P/3hKLnR4t77JiNdjdvtJ+h5K2WQzcdjRTVtK8HqRlH0yPVOJO215jv0m421je7wpd3vjfLzt2k9jr4dvbqq7vtWN0W8wD0mi3eKc6xsavt1uu7//vr/CZxpxWygb1xIbxtgMpAgLWT9bMWXDP29v1JejW3oYDid+4PEn3zkeEmc2L9/5hSDm+WbH5PvnIjfeMmt6dg+japM7fogOO9pOF/Ooh5f7rN87rQsrTvQMSfdLQ1DF/kRENYIgof7gPkO7lOGUqCJiWcziPs0MHE0oj+PinL8h6wK2WE733rLddlTxx3O0wGdhT/vUzdfeMf32F06ZIb+LpR5s0ARNG33Mbdrdzv+ee8XXI25zdvfyZ7OzyMW3fgbP77vNnts741zwN9vhRmsrY9ffyZ3zCNGkygPvpM6lPn1H92y9wdtqX0YPvGSy4qYNirESdP8WcndirOxiPpn5ra74ySN+5tM+xpdqXLXSfYycjzht8njMbRPl9pCWUv8hDp+VpfWO5yx4mP4+e8mwcRjDpdmDvHzfCxsB95mcgjS/pvkauPuCLNGUeVB8s0AXMp4TOTxp13uhc1NHnmRzjfcLDNefi7m0gqEM/qMfH5+ox9+ux2fCeqcc+qMfo5+px9+txPjxXj79fj1fuuXrCg3rsk/cTH9SDZxs+qifdryfg8VAP6lHHg3ow6+1RPQ/sOYbn7FA9sGeYDD1XzwN7BsNYN9Dfw3//H+iKCxMNCmVuZHN0cmVhbQplbmRvYmoKMjAgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCAyMTEKPj4Kc3RyZWFtDQp4nI3TsQrCMBAGYFBEyFPcWJc2SZNcAiK01ToreYNYQcHFipMPbxVsA3KlZLghH/lzF3JgpWcc/J1l2+Z5Cc1xX0JoGU+lcEZAV41E/aloVQ5tYFmtAdNuz59ZB7olQEoFqBz4G0vmYQX+SjA7sCXNcvljay6rckNDE0GnaKj4AEVtR2DUyIO+oeqDk9mJZjqKlTWnY7WZNBjTn5csqhGGUawt6FgUE++HOHF+Nj6xwBGYR3Cbj0A99Pyie7Y4vEhNMycmDdrp/8F8v8nOszf8J6PxDQplbmRzdHJlYW0KZW5kb2JqCjIxIDAgb2JqCjw8Ci9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9MZW5ndGggMTEzCj4+CnN0cmVhbQ0KeJwL5HIK4TJQCCni0ndJLctMTg1yd1JILuYy0DMytDQzVADSZkbmpiDa3MLEWKE4mUvfzVLBXA8oF5LGBVQAhIYKpkAhE0uFkFwuDQY+BmYGGSCUYBAAYhBLgEEYzIOQIgxSmgohWRBbXUO4AMFTFi8NCmVuZHN0cmVhbQplbmRvYmoKMjIgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCAzMTUKPj4Kc3RyZWFtDQp4nI2Vz0oDMRDGYaUU8hQ52kubmfyZBEXodl1PHlryBmuFCl6seBJ8dVdBEsUJwx5y2B+ZmW9mvuxVn5XR+UVthuPbaToe7no9nZVZI6QAej4Dkv86KTqrz5PajF7Tev6XH9UMzB9onzRZ0vlZXRtM7kbnp3+5YH+4y4vXFUt5EUWFumIpgkJNPFUiLj54qkRc3PNUklARimJ2G1nFIsm4ZIVcld07mx2YKj0cLHsdmCoubqkB+gocW2A9S7ueB6EMU/fAlwKla92BxxCEhaAVFoIkkhpLR7qRx2y1OssGRnV2hs/OWcmYgvNCWRwJZfEgCuxFVgHei4bgl0G1ZKm9pyFzqNZoz2OEEvcBCqKg0Qg3IzqZHUOMBYSRdw1IKFqiFCoX2g3sfWiMpG1o3N9Z+X6rbrP6BEq+VbUNCmVuZHN0cmVhbQplbmRvYmoKMSAwIG9iago8PAovVHlwZSAvT2JqU3RtCi9OIDEwMAovRmlyc3QgODk5Ci9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9MZW5ndGggMzk1IDAgUgo+PgpzdHJlYW0NCnic7V1bbxzHsf4rA+ThSAjC7enqa2AYELncHMEXGJbzchw9MNLGJmyRAUXZTn796erLTE1Xz7KXphzJoaH1zPb2fF1VXfeZ5cIgBjVIbb0adDg6kIPBo1GDDUevxeDw6M3gB2lGC8Mowkm4ZBhHPPF6GGU4gVENI+AJjEM4l0aFmWNANXoMmPiRkWEmfmQcog7SaoHXDuEaEyZYPAmkSBdOJC7k8cSNA4hwAloPARxAhYUCpeEEPwrn4ZMAosKJwQlhGlgRRhDZ4hxEdjgHkT3OCchKhDlK4EmYo8KgGsMcFZCVDHNUQFaAcxSe4JyArBTOweW0skP4B8oEWBWQlQ0EK0R2UgwakV2Qj0Zkb8NIQNYigOiArEeco/AE5wRkLXFOQNZg7RAkDFoZN+iArLX2Q/gH2gRYE5C1DQQbZDZuGiJ7YQeDyN6FkYBsRAAxAdmMOAcFInGOxROcE5AD7X4wAdkoJ4ZAAJiw2GADsjFB7DYgGyvCCOAJzkFkh3MQ2eOcgGyFHIdAdjgJymIDsh0DiA3IVgZxhQvBhk0d4nZAmBMIAKvCHBeQrcY5AdkanKPxBOcgssU5iOxwDiJ7nIPIUTEDshNhjg/IbgxzfEB2Mmy6D8gOgn4GpQonASSIGgJMGEFl0DgnIDuDcxye4JyA7AIdQdUR2oVJo0BsP+IYgnuHYwHdizgvwPsxzgv4gTocM3gW54UVPMR5YQmv4rywhg8qMHzyyebsZn9xe30zfLI73+1E0I+gl+fh5cJrzOcghDWfbr66uX797tX+ZngCJ+IkWMjfnmg8cX97OjxNQJfXV9uL2/3wZPtnKaQSShoRVF/rPwrxP+Hf080X168XMwLz4ygtmD8KmWbsX/30B7l9fXF7UYiyp0JIKYQO58aHl0rv4Vk+mvwK56a8D/MC3QLGNB6POB4YBEjMxfc2v9f5ep3PVf5cpDXkWTpaFEb4zCIdZ2luoaXQGcfHPAfp1+kaDYl++2x5Xbxmm9dWeY5OY3Rt5C1uCuKEtYJpCCvnNeJmVbJZXA9pbqRvl65Ffsp8nemXkGXXeFG8OG9MSlPkrUx6xf3akrVNXvs8yUJluk2W5UIWfp6HMol06jS+4KfGdFmG4yzHKBO7xJ/wylqnh3HX9g3oNT7JUuV9jLSjbPJx8T7PjXQWfdHLvYs0jOkzm/VzWmtFvxYyVEQvyBoLPrcZRyYZFXkpvE5kmv0sixbfOC/SaRO+ui+mIpjFDmHW01qvdZ4T7VHP9qNX7NNSXaz1JOtYbcc9dDCdI1jTeoW+MfN+VumjInN2eb932cYDvhJZljXGObHp2lcgHS7LIvsNtMt4rc6yOeQrWtefEZs6PXBtkYnPdLulfk4+udbpFexyfXyJJJ/42S69rJ1fUSYVFvWrUedque3IZzu+H3LL96Ts9+QTdpUMso81QOy/ofdRl5WYfVGm3WafE/HQr2b7mvSw2NZYrXueadsKFmNwHZVtVOtkQ8onfLQbtFF1mnRaZV+ln6VrFjFQZBlkXup1JO6fyzHB5332SY6g5/H4XuTP63PUEbe+rs3+bU0HW3PXfAONC61YSmP/hGlzsrRi18VubM4nDmEcY6eH4kIX9oqdHYW7gtHNc6dt9OLpA/p4H4xat46RjS7xXXEdW6XlwDUxxph8zVnWMTHrMs0Ho58oMcgQ/cmxtxWbYu4glp9P+5J5VSs+peaHxthyrQHB9rfOOWl+r3c8l5n0mNJY7KP48hz719Zc8Fw+2xIZFX1GnOJbc8wxropdkGqDY/KVh+aB5vJT/kPzKVHlH2UPSS5IaVzTzTtjOWRfTvNgEj/X9trQvDjHoqngtJWeHZOPdeLSXL/4faRXbYmetvZerF+ry36Oy3wy5joiH6GSVY67E30kF6F1y8F64MD1uviDat9YvMw+7xD/cYz6oeraNf7r6xZ+ovgwopf32XfdwFGVLq7aDyz3amHXJb+s9LjUynCW1oTzFEMmfXi2tGP0zXVuhtfG3DNfT+mjuJNPh4xXdKdRT7UwSx0+1fdknfI5vhY1klzuWalpW/2Cu2KOKfyXvKbIofg9P+u2FPN+x+tLn6KsLWa9XORr2TdJQbCLvZB8umBMcwptpW6XYlG3RhvMdCD98byq6Qtv1BfEWJztrvj2wl+9Nvp8nXOzFn7p+xS7jzxU+qI10YVSQxQdLOuILIssvymuiPkaU/R+FIsYNcm+1NuwlHf5XBVb387rtXi21RjFKP2X6EPW5L0l1xdbKLrXyilbe36XnlQynmqwc6IrJNZMvJV5+DqdsXt0O8q/yKzqg039Psof1dGWnApGsTMSwxf2tFvu75QTEhqPseHSCzFEnov92JI9PK14qXW76JgkfBfc8lm1B1M9L8hn42ybU+6nuSxbcpn6ssUHZ5tY6GzBaOGdzXo/+a1yTaava79WfMhkl1ZMeU7pVTd1Y5vGplhSfPc5wSN1I9XBhU+oYsyU23XGq9UeUm+v6aH6LDTuF70vOnYI84BPrXu/cYz4HFvRUfKz1bq5IyZ31+Ck/0V9Me3Fd2Mdk8sfg3mkDh3Vf3iIHshD9jAO5cHHYBzbe8g1Q5TvadaFHENL3sL0vdhQ6QeIhj5RGQOZd0aupfl5pft31p0y1560HvOC1QV4bew5It3PMr8+v/I9w2I/76Oeb9UgJc/+qGvhA9d11cFyuW8fUx1M+x131b517f9Y+4rfV+1LZDn5zSI7Kdq5aVWTyJUcleWfKzX2AqfUHlLMdRbJ4Rc5elVnxftDkO8FjWKRa8pyD3I30xD5O5/3dLIVusahPKOig+bVzfq7yKynLjpQ901r6Jn3Kd6RGnuio/j2kqupTP8D1+BYX6Ld6pU6eLqmrhXuKYcSh6d4rdt72cSi/ZCqJp90svhQRexJk30vsbJ62Kje+5rvVZ0mtZsp90wyZs1DuebQfpb7e5N8dmneYj+Lfx7nddSzeQ8XNlz8StEPtZTf1BuAmUdaCxa7W91LogtFDyjvi+tpzM7XSbL3lLapF1Byt7Wct0Nnu/1Tay9KbCfPm6zW+9ROGvfPaB3ejFeFV0M+K7zXetzo/U06TOvHll8kuWKJaau+v9bDylZru5p6OVK0baq6B7bWq4ufm0oWLZ1SMxb9LO5ty19WtcdiP4ucSx1e0Vjy+Ck3OyI+SdLfmPpPWsz++IzIXM4+ZdEnI3ZC502YrT7jEX53orHIv/jF0jMqNBWfMc6+ZcoZK8y1/uqD2ehOLPOyUuNVMfA+/nxRZxH6F31gUmd2xfzOGm7y3cU+Sk5I9az4pDpvGRMN1nA6F/dFSu2giM1qsmck3h6MOf/l/bj3+qzEYz/usR/3gfXjkO9Yt2VfQp8TXNQDItNWYge12Z5nPOpnH1q9trNsSzbvXbn3mZ8FfOyxid+2xzYu9+uj6rGNfH5vX/GxxyZ+Xz22O+J0XUcvvtdwKqb72bIj99Wl5vXzd1SsI3OLH9oS3ad1XasOL/ZE8sm1Ppd2yS7isyAZE3O76fnz8+V4pDXj65X9m+a7HCsq/DpXLj3AmE/es0f3q/PtumZ6gH5OT39OkboS5VW+P9PSncX3qQ71fmke0qj/p/vsfraL6bq6Zt8tdXHRLz7gH1afeyp0FLxCN90LWmPR3kujZl30Ckq/xC/nTXX8f3utUulALUtd1/+Fr7w/j88LVJiP9cmHV5/kvoTK/gfzT53jbLzHRO2x53tjjt87vrMO2WadEIJ91/OxDhF31yFq/bqunLyqGz+qOqQxv7f2eqxDxO+qDjl4v2Jc5lhSzD50ipUlho+zLk25pBHzd3nqnIrc29KZ3sX96Yw/5fnFL1mxzFXcPIfl/KRvFGm2bWyaYy6eX231vcs+arHMh9dyfJj3YtEHL7l9yRvF7A8W90dLPCP3pO7cA6JTj8+zJswunaX4j3nnY975oeWdZ8u++EFbEbPOLvoaxM/K3D+JNJDextH5K1T5VEf+arNvjDlF/Z34jpzh1+avC19Yxfbaj9X57tp3ekuOVu4PRNzSSyn3LvwR3+klcWaKT4W/Kj5NfT3q22WnfXXI+6F5u/O7vrTPX3iubPQ//l3fXxk/j/EhB/ev+K9Grhv3TojV5/MoPXc997XYv/N53wq+LP1rkgNNOSRdJ89fPBtIPqf9SkP7lXRO3ffdVT3eKt+xB2TL8pW7dAbrdfJd+TV/V/4uV/zbICVPyc/m2NynPdbv9drhb+n3VIlZ2RfZokM5/+j2CcWflTk0vmd5xFzOz35/IfMyT3GdY7ZG672Vvm55Pu7oXID2NRu+eBWnJ+49lKw/dv9bcnBy/2zCpOs35h3qpZS/C8Lqrsr3rdnNnTXnMX5GC3a/u9aH6XktI6a/nweZBpsx2d/8eQA96+oLfqB7dLDf8MD7w/LevGfgZp/wQe2Luv++9PjU+v7OQVvSM5+lxpl6Pr/FPj1L9EMdS97jPr2X+Jx99fQ3Dho184f+d4Yeiv6PPu4d0+/5UO61uPXr7rzvMKZ49tHea6nrtHveazmmpx99QaPXOz07WXSV7n/Z75LLlrWyvkz9ojWsMzHd3596cyWu0s8aOXapo+kzPZNtFh2kPV4908N6/h2+YqHHyEe5v7Gyz3ROr25Mz0wRfzT1/w/0B1S5jtQN5rzNB5WtKv6p7OEpkXnWtfi+yJ3kTWV/F88ZUV46+61MBuWZNZfy4rvkfJ+e+1F942N8Z2et1+LrffSyD/qynh6tEHc+6wwldm/T9ZBrCZRD7GE08uyHit+/2+cMfk3sk3zPPqrYN4r7P/Msftv4pw/0SMv9Okt9Za0TH1ocIX2IqRapsR/9+sft1y2vIe6sa4seGcG+M/O+ffmxte2if69n+VCfEY9GHP6tDJ9llZ/hje/zXJPri9IjmOJcvqdpJno+3XxzefvjvvyAhyYM0i8kS5oEr/1hdSFW/tj/p59+ir9g8s2//rkfNl9dfLd/uzm7fnd1O4ybzy5fvx2+dYMYvn5JZ31xcfPD86t/XMeT/evh9ubdnn7+Igy8uv3mZr//+vr6dvPZ4BEigN/sr+Lwl/tfbj/b/yssMY/hrxLhrOfb9G7Edwl1d7n/ESl5udl+jT9VhNO2z4Ynm//d//hTePfNP8L/vhue1pxsvt6/vX5382r/Fn/XCK/6Yv/68uL0+pfhW1xMe33iR+/d4JQ8ce7l5tnV1fVtWGlUOB1/+wh5DwK5ug1k4gcmfWDTwaVD5G+QIh3GdJDp2iSMxOfbQWSOBzWzR4V2/uP+zebFsNlev3r3JszbfH5x9d3wZH/1p7++eLr5aojLB4l+KyHBP98OT66uX+9F+m+shFCku/ny3Zu3yLVUZDvTBktNhnaBVfw9p4m6r26uX73Y3w7fbr7a7obNN2Hrhs3zN0G8p/l4lo/PX27Of7n9y4tb/GUaGSWU4VzNbJTz5sW7v9/Gt59fXv2w2Q1qc3p983p/k3ZHvAz79yosrN2J90HT5WABTqx1HgYJ9sQZbfxgFZxIDxp3D39t6tespKQ7GbXDn7OyJyDcaOyglTsx1jg5KHuitB014Eog7tjAy5/CdvmyXTC2tksa3K5vIaoK/gxWPCTdA50OSeEgKRwkhYOkcCopnEoKpxKKSigqoSjdOpjWwbYOrnVIq+u0uk6r67S6TqvrtLrWdx9M62BbB9c6+MbBiNYh0WkSnSbRaRKdJtFi0urG3n1wrUNa3ab1bFrPpvVsWs+m9axuHdLqNq1gE6ZNmC5huoTpEqZLmC5huoTiEopLKC6huITiE4ofW4eE6ROmT5g+YfqE6ROmT5g+YYY4k49jPsp8hHzMrlTofMweVGQXKrIPFRlvzHhjxhszXvLgL9HePr98c4nOeOn4iGEpcE9fbr68eLPns9IyZHBUTwO6YsMahzUbNjhs2LDFYcuGHQ67elhKHGaUSAjDOYosvcSQ3P1iNKyYvMpiFBeUbBgEDks2jDxyaEAeJZOIiiBMImrEYSYRFZlhElEobckkoiIlTCIKKQEmEYXS5sxrFCswLjUuCYxLHbEZlxolCIxLE7EZlwa5BMaliUsyLg1yCYxLg+woxqXxOMy4tLgNinFpcRsU49IigYpxaZFAxbi0KBPFuPSRkprLYPo4XHMZLB6Hay6DIYdhXXM5RvPTNZfBDHC45jJoJQ7XXI5R7XXNZVAoHK65HKM16JrLoFA4zLiESDfjElCwmnEJSKBhXEZLM4zLaGmGcQmoEIZxCcilYVwCcmkYl9FcDeMymqthXEYDNIzLaA2GcWkQ2zIuDWJbxmU0Esu4jNZgGZcGZWIZlwYpsYzLaA2WcRmtwTIuozVYxqWNlDAuozU4xqVHbMe49KgnjnHpEdsxLn3EZlx63HnHuPTIvGNcRrt0NZcy2qWruZQi0l1zKaO5+ppLKZBuX3MpBdLtay6lQLp9zaUUSLevuZQC6fY1l3JEun3NpRyRbs+4jP7EMy5j3PaMS4zbUjAuMW5LwbjEuC0F43L0OMy4xHAuBeMSw7kUjEt0YVIwLqXGYcZlDP6CcSkj3YxL9INyZFyiH5Qj4xL9oBwZl+gH5ci4RKckWZ4kIS7JuMQ4L1meJNHNSJYnSR2HGZc6Lsm41MgOy5Mkeh/Jch+J3key3Eei95Es95HofSTLfSR6H8lyH4neR7LcR1pUCJb7SAy6kuU+0sYlGZcWl2S5j3S4JMt9pEPmWe4jHTLPch/pkHmW+0iH8ma5j3SREsalj5QwLtEPSpb7hBIdhxmXHmXCch+JXlOy3Eei15Qs95HoNSXLfSR6TclyH4leU7LcB9BrSpb7gIhL1lyCiEvWXMKIXLLcBzDJkSz3AUxyJMt9QOJestwHoj9huQ9Ef8JyH4geguU+ED0Ey30gegiW+0D0ECz3geghWO4DmBJJlvsApkSS5T6AKZFkuQ9gSiRZ7gPR+7DcB6L3YbkPYEokWe4DmPtIlvuAQo1luQ+oyA7jMrowlvsAliqS5T6ApYpkuQ8opJvlPqBR3iz3AY10s9wH0D0ykwdM2ZjFA/pMZvCAeRyzd0BHyswdsAJi1g7oXZmxA9Y/zNYBXS4zdUCPyywdsCZihg7ohpmdAxZKzMwhZoYstANmhtz40WOPLOAD5ovcJcTiiaUBgFkkdxQxiWTJAVjkj8kNfT73Hjbwx50HBgLuOzAOcNfhAnvcc2Bw4I7DRe6YhDBkcHfiIndMQhhIuJPBODKyFAccssdGfdw+JiFMvrlDirk3S4cAYw53Uz42fJg8MeRw54URh/suDDjcdWG84Z4Lww1zXAqjDfNbClN05raUiO2imgglAnfMmamYzrOkTmE6z1ycwuDGPJzC2MYcnMJcnvk3hak8c28KM3nm3RQm8sy5qZjHs3RTYSRlLk9hIGXVnsKcnxV7ClN+VuspzPhZqacw4WeVnsJ8nxV6CqM2q/MUBm1W5iksDViVpzCSsyJPYSBnNZ7CuoCVeArLAlbhKYz5rMBTGPJZfacw4rPyTmHAZ9WdwnjPijuFjRFW2ylMAlhppzAHYJWdwhSAFXYKMwBW1ylMAFhZp2JLJJV1+QZWvCcok45s/u9i+/fwJi6RPv4LhPfkftROhffpNs1ODzLpwGZnwumYTm04Tfccdy6cphuJOx9O2T28Z69uL6+v8PbPX79+jq/hyfe3t/98++fN5ueffz758fLqh/3ry6uTV9dvNpdXm9v9m+s/vb3+4fuL1//eb552Iu2vvr+4evVTBLnZv333Zv/0rttQqczB+1C5N8xuRNkDGF9eX6WBgJS7gPEOpNMNKExKOqE0zFCmCeV6oVL9maBsE8p3QxEGXQsq5EydUMnfJijfhBp7oVK1G6GSKTMo2S12NUO1lAFTuj6oXLEnKNmEUr1UZROLUK1b25g89jI4K0NyTwzK3Aeqqe2mV9slhWpqu+nWdjcbjm9qu+nV9lwJJqjkcmV2siCaemZ7VTZXk/Hmd87CISfYIJo7bLv1TrsZOt8tzwkriKZsba/y5Ko2Qed77jkJBdG0YdutAXIyPBjbsu3XAPJgQdOGbbe/mzUAxqYNu25/R6GaO+y6lceIGappw67b33kC1bRh1613qRBIUPm5jNzLhNy8hNytBNncYdeth2byh5BbmpB7mNB89AdLrl5omKGz9eTOJsim9bhud2JmFc/tT8j9TpBN6/H9GjH5T8hNUchdUICm3vr+bZ31tjyDUx7CgabG+O5thHkboSlb3x2L/Oz0oOn1fX/mNbtmaOY4vtsTUaj2DvcrzwylWtaDNXOvrGb/qFr+UYl+vZvFnvtRoMqDWllJcjsJVGuHsUzvXYpQna0nt4hAtWSLRX2vHs4qrtuy7dXDfP8rQbVl26+Hs2x1y4ax53APqJZ/xEZFJ4N2Dhi6FXuwu9Erq9kf6pYnwZZIL1Vz7MmdNchNM9AtG8YGSq/sZr3TTT0be9P4fIMnQpmmno3dKqvmbTBNPRu7VVbNsjNNPRu7g6eaHbpp6tnYq7L5hlWCautZt8qqWc9MU89kf9FKZNX0Z7JbZdUcsk0rYmF3rBdq9l+mqe2y28vOHQwwTW2X3dquZqdjm9ou+7V9Nhzb1HbZre16Nhzb1Pb+bg9JumxT22W3ttvZcHIPGHJ7F2xbz/od9mxItqln0K/9s57Zpp5Bd8uGQjX1DLq1387m7Zp6Bt3ab+cddU09g+6WDcnXXFPPoLtlQ6GaegbdaTLM/ss1vSp0a7+cd7DZ68Tuc2/BTnaw3aHoVlFHdrBZB9ju0tgRBpt1gO3v35EdbPdJ+gudeQfbvU7XTZWfnU671+n6qZqdTLvX6bqVwc/K0O51+v5CZ1aGdq/TR2X4f7ZiQWcNCmVuZHN0cmVhbQplbmRvYmoKMzk1IDAgb2JqCjY2MDEKZW5kb2JqCjM5NiAwIG9iago8PAovVHlwZSAvT2JqU3RtCi9OIDEwMAovRmlyc3QgODg0Ci9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9MZW5ndGggNDAzIDAgUgo+PgpzdHJlYW0NCniclVnBjuQ0EP0VH+HUdtku29JqT8thxQghlhviBHtYAbMILUj8Pa/i6jhMlzKVkUZJd5KX8qvnV2V3SjHEkFIKreJAIVX5mAORfC4hR/lcQ+aBI4eSG44t1Mg49lBbwXEELjkkiqEJBgGu4zmi0BnXCddiBCDhQ5QnJro8wnK7PANcGvJQDynz9imkUnBzxrcVmCnjvw65jgeY8WgGRKu4MeO+vj0K5IEBAAMnAoiIKW739EATfuBk4BUlYqCCU1KgLI8WClQiwBAclZYlhEAVX6dSAzGYSoVxIuMrQG5FwgRyTwII5N55o5FGBWBN4FDGXQknA4A1h5xYqAa9tA0O/JKMq3LIRYKvLeQqodYO6oUoDCA3fEocQ+5CGwN5SMzAKjHiHs44kcBAehGMxDUUEm5YUheFtoYTCYN7KKXLpRFKBVhqMRSWeFrCycC4GpCbcAgiShcOkbwyJDDopUZ5e+NQkzDWoAq5MTXIgorcM0LNQgtiqllo6SnUAgKQq1Ar9JF6xom8AqFUlgF2ILctn0DuSS4BeWO1A3kIdR2KiyIHPMlRQh0psAwuDQpMwhgGyTnJpYKTIbqo0GmTpzhwLXJzC8wiT7DPjEchmcANHBOEz6IoikAeGCCBPh5dLuXQoqQa3zaZDdAXThA4YVo0qAQnLbSc5eaOkyE3j9AKWH/z5vbjv39+DLcPX/76+5cv3/z+8Y/bh3D77vPz/OL2/RZgDD/cvg0/ZYSI059v79+Fr54///oxyl8e5eu3bz1QMo4dqhtQJZIbKi2oYUL5o6p3qDIDfAmVzqJ69+kfYQn6URCxqEeQmM7iURCY3H1QxcSo1wKx0hUTOwJZObcH0y4FwlayY+qXQMjKTSRHbtLYR2MyQvlVjJxWHFtIWyWZRzNV5BncAi08wUqfx6mEeyK28jaPQ1/a9Kjfk36fTZJyvBQMmTnPHvEdQNgEcYhvEruBTNpfgpSz4Tx9ev5tQ9nnUpqzGvXIRkuXZFjuTJMJ9rqUjmA1Klg2wRyWcQRLCmYKslzzjqoqt+d/8aRxt1XToGPxeEhbUtCZkFX5WZWfTfDqsey+kmpOm+rhfywQ5b8odcVManVQl+MCVSMoZh6qw2XyIakmCDu4OoKYE5sdwj+CmEbMDsKPIGZZYYfQ87IYNlPPDnHm5TBsmgGPayCmXprDu48g5uRvDo/LdYGYKW6eFB9AzBS3a55WbBDHHCqrhTGTMxzJOfqhlRxUlkseVq3kpNNO9dGrqmV4ydWjLq9iqxQmT4968Ca27AR9miM5+3DMyofi7cBYXZ3lA8nTgeVdJLIc3IyWZ31XM1cvp3vf1bRgN5M/8kz4JYeuJazNl2j91spLs35u6915NMXjae3yEs/Q6tkm+LScME1Dth30qtbaZs0+NGWOV+7JkaXqBJujncwFHTPdy3lTgrtlxzD9119Zd2E2y77g+Q5NxRX25EAWz/PY9ThUEVGPphKyQ8B1b5a7OQk8DXfZMWTnagZkg3kskxaYKsJcy0LDDrC8wJRKcz0KdTqo2iMbtj4cE6/sRZJ0ppFOtTFlP8wJdrrYuEPXBZ0VehKo883c7UinK4/7OiYtq5w0lmjVs+Tp7+uqzt0E8fSTRxBTany6PHsJof1tV7fraj3d1Ao7rKcePN0slZ5W9QBiK+60y3x6CaG1ZagVquDS0MEPHfwwjYsdU7euqmJrjT2ZPYCYzJ32ok//h9DNvvtO3QOUJ5N9gZlK83SkRxBzgrfXM3mAMP3Q048uzVMyMzQcjPBeVs0VKwT2Okbba1wx+RinfLzfINY2T1QrNXfnIOhLWPfOx1TMOCs6j1jqw2T63DibDY9YWgzJFKFnIbG8gMztQvIsJNpeBKtFNiaaA2OvyuZahE7XIkrMYWOtKjGWb2GuXMLSJoEs40c3dglLezayJho6uktY2veR5YjoCi9hae9o7tKis7yCde8/zS1SdKdX7J7MJTJaW4egdlsz90DIsy5t++wwNx7o9GcPJWaVrqSOZG6D0umvH49Y91WKZfvk+RXkUDuyPThHYW47SDOVkxwW1PbSYS4k6fSHlElMX0v/pPZqLr3J8YOK7rtNYsyp5dkDOICYBRGL6Gsg5mQiR3k/gpgTgTax/Af8MzXODQplbmRzdHJlYW0KZW5kb2JqCjQwMyAwIG9iagoxNjAxCmVuZG9iago0MDQgMCBvYmoKPDwKL1R5cGUgL09ialN0bQovTiAxMDAKL0ZpcnN0IDg4MgovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDQxNyAwIFIKPj4Kc3RyZWFtDQp4nJWYb2/bNhDGvwqBvtleibzjX6Ao0MQdWgwZirTDgA174SRaYSyxi9gp0G+/55xKcuubdQ6QiBHJn47PPaRIUfDOOwrB5YYLucAVV3bkC67RUcm4Jscx4ZpdlHuhuFjRJlSXEuHaXCZg8JsrOBRcSeAQuUrgELvawKHoWgaHkgueAaDsQvAgoFUIJaBQXaAorIZYPGDsUSigcXAhRuAYYSbEQkCEVBEQRxdyApBBLngsMcilAcgg1yQckBsJB+TWwJHHeIknBhkzukcJxeO/uA8OvaLQWRpLOy9/8OBYpDHuJukaAc0SasRvLnIb5CI9EqqryCky1Yo/EmWT2yk69qJagrpeZEvZcUjSvTgWkQgiMjXp3hxzDvIcpILkOQEFGUUmx0lGkdlxllFkkIuMAne5yCgyyFVGkUFuMooMcpNRoDp6GUXxSK6MAmmIQUZRyMX9uNEusoyiRBSqNE4uRhku7BFTkMbwRGpimOpiFkkKyFmeXkGufq+Ei42lQC55hElwUQoyCmQxMexANbkUJV81o9CgTy3iMukldtsL2VAQA6I6ZXEkMp2yhNpAzuJZqJaKmBgxpSKubiDv1YAV0z4ePBgY4YBcRcMGcsVt9iA36Mxol5qIDZumBip7dtmTJC2iILmCoFkyyD67HEgaFxSSNK4oVGkscwRCvXzZffz6uXfdh93j0+3uzX3/0H1w3WL1pXsPE8t0vO5+dX+JBVH8u3u3cD+tN3e9lx/Mj59fvToDElVIM0BogiQNwv48SFYhwQDhCVJUSDkPUlWIRdg4QZoGifEsSPIqJM1DMJO+QVgNJBkYKU2BqBlOBl3rwWjUDCeD1+pBJGqGs8EmNU8QNcOZDZAyQVRhsyU5dYDoLsnZkJxpNFl1STb4tYUJEjRIMczhNs3h5+l8BCEDZJp+WV3XimHmtMlrWV3XikHYNnktq64vFmEPsqO6vlqEHb2mJ6caTJ8mv2Z15tR505Of3hdZnTl13vSyaxohquvr/GpCfvTa/zAMuUnj7JMtjQJp87khP7mkqMlp86bH3nKAFDU3zZKbMcFFTU2bnzfkR0WKqmqzpLcNjKqLOj/1KIw+q7qmBoeE0WZVXYzavEPkmDMw1GWkzb+y5Ig0MLRVBPtHA2Ncz6q2iGA3aWCMRq2ax7ARNTBGn1bNY9j5GxijT6vmMQ6WndG0qhYtuUyWLecBRHvTMFm2nNOyWjSLMBn2EocQ1SNkmLthnHfqeYDJkF8a5526k2fDmUKO9AND9arhSCGfAwaG6lXDiUI+JQwM1auGA4WcrL8xkqopG/xOo83UvTOzIbc0GkTdOjMb1mUa13Z158xsWENo9Ji6cWbD+Uq+0gwMdf4bjlfygWd4+2vvGGaDx3j0h7q742jwB4/rsrqn4mh49/PoMXVLxdHgMZ7e/apPDQdF+eo1MHQ9DP5IY16a9t7maPBHGud+U5f2aPBHGnPb1LEkw/qRxtw2dc6l7/3xy2a96z483ez2/8m90F0st73cd93b/v5Lv1vdLrs369vN3Wr9yXV/rNav19vVcMMO+3P5+Z8Fetwsd9vnXrdLhwZXrvtt8/iwvD+N8geo1/ufF3Rx/XSz+vcFLa76u9XTw0GU7+769W61+4q6t92i397267vleifdt1ha/Td9P25+X6/Qp3fxeTNrj+FiiOHdetc/4jkXm/u7MyIoxxHU8yK4/FGF6/7T0/3y8Ywg2lEQz3tYexCLH2U4O4gQjoOg84J4MwTx2G+fHnpQ1tszAuDjAKIawPcOXLzFE18/rh42B8P+IUZ7EMeODEeOvLq87t5/cs9L3tUlZrY/XR1OV9Ppaj5dHU9Xp9PV+XR1OV1dT1e3GVnmZJvRLcwIF2aUCzPShRntwox4YUa9MCNfmNGPZvSjOd/N6Ecz+pHo9x9yf0NODQplbmRzdHJlYW0KZW5kb2JqCjQxNyAwIG9iagoxNDM4CmVuZG9iago0MDYgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCAzODIKPj4Kc3RyZWFtDQp4nF2Sz26DMAyH73mKHLdDBaQkUAkhtVAkDvujsT0ABbdDWgNK00PffsI/2kk7APqU2P6MHRR1WdvBy+DdjV1DXh4H2zu6jFfXkTzQabAiUrIfOr8Qv7tzO4mgqMvmdvF0ru1xFFkmZfBBp+Hi3U0+bfvxQM8ieHM9ucGe5NNX0TyLoLlO0w+dyXoZijyXPR1FULy002t7Jhlw2KruyfrB31ZfRfN34/M2kVTMEWy6safL1HbkWnsikYVhGOYyq6qqygXZ/t+5ShF2OHbfrePr61xmYajCnClmiiOmKAKtQQkoBu1AmkktlIL2oA3TejnbgUpQwRRvQRWTNkwaLnoDUiDEabgYWGu4GJhpuCQpCC4JXPSWKVVMBv2lFQg5N6hnkGUHMwPrHaobWBfoyMC6RPUE1iXiEljv0VECz/1yhgqVBhke1DIRdZ/PY54K1xQyxQb/bX2fBX/KJQWC5rHP6/nYqe7qHFnPO8x7NG/QYOmx5tM4zVHz8wuQkcs/DQplbmRzdHJlYW0KZW5kb2JqCjQwOCAwIG9iago8PAovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDUwMwo+PgpzdHJlYW0NCnicXZTNbqMwFIX3PIWX7aLCP9gmUoRETJBYdGY0tA9AwMkgTQwiZJG3r7jH7fwsQvTJvueeg69JXVM1YVxZ+mOZ+tav7DyGYfG36b70np38ZQyJkGwY+zUSPftrNyepa6r2cVv9tQnnKdnvGUt/+st4W5cHeyqH6eSfk/T7MvhlDBf29O7a5yRt7/P82199WBlPioIN/pyk7rWbv3VXz1Iqe2kGH9Zxfby8u/bPjrfH7JkkFnDTT4O/zV3vly5cfLLnnPOC7eu6rovEh+G/dR3LTuf+V7fQdlmwPeeZKBL8EUnQDqSIdAbKQDVIE+UVyBKVUSUnchq020jwqFkSiRzkiKQCVUQZB9VE1hBpDjqCyKfIDyDyKXbooMmnKNFdk09Ro5+htFIhgyEVmaGDIRWp8V4MqUiD7IZUZF6CKK3cxTVKK0sLorTSwZk5EFXIZyitrJHPVKBYd9xI8UiUXSmoWMquMiSy5FoZaFpyrSy8WHKt8rhGrlUZ1wwIb8JSBnVAdkuulcNpWjojLVCnSEVn8Yw4CGs8kv6HoCIpg9aYCVmBjn/vtMgnHciBjiCckYKXOFmoM7uoyWnU40zLzwn/vBGaUzPNoxJ6YvK0wLCoPEqgaLs42wX/upX9fVl8WOkrQDdxu4Nj8F8finmat6rt9wHGFgp1DQplbmRzdHJlYW0KZW5kb2JqCjQxMCAwIG9iago8PAovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDM4MQo+PgpzdHJlYW0NCnicXZLLboMwEEX3/govk0WEcQIECSElJkgs+lBpPoDAJEVqDHKcRf6+Yi5NpS5AOpoZ3zuPwFRFZXsvg3c3tDV5ee5t5+g23F1L8kSX3opQy65v/Uz8b6/NKAJTFfXj5ula2fMgskzK4IMu/c27h1zsuuFESxG8uY5cby9ycTT1UgT1fRy/6UrWSyXyXHZ0FoF5acbX5koy4LJV1ZH1vX+sjqb+y/h8jCQ1cwg37dDRbWxaco29kMiUUiqXWVmWZS7Idv/iOkHZ6dx+NY7T17nMlNIqZ9owbUKmMAFtQHtQxKQjUAyaY1umKGaK8GZUgNZMMfQivLnVTDH0tiUImSkUYmSmKQjqO/iME9Acg/rOgFKm/Q60B8FLbJgMXMclU4FuE7guUJdo0AEEZwf0l8DZYc6EsxKuE8ylhJeEvegNFLTh1cw70L8beW4wVJwWhpgpHBjMzcyNF/MTKJoWPR3k84rau3NkPV8tX850M72l52GPwzhVTd8PhnzItQ0KZW5kc3RyZWFtCmVuZG9iago0MTIgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCA1NDEKPj4Kc3RyZWFtDQp4nF2UzW6jQBCE7zzFHJNDxPwwM1iykDAEyYf90Tp5AAxjL9IaECYHv/2KqklW2kMcfe6Zrq7CTVod6+M4rCL9uUzdKaziMoz9Eu7Tx9IFcQ7XYUyUFv3QrZHw2d3aOUmrY3163NdwO46XKdnvhUh/hetwX5eHeCr76Ryek/TH0odlGK/i6b06PSfp6WOe/4RbGFchk6IQfbgkafWtnb+3tyBSXHs59mFch/Xx8l6d/p14e8xBaLDiNN3Uh/vcdmFpx2tI9lJKWYh90zRNkYSx/69uPa+dL93vdsFxXYi9lJkqEv4DadKOZEA2I2WkhmRBeU3yoDJ2yUGVJe02UjL2LEEqJ1UgbUg16UB6BWWS1IC8A1kJynnSYk61o4LFnKqkusWcqqKe9SR6sJhTNaw5JKENaw5J6Ix6DgraMjMHBe2Yi4OCzqnnHKkkQU/v4kno6dKTkIuu6N2VJDpyB1Ada0hJN0zC1aTYBSkZGQkpGcMuHimZ+Gy9InFOD3/GUcHDn/Gc08OfyWMN/kwZa47EzDz8mUNUyEnMzMOfqfgL8fBnFRM0hsSexpL4/Azu2Yz3NBxZSwVdkza3WmpNekVNwq11FU9iMuuZhK5IsYbM3C72lCROVkqsT9wT87k1n1umPMZSnpoWmVoJsooPyHAQ5fgln4xxsS87bRu6vUm+1r/7WJYwrnjdYOW3ZR/G8PVGmqd5u7X9/QWRih9FDQplbmRzdHJlYW0KZW5kb2JqCjQxNCAwIG9iago8PAovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDI1OAo+PgpzdHJlYW0NCnicXZDLasMwEEX3+opZJosg2W1aDEIQ5Bq86IO6+QBZGruCWhayvPDfF8khhS5m4DBz53GpbOvW2Qj0I8y6wwiDdSbgMq9BI/Q4WkeKEozV8UY560l5QmVbd9sScWrdMBPOAegnjnaJYYPDxcw9Hgl9DwaDdSMcrrI7Etqt3v/ghC4CI0KAwYFQ+ar8m5oQaJadWoMu2ridrrL76/jaPEKZudiv0bPBxSuNQbkRCWeMMQG8aZpGEHTmX/28q/pBf6uQuosHAZyx50IkKlmmx3MmWQngL+yp2knuVGdqykwVy1tu89K+5Mv9Gb2GgC5m8/ID6XTr8O6vn31SpfgFXXN6kg0KZW5kc3RyZWFtCmVuZG9iago0MTYgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCAyNzAKPj4Kc3RyZWFtDQp4nF1Ry2rEMAy8+yt03B6WvFq2hRDYZlvIoQ+a9gMSWwmGxjaOc8jf15G2KVRgBo1njDxK6ubSGB0gefdWthhg0EZ5nO3iJUKPozYiy0FpGa6dIJBT50QS3e06B5waM1hRlpB8xMs5+BUOZ2V7vBHJm1fotRnh8FW3sW8X575xQhMgFVUFCgcRX3rp3Gs3ISTkOzYqCnRYj9FEElJ8rg4hZ0vG80ircHadRN+ZEUWZxqqgfI5VCTTq3704sa0f/vRF1O+QpxWRT0wy5I9EZil1V8gvTLIvuyUo2J7dM8lQ3DF5ZpKhODFZM8lQPNDQv9PRB7ak93jk4n1MhvZBkWxhaIP7ypx1m4vOD69AikQNCmVuZHN0cmVhbQplbmRvYmoKNDE4IDAgb2JqCjw8Ci9UeXBlIC9PYmpTdG0KL04gMTAwCi9GaXJzdCA4NjMKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCA0MzQgMCBSCj4+CnN0cmVhbQ0KeJytWdtuHLkR/RUC+7L7YA4vVbwAiwUkK84qgONAXmQfBnqQrYkyiW6QRkD89zmH3S2NZHkrgGPAFilWV9c5VXVItnMMLrgco8sJP5Irgh/Z9YIf4mJq+KkuFhoVFzutqkuJZs0lpV13qcEuhfkvnCnsEv422KXsBM9mPCNCO3XSaFecRtpVp0K75rTSrrsSYJcDooFdjq5U2CHCGmCXs6sZdllcLbRT1wLtimtEkatrhJGba8SRu+vEAV+dOCS6ThySXAwEIhkDIkEUMRCKAHIkFgHmSDBSMSAaIIiJcKRjQDwayBOMNbpIDok+0llWeM7EpPAsBKXwLESF90UhLIVnJS6FZyUwhWclMkQL5mFc4LkQW4HnQnAFngvRYRIr4RV4rsRX4LkSYIHnRoDwFRsBFnhuBFgDcwnjCs+dABFK7ARYs0uBAKtgQIBVMSBAIEmRACtKIBJgRQ1EAqwogkSAsEN1wLhFDAiwJZcyATZ4ZpZYFYlB5QbPQoANngWJzQ2epdAGnqV3DOBZib0H1ptiAM/a8ThApoLyyB2eBy0dnkuvGMBPRQVl2KUKtjJ8pQrG+L7UUGQS4KeBUQnw02AoAfF01JWEyrqKGMCOMQtaRCqIEnSHNtS4oC+0Ix5BA5QIuAJCC7MnWC6C/vn559VvX243bvX+7cnqbxeuodlOMDk+AoJffvnD9WKsV2O9Gev9j9dzMNajsZ6M9Wysi7Fu8JcN/rLBXzb4ywZ/YvAnBn9i8CcGf2LwJwZ/YvAnBn9i8CcGf2rwpwZ/avCnBn9q8KcGf2rwpwZ/avCnBn/F4K8Y/BWDv2LwVwz+isFfMfgrBn/F4K8Y/FWDv2rwVw3+qsFfNfirBn/V4K8a/FWDv2rw1wz+msFfM/hrBn/N4K8Z/DWDv2bw1wz+msFfN/jrBn/d4K8b/HWDv27w1w3+usFfN/jrBn8xGATGYDCIy4FlYHAYg0Eirh2WgUFjDAaPuNBYBhaT0WIyWkxGi8n4jMkPh385WX349C9cg4bNYvy6jXzT5t3N9W78c7S5/3y3vd3d3I3TOu0Pz+43XHKrg/Hnh3R48vBp++8f0tH7zfn24Wr18eHTbrhBhLSkz8TJbzd/Pj56f3brVsfnm+vddveFv/345X63uTq+/sfNuAjwHb+7dXDr1Dnjtahh15FT3M7cujQ9xSXIrWvIblovKZ/iWIq1wJtuPMUZD+t5Ws0hnGLTx2rmA9qwjgveukUa11NsGFjr8Iq71LqU2WeVxbvAe+fzocy/qpHBIFaYZ474YIIrXEPdWmvDiM4U154BoBTEHLjWYZ+QnXWJ0wtAK/HAl+BCtgBK+B3u0vClp6ero99x6klmglJ8kaDDJUHH17vNHRJ0eHN5/l3pSXvpQZN2X6N2AqlSfSs9I/Cig0ZMiwB3ZS40+ZhDATG4wq5rqh433IpM9EFF8lrhDrRJxDIeLpozaSycS/Gh4zaNOa6n69SCV1xUSSpfpqX7rhWP82sCptVLjYUc4sa77lF8nd7Gzyzr2qLvKBXOR+4ROpYT8sAr97po8QnvyiM2FY87ryJtvNICWPM5ZRYh+QaU7iWMWPktYq2ILakSKXLHolOfekuc07m26rPWXlmT8mwdNLBAKrAXvr9oGEXrYyFUViaqTDxu3LWzhhEOwvYh1kCeWVWobg/riMcrm2R/HcUILoA9x5Y4J5wUfQu5c32EG7MvGUEhUYkdlZOXQW1jg0lovubRQo09pCX6OoXTmNjcmpcurILWn7tHaTA89UzkXOdNg4/oeTYYwS7LmNbRSPCeE7mKaZAF9wm7S8QlqfssRfFi1BWJEUFNxLS4fizAMYoTo5Ffo1C3eaoffsnoqKzQ49OIVloJBUUVhczH8RmJtSLIfuWHKPZyDgkWkZ9QkDTEnqaOfpyxnFnPyJQvbZRvaZinDFZaRwGO1g52Y+cXjf32pfKebC4eLs/uvqu35TXpHQSORmTtV0xm+UUuFqqDTvKrLc/SG9OspsIWp3UKk4hqZTaFo74orI40FnZPHyQNsa1zAGER05jn3zBH7E1+kCtUjUlaa5qldfHMz27zG0KbRTbvhR0WkVU+yfZQ6exTNo60WXj1f8iPvsjP0Uvh/X/kp+zlp3fxaOPYxlZVIK6jZ4f0oqmgP7HN0vuktUN6Iyt40l3tDeIQ+eCku5I8mpmms+4GH+AqLbpbID5B9FF3YQ/BGBUxCS90fBZd1Pew5XbHvHMHaJCPtogwlAMxF11EOIuHcDBqfgB9Wsd9+dHTpMgZct2EJTYpMqLAstRFkSVC/oecI1RQJQ1KMN4kJT+znxS7ZN/xgroodgpQnUb7SbEVojPPhwg9rU+K3ZLHdNDPasrQm9pVZFFwKMvQtCHg2oOnzKRJwHEAQV0iQ9hG4yzhULKQB75JwpflWcKxy06pnyWcopmm7WtIuPbi8RYyTQlvOPXMIUwanrElwF3oi4antGx/k4aXpy1gdCx2tF6U/iYNx/bY5tIbIh5H1vvoJOSqLht72LNdFB25iX1kGYqOBwQlJa0xzUF9ZDGxonOZk882rdjckf7poIeDAjZjx60hAHXc/+2jdOOtmlkcU4SCjJChScrrY6EOSV8/W4U6rBM2LZ23giH0CfrNM0BxqerSW0PK8Q+/gEeeFygW5fnH6dfFor4Qiz8tYnG3uX+42mw/31zff5dQTPcDhIOr3Nfi9brn56f6o18RzsHd9upmT7tevma6DryEl/dP8FWhsYNBMjaORzLtJTkzXX2UCDSWkiJjQm1ZBm0anD7DPR2Tv7quPMUwpn89u9p8+4by7vLs4t7J6uD+MzhEXeuKz3P8JmlYfQTKv/P/klZvz25/3Wwv/rlDq4bV8e7scvv54PricuPCeM/h4c1/3PqN9IInUQwx8n/LcH4fq++2l5uEiNNTxGBze7+7++J+PDi/+bT5afXh7nxzt72+cD8uCf0JObq9vdxcMZ6vEvgq0NdP+i9hjtPLHtJZKduMV9XjVMT5Hupl+/g2dojhJBjuTY446aAv0SnYRXGg4v+khUnycAZ9xkmeOfkv0MX8sw0KZW5kc3RyZWFtCmVuZG9iago0MzQgMCBvYmoKMjI5MwplbmRvYmoKNDMxIDAgb2JqCjw8Ci9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9MZW5ndGggMzEKPj4Kc3RyZWFtDQp4nGNgAANGBmyACYiZwSwWBlaoGBsQswMxBwAB9AAlDQplbmRzdHJlYW0KZW5kb2JqCjQzMiAwIG9iago8PAovTGVuZ3RoMSAxMTI0NAovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDU5OTIKPj4Kc3RyZWFtDQp4nK1aC3Abx3n+du8OjzvgKBLgExJ10OFBEQeKJgmSIikJAviwSFniQ5IBWRIBkZRFvaNXJD8U2ZISmXZst2niOJM2maS1O508FpKdyCmT2MmM0jyaaR5N0rSTd9NMmqTuxFbT6Rhs9g4EQYlS7Da3I+6/u9/u/q/99z+cQACoOA8Bma1ja1qm913+Z4A8DSAzcTh7TCHKcwD9GICvTZw+qSU+UvZvgHAGwM/2Hbv/8OnJR84ByjbAXXV/9sQxAMsA/AqA4/5DZ/f53lvXCtQcAjzn9k9lJ52vfOELAEkBaN+/fypraxK+CpA2AIH9h0+eGfor2/cB+0OA8L1DRyeyZx868VtAegIgvzmcPXOMjqs7ALwGQDuSPTzlvdA8BIi7ANJ87OiJk3PfQAtAvHz82PGpY40H5bMAeRXALAjI3BzKwGW+gSdgx2lIoGhENx7/PQd/6a6CAAIB5jP3db7WEg8BhOfnbID4fH7ZXFg8aa5Y+twweyjQd+K3Hx4v63kdgvALPvCt311cy+tvG/8TzC/L/1w8KXwAgJ1jzUekveQ1SACdoVxLQ1ZN9qCFdHKAbREfC8/2oXu34GVoOG3xJuRIqwZ8mo9RB53lGoELQ9fwd6OpHCFPphl5yQEHJo7lYE986nC6D7qERt6IuzKOzY5OR6NUY5ccha4Dth22hO0uwS+ZXa7E52rinrgal1+2xSHB2ZhDeeJziBeL2SegNxcgl0dSLH45lRMme3Mh3vqM4zyIGL88sS3FIel0Oh137XVscXQ5DKnOLrkar5G5S0x8d46i96o0aUNvr6VR0zpe0068FnENQD2WQYAKDRuxCcPYjhR2IosJTOEQjuE4Ts/NmRrYiCSGMFoyfhBHcRwn5+bmfjr3xYIyNQTgh4E2s7W/qOs6hNBconQDTYD5rxzV8CGIECJoQjfWIYleDGIH0tiNCdyPz+Cz+Cq+i5/jl3h9Sb+63XMZlzGJSW5D6gDmEkIu//f0+twNWjF3w2rhDM7gIA7SbmDuojnePXfDohbNv37TCj8rWaOAwwtzO0pxeGluhF6/FUdn8bHF6+FjhfUCJo779U5uKdEJYBjvLNAENThSoClUZAq0gCa0FGixBCOhDjUF2oYaAKM4hb2YxkFEcQ+mMIlpnMJh7MAUjuMEpnEUR6ChBU1oNssC1Y3tGMK92ILu264ziincj1M4hCyOl6C0RagkjuIYzuI4pnE/9uOkuWMz7kIMGrZhP6agLZo9jOM4igOYwoSJ3ohTOIn9pgeeKLF4323L8yXl11YhHUuUM+RH84WGzbLltuVZ+iz98kIRaoX7SsonblP+kxdxoFA+VVJ+ZRWp4Q+WkyXlmlVsa29bPrBEef3/W+x7zfKhO5TfLl0cJ81ydenibCyUR5csnwfIqhKL/wygn/r9TfwWH/pxxJbs/zy2LGofXdy+7Xo7sYV+Fu239H9/YT4x3txai+aftebQvqXnCga20C8uPUY/fSs/d9zrzxbWoR+5SQ8XEFhyzh5UL2p/BXe/lT2XXPMZlC/ZfwLhRe0eaG957R5E3xQugchbXfuP/dAGJOdpIi/Qb2mNkTcnbxG/r2TPjyLxVuaST5o57MJaR7DuTe+7AbUMhsawPdWX1rSha1BHhphtbGeKtflYQzqzT5vZnmI0mLWSrwl9r8/vZ0gzJPXeKyBIZhJRRgymZfZFGTW0SY29PMzE0M4rDURO9k30MVtfys+EYHr0vpRf9/tmUhobHk75WTzt01gnpzrTaS1nobOTrGE45S+0NNbMx5s58uXhlLZPm5nJakweTmV8GtP4mMypdk61Z3yZdDrtYySSTusMw6mpdDrKBEPr05gYzE5qTEoOp5ikJ5hNT/j8/jQjmSgTDd2v+7XJnLQ3ofERzrHP4oD/ZVKmb4IJjX6N2ZLajDbDSCTXLAWZGBpJZYZ92dF0Sk/70xqLj6UYifi4aIX9o0wymD0ZuQJqacpmMLue0DUGPZFldO8+RiYYyTCpMcrshsZZVZIT10Ts1fgKLJ5Jc0im12TVYVyxK0j2JRr9Rd07jcW2kK1VSERnSDIxmNH6ZvQst4upL/i4TpnmY/GilpgQ1LO91hbKbaazwHCKT44vNcllmAJdUWShL+X36f50oz/K3EaO0j42me2NMtVgJKNpzJUc5NM15tITaebmrdGUxtx6Ih1lZYbGlpkq0a6JmJjRs0xNZrSZjMZUPaFH2TJjaFsqJ072pgPMPaWfibJyY2gkNTRmdfr86QDzmP0VRg5lye2pXFlZkpFsgpVFuM8yGkzkXPyPmwYTjFTpGhOCw6kcVx4Tg4mZGc3cttGvM5Kdp33WOJ9Cg2ZPmrmSA8ydHMgwuthUtzFgDvDovYwkGdZfIYSYtvIYyIH2bUuxMj2h9TFFTzBZZ1ImoWUYyb5YXk6gIpGYyeQqbBH2WMS3Kh1lXiMHTyTKKo0c4XWVkaO8rjZyAq9rjJzI61ojJ/G6zsjZeO0zcnZeLzdyDl6vMHJOXq829Hm9M1tmaFtK15oY2c0PSJQ1lgxWFQffZg1GSgZDxcHj1mC9AeaO/B/kW2nkUB+JMs3IEV77jRzl9SojJ/BaN3IirwNGTuJ10MjZeB0ycnZeh42cg9cNRs7Ja8PQekw3jRpahpVntKTOSCZpmpJkmMF9tclg0QiLNkbZGkPTBrTbWFHPduo8It4R4ePSNxdNS6rYmsacRCr7Us1pU8C7SjVz63CLocVMflsNMNJ36yaMRJbcnPej6gUztPeu1ztzLaSSC9dmaD3awG0YZkhmO6MsZjRV90RZ+x+CMpKc6IyyDiNHURXUmrQBfvIZDW6amRnQB/Ssltrr45FVT1xpJ6TS2xhlnQZDFVumJ5gYZGLQhDFnMjI106RrWs9MZ5StXQzRmqy1mKgnOFJjGR404iOpq1QTNN9VGhLq0gkeSB1JbUY30Xp/honJm89jhgcz696gycykzoRkdnI4xWgy62NCMsMD2c1zsrqmMTGk92c7fTpzJPsZDTJH0twloy21iW6FTDGZ4UaQglkm3bIqE0NcoqDJRDAzOWyFyoW90lHWNa8HTdOYFCroQe/pjLLu4hBzmOP9+gDflFuvp6g+LkxBw9iWatJ6dL+Pc1/o1Dhf8yawBZkU3FR6u1vGW8qtC5bSuW+vK+EkOW+qDE8BbhZ53rzrDV1r4lrsZ8uSqWHfaDql9aSbck3EG4myDYtGR33Di0bjS86904yNBuuM3GnDhMHWRmY0rYf710zn7aFMTDaxpkiUJU2RuW/O24S7pa71aE16Z2HVXiPnEIOJeeBbcOKBP5bfcil4iOrRO33+Eg/xpws89hk5dEbm9dBv5LA24tcLmihIUhR6wGCotA74FfCz7GlibY1Rdvdt+jcZORCvh8Uao2zQYB2NUTbE9dana01a/4yendfUZoO7MBuKRNk9xhWgNxJlW4wrIJzYalwhZs+wcYWYPSMc0xeJslGO4cQYx3BiG8dwYrtxFcDGSJTtMK6CmNS9xlVi9aWMq8TqS3Mc4dROjjOp+zjOpHZxnEnt5nsmI1G2h+/JiXG+JycyfE9OZDmmPxJlezmGExMcw4lJjuHElMlXIhJl+0y+OHW/yRen9pt8cWra5ItTB0y+OHXQ5ItTh0y+OHXYyKGraMAjZoutj0TZUYvcEImyY1zpZiseibK3GTlSwBy3SI45YWJIAXPSyKG7uOops2XOOG2RfMbbLZLDzxg5UgCctUgOeMAiOeBBI4ee4noPmS0T/rBFcvg5i+Twdxg5UgCct0gOeMQiOeBRI4d1xfUumC0TftEiOfySRXL4O40cKQDeZZEccNkiOeAx46pTpPPJaiLCHFNMCAyfmb+Ho+avt+rv3wb/ms6iGnW4K95UR0QolBJKByGCEpHuA9A1JAmUkG6yGaitQTUqK2Ixm7M60hKKdXjaW1tbqj3VXpuurwqH/XabrntahToXfVWuO1Inv0rdjnSloyn/vSZHZfpLP3mby+mkl2pr33jQ6XR5zp71EP61gSA2d4NeotfRhJ742kYiiGQQhIqUiOcgClQUHgKlGOeeNgRBkMZtRJKS0mbz595oWyjQ3mB31kaqQuFQrK2jvb21paqqutLkKhQOhfRVdlult7qqtaWdD7a2VNlVqn/zGYkQ6f2PpS9uom5H1uUSywbXPWUjxPZUz1CZ6HJlnW5CN11My+9+1Ldu/fLzT607kKAORVHXt37Y19m54sOt61XF5UwcWMe1uQWgj9FZlKMeRnw1BAG7Lf0RSslukZhK9FQAK3wV9Z56lKMsZnNWckWWt7W3tmqeqkqv3WbT9Q7OZ6yNc66X71LdymskbKNUfOq9//3a2CCllG7Z9oAq08cVNf9ql9fT9cSlk4M7esqWdY3ekzdATF7idBY61sQNUAgiFaZASIEjiKK0m6uw21ShDr8/6A/GuAoLzPhbqiq5/vyVS1CcI/KSoqpK/hppMeuvk2Gz3mBxpSpJxf1JVdmguF90K72Ku8BTC51FPVbHQ7fyJBFR7BY3m58PlnNubM6aO3HDjWsyctXc+GVimPW3VWXnPA93y+qsKt8tq/8lq/ybQfvcDfoEvY52dMZjIFSiRDoHCaIgiVOLHMw2bic2W9LG2WlHLKY3BGINDmfdTR5W4mA2y8O4i8Vi+qpQLNZmOhrn1qb/47MSIeIHL++61Etd8rQsi2p/T/9WSggd7h/Y8YCsqvKrijp4+T75yXesiMdXPPTuDbujTpfDGWwb2rqiu6t+5J7Nm1eqcgdHHhh7MIGCRp8wrRyOB0AgCkScooRr0yZRQegWCtb1xFo9pdblfJX7i5QlRqzcXz6v1F2KSgKqvFtxu5Xdspr/F1XZNa/V/BwhvH7jFOeFKPnXLe3yX/Z+QGdRhtp4lWlSSgpxA2Vwx4QSV5/fdZeqyhm+SUaV6ROceONkcTV6mM7ybzhxXausUEQKMkhM4USBUtpN+cJB6N3BmGSFo/mlKzus2msnpGo+CghF4XYq6g/LavY53FL+VRIQXY7pygryHyV+88v/rHA57VL+m/kX7Tanq5wQRz4vqyU+7MXK+HLrKBFC9whknh8vKvSY6KxarOmFg6PKexQ3WWfq8Z6izN82vbSwPtdhCE3xiL9OFgSQQQj8tNBzlvCSWBQ+hEAs1lZ6UHgw9txkVcGMzQvij3iUV15RPOZ53SGrjytVjZXux93KDkt8T/4DZJ+Hm1dxqzL5RP53VVXEkR8t8neazmIlAnF/nUyXtMlKrIjFFtukmix2tjApsrPFI5N6t7JDUVV5q1fO/7TISXm+l7xgetppRS0nV/LbZRXUPMUX6HV4EDbjbPHcSkQQyDiPs0my2esFvGFvqH45PKho4HG29OxWF0JtezHQLpzgb71f5If10sU/FykVn72c3CJQKgxvTAzz87o1Kc9cXtG5dsWlJ5+81LXc13V55uTwWE9lddfoyMjoirbW+tGRwm1wis7Cg+VojkdtRAChApmCKJZcC910c6UX8NV6l1dyRssDMfuC83C/4Woy/5CW9lhbSNcrzaDnOjszc/Y9qpIh9q513T1PWxo7fvjQ0V8qbnK8I9bW9f0CF+fMmBvmMc9NqEgG7cS63acgSQVebIUrXlsJhAIrw1qYR2FPV8yxYEWLG3t18USFl2JMePDx/g1/Irgdu5ZV2M8/piq7CHp6enoeL3A4vWmias4mOV1lrl+/KqvkgVhra8c3+YkPzN2g4/Q6OhCPr1tJBFEgBHQQgghRwDmAiCAPQRTpOChN8JNXmgd0oF2PGYGYlQeEwpa/FSJyW4hH6Vhbady2jF7praqqrqdmlP7F+QR1Oe9TVJs8sL5/ILDp7tNH4m/fOnZ2A3U5x6scUm9Lxwatd2N6umXgke1ye6rN4Zadq5rWrPYFfJ7lu3Z03dfWdW/E4a7QIo0NvoCv3NuyuXvjeAsI/55BB+gsauGP1/MYTXaDkK4hkczH6VpUB2P6/LGZv0LmY4duHpgb6ksy1/IcPxbX3MoeVaZhVRnizSFFfeOfzFN699wN+iidxYr5vcwwJYzzvZLmXiuwPGaFzarSiGzqqvSk/uB95l0w1Nc3pCq7FPd73yXPPEGeMcPX9Nbh4a3z9BMzIPz7Cn0nnUUYq+Ir9dqqMonaFiJEIUgGugNdohWx2jo8Qsi6J6urizFb8BQ8LBzm6WS9W/zhN0S3Y7rC/afvUbwTDrf4jR8JLufBCvdffNBdsd/lFB2kl7TbbE6X5zvf8fB2/iv5Wd6u+PGPK0D49x26mc5CQzDOv/IVVA9Khd0L+tdQH4qFC/qPtbV3EP8iG9hJMY63uZ02cl/+mmmLHyqqO/9xMsYjeV5RlQH3Mgf5vKr0c830e8vy6908EwGFNneD5GkFGtCC43HFsFOJBIkg0cEhVjOcimsgkMBzEsB08r4hO5EkYdwmWre5z7zmb4JAELpNnDhuI6KYFDen457Vq4HVLavvQgPCsWBbo8NZw08FF6uDn9ZVNpvduh/W09LbImbGxFiMx8Kq1ue233Uk85jR7G+oFUVli9NN1uy9+/QhtzImq1XDPen+yROxoLy6v7F3W5m3MmLU1Ioul1y7Yc2BHfnrPDsIa6szd/d6l1V0azo/49G5G7SaVqCRn3GFEBoigkhvl+v33ZzrN2J1WzAQCxVy/fB8HlZVmofZb87zX7zA4/mFI1sPxygpk9OKLJXdFWpdSwmx7Q83l4mKkpbLCG07NCI/cKih4dADnSNBWXW6QqviiaD/UX9YkVVZH+niWX5k7gatoxVYiQZsiPdAIJQI9JyD2EAEGzFjaoF3SsVxu2URTQO0Bi0c1LES9a16MOg0DRLmYaqY0vJYVeDbjEcey1KVlVcviOTCybc/oir5F+jalrUBp+xKOd1rD/Qf7m5t7ZLPn659+Omnz1TKqqNzU5Miyc6ajc2kh3YPDHRTrvckQOvpdYQx/elV1QqP9oNDrG44Fa8A0MPDw7riFe4bYi2Fka6bRuK13O92W+3FY/y/DAEII9jVcXNCVt6xnhZOd+n9YRIjqiqPyepzgtvlHJdd8tf+1elyZlW3/FlVHlNl+j6ehuT/5kNUEV2y0/nK75wO2WWXv/wFK0/k3xW/RK+jDH2WQC5ToELqWRDFVZqO+swm2V1optNx+Q4ZKmdvGz/a2yxe3MobB/jO1PTlAK1AOXTE4i01XlUWBUoGF7x3UUJSUQFU6BWrltehHMtChYQkfId0xM4vr6vn+UvqoydPPMrr86di3G1pV1usy6xj8pkDhjF99uy0S9NcB85MJeLyihVyPJmMh8PxBOczOZega2kF6tGMU3GPQkREVwc07zKbJNYSKgmF6LOCpybjPFavM8OJGV6SQzYiCBt46PGDj0AUyTgI6VsCk457V64EVjavXBMO8gSiIWAmECV3TGWptKssD4Alc0kGxpU+rKixA1OHREKEw1OTMbdyL7nHToj94NpOU/KOz7kVyzkaBt9x0FVT45p+ZOCniptoF2WvV744GHPV1blb+vlvUgB5hjp4FhQPKIRfSaaRLFkXboB6LI+13fIyUXyN0/lZNJ1iWFXlUUVt2dPIHWLrmnZVTqsy+S6P+KsTbmWTrLavyf/G8tBlAHk/vY4IHrY8dAUo7RkSzRxAIPwMQZJse/gbZ7dt3mU5qOv2ID5O6IXbjafT8TIAEaxuDeqtQZ2/uvJbrfhiWnw7LcrG432x8a1dW3n43qrKY4r7YU4+XL+qnws7Or7rJ6rcLavP8dZzJvndiOFWNljSrpu7QQ3qgI7NL/qJYMYZ7l0eaiqb5yEZqXidVRd6+RUGQsSMNH+Duc0311WxWMB8v1mUptycpVgXl/78AVXeKasH29apcppzNyarHUflM9Ok1owhv34wsZZ4zGu6gYu0eggEtQANUQfqoMc1r0sS5hOWdUMLb3V1qIl1WG914WLG4vG0F1MWm67/+zJplrgdY177xYvUrYw5XeRvldrNbhf5B8HmdHvyHyW77S630ybkm3kU/V/ZfneUDQplbmRzdHJlYW0KZW5kb2JqCjQzMyAwIG9iago8PAovTGVuZ3RoMSAxNjQ5MgovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDUyODcKPj4Kc3RyZWFtDQp4nO1aC1xU1db/r33OnDk8RGaAQQu5DODQNUPjMXjVUPSiyUNFUNQU5Y2KgDxKTRNfiCmKj66mYj4oFQOV0qyssIdmYd2y9FrW9aZmetGeCuLMnq9zQCXTrplf+X3X9f/NOfu81l5r7bXWXmefAQFohUIIGDggtlPAY29MeQWgWgCjY+PC4r7+7HBfgIoB/DV5fGLO4FkPagHWEQBPT8zLAeAM4DgAOT1zUlqkNf5tQN8RcDmfkZqYct+bieEADQRgzshITfQ8ZxgFkPK8b8b4/IkTX/E6A5h8gbsezMxOTjT2v/ufgEYEWpnGJ07MkTaTBKAOgFdW4vjU9s9EjgKEjgD9Iyc7L58HogYgR+V6Tm5qToY0fzaAIwC0O8k2e6tYAhDIZkNrECAtxlI4Igda5agFaUAQmpq8s8LzGkSA/UbrUKBdYf3RH37wGHsVD4W7ckYQP0ufY9OPat39HO52UK8c+e7lu5X9Z4MHHqw/apniMdZR4SeBXeZNkNUjV3XrC/ZIekY+tQbyMrPyyRkEEc5NPVI7tkvpBwRG7soZ23kAotaf7YIG0JqkFQAONO2FT1AjrAAYNIqGDGKTLldoUGx0LNbAC5Ob9LPfyDYC9JSqE2Rl5wVH9VmoVnJV+1b2Ik4D8IQzBDjBC/cjGF0RjghEYyAGIxVjkINHMNlmU7l0RDC6oCf6IgoDMAiJSMc45GKSzSZNAMR/XtPyTfJ6qHa5BwHogq7ojl6IQH8MRRKgeVQTo5miidY4aVpr2mjaaqZpeoMhDP0Qh1EowVq8RXbUhnyoJz1Mj9E8epKepgbWg/Vhg1gKe5wtZRvYu+wA+4bVC1qhmxAuJAv5wkyhXNgo7BD2q1I44HFFc9HuR78vxavNbYI9nm9uM8h4trktoANmNLdFuCKrua2BGV2a2xJc4dvUptZwRJvmtjPs4dTcdodT02iLdtRO5T8IqUhHATKRiFzEqvss5CNetXc6MpCPfuqZVOTiPvRCNjKRgiHqcR7GIBtZ8EIg/NEZ9+Mv6IZ0jEE+7kNnJCIY96MzzEhFZyS14OR1mVPLJwchFtGIRbdr9nlpf+Vab2QjB5OQe1lWLwSgs/rzQhwykAqvn/Q6ELnIxlikIlm9OwwFyEcGslVtvHCPyiUfOchDV3RCp2ZtMlCAJPgjGdkYj07q3eORh04Yc5n7nwH4wx9RfyjmXYXaa6LhWiDd/yKG3CCybxGm3iZY94uoviY+ulkw3e+Irldh/HWx+xfw8XVg+b8AIeq2wtyfYPe1IeIG0OMWYsk1sOuGcPgWwfZTaFrdNPr8BFn/AeW/E479HJLmNyDyP6LgF7H6N2NHMz65PrTCr4LHHdzBH4ph2uzLqGqC7Cyn3gI8Lm9pCbtIuzi7kVdhfDMevS7m3jTK7XapOHELcPEO/n9DWSMhH2uh/Rh7ZbVICwe0hgsQpjPq6Oqfj12f8y/99GctZOCQeypbVqNs62uutMHQG9Cel6FyRqKRFPiQUWdkLrwze4P5s9d5Z6vN2fov8cGLO2U0QOpoucCrlDfjakD6XAZc0A5+QJ7OGCAa3FwlSevmydxcJdGHjAHm4CCTyceoMwaYlaaPsVoI+oL8l4/eMK5gf+FavudL3ocStz8zaFkGf4LChs2LKSvlL8goOrNi4va8Nq6ayZ8uW29bSknz8gfPiKD2PfJjsouVlYkFtuPa3bIH2gNhRn/Bx1tibq56Q2BAKAvRSEwSfbx8mc5Z76tIpdfu5hGOEfnLhj5VN2Nm3cr4J/KjW9MO3ZxjfO9b/CyPuWChreRUTffXPaEJHDw7IaCMf/zxp/zgcv9hhYNYCb+4/5EGOkj9aQAdrE95jdeBKfprc2XAHm6K7XRGL1Gvc2YiGQN89cFBzNfHKBRbO7AjFEyvfvst72FdTy41pJ09mzfW8DoZ57iZ7+Y1POg85c0l44lj5FUMUu16l6yseyg2vYxqTYolWsi0LBVekMFX8jZ8JXfnKy/Z4l3ZA/cAYS1NYTYHuyuPOjPRqFgjSA/fwADRYHCX4BY1fl5c2ZlZM86uW/JB9lDrN8Kw4zyHc36UR32/iCQa8W4VdTy11E0ztt+EAR1W8UMHD/KPysbUzGxFfTjn3/GpH9joEP31As0h5wWpO63Lm2TXzriG7LRNyKatfKBlkQzLc0J0A4T+lmo0PcGSZXWFS/FqlswHKG4mK9fCbMc1i1UPQ5hR58pEH29fFmL0ZKpqwpf07Da+5+8v8gNbibawHtlRA7O7ymjM3MOPrJ5JrWpj8h4IL0pq7kXzgaysODbLpUiUJeNCapMFqwG7BBloDcQaKVCJAJ2PEgs6YzUzsKA2LIgZ+Aid9Sz/wnpWx0fIaFyjGd0ATXDjx5rOjXvAlFGQHWUPtMafgLBLNlc80EvUUxAztRgYvexo5dH8W/4172+xUDXpqDU9Z+X9pp8uKzs9vWkrgm/jHeqvOF4978C3HaYOK1bwg4cP84MrVlCHZumlnTLg3hyFejfFVpeDTom/auGeU/Rg5Vb+XJ3VSq9MXR8TU/4YPyJjG99bW8vfrqKH4lempj05+EISmn2bVI53X58nkZGqhXu+on5NfI/RoSnlMTFPT+VH2Fqycm/uJONpfuDdWv7pKhrx1+LUtPn9LiQJ5ZYRQrkid47tmPSm7IFAIMykmEdykzyZu7un4C41DbbfpcEOMpn8/HwRYtIrHqx319g57lg1dnE0Cxz+cO+dRUfLHyJ6hZc1NvBF+zW0XjtmW07W+uExK3P+ya38I6J9NProcRr8qqB5blJRt4xeIYO63du6o2fK4j2Fu/iZZcvp3s/S54b3zI0IT+h1d5ce5HjsJTKsWsVPvwBCCiA1ZUnENnt0irTYWsLjpJWUyldeSJWavMh2TBsnQ8kHV/w1WGfUuRqaolGznrZ9zGdwG5/xEW1L3zX1sZfTZTS+d5RvffllGnhUE9D4fcGOjIwdBWBIsh3T7JZc0R5mINzbZAoOCmUhoSxYyaPekra92ewbGODJ3HTGYB8n5qJ0EOwkaJ2Ym6uBjV7y5eyEde/nFpVHPDI+r9jAH/bcSu47C//9wlie6dh+SpWcUDrINXzIEJ/InNBp7dLfXV5YNdbs4NQ24H5pVEZqlNf8/dndH3tr7sUfPn5w/ANkiiyMWd/KTddK49A5pnv8Q4qP2E5K82XAAFNTVAWGMmVslHTj420y+fm4CZcUD2oa3mqqaOUxrnL6RvKoeJqf2DKlMqudixBVmp5RGhlROiZjYZQMCw+dHr+Fr+UN3Maf2j5oas/zAubWTsjbXzT7ndysd0DItH0hOUmu8FLs4suCg5qdwtjsRM29hhglJgqj63jl9hdo0Kl95L/VjmfpFhUkLxkUszS5X0G0Iy2238w/8txHaafqKHXfYt5QnVcyrnbRkvcyu+fFbOXn/qZEwwTbSSnikqZKj0pUBwYYDO6BijNctn7Qlf7Z0S38xNMVdPem6ZXjPFrRJj5C7zm+0iF9YXRUafqY0ojIhW23UyIRyTRqS/z0UIE14HzPqYModkLt3LnvZOW+M7tofx6atfWTXC/13aytQe/mZtQZm7vUXtZZI0mikHaGb965kwZ8sZy0b2U1fi0UDiwZmfhEHA1eNa7vw3EGetzzRf6Z525K/v4Mpb2d+Dr/9M0CkkcsiBn2xEMXc58Zfs/ArnctOKB44QTrGila9cJgIMzb1+TXXg3JYJ2PE1P9u6UtXJkoXGUJIeF9frjqLnpc33/6yHnb9R45WydX8hMbVNtUjWvnTBtqeOWBFoaxrpnw+qRg/4H3z1lNbXvmPriWom2koYSq+OmhxC58+yZvmC3sSN89Z87erAlvz5y9ewwIFYD0F3WM1HnEqAs0mwMDDHqtzqgzq8KwOD6EVuuDvtqy5uvZxIfQohnxsyOFiZZiGZZvi1fO49bnLf5C0YLVESXKqCtfb9LkAgjKrKD4t+BtCg5SmLq5ShVU8dGoOXNGjZozR0IjpD3Thg2dNm3osGnKTKbIMlJWPuMo3xMQ5hKollWKWHaMdaRQqqNT1nGp1hSqYAbenTzYSnqJbKyvxWIVlemPldF9FjOa9GJxLebHOD7k8vxYAdglqWPTFH+qxu7qDm46o07NE5cbkpuugv6m73x01erP2zt3qt90iFrx+OK0/Bk8efqYvhN6SeDfzllVVjTrKf5148V6YXth4ZKJliHCqxOK+k4bbElrtnKA5PozK7v91Mp/0wd+s3nN2Vl8CC0uHDKzn2JkhXtR2XxufU4xcslTESVgqm/HSa5Nc2bLWHa7lieNPsUrd+6k2FOnKHbnTl55cuyCfv0WjB23qF+/RZ57KbXuLKXu3ctXnq3jK/dSxKQPi4o+nDxZ2U4CQ4W1Rpqlym5qyuM/y1e6q/NVBZW7XJ2vWtm1zFfWGrkn/1nGsryj6dkyZTVZTuwvGZRapsVY6UyXR6bMucOe6V4RHp5jOyYsGSyB/7BwiazlRXZOMaUJFnV+SbN9oXlXckUHIEzjz5TBdTW4awwGtdr28vVrr4ofYjL5tVemC7NvoJeo2cgn2/caF5FcPHQcGY4e2cb3v83f58v+ROtdFufmzCUancLP/+vTtdT+LfKhAWJEm4CY+2PDQ6Lcu/jXPrPs+DTbEcPIxPjwrpGuwfd9/uzSg/nnwRBqOyHUa3MgqLOdzqhzuTTNhbhIklYymUKETy3JH1KFb9i9nt2de3vlx644WUgSeA31pJzGjG5hdzkI/A37uwUpYc8y1Ua2Ouk+qUUM+0iSj7eJ+emMuqaBEWdSBU93Dvq2csXpmUQVVDopuiiWLRByG0Huc8rnE3te+NAyuXh13/kKx86A1EtSZ+4w9eUmkKRe1pPcy3qSXqcezhSqRi8ubhcjlftDADtvSa0DE8noEuii/tTopcM8gbacdWqgDZZWp6mKj+IP8AYX3iDhYoMoX+Qia4Swx9JV7ddao/arVK7eJj8Xg8EcEqJ2byQnRttiSvxHR04a5tHWephqKNSZwugN6+Z7lxy11rR1oVB3sfuDYVLHi8vFjAvDp7yYCsI6QFMpNVXWwRSsWIfcjLp17BtrB/GQNZQd4cJ6B4rj/7bkO/BnwVBiO6DVqPVoOyDc15e5NNeigvKSEqAX1JKUCa56g7CPc16yl/ZSHimU9zbt5Qs43/ohjaos2PIhjaq6jyz0OQ2kAfSP+gb+Z76Nb+HeFkqnJEo6ReZVfB1fX8ffKlO0XwiIxqZ6KUwtpHUkGvkAR34vXVTfIVP5J1RIYcq9lbbjUqmsfGNW49/PeCUC/ZQix8WoMwpqtIh6rYGJwuKP+PbXRSrXvlSYVjbsoTXpwzd14tMSxeOW6cGO5k/mvEjeG4l28w0eq0i/7ZGlD60fm1k+giJ6hotd+GqrLSqlin/w1vv8tRcgoNh2XHpF9sCf0Ak9LmUgszkkuDl8AkSDe9MLrVKRXp2Qrp70hXUn+ZO1Be9MLa99icLff5/CXyJ6b+2j+x4hquVPnkxfET98RUryqmFDVqUNKYqKmjU0vigyqshjGUnPFB5a6OpktG586sLC0gurN1mMTq4LDxU+wxuXUWjk7PhhcwcMmDtMma+W9JkSM3BSePikgTFT+kAdZ0WHdjAiAAhTKgMXZ3apfFasqXe5NFWb9L4u3pLkrgZqKAv2Z8K81dT+5Bwq+ITXvrqf73nNlTa3XfPw238nJ/9V+yZs58fLqYaGfZVa9hANW5kSWTjKTMNXyx5jv+LT+Wl+kafzL554ilyezXmURlLn4dP7VFCH196jXi/wzaPXpaSuHdUleUa/xHXKWxjJvLcYKJuUf6+EOetdjJK98j6kdzcyRvLe/bSsf1FKl8QNGXzM/r1CMOWzXHJI5sf4s/yJ6jO8HU+aRQ4sV/GaaN5bmHiJExOM5rtYcBBjfka9Xpi4dz8f08yJlimc+DzrAn4umTwpljKrz9AxKpvFz1kXQJ0Vqu1PaOvRHwlAmJcvlOIOSpxALxhYUyrz83Fifv6M+Zn1ZnOIWSl2gi+lpOAgZjL5+niLjGkNelFUqzAXpQoLMJv91CwtaT2Z5iTfzZ34xue30wiqp17UgT6mvpuJepUcX5dfGung2Gb+vgkPH1g/kihx7Z6UCe/M0znRX6h7YPjITsnbTvOvSy/w+Q2PEs0k0MQf8o5Um5N7HOLf75q8qAejbgunZa+MIeq13FpdSdF0lALIn+oo8dUq/hrvy8/t5LUnZtvZBaWHd08M1mpH7yDHrVXEtqY46byjOuZYOodHTba8sYva7Xus6zL+DV9y6Axf0lBo7GTgn/v28BOKE14snrghPmFT7thXCmw2km1OYqD8naTVdAPwrs2GaJuTMFE90105A4IPrxVN8mi1diEjiSZrJl/Elsqjz2faLf3x/X43WyOmC99dqm3EdMtw4TteRYOUa0K8mC5uanlN3NR8rYw7sknURsmFYVqJSVqj2awPCWGTHFr1G9CG17UO8pc01CZrFr9w8IFuB0gqzgHhOduXbAm9qfynJrxFJSfR+uSSkuTRpb0z7ypJTpo/P6nX+DDFM9T7NfVwRNurnhCu/XjYz/mIQfNTkubNS+o9vicYLlAXabpUo67kXV7DE+wpzTJXU0xdNMWNE5mO0vgKwGE++Sh/fpG7Kmt0/52kDVfWIa5Pch8suFFeMn6ZV0uSXrnxe28nkhNu3B43xC/49rKDYLi95PmjSQpH2E0/G3rjtrR3/v3tLq+4tb58u5DW65dtqe3y622tDULOTckyXFnZvHGSpTvxd6tISlL+QXuHrkWS9fp+Jj2MzF/Ja8ItkWnJr+v39yKp/sb0kz5XVqBuDTGurI3ePiSl/bJujN863W+U7OXr9ykd+m3ySDW3py/eLEnnbswe4rTffxwVkvyR9lt5iH0QetP9/0Z/uRUk5SprqVfIbriyVvrb+dxKkiKUVdI7dIfu0B367yTtYpRokpQvMFedd0flT47DUaztjZLfVbjrkFhIsliI6OtddxiCiv90j8onAj4tjzX3YPevleVmnvmtJAxGmdAHz10+btH+I0k7GRf+aBnu0B26QzdH7Mfs/j+x3sBZDQplbmRzdHJlYW0KZW5kb2JqCjQzNiAwIG9iago8PAovTGVuZ3RoMSAxMzM4NAovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDYwNzQKPj4Kc3RyZWFtDQp4nO16C3Bb2Xned859APcCl2+CFEFSF7wESAEXFAkSJEVS4hXAlwhKol67gLQyAZGUKK2k1b6ltarsxmvvLv3atBPn/Zg0qSep6xxI3njtqNu142o8zbhN2k47cTuNx+lmY6edOjO2ZhNHZOecC/Alcmu7yUxmsvcf8vznnP+c87/O//8XAAiACrwICfmjJ/YmLtJXvg6Q1wHk568Urvn1iisA/RyAt+afe8Z0HlS8AUiXAfzP89cuXHlu4aVbQO0YYAQuFJ6+BqAKwP8C4L1w+cb5yova/wHMx4Da7y4tFha03/jqVwGSBdC/tLRYUCsVAKQPQPvSlWeup5c9NYDeDmjm5SfmC5feWVwElNcB+Z9eKVy/Jv12xSMAvg/AvFq4shg43PPXgDwLEOfaE08/s/rHSACkjs9fe2rxWvRx/QZAvgfgLgjI6ioqQQA6hU/Ag+eggCKKYXwcwC8bAUggkCCe1X/P99rmIYD02VUVkH96pWl1r5zhIxsfOiVGKPDKy5Ujc5UjP4Ak/QWf+U/vvbyPt//Z/mH7StPKX8kZievaw2nFI9Mu8joUgC5TrqWM25IPIUEGOYGyiY/151Tm0SN4GyZuuLxJRdJrAl8U/HjpXa4R+JF5E18/ni0S8qkcI1/ywov5a0V4Ur93JTcOS0GUdxx/3jvjHfRGlUaP4i0NXVIfUVNqjxRSxJA/9VajU+tUOPrbqgMFWrSI6tRbcNZAjEkYK7aTV49lmfNqtigtjBUjvPdl74sgsvPq/MksJ8nlcjnHf857xDvktZUmj+KPvklWP8rkTxYpxu4oCyrGxlyNCuvUCTvxVsbvAGhCFSToMGFjAlOYxUkUsIiLuIbncGN1VUhv46CYO4EC5nEBj+MpPrf6ZzQIrP4ZVAChNYV+pKTfgPjfLP5MtKPLtROqUI0GBBHGWczj0/hZ/AJ+E7+Nz+HL+Nf4A3wNf4j/im/if+DP8V38YFtP2vk5gzPIIMPtRr3AakoqrnyD3lu9T2tW77s9nMRJHMZhOgysvizmh1fvu9im9fe27HBvwx4lOnxh9ZFN419aPbYdHb2Lz23a7yuiv07Hffk0t46sAZjFZ0o4gY5PlHCKCtwq4RK6caSEy2hCXwlX0ISmEq6iCcBxPItzuIjHEcdxLOICnsVlFPAUHsEinsLTuIgncBUmEuhCt4D1NeaWNes0wziFDB7FEQy/zxlbe2W6NJ7ANdzAU7iIC1jCM+L8bvQgCRMnsYRFcfY6H7N4Ck/gEhYxL6gP4lk8gyU8IWRYfw7uAL+KH64DGSvBp7aB/7AONPD3Ao9ugq9tgL/5/wHpxo7w39ZBPlWCO9uBcmoNfl3AOzuD2iMguwH+2GNvghd3gFUO3gMl+OwWuO+CdnRbeG0T/LsP4AP4Bwc/AEjbhqh0H6C/jLofJ5XRX0KW/gJGtp1jyG7qn93c33HPye3p6Nd/tPX/EB760s680suIbTt+ELv+Xpl6n4dGEPkJ1vRtO358c21N9+5Qa2+39gR6Hxqbw8xa53tI/7h8ij3Ihj3+agO+4ZGuI0MfQ2bHPUa2l3dH+uPr55Drm/clf7u9D6zNv4zaTXtlMfEjn9sJc8e5MHb/qPt88HzwfPB88Pyjfd5DgsE2GU5lx3OmmXkTFccyTD1xOsv6gqwzlz9vLp/KMhouuB+2zFvngqEQQ44hbY3dBkE6n4ozYjMzfz7OqG0umOztWSZHTt/uJHp6fH6cqePZEJPCueNnsiErFFzOmmx2NhtiTi5oskGODeZyZtGlLiywztlsqNQzWTef7+aUb89mzfPm8nLBZPpsNh80mcnndI71c6w/H8zncrkgI7FczmKYzS7mcnEm2ea4yeRwYcFkSno2yxQrxVQrFQyFcozk40y2rZAVMheKyrmUyWc4x0GXA/6fKfnxeSZFQyZT0+ayucxIrNithJkcOZbNzwYLx3NZKxfKmcw5kWUkFuSilc6PM8VmnnTsNqirKdVmHitlmQxWqsDoufOMzDOSZ0o0zjy2yVn1pefflHHO5DswJ5/jJPkxwarXvu3xIT2eiobWdK/Zm22hu7uQmMWQZnI4b44vWwVuF6EvBLlOmRlkzpqWmBS2CmPuEb4dlrP22Sxf7Gy3yG8LgW77dGk8GwpaoVw0FGeGXaR0nC0UxuKswmYkb5rMn57my03mt1I5ZvDe8azJDCuVi7NK22RVQiXmmzLml60Cq0jnzeW8ySqslBVnVXbmZLYoL4zl2pmxaF2Ps2o7cyybOeEOBkO5dlYrxmvsIirTp7LFyso0I4UUq4xxn2U0nCr6+T+DhlOMBCyTSeHZbJErj8nh1PKyKY6NhixGCmU86M7zJTQsRnLMn55kRnoyz+hmU+1gwCJQa40xkmY4cJsQImxVa6MIOn4yyyqtlDnOfFaK6RZT8ikzz0jhjepqggqkUsv5Yo0aY6/Fgm25OKuzi6iNxVm9XSS8DdhFytsGuyjxttEuyrzdZRcV3jbZRZW3Qbvo4W2zXfTytsUuarzdY1tlvTM1nzmZtcwuRs7yCxJn0Q2TgbXJJ93J2IbJyNrkU+5kqw1mxH4C+XbbRbTG4sy0i4S3IbtIedtmFyXeWnZR5m27XVR4G7aLKm8jdtHD2w676OVtp13UeGvb5ohw07ht5ll13kxbjOTTwpQkz2zuq102i8dYPBpne23TnDR3sKJVGLR4RHxfiiCXvnvNtCTA9kaLCqkfz3bnhIA9GzXz8HTCNpOC314bjIw/fAgjsW0P5+MIfEFE9rED1mAxQeq5cH22OWJO7sAwQ7owGGdJu6thJM76/1+kjKTnB+NswC5SBMJmlznJbz6j4UPLy5PWpFUws+eCPLJaqdv9hNTXReNs0GYIsCorxeQwk8OCjGnp2OJyl2WaI8uDcbZvM4nZ5e7FZCvFKU2W50HDOZa9Q03JDN6hEakpl+KB1Js2ly1BbU3kmZzeeh/zPJi5eYOm8wsWk9KFhdkso+lCkEnpPA9kW9cULNNkcsSaKAwGLeZNTzAaZt60OCVvbneI5YZMOZ3nRlDCBaY8tCuTI1yisGAinF+YdUPl+lm5OBsq68E0TaZESnqwRgbjbHhtinnF/IQ1yQ/l1htZUx8XpqRhnMx2mSNWKMi5Lw2anK+yCdQwU8KHNmZ313jbuXXJUhb37f0bOEmXTZXnJcBWkcvmPWBbZhfX4gSrSmdng8dzWXMk11XsInWxOBvdNHs8OLtp1tl27futOGizwdj7HZiy2b7YsmmOcP9aHtyZlMnpLtYVi7O0EJn7Ztkm3C0tc8TssgZLu47ZRa8cTpUJfwwnnvy78lsuBQ9RI9ZgMLTBQ0K5Eo/jdhGDsbIeJuwi9sVCVkkTJUnWhJ60GerdC34b/C7XdrG+aJxN7TB+yC6C1NWyZDTOpm02EI2zDNfbuGV2mRPLVqGsqRmbuzDLxOLssH0bGIvF2RH7NghHjtq3iRiZtW8TMXKM04zH4uw4p+HICU7DkZOchiOn7Dv8W4dYnD1i3wER2KP2HeKOZe07xB3LcTrCsdOcTmBnOJ3AHuN0AjvLz0zH4uxD/EyOzPEzOZLnZ3KkwGkmYnF2jtNwZJ7TcGSB03BkUfCVisXZecEXxy4Ivji2JPji2EXBF8cuCb449rjgi2OXBV8cu2IXMbRmwKuixw7E4uwJFx2Nxdk1rnTRc2Jx9qRdJCWap1yU0zwtaEiJ5hm7iOG1XZ8VPbHiORflK553UU5+3S6SEsENF+UEL7goJ/iwXcTI2n43RU+Q/xMX5eS3XJST/5RdJCWCF12UE7zkopzgp+0i9q/t9xHRE+Qvuygn/6iLcvKP2UVSInjFRTnBqy7KCV6z72gyLRerqRjzLjKpffZ6OQ/Hxbe1dQB9ld5FI/+e1GkLEhlkGjIokel5AEMZiRAyTGaq22qTSUXbFUtEkgO1/b29iYbahjrVstoiHR0hj2pZAyHJ9NP3vI1Oo/c9anj36gYdXHljwFvd/Suk5jW/10dfCQQe3PB5/T719derv08u8O+KswCdp3dRj1Z0IO04BlEomfYQCkWmyiIkCWcFJ14iy+Ss6vJj7m4IAJH23R1mR0sw0NrQinrUJjWtnnNY3dffG0oE6utUT4D/V60QSfQn+yKWVV9bRhb8fp1UX7rcZ8WGehfGV94l9OBYOvXlrzmHDjlfM3T6SZ9x/vhgpro+u2/wsX7yz4aTff3fXLk73j8wdh8EI6v36UV6D3H0O70gVKZEvgVZorJ0E5Rijt+KDCRJmVOJoqQV/kFiHHZfpD3Z6dF2xQKRjkiyb6C/vzcRCJSVGYlYbR61vq4h0Jvo53O9iUB9BbW+8XGFEOXjH83dHJUMLaH7perczOc9hHg+nzldLfn1hGZIozdz+s/cCu4/0HzrZ0bPD2k+3X/4wFeDg4MtXzkw49d92tD5UVCh82v0LmoRgu3sWVexQiglZ2VXxfV1gNlaF6oPoRbVSXVdtb2JQEOgvs5TQS1rINHfP9Cf7OOMW9Vcp9/+uY9RQui+Fxbf/fbEiTCllJ5Z+llXn6+82tLT0zr3/NCJjhOTI5VVQwtnH3wHRHC0h96Fhb2ODQpJptIiCCnxBVlWznIlDgslWgiFwqFw0uP6Y9na9XWqFarfBhOW/iWfYfhW/iUZFe1XyFmfUaGvnHX5Mnztuv9PDV+bbrzLcaPEUzO9i1bscSIP86QQWR6WOTutaObcqFrj+3BTze0rGPmMYKBIhgUD/7ZC31vmIawb/9vQI7qx8r01Dp4UWulw2kEgS0RepISfripUkoalkjZqk721G7XBfaY6tIa5rpWsXmei22eQxwzeVOjdurHymxV6d5mLle+SAG8fPK0bhk7MlW/pBkpec1Z4TRDdTlwlEgiVyCJkeYP7DFPhOE2NdcH6IHec9qRHC2xkjPMg/tUmxEUUTvPgyZdeevILhp547+cyM7/rsnJlaeny3+oGWfiIM7by1yCIrd6nDr2HAYw4+yRCeKySZMgSbgE8dN2ELNM5UJrKgJCN924A/eFw3Eq69y7SIXhpCPBLluyLRDq6aLLv4Yuo1tcFAg2tlLP7zo1R6td6ajzaqaOnTu45duzwma6hq5kjTwxRv5bwVkjqydGx2fDh6VOF7k+/oPed6vH666L7R5JtdqgxkDg02H+qZ+BEVPPremww2WfZbYHG7snBD13kvxPaBdAOehe7EHJauYXJWRAylJFJ2cq70BBOWorWIFTJzZnc4GiWsOyK8RVhsm/5/Ib+tmvSo4bewa3ZoRsPiroBisjqffItWoMOJHD1i7F2j6QQMp1hjbNZxwSBAqLccr+yoXQ84yGKIs2psutvQeGIW0ggScOCTp5TiSyn5ZmcU9vZCXQmOnvQgUgy3LfHqzVyzSf7+gcGkn1Wm+pRXbd09b7mpUlVtfr7k0mPyrXf+zsnei6f/czzXYOGrHk7NCN2+uC1gqHbuj9wMvXIyWenptNdeud4NHWyor7lQniX7jG0hv3xpSMrv891YYfsQ48cb67Wu9v32FzTfav3yd/QGsTgOPt9hNAOIsl0eof4Pb41fscQ5fE7UorfHeXoHdjgNB6P61il6M3DJLsuESJdf3xqvoeSSs3WdaVmtHt0mo9Oj/YcqFF03dYqCe2Zn9JvXOnsvHKjdyaiVWj+nj1HZi1r9sieHr9WoYVn+kCRWL1PVXoPzbDxpFOpERnWbqrITYQqUsmSLbzC4oGzJAc3D51TJSquaNAJbZkHpcNlWxNJSkszOaeupQVosVtiHWE0I5jsi3i1hnWxG5JbAkySW66cDLge6np//aJMiHxpaWnI0OPcIDHdv+9ybkIihB4am0pJ5FP6q0utrRdem36XTz9YEkQzR846vmCzb3/u9KGWt1GSGbQGIUQx6oxAIpRI9JaXqCCSShahKOuSyHMe1w/b2oC2aNuejjBCMPuscEQTblg2XClKbzSXKBdqeWRqU+vr77ygEqK+cP7qDUNf+S1pev/e4UpN99ua0T/vfGLGOTit/9TVttDlFz9xvUY3tIOPhev8iu4NHIiTXmkim52QQNG72k494sbtw6+55qlsJqrUFaUetYpQjzQdFCPyhpGcS9jBv/ekILdAvEQhygJUVZrjcWE8oxGPR1xBYdHYQ5SyvD8jyLGVOucExP3c1zmY6OY3tC/SbiV1NzgmyymeB8ekKkq8rQa3ajYZmjv8Hy7sqdBszS83z2emhpYuXeTOffHSxWFudOM7Y5O8PzkxdZC3B6f+++BUk2Zo/lnn2Pj0q0vNwQuvHY7pFRX6SvBdEj7jaE27NOfMmamm4NQZiG9+6S56D2HEnaiPSIRMl+srMgdCxjOK7Po2gDCscHJTRha23hxoql0Ti27OMPQun7/l6FD+cUPfqxsTKWfG0LsMnf68z+/3fSfc8eHFlXdEdK2fmj02ufKXIpby77H/Ff0GKrGbV1K8cirXfZTuzyhu+K6qAqp2V7U01qMShqikatz4XXZBi25I3Lw/axj6MNfGMOVRTIQyesnQ+/hYn248+Iyhk2/y4ZWIqBVmAPJ9eg8RXq2EAj6JrmmIkP0ZWVpTTgTtQ/3JciYpH7rm/R6P4uZobvb6snJiuvH1Sr+R0Hy+7xLJ59N6Kg3/tw095mrI0Ff++W/5VJ+u6W+/5/NqftX3X/6ozBf+Bb2HSuxyAoIf6paXgFCGtKmsXLeGK3J5dx4WePTOAFKC1mAQpx3dR2RUiujtXpUATz6Y45cA+zNejyKVUhb/deL+DJ8lc/z08fXJnMN/Dj2Ifu4vVntS04KbXaY30bCz22zpZg1Dj+r+/seudjXmBo4vCbWl+rvHhTjjvQIp260t/Vg0ce3Syp8Kp2qcHZ88svIXLn50YuLIyrtrEtMArUEYM2/4eMlVEraWV+1zhHDJyp4fdBqEpA/fiZxj/CTXggsU8/lbjw7nLxl6l25MHCxdCy6D32eHO7e5FqA8y1KN1qAaFpJOorGuQpclSqbX8yq/GmSOX5g0mampAWqsmrbmJlSjKsIvyHqMFq8a6tbUwiMOe54nlxuXL9+QKZWfv+rwt1Up45Rb/eaFWOzCzZsXAvX1gQs3M8dm9OZmfebYsZlIZOYY53NmNUV30xq0Yi+ecWq4R9mdoboqRZF3bUqm3LFcZbuJFJSmMzxRjkoimQq1c/8San+YJufU7d4N7N67uyvSzt8YOtuTbjLd5Gtrwra5Vw9CZlEs8VfCQC+/GlGff+jxi254vfj4gKHHSZAn0olJKrLqW36fG7Xswx+94Gto8J3/2Mx3dIPQ04f02rfPjvqaeWJ1fYtcoV7+5u20+3jucA3kCrpee7aiOdm3NWLUb4hemy6Az9hzroMfv29gtEKPGzr5E73C8Nljfv6C4wys/Inr2bHV++Q/0hpemju9O9Tx49vU8e1JOxz2bElVa4V8pFxQloJYRxct1/GljwLenOuq8EZVj9qwr7v/YPNB59Ep+9GR0Vzc0CIVanWDHerpCxzYP3e0p5DW40O1uk/2NJudkV2tjRW1U/vC47HoYK3m99XWV+5pq2/ZZdRND8UmOkH4r33IFXoPUfctlqYysijl+Wco+zNQFDXvIao6rHJJoujsDVu94Tav1hRLrJf0vWt5oXe9uA+s6/r6Ud3v14/6eUi5yW/ezVDnfj409rvE79dN3fgsH/2soZu6f+WHvX2GHhKReGL1PjWoF+3IfCFECDlUCiRUWBuESHPKWpXfUBrllT0IkeeUcmHPA0k7rGSyXQSSwMbYzY2w9a2T1/OfXxLR42UnI1oRF1uOjOgfPk+aRA77y58/Nknqy+nM0OMdHSD8F1DUS71ohOWYtT5Z4h7qOqdEyumsEYFwv8xfMTukkj801NaWsplHUi3rz31fJn5vV5X3F3+RGlqX10+/5Gvq3EX+SPJo/qqVJ8mnVd2v6Svdu0CwezVFfdSLFrQ5uysVuvnIUXFkC4LtQ/zIAP/8ZkCKJPvLx5ZyKOHvNr/iV478G7V09K96q+Jev7LyjuLT7Lf8Xqnyi+QP/Apn4HVyrcrv9fgeXPN6QZBYfQNfxDOoRKsTBP/A4VH+YzKeuUCOummzXRIhcmBgLWmrljWs0YDc6Hh0uU+r3Z3xa59s8ale7WM8Kfxfrnl/rA0KZW5kc3RyZWFtCmVuZG9iago0MzcgMCBvYmoKPDwKL0xlbmd0aDEgMTY4MzYKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCA1MzYxCj4+CnN0cmVhbQ0KeJztWg9YVFXaf99779y5sIgzOAOsTcYwBGSmyDCAX3wFru6SUVGauuYfkL8q6oCoqKisYpGpkRIRoimikqKgQbqGLikiJSYbfEXubMvnw/aw7mxNhjLgzJlvz50BwdSo/NLnWd/fc+eeuX/ec96/5z1nBhAABkEWsBD93MRRgSsLVesAsBEAYiZOipj0beoX4wEwBwAi4+bH6ndLwx4CYAIAEJJiF+kBQAYAbQAgJKUsS6w5P80VwC0AQBmZnBAb/9ipWPp+NAAEJycnxA674j4LAEcAgE/y/PSMvP95NA/ALwNg6ISUhXGxy7xXOQFIBIBB/vNjM/R8GfIAYAQArwWx8xN8n/3dRQCW9v+ZfuGidKKFGgB0off1aQn6ZH7DOgAwAID0KNrWVXAb6VDRZoPBgAD8FsgDF9CDlH7rQxJAYO1NEkB53oQQwLnUOhXgwazO1o4O1dwbeAC/WbzCcn/t+Js1ZtbgsCvwwK/EO4bLHzxAz399MfqzzlZLpmqui/gCML28EQTxm0L89AFmaVJyOg4GWJSyIB1lgMCBQhwjgx6YC8BU074A6XfKwnYVADjpSMwFCYDUly8EgCb7mb0ANWwhAAMSkQNwWdAjr51emPjMRKgBLy9vu4zOpUwpAL5jH6ZAT17gIr5rf1Mh9k3PnGifoSADFpzBC/xACyEwBsbDBHgRpsJy2OHlbbOJHPxgBOhgDETA7yAKpkCs/R6fKhlPu+Ba+5jk8t91Dg27gw8A+MJICILfQqTj/grJ85JMyTMSV8lgiUziJlFI3CUewEAEPAWTYBZshJ1wGp3QEzX4KIbjElyJq/A1fBt3Yz2eRzPzJPNb5gUmnlnHrGfymL3MKeYs08SYmE5Wyj7ORrDj2Tg2nV3LlrCl7CH2ffYcADjDKio55/Rv38+FekcbwRlOONoMuEKFo81CgBhdtM3BUEh0tCUQDAGONg9Dwd3exsHgAs6Otgyc7RbmnNBD5DkRUiAWFkA6TIEEmANJkAzp8JR4JQHS4DF4ARIgCRaLz6XBZPHqIpgDC2EBeIEWRkIAjIYx8DgkwRxIh8cgAGJBB6MhAIIhAQJgdh9+Xjfw6/v+CzARnoGJ8Pht+u//7fpzv4GFoIdlkNYrgxcEQoB4eMEkSIYE8Oo3jmhIg4UwFxIgTnw6AhZDOiTDQlE+L/AXuaSDHhbBf8EoGOWQLxkWw2wYCXGwEObDKPHp+bAIRsGcXu6PiO40EkbC03cVr96Aj2+KqzcDDvp/xMQBYu4dQsY9gq23xb6b4uwN+PtAwfj9gniuH3YyTbcC63MbBN8C0+8I/tAPu+84vruXwI3uh+RbYM8AcPHnQiLtxe9vgtUDwtafiLob8M8b0PVTwY/uhyk/gNd/IXxyHVJXB0b+DOh/EPm3RfXPRpMDnTdC+HUvxv4oTLuP+7ir2CKUCgbB4PSI0yNOiU6JTkeczjqddVb9QhjhwJg+mNwPcbdB6m2xwbnkPu5joAAJmK1ZTmZnuqaVwq9gMAwBmChXy/GGw+wEndD/sGYxQEAIp59MDf3srLnepjsLkQBSfwFEzhCrRgoNqpVqjCIWxoTAmIjFWiSzWjjPa+0CmIGvtsQbgAUzAJ8jAAyBB8EPYJFcHci5KxU8L1UOY5QKntM8rA4M1gX5+mrUOnVgMG1q1Gam4TN0z5nx1tSZJ7I2kE8vEwUavzs3t/ZlImCDvmpedQMZIcCWzvzssnhPBZ/RWlx4Nddw/JXkQ/Napu5IeeU43bkptbVJkwUVPAwQoRnJarw5Ri5z47SBTzAhWleG03gBvQB0SO7SZLP7/K3VicdI06FD+NixxOqt893NqjwD+WYr6SbJly5hAfJbUW7Ik2TNK14YWk02k6vkKtlcHbpw19xt5gPTELAFx+E4bEGYdqATGCq9NFygexNKqje52otzk8sY7mF1oI+bLojx0ahZvTWHycPhWHqxjURZI1FP8NmSYnLCRNIFuEJCyElSQ7Sdhlqc223GpA+pZGYAiUEAao1FcrVS7TjMXLPFhy2yxLNGAQzWKIM10uDQQ6agAn+AiL5q8HHTeah1aqXCoYogNzcfLdWFB69Xz9tybOH75LOKwxhwogIHvRVlLWBdPievdBATSfj7WhNGni7GX/81TyXJStiZFnZdG2+hslpmMFjJ+nN2hXyH69Btc+yhK2/aRy4d0TNyrVwt18o11CvN3Diz+Vq1ABY9m2sGNs+SYn8aTYK4rxUh18jRZKa+JYj7cum2NgmIngURWjmVwdvHV6dVuLtrqRtxgjmXdB8uJd35HVMKYuflPydAd2Qt+XrTirZtU/4QOa18dY8mSwW6z2gfj9JsZo8KYDYYHHeFRgFgMMBENWpRLdfINahBjVxjRn/mqCdzFP3bFdasVmuWol2Arul8iRl4RZeRHg4O0mi7vBFy8UW5FrVyabTpWonCbOJiFGK0RHYdFaCrko+i0UbtdVRQwWB4CCBCxoC6x1G9wI2VMT59TSg9eokkk+7rLoo8FlwyHSJNx3pc+Rg+dogDUk38bdDXR21A/Ek1OuOC6uvmq8YFjnHz8QKAhyNm3UQv6Q1RX41abmYqv0Vt3hbyyTdEhu2761966eO9JEqAA+RCVRVpKTeknVqx4uRCM80DpbZwUSYpeNA8EKEe4oFq1g9/QDq2FWVtYTiJmFpDmcwBScpkkeZoEoYjotjIHyOzGK18pSjzA7eWGlGNZqbShEF5eeSTr62NjH/JRy9N/3gPiWIa0ExaiUyAXaStqoq0v9Mac2jFiqMJZgNbYElmCwBhh83Axwsq0AJE+PpovHleqRjGeHgMY5UOF/ZTD2O0jv78/HxBF2SPSg/JVDcbHMs5m/pcZs6YxujTVUsOkCqjgfzpiAuC86tNyzddzE47lmIxkfYP8L9r6zCoSsJDQenUwtkvLH5m9OBQ5YTVdbl7SMf2TaQ0/a2nZuzVJ2ZFD4scj3C+DPH1jR1bqeVzHBlbCjBRR/OKRp7DgzXTLPUxGMwGqQ/1DptBGiAAzWq9scfo5Fp5T/TxoebTpPDbb0nhaXP2lf37r64VoLvyU3Lk+HF86lNJVHd9/j/WrftHPiCEATgH2WMsFrU0yByfGmRSrI0WLFNgJXpipQLLLNZGG5AwGQkToCuTz6aHGfiYrh105FEAfC39iQIgQuRgn6UQUc/IZIwMfayZTDYxWE0yq4kYmDxrigCWMnaSBSzAjrNUc8BRP8i1GSTTeQU8DMEA4719fXVBTzAhTzA6Ojd581K/Jxht4DBGKdfoNK6MH5VX58pKXRmlwp0p2vz1huSDTfM2lD+/c9e7NX6tYR99kz7hw6oMo4un/tjsDR/GDU5Yu8J3+juxR3wWNuVn7545ytVtyMgxQl5J3qToDdue1KRcOGJxaQxMi25ecDCmxe1B5WCJi27OtBUrRR+1tfLjBLrz7mvPWFo6GIejevv6+mmUQxRu1Ah0fqHDZcxGxdAZ5fkn0X/PHnKhJu9wzFAVl1i7Ke9MQtyZ/NzaeAGsLv4r406SossdZOupuNXDjSwcJJ1vbsNflRSj5O03iJXqN9fWKinhFeBFteLD9DqmxlfsR2nvNzhEy/McG9lC6ksPYEhjMXJ7FMYH/li0/vyi1PMbpucnuxsV24jNqwETv7qESWczWnLn7HqdWA8eJubN4RmTcr5YbbdCqzjHiZJe78/d3UNLJw2H6nulpL2zqhpyYc8e9D+ZXz5jqMLYphoaczh9U21ifG1u/pm4hDNepzCh4zLGn4xb6c90mME4fHVc85vodLAM2TfeJteKS8iVbQ5JW3jFjT27KZVqnTpIFJdXKh3OHuLhyrDTvyR/OkDFzbhUk3Ythq1IOp618dyCZS2vz3hrwbA2n33dXqcxzmjEOWej3yMXPo9vWNOw5LUvV+cc/Halbl50eHp5rL3OYhuFGGBBARChVOuGyIOCg7WB7h5SsVOlnM221Joz6xZMWfDAOLcntYuTeKiv7wa+ObtiqsqlgXdbktYVT7Vn3SExiD6sA4igjhEiphWdXOPKaPppU6eVK3iO7Ulxoi7d3dlx+6/uCqj2mr3/tWOXFUNnHco/Rr7YL+r20Kyhnm3vkaaaPpq17piyMTp7+PznK2swdPiKWRUYbTLirA/jVvp3dDXXdS1mo9Z07NtDcgtsULTjymvUn1occ6+7fXbXyrWirG5KuUYuRhqPtUajIviLqm3Gtcbje9OPzKHFjQBW2dKNK4mtzhLA1hz5aHY1nTMB0CyEA0vzCI0L1ttXF0TZKRV8izF9fFzc+PFxcTx0gxRmjh07kx7A2AzWGuwQwkEGKoCJVBO8xttbowsMpMoa0o9J7Kk8F08XF4VLSvx1fl25mxrTDKsXS/W9XFlRsmaB/kDnDK4AEaw9n9ECA0MQK7kAZgf6WIMURGFk2qylpYyBCUAfpsw6wtJMCwLGXGKJd+gIa/tUQLXG6xVQC4BwVLQxlVhp156HeAJ5jw6vK1Mpb2lTBHyWX3B2jOxx4+5PkDceW1V82LTv5envxPJgWvHqqyuWbiQ28u01C8ft23zqTYsnp1q7c/aBVEt4j70KeEWvvZQ3s1ebIthwsOjSGmN1SeqhRGovHkyLX19NbLXUXFVnZ1c7opsHXmGvcfpkEzGRfS+uIxvJmfJyHNPYiGPKy8mZxu0Ns2c3bBc/veow/msTJtbVkULT16SorrkYhcJCdC4pIVcLC4m5mPbXYq3hfcSx+9J1kVb5vbwpZ2/Imy1tqhvzpqJf3rTWCOEd/ROnpVkS/r3MSaOxRoxGsfeIm4Yg3iAzZ1IMjTmc1zehqdqsMX1DroYdMXx1XJ+U1tFZw3R8L53ZLce28J60Vu7jKUrfXr+QDTesH/qswuXFUfryBB7a0zYxjIkdNGNXsiUIEPJsrZIgXgHDASKkIxnqVgp3Dw93d3EF5+3jFyKmQl2Qr9/DdLqk/DmJZ7PimeykjR9k5bR98vFb5PJ7/yQNj7R6vffG7lP6dBs0nd5iK25DCVcapksY+4e4qYneoYHndmY3ZjTUhmZmboyLnv9AWGDTO2vq0+r/bcGpNiObK9UDK1YdNDf2lBshHjRofX11bLqlrd34+Iwgv8DBAZ6Tx8b/aSVNj6jvjoyPUzuxzU5DJle8TPVhM0o28I7MQ1cgGpGDo4ShSZ3bYTTKgtsO5rZmGY9vmXpkJZPObugG5BbvWo1YyzZawkvrpx0DhBgASQ0v1ksRYrmhRUmNtd5krUfAUhmW0pzDw7VQrt7+tJDL96l27KCLCiaIjDBjlAwjLThOhlFmMqKdVHiSCh6uJXMF11K4vG7giq6JeSEDQJLB29cVaC91xEonB/WoRxmRoYmYSC7JJSZsJ548WDcw6VawAjPJWsbSdIIQY60RRz5EnCH8QtyDg0NCRAHU6MqgPmymW9jk7KRHR/SKgmBNH7Fmv7VmiFOju8ucxRm8QOXq8lq6LYpyLAOQxNhHtUiHOrq4RKVaWcYmWyq5TEsFm1LJxcgM1ddKZQbHSocPFVc6D9qzgFxmzwJ0kewXSE++Gm961Z3VXyQnS9/FJ1tb8cl3S8nJi63m1Ka8L7v1TapO/ByfxSj8vKuLPEIqyWHySKcBKzAXnXFJLXmapJKrZMNJxwjZEnt1GyEu5nTIlphdiAsD4kLMQiotOIk+2fxvWVoFFc1Pi3T4BKPrmfc1vZmKZ6RUvGamZGnh00mHFy4pn2Xcgw+9V4nu258/U0GC2KOVTNuaD/fPTNk+Ofbg4kqUFRQQsj31c9J1nChk4hqz0dbGh9lXBONp+a+9Xv5rNDrt9WmZl2qCg8WKS6ngpUp3MXexOXXkbJVgETJOLsluSNe3FJWULP/jnOl7U+d+sERi4t9Hv0MnULa5auvJC1WkXpXz3c6415+dXpKSemC2YeqOlOTCyc+8kbjzu5y3u9840DFK5kU6T+0lnQVi1rC1ScwC/c+LY2SO4p4uTHx5qd8QtVLNirnEnkfZSRXkq32CyfV/t606nbq4Ye3MuvD2TM7fUhrp8uSJpGr0e7ecfKLa0FH0WtWS82tfblqO+PhIFWsyWEsCx75HPj5TS84don5RabvI+wsqUEMgwPiRDPWAvsUmsH3St1+vilztlUvmKkvjqsSTOORAGQ7a9+sO79rir8k3KAvdWj2nAn0q9pFz51d9tDj19KpZJSt+u+gjFTP9L7gUVSjD3ajOf7XjnfXvk9lk/YvLxpaTc3UnyOk/frmqec3qP2c+vWbv9OXNa+yrJLF2kdI4tjs6Kti8a60SL4teqpAZ2s3tdknaeH/hIbskEcMY6tKOdZ6oTug7GXiIy0F62e5ubAyVJOlD8q8DZeS7/Z4d6tPF/8IhstDC6rkV5C/l76K2sa8gggpnfkHWk6/IN+T35Mv8V68UbzyC23H5pOVjy1FbV41jjv1tZVNW1p9XPL1270sZn1JJwkkDWybWnGL+YsusKS1MnhBzNcUpj3pBPQtcJGsQ7yvVOi7SksUaDAZAjMEMrpFrp7kswrsn7YtzAs96LqtfurR+2fIzS5eewYye1vJl9UvtPDdzkdyCvjy5BZQn1EvCsaRPvVNiEMAaztA/k0E1cWFC0VPMeVKeEePBLSSECZXJx0/wrBw0/FFXF/RMSSOWr8aFf4rsK3p7fJmYUJxK/yM1vk85x2P2hLlzJ0yYO/p5GT3NnTD6hdHgbKK7AABSfc+/mf7zSOpv18GtSABabQ+QV/vtefUlPm/gz95LJIwYuD4GxM/n3tID8yNs+J9AEjOk/9R3+YCB69Kp/gfiMPLO20WIubO+fK8Qb7m1rqjMUuHH61LKwY6fMhapjFYPAyfhB/LxL0nOerpfe3OSyugO7L1NfBDk3u0x3KvEN9/az3ifH6c3vvnO6JlPvvv2Ys3frwX5yoGNi8+iey93hpiiXzY3M0U2w+3uSyy3l40punOyD5Sccm/dJ6//eePhc+++L95J4itvro8bfZvz/OXtSElSA3k/lwcHMPWnvsvH3x25+43Bi+4YXifB1P/7zUhioruDt+dzJ0nSQXfV7tN9uk/36T+T+FYolaigjC+lvxuI28KN4vUK+xzCG6CSj7Sv+2j7Lg/3jhJrhPC+3yUyqL/Zc3wA3nIOutU7P0SM/qe9R4lVQDUr2O10n+7TfbpPd4JYT/v5/wBwaqmiDQplbmRzdHJlYW0KZW5kb2JqCjQzOCAwIG9iago8PAovTGVuZ3RoMSAzNzk2Ci9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9MZW5ndGggMTYwMgo+PgpzdHJlYW0NCnic7VZLiBzXFT331atXVa++0/Xr7umfu0Zd8nQ80lR1T5OxRjIEyRkwlnGMdsGeSPMRmbEmMzJYZJNFFoFkoaWdRRYxwZuANyEiEAiEbAyGJJuA7YUnjiM7WcYYvFInVd2aGU0wiKBFFjp3ce+7755Xp+7rvt0gACZ+AAVnL3/rTHb5s+c+AuhXAK5c3Vnb/fiPv38ToFcAvLS5tr87HkMB8FsA+ub2rY3Nfw3vAfobgFjeWl+7Nve77e8CdBrA0tbW+hp/mr0FEAcwt7Vz83ULeAfg7wHKe9s3rq690X3zU4B9AtBnO2uv79IlGgD4A4DOq2s76/b7cw7ArP/o+cvujf2bUFAo/qTYB0DjMViZ+ZwWMYMCrMiXuWcwgYLjIJwEAUyOv8QCw/jO+A5b/a+az8sMAS+sn/7by+65L2CycuOvfwp/fd+P74y/ZKtMFr0BO+SyqYJgqj0AL5VZZRXHRXzv4PrBzsHt8Rg4vhp/OP5555XOy53vnNBDDHQbKnR6jjYAPDv1X6CGHxYPVI2jWu8Y8YWNi9fwDC4e3KaD8QEWmIT+QEcEni9UcgOECHvTmMHBtWms4HlE05gfq1ERle9ZxKLMX8E69rCP67iBV9HBIhZwFpfK1c3S72ET6+ggK3c6WEYHe1jHPl7DDtZxHVfL6v3p3iK+jqewiKeQ4SwyDPAi1rGJ17CNNex9BffhsfVVRpXH9miNTfDPR2dKkz3EFT8sGFD/HzijRyjhMR7jkYMB1WPx/yUYcAkK6qjTXbqLBkb4BkBdl0QcXaClLI7CoFzk2QVaGg7SnqKJbtobDi7QUtpzSYTBdDPtjTRxGNOVlTTx/dBPqqvVer3j+4Zpa8npfvrjw0wYtPv99HxZ6Mtbvi9NWbiQ7vbbQej7SRw35tIw8UPDSE6fO5/27719lPP9JF05n/b73TCovHMrCHX9VhD6IIywSu/Sh8Uv0qlAE4Ul3bSX9s7QAiW99MgGpRsORkuFPU1R3GJx1GYtiqPi3SfkMGhTFsVRHsVRnE18nk04WVFYsFrUpiiO6F2FcdGsNaQqBZceN6jrneo9GToGqUzhxIicGUd1KkwISYpCXBhEjBSF6aZmqQZjxYrCRusUqYIYZ1xoJpdCt5gquMJUwRRL8XxGP9Mt0/AclxgjRTDFNuPek0nUIFszyFAslZu1RlMoClN8EkIRlktU6BNMlcWRmigWpKaNVqBwRlRK0BnjTKFCrGC6yRkYqojoU/o7foRfAFTc+lEPis/FfUu6k55N+lY2JzqsjQ9vIn2g8YXl2VFxGByeUZYfow0Ho/M0rR7mWnHq8MSj7z+WNjkXquHZltAUJoRtVdw4jhtx1IjjmTCQpq5phrRnqk5Q99vNaDYIm4252WanXauHkWOZum44M34wG3U7zXanEzf82PY0XQhNk9JyTD+2bWkFTr0aBJ5j6IbeCqIosCtmfyt2XUMVuuCOpbuWKU2uqlyqnkvbP7WkpnApLcsz6tWwWgk8txCpCVv6ge/Xq7NRo+VFXqSbutB069SMbuiG6wVRLezOJt3ZVq0eBZ4tdV3arh9H9Xr1Ca/jeqajS6EahmvqwtA8JwijMPRbhs6F7v/SNGaWpdA5E0xwadi2ZdumFLqK4l/s+wyUwkKIHkZ4Ft/GDXwfvwHQFU0KomwU5sOBFgbdFRpkYdrVhkmRybMm5cNBLz+ZmKcHE3FBzLN41EsmJ+bZKBWjYsKkvRVKiq/ZaGmF1HyYDPOSmmiL5dwp7jbUypmUZxNCcdvT2ZMOi0mUlHNpKc/alIf5Yr6YD2nXk9JTVbVeXxY6546tmi9pQlVth8ufOJPgbdvWuapaupS6par8DDcMrgrLVu/9udlsJXPtF6nOpCZEnSksVrhJ1WXTc23TtF3PdJnCLGk7hlFxbGOFCsyYmqZLIWqaxRxHs+2KcAc1267VNFOI/smo4Wi2waySZJGRVkQhQVQqBrdtVa/4qs8H3KOMFYOAYqYogWIqbGHZNO1WoYMRY1JKw3YqhQQwXEJMb9E/UEMCjBa0sjNRGDiqJrqjbKloqQiij4PFuGU5qrLxzdUNxZLt6igSsdmen2+35uefaF7sfi1sBJGzurGx6sbt4Ez3ckd+0D/X75/rA/8G+eVPxA0KZW5kc3RyZWFtCmVuZG9iago0MzkgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aDEgNDgwMAovTGVuZ3RoIDMyNTIKPj4Kc3RyZWFtDQp4nK1Xe3gU1RU/d2b2kRezu3mtbHFmGRJjN7iQJUgwskOSHRKj5rlfdxIhu5JAoGjSbrRKbQlSlS7Q8IhUhK/hq2gFwdwFNKG1GrV+rVUK/aq1Lwu1am2FpkXRKs1uz53dYLCt/7SX3Ln3vM/9nXOXGSAAkAn9wIO8/PY++brf1H+MnIMA3MYVvStvmZ9VkA3AzwOwHF0ZifZCASho8A7q2FauuXOF7ZrxNUj/A3We6u6KdHKP1b8LMO0oyud3IyNnkL8X6TNIz+q+pe+Oop/xOwBEG6PX9CyPoOx3SKN/KLklckcvfwf/JtI3IS33frmrd+LxJXVI34X+q00vm16Gr5nWQz7caTwvGcJCyIOvACRZrCnPxBfg/zqsqeUo/BCGYe8loo3w9RR2U8Yz8Dw8Zux2w5bPcHsMDqR3g7AL7vuveqthA/rZB0en8MLIvRMewMij8D0AMpP4MOoX09Lfwov/2RX5A3kRtsOjqLkdRvC5G6v+Ve4cbOea4VbuNX493A3fxDMOkVUwgPph2EfaYRlyU2MZdEHPp5zGYCs8DGuxoy4O0/rke5DzzyOY+TfRz05YBV/CSor/vDx5DuYJb0NO4hV4hpcw98fhCcNk/aStpZZfzT3JcRPYNbANVuKMkF9jnlv4xZ+B5v88zOuFbsgTXmI9lPxFYh3m/lus0PcRjRPqkvY2PRRsbWluamy48Ybr66+rq12iBWqqqxar/kXXVl6zsGLB1fPL587xXjW7tOSK4qJZyky35Myz28RpOVmZGVaL2STwHIFSmZJwgPJFsl2LKAElUju7VA44u2tmlwYULUzliExxEYqV2lqDpUSoHJZpMS6RKewwVVFzxac01ZSmelGT2ORKqGQhFJker1HkUdLWFML9lhpFl+lZY3+DsReKDSIHCbcbLYysWLZygGq3d8cCYcyRxLMyq5XqrszZpRDPzMJtFu5oidIbJyWLiLHhSgIL4xxYc1hYPGkg0kkbm0KBGpfbrc8uraPTlBpDBNWGS2quphbDpbyKpQ6b5HjpWGzzqA1uDnuyO5XOyE0hykfQNsYHYrH7qN1Dr1Rq6JVr33TiybtoqVIToB7mtb75Ypz6T0ISaiqyKXLsPOBxlLNnLuVE0hxzke08sC3lqilpDrnZcGmIdSymKbIWC8cio8n+mxXZpsTi2dmx3gDCDY0hdDGa/P4mF9U269QW7iYL9fTRteZ6mtvUHqJckSZ3R5CDf37FvcDltl/UafxvYkBYEBxEWGYwNoZiciC2qcbtcgdqUOym/U0hBs+mURludh0G1evRKRdmkrFJSX6QSfonJSmmisAqWOP6llCMCkV1nUoAkd8Uof03Y5etZgVSbHTaBy63EnPY5QqvbuiyLOo6V8nUVIxgodVUA+wfZhKzGcS0D1LLWRcGKLY75AoF3TA/ASUQTv/d3u1EBzICXutJNURriKo1uFEj6coF4nO8aBEJY+FW1RhFpV6ll+YpVRerbICzqiVkmKTNaF41hfDytBX1Boz7hfCFa1IpMF9KU+gY+JKn4/Nk1xEfzAO9hikXVGO3FQdioc4VVAq7OvH+rZBDLjdVday0roS6dNZ+iNCVp11Gk+hGz7SG6luU+qa20IJ0IikBcycUBT7lRgm5Um6wEam1yCqHOBevo6INGbKGG6WqEp/UUmTFaUPADS5r4KpKOURcMKmNadAr5UBXTVqP0Zc4NbG2qq6d9GZmJPqprnW5dXdqzC7lUCynA6OFlYFaOynCnysUWLFPq2sNFsPSyZpfDildiq50y1RtDLGzMXgMlNNgGJina9V6CTUFLIQJ3CieJBiYVPO4poJLlxg0uzaUa1WwWfBe9aOokRKm0G5cWBf2ku66lI+slKfPtnXRun83rUsFZZYxq1LfEmM5K+k8AQGx46xbjVC0YO+G/5MAW1aNpAVyTKnrjCktoUqXgUFz6GuuteyEDqgn9a1Vs0vjHKmKK2RjU1wlG1vaQvhLWnUM353kja2hwxzhqsNVenwWykPHZADV4HKMy5iMkBnBvDUjYTX0XcdUgH5DKhgMg14+SsDgWSd5BJaPcimeLRWo2AikAocSISVRJ7UF5FlTvH6DZ4w4sGKxU7B76OzGIuN/KwG5kzXIXXp3LKyzSwYFCA/+EUqURQiXsihOOHM2zVS6qmiWUsX4fsb3p/hmxrdga5ICguaX1g6vojz9RVfMdpZBqeOPScz21mw8Do+vbpkwDSzJJIh4iOP4ZlKG75E8WEBScziziTfzGVYTLyDLf9x73O4gFRV2n903d06u2+7Otbvtx4WuC7uv54+b1n+8zlR+oVD4M3tZINAJR4UlwncgC6rV4gx8feD5nOz9HOFFroPjss0cCCbhkJ7xSwu52nKfhbOYjoDft3Spz2MHn69j2dKOpSya3WdEI3bF7i53Y2h3Pje0IxEij+4gj3LhRCs5uJ0cTLRuZzHbyUmugevFZCXVDrxgIvADfYicIJyXEALepV/yGCfA7Mvd+e3kfXJy7148d2PyjKCYdmKuhVCi5jnM2WAG52UZYlTPsPD5UZ2/DPwecPo9UwAgNk6ZydltDneZg5/c+8ocgvLRe++9f5bAR2dHtnz3kW079g4Ncs8mhhKbyZfJcvJFsjqxPbGLzCWOxLnES4lXEn8hn8Pc9+D7uojYZ4JHzROsHJeVbRIE3my2EiB9OjgxA0TG6ff5vL40MnPn+BATU3kRg2UPWZl4jtzwCPnCLqHyjwfeuuDcxTBpxrPNQL+fg2VquSPXWZiXB7kWszMXP2IKcs3CjMun4zGnT+fz8gr79Dysd1RfaSEFFhK1bMCysKNjWZamjw8VTi9DodBAAf85KowH4pEHysziK64u8JXNL59XrMw0W5Rcd76bn+8rKxBmJD5894Vz8pMVZ7bte3hz3df91Mu7Jza4bnv85IfkpVNJOPhQ/s+Hd92z76qruQ92JRa3vY+5r0JMsjH3LPi8mmcVTCbIyIDsHMjIzOjTM80CYmKAkqoKy6QM88jk8hWbg2C7CNm/Oqw/9RbJnsjiHxLGE08mYonB58k0Lkju2YV1DyM2Dqx7IcyCVvWqyx2IC8JidvBFxdlu0R3VRVESuWm8KPL5+a6onm9h8BRaSBqWKaBgx6ZTKUw1bapHLmLiyDWbsUfK5yEcDouBT34ew2q+4Eh8eP7hH3sOzh/dfUAoea7v6Tf/8fq75360Z8PdO3f233jvDdzrifsTazftdlEik6y2W4jw2usTiX3DB07Ev/3gkSV3G/cN5zWK8MDb3R1i5Xlwpb7JfqJ+9CBbX/W8/MKFRyZ2ZK62vIZkBuoTSN1TsCxK3AjVmUcvPPLx2szVaf4nI8MMcJyrwEochE7uALQLUWjEuQdnM85VOMNp3evTcwwnfv8S/EYlr+CXyVacf2Pfw4b3DNIMrXATXjEObODFHXD7OAF/MMliN0r9QEgFBMmi9FpFVPyOlchiXCVcrwEfWYj8BbiiHFRiQb+S8RwignqAjE2Q4QkCEySz4QKRL5DzjSXSOa1E+rv2eelvmkfqGF83zonjDeMd4wPjw+OmrLfevFz64xuaJL5B1De0AukPpzXpxOlTp8dP8+pp33zttOaU/no2KZ0l7wTP1L4b/EsZBP/8zjvBP9VC8G1ISq9feyp4ivDB31/LB3/HJyXxVelVznioP3W6tBPPkR+OVUrPNhZLTz1dIiWPkcbR3tH+UX40OaYmRx1lmjTiH2kY6RlZNzI0MjxicT5Jeg/vPUwP8+JhsvUJQp8g4hPEKh7xHxk/wvfTrZSjdIyepLx32D/M7T1ED3Fjh04e4rwH/Qe5ocfI2IGTB7iG/QP7Oe/+nv3P7E/uF/bsniU17iY9O8kzO8lObYZ0/2ChJA5Kg+sGBwaTg6Y529RtXP820jvQP8BtHSBjAycHuIbNHZt7NvP3aklp6B7yjQ1zpb6oX4riQXpurZRu1cql6cQZvMznDFp8fNCMRw+jrAPnTdpcqb2tVmrDNbfMETQhPEIZH1zDk2y+kr+eX8PfxZvGm5JqZxOnNpUv0NSmohLtRCOp02SpFj0vwTmskVPauMb1a6SgLD9oJ2LQViYG8UsxiC0sSaJf7BDXiYIoesUGsUccEE+JSdHiR964yPcAaQDSX0BMZJRsjbe2eDz1o5YkfnVYGtsp2UiLWthTbWqj5o0Ugm3toTgh39Lv2bIFqmbU0zJ8aQnP0OtpJ3t7YZt+3NhmxAugSo/2Rftu87BBUhvo83iiUbYjjPKkZMaOeKIoRjU0QqLvNoh6on0kGu2DaB/yo2QZ7qNRiCI/StAEZ9ST9n/REwZYho7w0ZcKEY2iXRT9RNPhnMvgX0uYxFYNCmVuZHN0cmVhbQplbmRvYmoKNDQwIDAgb2JqCjw8Ci9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9MZW5ndGggMTIKPj4Kc3RyZWFtDQp4nPv///8PAAnzA/YNCmVuZHN0cmVhbQplbmRvYmoKNDM1IDAgb2JqCjw8Ci9UeXBlIC9PYmpTdG0KL04gOQovRmlyc3QgNjkKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbmd0aCA0NDEgMCBSCj4+CnN0cmVhbQ0KeJy1k0tr20AQx7/KQC7JwfuY2SeEgB8N8aUFu7SFkoNjL66oLBlJhvrbd9aRWxmaXIp12NE+Znb/v/2vQQQFBgms5WAAyXC0gCFydGA1cfRgXeAYwIccIwTD46QgxAD393KRtkXbNUe4HW/ql3QnPzWb1BTVFm7nm1R1RXe8k8vDfl+mHXdBPTzktM/HfQL5WFfdLLXrpth3dXPqflzteGI6zt8NThaHl+LnDc54m0O54iXlatuCkeN2natFsjIXyP8jtEouu7T7AlpFOV3tn1Kx/dGBV0rOu1VZrMfVtkygThtNJvUv+D4ywXGm1zknQtT4fJp9LMqErNMxpMXrka+jdHZWOq+61Lyj1AXhh2KNFsZ7DL1k4mnlKbihcPQCudFvy+cM4ciRhRHpKJxCvnq0gYSKzmcoSkRu3CUWf20sH85YmtQedqlY11XbI7FnJFrxiS1pHGDRVjju9zbwKogYjBkw0T5Yoa2jt5log8L6wHXP9UCfx2iw6yWS8N9IrkMyc5w9MclxU+zqfxgsL/36Cse891KsIRGNJXaKIoFsFAealGZb+gDRR0atjH/+41hl2X3E9P+aVmsRtVFDk7rgOTGQ/NYPWAyCUFF/iUhc2GiKF7Rjpi2n89ky8bGN6uH/Bhe6aZsNCmVuZHN0cmVhbQplbmRvYmoKNDQxIDAgb2JqCjQ4OAplbmRvYmoKNDQyIDAgb2JqCjw8Ci9TaXplIDQ0MwovUm9vdCAyIDAgUgovSW5mbyAzIDAgUgovSUQgWzw3RTBEM0VEOEVFMDk1MjY2NjhCMzYyMDM5NkQxNzkwMT4gPDdFMEQzRUQ4RUUwOTUyNjY2OEIzNjIwMzk2RDE3OTAxPl0KL1R5cGUgL1hSZWYKL0luZGV4IFswIDQ0M10KL1cgWzEgMyAyXQovREwgMjY1OAovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDg5Ngo+PgpzdHJlYW0NCnicLdY5i15lGMfhcybbZE8m+75nsu/7vu97ZrJnMolfIIWmEBUVl8Ym8C/shBssrF87wY8hImJtIRZ2ghDnXLzNxc3Dw32aH5ynaZrm3bu2Gf2tadqmmds0Awa2HOAkTuYUTuU0DnI6Z3AmZ02s+sLCXy3cwU87733Yef/bzpGR/hdncw7nch7nc4gLuJCLuJhLuJTLuJwruJKruJpruJbruJ4buJGbuJnD3MKt3Mbt3MGd3MXd3MO93Mf9PMCDPMTDPMKjPMbjPMGTPMXTPMOzPMfzvMCLvMTLvMKrvMbrvMGbvMXbvMO7vMf7HOEoH/AhH/Exn/Apn/E5x/iC43zJV3xvoGm/6XqYsOUAJ3Eyp3Aqp3GQ0zmDMzmLszmHczmP8znEBVzIRVzMJVzKZVzOFVzJVVzNNVzLdVzPDdzITdzMYW7hVm7jdu7gTu7ibu7hXu7jfh7gQR7iYR7hUR7jcZ7gSZ7iaZ7hWZ7jeV7gRV7iZV7hVV7jdd7gTd7ibd7hXd7jfY5wlA/4kI/4mE/4lM/4nGN8wXG+5Ct2XUVX0VV0FV1FV9FVdBVdRVfRVXQVXUVX0VV0FV1FV9FVdBVdRVfRVXQVXUVX0VV0FV1FV9FVdBVdRVfRVXQVXUVX0VV0FV1FV9FVdBVdRVfRVXQVXUVX0VV0FV1FV9FVdBVdRVfRVXQVXUVX0VV0FV1FV9FVdBVdRVfRVXQVXUVX0VV0FV1FV9FVdBVdRVfRVXQVXUVX0VV0FV1FV9FVdBVdRVfRVXQVXUVX0VV0FV2VrkpXpavSVemqdFW6Kl2VrkpXpavSVemqdFW6Kl2VrkpXpavSVemqdFW6Kl2VrkpXpavSVemqdFW6Kl2VrkpXpavSVemqdFW6Kl2VrkpXpavSVemqdFW6Kl2VrkpXpavSVemqdFW6Kl2VrkpXpavSVemqdFW6Kl2VrkpXpavSVemqdFW6Kl2VrkpXpavSVemqdFW6Kl2VrkpXpavSVTUjbfN6fvfbej3cb2CUD/iQj/iYT9rmjbfQm7/795+2zcdD/flZ23zye39+3jafrenPY23z+Z/9+UXbfHm3P4+3zVffdds++q/z63/75y/5il2fPec9ffb02dNnT589ffb02dNnrxlsm7fvdzvf/tH5Q5nHJpx423Xzz993/vJT51+Dnf84efdjd2dgnB80zf/YMymnDQplbmRzdHJlYW0KZW5kb2JqCnN0YXJ0eHJlZgo2NjE2NQolJUVPRgo="
    const positionsForDoc = {
        'HEADOFAGENCY': "სსიპ ტექნიკური და სამშენებლო ზედამხედველობის სააგენტოს უფროსი",
        'DEPUTYHEADOFAGENCY': "სსიპ ტექნიკური და სამშენებლო ზედამხედველობის სააგენტოს უფროსის მოადგილე",
        'HEADOFDEPARTMENT': "პირველადი სტრუქტურული ერთეულის ხელმძღვანელი",
    };
    const [managerToEditForInternalFlow, setManagerToEditForInternalFlow] = useState(null);
    const firstOptions = [
        "საიდენტიფიკაციო ნომერი",
        "ნებართვის მაძიებელი/მფლობელი ორგანიზაცია",
        "ორგანიზაციის იურიდიული მისამართი",
        "ობიექტის მფლობელის საიდენტიფიკაციო კოდი",
        "ობიექტის მფლობელის დასახელება",
        "ობიექტის მფლობელის იურიდიული მისამართი",
    ]

    useEffect(() => {
        if (caseManagers.length === 0) {
            return;
        }
        setManagerToEditForInternalFlow(caseManagers[caseManagers.length - 1])
    }, [caseManagers]);

    const objectHtml = `
            <div style="font-family: Sylfaen,serif !Important;">
            ${htmlEnums.objectHeader}
            <p><span style="font-size: 22px;">&nbsp;N:{docNumber}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                თარიღი: {dateTime}</span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            <p>&nbsp;<span style="font-size: 20px;">ძვირფასო {fullName},</span></p>
            <p><span style="font-size: 20px;">&nbsp;თქვენი ობიექტი წარმატებით დარეგისტრირდა ობიექტების უწყებრივ რეესტრში.&nbsp;
                &nbsp;რეგისტრაციის&nbsp; &nbsp;ნომერი&nbsp; და თარიღი: {regNumber}, {dateTime}</span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            <p><span style="font-size: 20px;">&nbsp;კეთილი სურვილებით,</span></p>
            <p>
                <span style="font-size: 20px;">&nbsp;საქართველოს ეკონომიკისა და მდგრადი განვითარების სამინისტროს სსიპ ტექნიკური
                    და&nbsp;
                    &nbsp;სამშენებლო&nbsp;ზედამხედველობის სააგენტო. </span></p>
            <p><span style="font-size: 20px;">&nbsp;tacsa.gov.ge&nbsp;</span>
            </p>
            <p><span style="font-size: 20px;"><br></span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            <p><span style="font-size: 20px;"><br></span></p>
            <p><span style="font-size: 20px;"><br></span></p>
            <p><span style="font-size: 20px;"><br></span></p>
            <p><span style="font-size: 20px;"><br></span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            <p><span style="font-size: 20px;"><br></span></p>
            <p><span
                    style="font-size: 20px;"><br></span></p>
            ${htmlEnums.objectFooter}
        </div>
    
    `


    useEffect(() => {
        if (caseDetails.length < 0) {
            return
        }
        setDeclinedDetails(caseDetails.filter(detail => detail.declined === 1))

    }, [caseDetails])


    useEffect(() => {
        if (caseData?.requesterId) {
            fetchUserDetails(caseData.requesterId).then(setRequester)
        }
    }, [caseData])


    useEffect(() => {
        if (caseDetails.length > 0 && caseData) {

            const physicalFirstName = caseDetails.find(detail => detail.key === "დამკვეთის სახელი")
            const physicalLastName = caseDetails.find(detail => detail.key === "დამკვეთის გვარი")

            if (physicalLastName && physicalFirstName) {
                setObjectOwner(`${physicalFirstName.value} ${physicalLastName.value}`)
                return
            }

            const legalObjectOwner = caseDetails.find(detail => detail.key === "ნებართვის მაძიებელი/მფლობელი ორგანიზაცია")
            const orgName = caseDetails.find(detail => detail.key === "ორგანიზაციის სახელი")


            if (legalObjectOwner) {
                setObjectOwner(legalObjectOwner.value)
                return
            }

            if (orgName) {
                setObjectOwner(orgName.value)
                return
            }


            const forgineName = caseDetails.find(detail => detail.key === "დამკვეთის სახელი")

            if (forgineName) {
                setObjectOwner(forgineName.value)
                return
            }


            const owner = caseDetails.find(detail => detail.key === "ობიექტის მფლობელის დასახელება")
            const owenerForBuildingAndExpotion = caseDetails.find(detail => detail.key === "დამკვეთი")

            if (owner) {
                setObjectOwner(owner.value)
            } else if (owenerForBuildingAndExpotion) {
                setObjectOwner(owenerForBuildingAndExpotion.value)
            } else {
                setObjectOwner(caseData.requesterName)
            }
        }
    }, [caseDetails, caseData]);


    useEffect(() => {
        if (caseData) {
            setIsAddressRejected(caseData.addressDeclinedStatus === isCaseParentIdRejectedEnum.prepareDeclination)
            setIsCadastralCodeRejected(caseData.cadastralCodeDenclinedStatus === isCaseParentIdRejectedEnum.prepareDeclination)
        }
    }, [caseData]);


    const findItemAndParents = (items, id, parents = []) => {
        for (const item of items) {
            if (item.id === id) {
                return {path: [...parents, {title: item.title}]};
            } else if (item.childrenPermitTypes && item.childrenPermitTypes.length) {
                const result = findItemAndParents(item.childrenPermitTypes, id, [...parents, {title: item.title}]);
                if (result.path) {
                    return {path: result.path};
                }
            }
        }
        return {path: null};
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const {data} = response.data;
                const result = findItemAndParents(data, caseData.permitTypeId);
                if (result.path) {
                    setPermitTypeTitle(result.path.map(item => item.title).join(' / '));
                }
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };

        if (caseData && caseData.permitTypeId !== null) {
            void fetchData();
        }

    }, [caseData]);

    const fileActiveManagerIsDeputyOrHeadOfAgency = (file) => {
        const user = users.find(user => user.id === file.activeUserId);
        if (!user) {
            return true;
        }
        return !(user.roleName === "HeadOfAgency" || user.roleName === "DeputyHeadOfAgency");
    };


    const isUserHeadOfDepartmentAndCaseHasCaseVisagers = (file) => {

        const caseFileApprovers = caseViewerManagers.filter(manager => manager.caseUserType === CaseUserStatus.CaseViewer);


        if (caseFileApprovers.length === 0) return false;

        const caseUser = users.find(user => user.id === file.activeUserId && user.roleName === "HeadOfDepartment");
        return !!(caseUser && caseViewerManagers.length > 0 && file.sharedTemp);
    };

    useEffect(() => {
        if (caseData && caseData.caseNumber) {
            document.title = "№ " + caseData.caseNumber;
        }
    }, [caseData]);

    useEffect(() => {
        setAnimate(true);
        const timer = setTimeout(() => {
            setAnimate(false);
        }, 500);
        return () => clearTimeout(timer);
    }, [selectedOption]);


    useEffect(() => {
        if (caseData && orderDepartment === NomenclatureEnum.building) {
            if (caseData.status === CaseStatus.Approved.id || caseData.status === CaseStatus.ConditionalEnded.id) {
                setCanUploadDocumentForBuilding(true)
            }
        }
    }, [caseData, orderDepartment]);


    useEffect(() => {
        if (caseFiles.length !== 0) {
            if (orderDepartment === NomenclatureEnum.explosion) {
                if (caseFiles.some(file => file.approvalDocument === true && file.status === CaseFilesStatus.SentForVisage && file.orderDecision === OrderDecisionEnum.Decline.id)) {
                    setDisableCaseFinishButtonForExplosion(false)
                } else {
                    setDisableCaseFinishButtonForExplosion(!caseFiles.some(file => file.decline === CaseFileDeclined.explosionFile && file.status === CaseFilesStatus.SentForVisage && file.isDocumentSigned === true))
                }
            } else {
                setDisableCaseFinishButtonForExplosion(false)
            }
        }
    }, [caseFiles, orderDepartment]);

    const checkIfUserIsInChat = (userId) => caseChatUsers.some(user => user.toUserId === userId);

    const handleCloseUserDialog = () => {
        setUserDialogOpen(false);
    };
    const handleOpenUserDialog = () => {
        setUserDialogOpen(true);
    };

    const handleOpenVisagersPopup = () => {
        setIsVisagersPopupIsOpen(true);
    };
    const handleCloseVisagersPopup = () => {
        setIsVisagersPopupIsOpen(false);
    };
    const handleOpenVisagersFilesPopup = () => {
        setIsVisagersFilesPopupIsOpen(true);
    };
    const handleCloseVisagersFilesPopup = () => {
        setIsVisagersFilesPopupIsOpen(false);
    };


    const handleCloseRewriteRequestDialog = () => {
        setRewriteRequestUserDialogOpen(false);
    };
    const handleOpenRewriteRequestDialog = (userId) => {
        setRewriteUserId(userId)
        setRewriteRequestUserDialogOpen(true);
    };


    const getGroupId = async () => {
        try {
            const response = await axios.get(`${baseURL}/GetChatGroupByCaseID?CaseID=${caseId}`);
            setGroupId(response.data.data);
        } catch (error) {
        }
    };
    useEffect(() => {
        if (roleId && roleId !== "USER") {
            void getGroupId()
        }

    }, [roleId]);

    useEffect(() => {
        if (caseData) {
            setRequesterId(caseData.requesterId)
        }
    }, [caseData]);

    const handleOpenChat = () => {
        setIsChatOpen(true);
    };

    const handleCloseChat = () => {
        setIsChatOpen(false);
    };

    useEffect(() => {
        if (caseDetails.length !== 0 && requester) {

            const ownerIdentificationNumberCaseDetails = caseDetails.find(
                caseDetail => caseDetail.isIdentificationNumber === true &&
                    caseDetail.key === "ობიექტის მფლობელის საიდენტიფიკაციო კოდი" &&
                    caseDetail.value
            );

            const adr = caseDetails.find(
                caseDetail => caseDetail.key === "ობიექტის მფლობელის იურიდიული მისამართი" && caseDetail.value
            );

            const clientAdr = caseDetails.find(
                caseDetail => caseDetail.key === "დამკვეთის იურიდიული მისამართი" && caseDetail.value
            );

            const forginerAdr = caseDetails.find(
                caseDetail => caseDetail.key === "მისამართი" && caseDetail.value
            );

            if (clientAdr){
                setUserAddress(clientAdr.value)
            }
            else if (adr){
                setUserAddress(adr.value)
            }
            else if (forginerAdr){
                setUserAddress(forginerAdr.value)
            }
            else{
                setUserAddress("მისამართი არ არის მითითებული")
            }


            const exploitationIdentificationNumberCaseDetails = caseDetails.find(
                caseDetail => caseDetail.isIdentificationNumber === true &&
                    caseDetail.key === "ობიექტის ექსპლუატაციის გამწევი პირის საიდენტიფიკაციო კოდი" &&
                    caseDetail.value
            );

            const ownerPrivateNumber = caseDetails.find(
                caseDetail => caseDetail.key === "დამკვეთის პირადი ნომერი" && caseDetail.value
            );



            const clientIdentificationNumber = caseDetails.find(
                caseDetail => caseDetail.key === "დამკვეთის საიდენთიფიკაციო ნომერი" && caseDetail.value
            );

            const passportNumber = caseDetails.find(
                caseDetail => caseDetail.key === "პასპორტის ნომერი" && caseDetail.value
            );

            if (ownerIdentificationNumberCaseDetails) {
                setOwnerIdentificationTemplateString(ownerIdentificationNumberCaseDetails.value);
            }

            else if (ownerPrivateNumber){
                setOwnerIdentificationTemplateString(ownerPrivateNumber.value)
            }
            else if (clientIdentificationNumber){
                setOwnerIdentificationTemplateString(clientIdentificationNumber.value)
            }
            else if (passportNumber){
                setOwnerIdentificationTemplateString(passportNumber.value)
            }

            else {

                if (requester.isOorganisation && requester.orgNumber) {
                    setOwnerIdentificationTemplateString(requester.orgNumber);
                } else {
                    setOwnerIdentificationTemplateString(requester.pNumber)
                }
            }
            if (exploitationIdentificationNumberCaseDetails) {
                setExploitationIdentificationTemplateString(exploitationIdentificationNumberCaseDetails.value);
            } else {
                if (requester.isOorganisation && requester.orgNumber) {
                    setExploitationIdentificationTemplateString(requester.orgNumber);
                } else {
                    setExploitationIdentificationTemplateString(requester.pNumber)
                }
            }


        }
    }, [caseDetails, requester]);


    const caseViewerIsHeadOfDepartmentAndHasInternalFlowDocument = (caseViewer) => {

        if (!caseViewer.caseFileId) return false;

        const caseManagerFile = caseFiles.some(file => file.id === caseViewer.caseFileId && file.isDocumentInternal);
        const caseManagerExists = users.some(user => user.roleName === "HeadOfDepartment" && user.id === caseViewer.toUserId);

        return caseManagerFile && caseManagerExists;
    };


    const getNewestDocumentWithPermitDate = (caseFiles) => {
        const documentsWithPermitDate = caseFiles.filter(doc => doc.termOfPermitDate !== null);
        const sortedDocuments = documentsWithPermitDate.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        return sortedDocuments[0];
    };

    const uploadFileToGetDocumentNumber = async () => {

        const file = {
            caseID: parseInt(caseId),
            name: "test",
            ext: "pdf",
            file: dummyFiles.dummy,
            mainInfo: "",
            additionalInfo: "",
            shared: true,
            blank: false,
            documentType: 0,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.Sent,
            decline: CaseFileDeclined.No,
            declinedInternalStatus: 0,
        }


        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, file);

        const caseFilesResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseFileByCaseID?CaseId=${caseId}`);

        const caseFiles = caseFilesResponse.data.data.resultItems

        const caseFile = caseFiles.find(file => file.id === parseInt(response.data.resultId))

        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFile`, {caseFileId: response.data.resultId})

        return caseFile.documentNumber;

    }

    const generateObjectHtml = (template, replacements) => {
        return Object.entries(replacements).reduce(
            (html, [key, value]) => html.replaceAll(`{${key}}`, value),
            template
        );
    };


    const uploadObjectFile = async () => {

        const documentNumber = await uploadFileToGetDocumentNumber();
        const regNumber = await getObjectId();

        const html = generateObjectHtml(objectHtml, {
            docNumber: documentNumber,
            dateTime: new Date().toLocaleDateString('en-GB'),
            fullName: objectOwner,
            regNumber: regNumber,
        });

        const file = {
            caseID: parseInt(caseId),
            name: "წერილი მომეტებული ტექნიკური საფრთხის შემცველი ობიექტის რეგისტრაციაზე",
            mainInfo: "",
            additionalInfo: "",
            shared: true,
            caseFileNumber: documentNumber,
            blank: false,
            documentType: 5555,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.Sent,
            decline: CaseFileDeclined.No,
            declinedInternalStatus: 0,
            isHTML: true,
            html: html,
        }
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, file);

    }


    useEffect(() => {
        async function GetAllCaseNotifications() {
            try {
                const response = await axios.get(`${baseURL}/GetAllCasenotificationByCaseID?CaseId=${caseId}`);
                const notifications = response.data.data;

                const filteredNotifications = notifications.filter(notification => notification.nextStepUserId === userId);

                if (filteredNotifications.length > 0) {

                    const latestNotification = filteredNotifications.sort((a, b) => new Date(b.createAt) - new Date(a.createAt))[0];
                    if (latestNotification.viewed === false
                    ) {
                        setLatestNotification(latestNotification);
                    } else {
                        setLatestNotification([]);
                    }
                } else {
                    setLatestNotification([]);
                }
            } catch (error) {
                console.error('Error fetching notifications:', error);
            } finally {
                setNotificationsFetched(true);
            }
        }

        if (initialLoading) {
            void GetAllCaseNotifications();
        }

        const CaseUserHasViewedCase = async () => {

            if (roleId !== "USER" && roleId !== null && notificationsFetched) {
                const urlParams = new URLSearchParams(window.location.search);
                const caseId = urlParams.get("id");

                const payload = {
                    id: parseInt(caseId)
                };
                try {
                    await axios.put(`${baseURL}/UpdateLasetCaseNotificationViewed`, payload);

                } catch (error) {
                }
            }
        };

        void CaseUserHasViewedCase();

    }, [caseId, userId, initialLoading, roleId]);

    useEffect(() => {
        if (latestNotification) {
            const timer = setTimeout(() => {
                setLatestNotification([]);
            }, 10000);

            return () => clearTimeout(timer);
        }
    }, [latestNotification]);

    const handleClosNotification = () => {
        setLatestNotification([]);
    };

    const handleOpenDialog = (file) => {
        setSelectedCertificateId(file);
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const findCaseFileById = (fileID) => {
        const file = caseFiles.find(file => file.id === fileID);
        return file ? file : "";
    };

    useEffect(() => {
        const approvalExists = caseFiles.some(file =>
            file.approvalDocument === true &&
            file.internal === CaseFilesInternal.Yes &&
            file.isDocumentSigned === true
        );

        setApprovalDocumentExists(approvalExists);
        setApprovalDocWasChecked(true)
    }, [caseFiles, userId]);


    useEffect(() => {
        const token = localStorage.getItem('jwtToken');
        const decoded = jwtDecode(token);
        const USER_ID = decoded.UserId;

        if (roleId === null) {
            return;
        }
        if (!caseId){
            return;
        }
        if (roleId === "ROOTADMIN") {
            return
        }

        if (!caseData) {
            return
        }

        if (USER_ID !== caseData.requesterId && roleId === "USER") {
            navigate(`/caseinfo?id=${caseId}`)
        }
        if (caseData && caseData.creteByExpert && roleId && roleId === "USER") {
            navigate(`/caseinfo?id=${caseId}`)
        } else if (userPermistion && caseData && caseData.creteByExpert && roleId && roleId === "EXPERT" && userPermistion === "cannotEdit") {
            navigate(`/caseinfo?id=${caseId}`)
        }

    }, [caseData, roleId, userPermistion, caseId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/GetPermitTypeTree`);
                const data = response.data.data;
                const findLastChildren = (nodes) => {
                    let children = [];
                    nodes.forEach(node => {
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            children = [...children, ...findLastChildren(node.childrenPermitTypes)];
                        } else {
                            children.push(node);
                        }
                    });
                    return children;
                };

                const lastNode = data[data.length - 1];
                const lastNodeChildren = findLastChildren([lastNode]);
                setObjectsOfRegistery(lastNodeChildren);
            } catch (error) {
            }
        };

        void fetchData();
    }, []);


    useEffect(() => {
        if (objectsOfRegistery.length !== 0 && caseData && caseData.permitTypeId !== null && isObjectInRegistery === null) {
            setIsObjectInRegistery(checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId))
        }
    }, [objectsOfRegistery, caseData, isObjectInRegistery]);


    const GetAllFileTypes = async () => {
        try {
            const responseFileTypes = await axios.get(`${baseURL}/GetAllFileTypes`);
            if (responseFileTypes.data.success) {
                let allFileTypes = responseFileTypes.data.data.filter(type => type.caseId === caseData.permitTypeId && type.isCheck === false);
                allFileTypes = allFileTypes.sort((a, b) => a.sort - b.sort);

                const uploadedFileTypeIds = new Set(caseFiles.map(file => file.fileTypeId));

                let missingFileTypes = allFileTypes.filter(type => !uploadedFileTypeIds.has(type.id));
                if (missingFileTypes && missingFileTypes.length === 0) {
                    setShowMissingFilesPopup(false)
                }
            }
        } catch (error) {
        } finally {
            setInitialLoadingForDocTypes(false)
            setDocTypesAreLoading(false)
        }
    };

    useEffect(() => {
        if (caseData) {
            void GetAllFileTypes()
        }
    }, [caseData, caseFiles]);

    const getUserDetails = (userId) => {
        try {

            return users.find(user => user.id === userId);
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        if (users.length !== 0 && userId) {
            const activeUser = getUserDetails(userId)
            setActiveManagerFullData(activeUser)
        }
    }, [users, userId]);


    const combineUserData = () => {
        const updatedCaseViewerManagers = caseViewerManagers.map(caseManager => {
            const user = users.find(user => user.id === caseManager.toUserId);
            return user ? {...caseManager, departmentId: user.departmentId} : caseManager;
        });

        setCaseViewerManagersWithDepId(updatedCaseViewerManagers);
    };

    useEffect(() => {
        if (caseViewerManagers.length > 0 && users.length > 0 && caseViewerManagersWithDepId.length === 0) {
            combineUserData();
        }
    }, [caseViewerManagers, users]);


    const getFileNameById = (fileId) => {
        const file = caseFiles.find(caseFile => caseFile.id === fileId);
        return file ? file.name : "";
    };

    useEffect(() => {
        const currentYear = new Date().getFullYear();

        const fetchHolidays = async () => {
            try {
                const urlCurrentYear = `${baseURL}/HolidayCalendar/GetHolidays?Year=${currentYear}`;
                const urlNextYear = `${baseURL}/HolidayCalendar/GetHolidays?Year=${currentYear + 1}`;

                const [responseCurrentYear, responseNextYear] = await Promise.all([
                    axios.get(urlCurrentYear),
                    axios.get(urlNextYear)
                ]);

                if (responseCurrentYear.data.success && responseNextYear.data.success) {
                    const combinedHolidays = responseCurrentYear.data.data.response.concat(responseNextYear.data.data.response);
                    setHolidays(combinedHolidays);
                }
            } catch (error) {
                console.error('Failed to fetch holidays:', error);
            }
        };

        void fetchHolidays();
    }, []);

    const handleConfirmButtonClickInternal = async (file) => {
        setFileToProcess(file);
        setIsDialogOpen(true);
    };

    const handleConfirmButtonClickInternalExpert = async (file) => {
        setFileToProcess(file);
        setIsDialogOpenExpert(true);
    };

    const handleDialogClose = () => {
        setIsDialogOpen(false);
    };
    const handleDialogCloseObjectRegistery = () => {
        setIsObjectRegisteryDialogOpen(false);
    };
    const handleDialogOpenObjectRegisteryDialog = () => {
        setIsObjectRegisteryDialogOpen(true);
    };

    const handleDialogCloseExpert = () => {
        setIsDialogOpenExpert(false);
    };

    const handleDialogSubmit = async () => {
        const filesToUpdate = caseFiles.filter(parentFile => parentFile.parentId === fileToProcess.id);

        for (const file of filesToUpdate) {
            await declineAttachment(file, 'decline');
        }

        const updatedFileData = {
            ...fileToProcess,
            declinedInternalStatus: DeclinedInternal.Yes,
            status: CaseFilesStatus.ReadyForVisage,
            internal: CaseFilesInternal.No,
            returnComment: returnComment,
            activeUserId: fileToProcess.creatorId,
            stepHistoryJson: fileToProcess.stepHistoryJson ? fileToProcess.stepHistoryJson + (", " + fileToProcess.creatorId ? `${fileToProcess.creatorId}` : "") : (fileToProcess.creatorId ? `, ${fileToProcess.creatorId}` : "")
        };


        setFileDataToProcess(updatedFileData);
        setIsConfirmationModalVisible(true);
        handleDialogClose();
    };


    const getUserFullNameById = (userId) => {
        const user = users.find(user => user.id === userId)
        if (userId === "ვიზირების მოლოდინში") {
            const agencyDeputy = users.find(user => user.roleName === "DeputyHeadOfAgency")
            if (agencyDeputy) {
                return `${agencyDeputy.firstName} ${agencyDeputy.lastName} (ვიზირების მოლოდინში)`
            } else {
                return `მომხარებელი არ არის აქტიური`
            }
        } else if (user) {
            return `${user.firstName} ${user.lastName}`
        } else if (userId === "შიდა დოკუმენტი") {
            return ``
        } else {
            return `მომხარებელი არ არის აქტიური`
        }
    };


    const getUserDepartmentForRemovingObjectFromRegistery = () => {

        const user = users.find(user => user.id === userId && user.departmentId === departmentID && user.roleName.toLowerCase() === "expert".toLowerCase())

        if (roleId === "HeadOfAgency".toUpperCase() || roleId === "DeputyHeadOfAgency".toUpperCase()) {
            return true;
        }

        return !!user;
    };

    const handleDialogSubmitExpert = async () => {
        const queryParams = new URLSearchParams(location.search);
        const caseId = queryParams.get("id");
        const expertDepartment = await fetchUserDetails(userId)
        const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFDEPARTMENT".toLowerCase() && user.departmentId === expertDepartment.departmentId)
        const toUserId = toUserIdList[0]


        const caseNotificationForExpert = {
            nextStepUserId: toUserId.id,
            caseId: parseInt(caseId, 10),
            documentId: null,
            action: CaseNotificationEnum.declineInternalFile.id,
            caseStatus: 8,
            viewed: false,
            declinationReason: returnCommentExpert,
        };
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotificationForExpert);


        const updatedFileData = {
            documentId: fileToProcess.id,
            caseId: parseInt(caseId, 10),
            requesterId: userId,
            caseDocumentInternalFlowStatus: 55,
            departamentId: 2,
            toUserId: toUserId.id,
            flowTypeStatus: 1,
            comment: returnCommentExpert
        };


        setFileDataToProcessExpert(updatedFileData);
        setIsConfirmationModalVisibleExpert(true);
        handleDialogCloseExpert();
    };


    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await axios.get(`${baseURL}/GetAllDepartament`);
                setDepartments(response.data.data)

            } catch (error) {
            }
        };
        void fetchDepartments();
    }, []);

    const fetchBarcode = async (link, width, height, margin, cropMargin) => {
        try {
            const response = await axios.post(`${baseURL}/GenerateBarcode`, {
                barcodeItem: {link, width, height, margin}
            });
            const img = new Image();
            img.src = response.data.resultId;
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const cropWidth = img.width - cropMargin * 2;
                const cropHeight = img.height;
                canvas.width = cropWidth;
                canvas.height = cropHeight;
                ctx.drawImage(img, cropMargin, 0, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
                setBarcode(canvas.toDataURL());
            }
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        if (barcode === '' && caseData && roleId && roleId !== "USER") {
            void fetchBarcode(caseData.caseNumber, 150, 30, 0, 20)
        }

    }, [barcode, caseData]);

    const updateCaseViewer = async (record) => {
        const body = {
            ...record,
            status: CaseDocumentInternalFlowStatusEnum.SentToHead
        };
        try {
            await axios.put(`${baseURL}/EditCaseUserAllProperty`, body);
        } catch (error) {
        }
    };

    const removeCaseFromRegistery = async () => {
        const queryParams = new URLSearchParams(location.search);
        const caseId = queryParams.get("id");
        const body = {
            id: caseId
        };
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.removeCaseFromRegistery.id,
            caseStatus: 8,
            viewed: true,
        };

        try {
            await axios.post(`${baseURL}/RemoveCaseToRegisteryByExpert`, body);
            await fetchCaseData()
            await fetchCaseFiles()
            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
            setAlertMessage('ობიექტი წარმატებით დაემატა უწებრივ რეესტრს!');
            setAlertType('success');
            setShowRemoveFromObjectRegisteryPopup(false)
            handleDialogCloseObjectRegistery()
            setShowAlert(true);


        } catch (error) {
        }
    };

    const sendNotificationToHeadOfDepartment = async () => {
        const expertDepartment = await fetchUserDetails(userId);

        if (!expertDepartment) {
            console.error("Failed to fetch user details.");
            return;
        }

        const headOfDepartment = users.find(
            user => user.roleName.toLowerCase() === "headofdepartment" && user.departmentId === expertDepartment.departmentId
        );

        if (!headOfDepartment) {
            console.error("Head of department not found.");
            return;
        }

        const caseNotification = {
            nextStepUserId: headOfDepartment.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.requerdToMoveCaseToObjectRegistery.id,
            caseStatus: 8,
            viewed: false,
        };


        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
        } catch (error) {
            console.error("Failed to send notification:", error);
        }
    };

    const MoveCaseToRegisterByExpert = async () => {
        setIsUpdateCaseRegisterModalOpen(false)
        setIsLoadingMergeProcess(true)
        handleDialogCloseObjectRegistery()
        const queryParams = new URLSearchParams(location.search);
        const caseId = queryParams.get("id");
        const body = {
            id: caseId
        };
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.movedCaseToObjectRegistery.id,
            caseStatus: 8,
            viewed: true,
        };


        try {
            if (roleId === "EXPERT") {
                {
                    const payload = {
                        caseId: caseId,
                        requesttomovetoobjectregistrybyexpert: true,
                        requesttomovetoobjectregistrybyexpertDenide: userId,
                        answerOfHeadOfDepartment: false
                    };
                    try {
                        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateRequesttomovetoobjectregistrybyexpert`, payload);
                        await sendNotificationToHeadOfDepartment()
                        setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                        setAlertType('success');
                        setIsUpdateCaseRegisterModalOpen(false)
                        handleDialogCloseObjectRegistery()
                        await fetchCaseData()
                        setShowAlert(true);
                    } catch (error) {
                        console.error('Error merging cases:', error);
                    }
                }
                return
            }


            await axios.post(`${baseURL}/MoveCaseToRegisterByexpert`, body);


            if (!caseData.creteByExpert) {
                const currentDateTime = await fetchDateTimeForConditionalEnding();
                const formattedDateTime = formatDateTimeToISO(currentDateTime);
                const finishCase = {
                    caseId: parseInt(caseId),
                    caseStatus: CaseStatus.Approved.id,
                    finished: true,
                    finishDate: formattedDateTime
                };
                await axios.post(`${baseURL}/UpdateCaseStatus`, finishCase);
                await uploadObjectFile()
            }
            await fetchCaseFiles()
            await fetchCaseData()

            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
            setAlertMessage('ობიექტი წარმატებით დაემატა უწებრივ რეესტრს!');
            setAlertType('success');

            setShowAlert(true);


        } catch (error) {
            console.error('Error updating case status:', error);
        } finally {
            setIsLoadingMergeProcess(false)
        }
    };


    async function fetchFlowData() {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const caseId = urlParams.get('id');

            const endpoint = `${baseURL}/GetALLByCaseIDIdCaseDocumentInternalFlow?CaseId=${caseId}`;

            const response = await axios.get(endpoint);
            if (response.data.success) {
                setFlowData(response.data.data);
            } else {
            }
        } catch (err) {
        }
    }

    useEffect(() => {
        void fetchFlowData();
    }, []);


    useEffect(() => {
        if (caseFiles.length !== 0) {
            const filesThatHaveParent = caseFiles.filter(file => file.parentId !== null);
            const fileIdsObject = filesThatHaveParent.reduce((acc, file) => {
                acc[file.parentId] = true;
                return acc;
            }, {});
            setVisibility(fileIdsObject);
        }
    }, [caseFiles]);


    const toggleVisibility = (parentId) => {
        setVisibility((prevVisibility) => ({
            ...prevVisibility,
            [parentId]: !prevVisibility[parentId],
        }));
    };

    const mainFiles = caseFiles.filter(file => !file.parentId);
    const childFiles = caseFiles.filter(file => file.parentId);

    const childrenByParentId = childFiles.reduce((acc, file) => {
        if (!acc[file.parentId]) {
            acc[file.parentId] = [];
        }
        acc[file.parentId].push(file);
        return acc;
    }, {});

    useEffect(() => {
        const fetchData = async () => {
            const queryParams = new URLSearchParams(location.search);
            const caseId = queryParams.get('id');
            try {
                const response = await axios.get(`${baseURL}/GetCaseHistoryByCaseId`, {
                    params: {
                        CaseId: caseId,
                        PageSize: 1000,
                        Page: 0
                    }
                });
                if (response.data.success) {
                    setCaseHistory(response.data.data);
                } else {
                }
            } catch (error) {
            }
        };
        if (roleId && roleId !== "USER") {
            void fetchData();
        }
    }, [roleId]);

    const fetchPermitType = async () => {
        try {
            const response = await axios.get(`${baseURL}/GetPermitTypeByID?Id=${caseData.permitTypeId}`);

            setHasConditionalDeadline(response.data.data.hasConditionalFinish);
            setHasOrderDate(response.data.data.hasOrderDate);
            setHasExtention(response.data.data.hasExtenstion)
            setDepartmentID(response.data.data.departmentId)
            setCaseDataForDocument(response.data.data)
            setInspectFileDepartmentId(response.data.data.inspectFileDepartmentId)
            setOrderDepartment(response.data.data.orderDepartment)
            if ((response.data.data.orderDepartment === NomenclatureEnum.building || response.data.data.orderDepartment === NomenclatureEnum.explosion) &&
                (caseData.status === CaseStatus.Approved.id || caseData.status === CaseStatus.ConditionalEnded.id)) {
                setCaseCenBeCanceled(true)
            }

        } catch (error) {
        }
    };
    useEffect(() => {
        if (caseData) {
            void fetchPermitType();
        }
    }, [caseData]);


    useEffect(() => {


        if (roleId && roleId === "USER") {
            setInitialLoading(false);
            return;
        }

        if (departmentID && roleId && roleId !== "USER") {
            const fetchDocumentTypes = async () => {
                try {
                    const response = await axios.get(`${baseURL}/GetAllDocumentType`);
                    const docTypes = response.data.data;
                    if (docTypes.length !== 0) {
                        const departmentDocTypes = docTypes.filter(doc => (doc.departamentIds || []).includes(departmentID));
                        setDocumentTypesForEditor(departmentDocTypes);
                    }
                } catch (error) {
                    console.error("Failed to fetch document types:", error);
                } finally {
                    setInitialLoading(false);
                }
            };
            void fetchDocumentTypes();
        }
    }, [departmentID, roleId]);


    const handleCaseNumberClick = (caseId) => {
        window.open(`/dashboard/mycases/casemanager?id=${caseId}`, '_blank');
    };

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClickOpenBoundCases = () => {
        setOpenBoundCases(true);
    };
    const handleClickOpenCaseDetails = () => {
        setOpenCaseDetailsPopup(true);
    };

    const handleClickOpenCaseUserPopup = () => {
        setOpenChangeCaseUserPopup(true);

    };
    const handleClickOpenCaseUserPopupInternalFlow = (file) => {
        setOpenChangeCaseUserPopupInternalFlow(true);
        setInternalFileToEditManager(file)

    };
    const handleClickViewerOpenCaseUserPopup = () => {
        setOpenChangeCaseUserViewerPopup(true);
    };


    const handleClose = () => {
        setOpen(false);
    };

    const handleCloseBoundCases = () => {
        setOpenBoundCases(false);
    };
    const handleCloseCaseDetails = () => {
        setOpenCaseDetailsPopup(false);
    };

    const handleCloseCaseDetailsToChangeCaseOwner = () => {
        setEditModalIsOpen(false);
    };
    const handleCloseCaseUserPopup = () => {
        setOpenChangeCaseUserPopup(false);
    };

    const handleCloseCaseUserPopupInternalFlow = () => {
        setOpenChangeCaseUserPopupInternalFlow(false);
    };
    const handleCloseCaseUserViewerPopup = () => {
        setOpenChangeCaseUserViewerPopup(false);
    };


    const prepareRequestBody = (caseGeography) => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get('id');

        return {
            caseId: caseId,
            councilRejected: caseGeography.council.rejected === LocationProps.declined ? LocationProps.declinedAndSentToUser : 0,
            populatedAreaRejected: caseGeography.populatedArea.rejected === LocationProps.declined ? LocationProps.declinedAndSentToUser : 0,
            regionRejected: caseGeography.region.rejected === LocationProps.declined ? LocationProps.declinedAndSentToUser : 0,
            cityRejected: caseGeography.city.rejected === LocationProps.declined ? LocationProps.declinedAndSentToUser : 0,
            council: caseGeography.council.id,
            populatedArea: caseGeography.populatedArea.id,
            region: caseGeography.region.id,
            city: caseGeography.city.id,
        };
    };

    const changeCaseFileSharedStatus = async (fileId) => {
        const fileToUpdate = caseFiles.find(file => file.id === fileId)

        if (fileToUpdate) {
            const updatedFileData = {
                ...fileToUpdate, shared: !fileToUpdate.shared
            };
            await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            void fetchCaseFiles()
        }
    };

    const submitRejectedProperties = async (caseGeography) => {
        try {
            const requestBody = prepareRequestBody(caseGeography);
            await axios.post(`${baseURL}/UpdateCaseRejectedPropertiesByCaseId`, requestBody);
        } catch (error) {
        }
    };

    useEffect(() => {
        const anyRejected = Object.values(caseGeography).some(geo => geo.rejected === LocationProps.declined);
        setIsDenyButtonDisabledGeo(!anyRejected);
    }, [caseGeography]);

    const areDatesEqualByDay = (deadline, dateTimeNow) => {
        const d1 = new Date(deadline);
        const d2 = new Date(dateTimeNow);
        return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
    };


    const fetchUsers = async (departmentID) => {
        try {
            const response = await axios.get(`${baseURL}/User/GetAllInternalUsers`);
            let users = response.data.data.result;


            let deputyHeads = users.filter(user => user.roleName === "DeputyHeadOfAgency");


            let filteredDeputyHeads = deputyHeads.filter(user => {
                if (!user.deputyDepartments) return false;
                const departments = user.deputyDepartments.split(',').map(d => d.trim());
                return departments.includes(departmentID.toString());
            });

            if (filteredDeputyHeads.length === 0 && deputyHeads.length > 0) {

                filteredDeputyHeads = [deputyHeads[0]];
            }


            const otherUsers = users.filter(user => user.roleName !== "DeputyHeadOfAgency");
            const finalUsers = [...otherUsers, ...filteredDeputyHeads];


            const sortedUsers = finalUsers.sort((a, b) => a.firstName.localeCompare(b.firstName));

            setUsers(sortedUsers);
        } catch (error) {
            console.error(error);
        }
    };


    useEffect(() => {
        const GetDaysBetweenDates = async () => {

            if (dateTime && caseData) {
                const isoDateTimeNow = new Date(dateTime).toISOString()
                try {
                    const response = await axios.get(`${baseURL}/Datetime/GetDaysBetweenDates?Start=${caseData.createdAt}&End=${isoDateTimeNow}`);
                    setDaysForCancel(response.data.data.calculatedDays)
                } catch (error) {
                }
            }
        };
        void GetDaysBetweenDates()
    }, [dateTime, caseData]);

    const preprocessHtmlForPdf = html => {
        const currentDate = new Date()

        const monthsInGeorgian = [
            'იანვარი',
            'თებერვალი',
            'მარტი',
            'აპრილი',
            'მაისი',
            'ივნისი',
            'ივლისი',
            'აგვისტო',
            'სექტემბერი',
            'ოქტომბერი',
            'ნოემბერი',
            'დეკემბერი'
        ]

        const formattedDate =
            `<strong>${currentDate.getDate()} / ${monthsInGeorgian[currentDate.getMonth()]} / ${currentDate.getFullYear()} წ.</strong>`

        const container = document.createElement('div')
        container.innerHTML = html.replace('{ხელმოწერის თარიღი}', formattedDate)

        return container.innerHTML
    }



    // useEffect(() => {
    //     const GetDaysBetweenDates = async () => {
    //         await fetchDateTime()
    //         if (dateTime && caseData && caseData.userFixDeclinationDate) {
    //
    //             const isoDateTimeNow = new Date(dateTime).toISOString()
    //             const isoUserFixDeclinationDate = new Date(caseData.userFixDeclinationDate).toISOString()
    //             try {
    //                 const response = await axios.get(`${baseURL}/Datetime/GetDaysBetweenDates?Start=${isoDateTimeNow}&End=${isoUserFixDeclinationDate}`);
    //                 if (response.data.data.pureDays) {
    //                     setDaysToUploadDeclinedFiles(response.data.data.pureDays)
    //                     setWorkingDaysToUploadDeclinedFiles(response.data.data.calculatedDays)
    //                 }
    //
    //             } catch (error) {
    //             }
    //         }
    //     };
    //     void GetDaysBetweenDates()
    // }, [dateTime, caseData]);



    useEffect(() => {
        if (roleId && roleId !== "USER" && departmentID) {
            void fetchUsers(departmentID)
        }
    }, [roleId, departmentID]);

    const formatDateAndTime = (dateString, roleId) => {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        if (roleId === "USER") {
            return `${day}/${month}/${year}`;
        }
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    const handleConfirmAction = async (approveValue) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get('id');
        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: approveValue ? CaseNotificationEnum.headApprovedRewriteRequest.id : CaseNotificationEnum.headDeniedRewriteRequest.id,
            caseStatus: 8,
            viewed: true,
        };

        try {
            const rewriteRequest = await axios.get(`${baseURL}/GetCaseRewriteRequestByCaseID?CaseId=${caseId}`);
            if (rewriteRequest.data.success) {
                const payload = {
                    id: rewriteRequest.data.data.id, approve: approveValue
                };
                await axios.put(`${baseURL}/ApproveRewriteRequest`, payload);
                await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
            } else {
                return;
            }
        } catch (error) {
            return;
        }

        const rewriteDocument = caseFiles.find(file => file.decline === CaseFileDeclined.RewriteDocument);
        if (rewriteDocument) {
            const updatedFileData = {
                ...rewriteDocument, decline: CaseFileDeclined.RewriteDocumentResponeded
            };


            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            } catch (error) {
                setAlertMessage('Error updating file shared status');
                setAlertType('error');
                setShowAlert(true);
                return;
            }
        }
        await fetchCaseFiles();
        await fetchCaseData();

        setIsModalOpen(false);
        setIsModalOpenDeny(false);
    };


    const timeLeftUntilEndOfWorkingDay = (currentDateTime) => {
        const now = new Date(currentDateTime);
        const targetTime = new Date(dateTime);
        targetTime.setHours(18, 0, 0, 0);
        const diff = targetTime - now;
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        return {hours, minutes};
    };

    const handleEndDeclinationConfirm = async () => {
        try {

            await EndDeclination();
            setIsEndDeclinationModalOpen(false);
        } catch (error) {
        }
    };


    useEffect(() => {
        if (caseData && caseIsCompleted === false) {
            if (caseData.status === 3 || caseData.status === 10 || caseData.status === 8 || caseData.status === 14 || caseData.status === 6 || caseData.status === 14) {
                setCaseIsCompleted(true)
            }
        }
    }, [caseData, caseFiles]);


    useEffect(() => {
        if (caseFiles && caseFiles.length > 0) {

            const declinationDocs = caseFiles.filter(file => file.tempProlongationDays !== null)

            if (declinationDocs.length === 0) {
                return
            }

            const declinationExtensionDoc = declinationDocs[0]

            setProlongationInfo({
                prolongationDays: declinationExtensionDoc.tempProlongationDays,
                prolongationRequestDate: declinationExtensionDoc.prolongationRequestDate,
            });

        }

    }, [caseFiles]);


    const fetchDateTime = async () => {
        const localDateTime = new Date().toISOString()
        setDateTime(localDateTime)
    }

    const fetchDateTimeForConditionalEnding = async () => {
        return new Date().toISOString()
    }

    const formatDateTimeToISO = (dateTime) => {
        return new Date(dateTime).toISOString();
    };

    useEffect(() => {
        void fetchDateTime();
    }, []);


    const handleConfirmButtonClick = (file, action) => {
        const updatedFileData = {
            ...file,
            decline: action === 'accept' ? CaseFileDeclined.ReuploadedFileAccepted : CaseFileDeclined.ReuploadedFileDeclined,
        };


        setFileDataToProcess(updatedFileData);
        setIsConfirmationModalVisible(true);
    };


    const fetchCaseData = async () => {
        const queryParams = new URLSearchParams(location.search);
        const caseId = queryParams.get("id");
        await fetchDateTime();
        if (!caseId) {
            navigate('/dashboard/notfound');
        }

        setIsLoadingCaseData(true);
        const endpoint = roleId === 'USER' ? `${baseURL}/GetCaseByIdByUser?Id=${caseId}` : `${baseURL}/GetCaseById?Id=${caseId}`;

        try {
            const response = await axios.get(endpoint);
            const data = response.data;

            if (data && data.success) {
                if (data.data === null || data.data.length === 0) {
                    navigate('/dashboard/notfound');
                } else {
                    setCaseData(data.data);
                    setCaseGeography({
                        region: {id: data.data.region, rejected: data.data.regionRejected},
                        city: {id: data.data.city, rejected: data.data.cityRejected},
                        council: {id: data.data.council, rejected: data.data.councilRejected},
                        populatedArea: {id: data.data.populatedArea, rejected: data.data.populatedAreaRejected},
                    });
                }
            } else {
                navigate('/dashboard/notfound');
            }
        } catch (error) {
            console.error('Failed to fetch case data:', error);
            navigate('/dashboard/notfound');
        } finally {
            setIsLoadingCaseData(false);
            setIsLoadingCaseDataInitial(false);
        }
    };


    const getObjectId = async () => {
        const queryParams = new URLSearchParams(location.search);
        const caseId = queryParams.get("id");
        await fetchDateTime();
        if (!caseId) {
            navigate('/dashboard/notfound');
        }

        setIsLoadingCaseData(true);
        const endpoint = roleId === 'USER' ? `${baseURL}/GetCaseByIdByUser?Id=${caseId}` : `${baseURL}/GetCaseById?Id=${caseId}`;

        try {
            const response = await axios.get(endpoint);
            const data = response.data;

            if (data && data.success) {
                return data.data.objectRegistryID;
            } else {
                navigate('/dashboard/notfound');
            }
        } catch (error) {
            navigate('/dashboard/notfound');
        } finally {
            setIsLoadingCaseData(false);
            setIsLoadingCaseDataInitial(false);
        }
    };

    const toggleUploadMissingFiles = () => {
        setShowUploadMissingFiles(!showUploadMissingFiles);
    };
    useEffect(() => {
        if (!showUploadMissingFilesExpert) {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showUploadMissingFilesExpert]);

    useEffect(() => {
        if (!showUploadMissingFiles) {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showUploadMissingFiles]);

    const toggleUploadMissingFilesExpert = () => {
        setShowUploadMissingFilesExpert(!showUploadMissingFilesExpert);
    };
    const toggleUploadConditionFiles = () => {
        setConditioalFilesPopup(!conditioalFilesPopup);
    };


    // useEffect(() => {
    //     const CaseUserHasViewedCase = async () => {
    //
    //         if (roleId !== "USER" && roleId !== null) {
    //             const urlParams = new URLSearchParams(window.location.search);
    //             const caseId = urlParams.get("id");
    //
    //             const payload = {
    //                 id: parseInt(caseId)
    //             };
    //             try {
    //                 await axios.put(`${baseURL}/UpdateLasetCaseNotificationViewed`, payload);
    //
    //             } catch (error) {
    //             }
    //         }
    //     };
    //
    //     void CaseUserHasViewedCase();
    // }, [roleId]);

    let foundActiveManager = false;

    const isManagerActive = (manager) => {
        if (foundActiveManager) return false;

        const visageFile = caseFiles.filter(file => file.activeUserId === "ვიზირების მოლოდინში")


        if (visageFile.length > 0) {
            const caseHeadOfDepartment = users.find(user => user.departmentId === departmentID && user.roleName === "HeadOfDepartment" && user.id === manager.toUserId)
            if (caseHeadOfDepartment) {
                foundActiveManager = true;
                return true
            }
        }

        const filesWithActiveUserId = caseFiles.filter(file => file.activeUserId !== null && file.shared === false);
        const activeCaseUser = filesWithActiveUserId.find(file => file.activeUserId === manager.toUserId);

        if (activeCaseUser != null) {
            foundActiveManager = true;
            return true;
        }
        return false;
    };


    useEffect(() => {
        const CaseRequesterHasViewedCase = async () => {

            if (roleId === "USER") {
                const urlParams = new URLSearchParams(window.location.search);
                const caseId = urlParams.get("id");

                const payload = {
                    requesterViewed: true,
                    userViewed: true,
                    caseId: parseInt(caseId)
                };
                try {
                    await axios.put(`${baseURL}/UpdateCaseREquesterViewdbyCaseId`, payload);

                } catch (error) {
                }
            }
        };

        void CaseRequesterHasViewedCase();
    }, [roleId]);

    useEffect(() => {
        const fetchDocumentTypes = async () => {
            if (documentTypesForEditor.length !== 0) {
                const newDocumentTypes = {};
                for (const file of caseFiles) {
                    if (!documentTypes[file.documentType]) {
                        newDocumentTypes[file.documentType] = fetchDocumentTypeName(file.documentType);
                    }
                }
                setDocumentTypes(prev => ({...prev, ...newDocumentTypes}));
            }

        }

        void fetchDocumentTypes();
    }, [caseFiles, documentTypesForEditor]);


    const handleFilesPopupCheckboxChange = (event, file) => {
        const newSelected = {...selectedFilesPopupDocuments};
        if (event.target.checked) {
            newSelected[file.id] = file;
        } else {
            delete newSelected[file.id];
        }
        setSelectedFilesPopupDocuments(newSelected);
    };


    const handleCancelCaseConfirm = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get("id");
        const denyCancellationFile = caseFiles.find(file => file.decline === CaseFileDeclined.CaseCancellationDocument);
        const updatedFileData = {
            ...denyCancellationFile, shared: true, decline: 0
        };
        await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
        await fetchCaseFiles();
        const payload = {
            caseId: parseInt(caseId), caseStatus: CaseStatus.Canceled.id, finished: true
        };
        try {
            const response = await axios.post(`${baseURL}/UpdateCaseStatus`, payload);

            if (response.status === 200) {
                setAlertMessage('განაცხადი გაუქმდა');
                setAlertType('success');
                setShowAlert(true);
                setIsCancelModalOpen(false);
                await fetchCaseData()
            } else {
                setAlertMessage('Failed to update case status');
                setAlertType('error');
                setShowAlert(true);
            }
        } catch (error) {
            setAlertMessage('Error updating case status');
            setAlertType('error');
            setShowAlert(true);
        }
    };


    async function updateFile(file) {
        const updatedDeclineStatus = file.decline === CaseFileDeclined.ReuploadedFileDeclined ? 1 : CaseFileDeclined.FileIsCorrect;
        const updatedFileData = {...file, decline: updatedDeclineStatus};
        await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
    }


    async function sendAttachment(file) {
        const updatedFileData = {...file, internal: CaseFilesInternal.Yes, status: CaseFilesStatus.SentForVisage};
        await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
    }

    async function editAttachmentFiles(file, newParentId) {
        const updatedFileData = {
            ...file,
            parentId: newParentId,
            internal: CaseFilesInternal.Yes,
            status: CaseFilesStatus.SentForVisage
        };
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, updatedFileData);
    }


    const checkIfObjectIsInRegistery = (objects, object) => {
        return objects.filter(item => item.id === object).length !== 0
    };

    const checkIfThereAreAllTheCaseManagers = (caseManagers) => {
        const lastCaseManager = caseManagers[caseManagers.length - 1];
        const lastCaseUser = users.find(user => user.id === lastCaseManager.toUserId);
        if (lastCaseUser) {
            return lastCaseUser.roleName.toLowerCase() === "expert" && (lastCaseManager.returnComment === '' || lastCaseManager.returnComment === null);
        } else {
            return false;
        }

    };

    async function unDeclineFile(file) {
        const updatedFileData = {...file, decline: CaseFileDeclined.No};
        await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
    }

    async function declineAttachment(file, action) {
        const updatedFileData = {
            ...file, declinedInternalStatus: action === 'accept' ?
                DeclinedInternal.No : DeclinedInternal.Yes, status: action === 'accept' ?
                CaseFilesStatus.SentForVisage : CaseFilesStatus.ReadyForVisage
        };
        await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
    }

    const EndDeclination = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get("id");
        const filesToUpdate = caseFiles.filter(file => file.decline === CaseFileDeclined.ReuploadedFileAccepted || file.decline === CaseFileDeclined.ReuploadedFileDeclined);
        const hasDeclinedFiles = caseFiles.some(file => file.decline === CaseFileDeclined.ReuploadedFileDeclined)

        for (const file of filesToUpdate) {
            await updateFile(file);
        }


        const payload = {
            caseId: parseInt(caseId),
            caseStatus: hasDeclinedFiles ? CaseStatus.Declined.id : CaseStatus.CaseCreatedWithFiles.id,
            finished: hasDeclinedFiles
        };

        try {
            const response = await axios.post(`${baseURL}/UpdateCaseStatus`, payload);

            if (response.status === 200) {
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setAlertType('success');
                setShowAlert(true);
                setIsCancelModalOpen(false);
                await fetchCaseData()
                await fetchCaseFiles()

            } else {
                setAlertMessage('დაფიქსირდა შეცდომა');
                setAlertType('error');
                setShowAlert(true);
            }
        } catch (error) {
            setAlertMessage('Error updating case status');
            setAlertType('error');
            setShowAlert(true);
        }
    };

    const handleUpdateObjectRegistryId = async () => {
        await axios.post(`${baseURL}/EduitCaseObjectRegistryID`, {
            id: caseData.id,
            objectRegistryID: newObjectRegistryId
        });
        setOpenObjectRegistryIdDialog(false);
        await sendNotificationAfterEditing(newObjectRegistryId);
        await fetchCaseData();
    };

    const sendNotificationAfterEditing = async (newValue) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.editedField.id,
            caseStatus: 8,
            viewed: true,
            key: ["უწყებრივ რეესტრში რეგისტრაციის ნომერი"],
            oldValue: [caseData.objectRegistryID.toString()],
            newValue: [newValue]
        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };


    const sendToVisageInternalFlow = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get("id");
        const response = await axios.get(`${baseURL}/GetAllCaseUserDefault`);
        const records = response.data.data;
        const matchingRecords = records.filter(record => record.fromRole.toLowerCase() === roleId.toLowerCase() && record.isDeleted === false);
        if (matchingRecords.length > 0) {
            if (roleId === "EXPERT") {

                for (const record of filteredRecords) {
                    await updateCaseViewer(record);
                }

                const token = localStorage.getItem('jwtToken');
                const decoded = jwtDecode(token);
                const USER_ID = decoded.UserId;
                const expertDepartment = await fetchUserDetails(USER_ID)
                const record = matchingRecords[0];
                const toUserIdList = users.filter(user => user.roleName.toLowerCase() === record.toRoleName.toLowerCase() && user.departmentId === expertDepartment.departmentId)
                const toUserId = toUserIdList[0]

                const payload = {
                    caseId: caseId,
                    toUserId: toUserId.id,
                    status: AddNewCaseViewerEnum.SentToAnotherDepartment,
                    approved: true,
                    needApproval: false
                };
                try {
                    await axios.post(`${baseURL}/AddNewCaseViewer`, payload);
                    setIsSendAllConfirmationModalOpen(false);
                    await fetchCaseManagersData();
                    await fetchCaseFiles();
                    setAlertMessage("ოპერაცია წარმატებით დასრულდა");
                    setAlertType("success");
                    setShowAlert(true);
                    setIsModalOpenedToSendCaseToHeadInternalFlow(false)
                } catch (error) {
                    setAlertMessage("ფლოუ არ არის დაკონფიგურერბული, მიმართეთ ადმინისტრაციას");
                    setAlertType("error");
                    setShowAlert(true);
                }
            }

        }

    };


    const makeAdditionalDocumentsUploadeble = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get("id");

        const isRequestedAdditionalDocument = caseFiles.find(file => file.isRequestedAdditionalDocument === AdditionalDocumentEnum.RequestAdding);
        if (isRequestedAdditionalDocument) {
            const updatedFileData = {
                ...isRequestedAdditionalDocument,
                isRequestedAdditionalDocument: AdditionalDocumentEnum.AcceptedAdding,
                shared: true
            };

            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            } catch (error) {
                setAlertMessage('Error updating file shared status');
                setAlertType('error');
                setShowAlert(true);
                return;
            }
        }

        const payload = {
            caseId: parseInt(caseId), caseStatus: CaseStatus.UserIsAbleToAddFiles.id, finished: false
        };

        try {
            const response = await axios.post(`${baseURL}/UpdateCaseStatus`, payload);

            if (response.status === 200) {
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setAlertType('success');
                setShowAlert(true);
                setIsAddDocumentModalOpen(false);
                await fetchCaseData()
                await fetchCaseFiles()

            } else {
                setAlertMessage('დაფიქსირდა შეცდომა');
                setAlertType('error');
                setShowAlert(true);
            }
        } catch (error) {
            setAlertMessage('Error updating case status');
            setAlertType('error');
            setShowAlert(true);
        }
    };


    useEffect(() => {
        const declineCount = caseFiles.filter(file => file.decline === CaseFileDeclined.Yes).length;
        const conditionCount = caseFiles.filter(file => file.decline === CaseFileDeclined.isConditionalFile).length;

        setDeclinedDocCount(declineCount);
        setConditionDocCount(conditionCount);
    }, [caseFiles]);


    const decodeJwtToken = () => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            try {
                return jwtDecode(token);
            } catch (error) {
                return null;
            }
        }
        return null;
    };

    const decodeJwtTokenFromArgument = (userToken) => {
        const token = localStorage.getItem(userToken);
        if (token) {
            try {
                return jwtDecode(token);
            } catch (error) {
                return null;
            }
        }
        return null;
    };


    useEffect(() => {
        const decodedToken = decodeJwtToken();
        if (decodedToken && caseViewerManagers.length > 0) {
            const isVisible = caseViewerManagers.some(manager => manager.toUserId === decodedToken.UserId && manager.status === AddNewCaseViewerEnum.SentToAnotherDepartment);
            setShowConfirmationButton(isVisible);
        }
    }, [caseViewerManagers]);


    const formatPureDate = (dateStr) => {
        const date = new Date(dateStr);
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };

    useEffect(() => {
        const decodedToken = decodeJwtToken();
        if (decodedToken) {
            setCurrentUserId(decodedToken.UserId);
        }
    }, []);


    const toggleUploadPopup = () => {
        setShowUploadPopup(!showUploadPopup);
    };
    const toggleUploadInsideFilePopup = () => {
        setShowUploadInsideFilePopup(!showUploadInsideFilePopup);
    };
    const toggleExplosionUploadPopup = () => {

        setShowUploadExplosionPopup(!showUploadExplosionPopup);
    };

    const toggleUploadPopupInspection = () => {
        setShowUploadPopupInspection(!showUploadPopupInspection);
    };
    const toggleEditPopupInspection = (file = null) => {
        setInspectFileData(file)
        setShowEditPopupInspection(!showEditPopupInspection);
    };

    const toggleUploadPopupAdmin = () => {
        setShowUploadPopupAdmin(!showUploadPopupAdmin);
    };

    const toggleUploadPopupCertificate = () => {
        setShowUploadPopupCertificate(!showUploadPopupCertificate);
    };

    const toggleEditPopupCertificate = (file = null) => {
        setCertificateFileData(file)
        setShowEditPopupCertificate(!showEditPopupCertificate);
    };
    const toggleShowRemoveFromObjectRegisteryPopup = () => {
        setShowRemoveFromObjectRegisteryPopup(!showRemoveFromObjectRegisteryPopup);
    };
    const toggleUploadPopupExpert = () => {
        setShowUploadPopupExpert(!showUploadPopupExpert);
    };


    useEffect(() => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
                setUserId(decoded.UserId);
                setPermission(decoded.CanEditObjectRegister === "True");
            } catch (error) {
            }
        }
    }, []);

    useEffect(() => {
        if (users.length !== 0 && userId) {
            const user = users.find(user => user.id === userId)
            if (roleId === "HEADOFAGENCY" || roleId === "DEPUTYHEADOFAGENCY") {
                setLoggedUserDepartment("69")
            } else if (user) {
                setLoggedUserDepartment(user.departmentId)
            }
        }
    }, [users, userId, roleId]);


    const fetchCaseManagersData = async () => {
        if (roleId !== "USER" && roleId !== null && users.length > 0) {
            setIsLoading(true)
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const caseIDFromURL = urlParams.get("id");
                const response = await axios.get(`${baseURL}/GetAllCaseUser?CaseId=${caseIDFromURL}`);
                const caseManagersData = response.data;

                if (caseManagersData.success) {
                    const enrichedCaseManagers = await Promise.all(caseManagersData.data.map(async (manager) => {
                        const fromUser = getUserDetails(manager.fromUserId);
                        const toUser = getUserDetails(manager.toUserId);
                        return {
                            ...manager,
                            fromUserName: fromUser ? `${fromUser.firstName} ${fromUser.lastName}` : "დაემატა სისტემურად",
                            toUserName: toUser ? `${toUser.firstName} ${toUser.lastName}` : ""
                        };
                    }));
                    setCaseManagers(enrichedCaseManagers.filter(manager => manager.caseUserType === null || manager.caseUserType === CaseUserStatus.CaseUser));
                    setCaseChatUsers(enrichedCaseManagers);
                    setCaseViewerManagers(enrichedCaseManagers.filter(manager => manager.caseUserType !== null && manager.caseUserType !== CaseUserStatus.CaseUser));
                }
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        }
    };
    const updateSharedFiles = async () => {

        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");

        const tempSharedFiles = caseFiles.filter(file => file.sharedTemp === true || file.approvalDocument === true || file.decline === CaseFileDeclined.ConditionalFileAct || file.parentId !== null);

        const headAgencyFiles = tempSharedFiles.filter(file => (file.activeUserId === headOfAgency.id) || (file.parentId !== null));


        const updateFilePromises = headAgencyFiles.map(async (file) => {
            const updatedFileData = {
                ...file,
                shared: file.sharedTemp ? true : file.shared,
                approvalDocument: false,
                decline: file.decline === CaseFileDeclined.ConditionalFileAct ? CaseFileDeclined.ConditionalFileActSent : file.decline

            };
            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            } catch (error) {
            }
        });

        try {
            await Promise.all(updateFilePromises);
            setAlertMessage('ოპერიაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);
        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა');
            setAlertType('error');
            setShowAlert(true);
        }
    };


    const updateCaseConditionDeadline = async () => {
        try {
            const queryParams = new URLSearchParams(location.search);
            const caseId = queryParams.get("id");
            await axios.post(`${baseURL}/UpdateCaseConditionDedline`, {
                conditionDeadline: conditionalDeadlineFromDocState, finishedWithCondition: true, id: caseId
            });
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        const conditionalDeadlineFromDoc = caseFiles
            .filter(file => file.conditionalDeadLine !== null)
            .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];

        if (conditionalDeadlineFromDoc) {
            setConditionalDeadlineFromDocState(conditionalDeadlineFromDoc.conditionalDeadLine)
        }


    }, [caseFiles]);

    const handleUpdateCaseStatus = async () => {
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get("id");
        await fetchDateTime()
        await fetchCaseDetails();
        await handleDeclineAllDetails();
        await submitRejectedProperties(caseGeography);
        setIsLoading(true)
        setIsLoadingCaseData(true)
        setIsLoadingCaseFiles(true)
        const pendingDocToUpdate = caseFiles.find(file => file.decline === CaseFileDeclined.CaseFileIsPending && file.activeUserId === headOfAgency.id);
        if (pendingDocToUpdate) {
            const updatedFileData = {
                ...pendingDocToUpdate, decline: CaseFileDeclined.DeclinationDocument, shared: true
            };

            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            } catch (error) {
                setAlertMessage('Error updating file shared status');
                setAlertType('error');
                setShowAlert(true);
                return;
            }
        }

        await updateSharedFiles();

        const declineFileToUpdate = caseFiles.find(file => file.decline === CaseFileDeclined.DeclinationDocument && file.activeUserId === headOfAgency.id);
        if (declineFileToUpdate) {
            const declinationDate = new Date(dateTime).toISOString()
            const updatedFileData = {
                ...declineFileToUpdate,
                prolongationDays: declineFileToUpdate.tempProlongationDays,
                prolongationRequestDate: declinationDate,
                activeUserId: '',
                shared: true
            };

            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            } catch (error) {
                setAlertMessage('Error updating file shared status');
                setAlertType('error');
                setShowAlert(true);
                return;
            }

            const updateDeadlinePayload = {
                id: parseInt(caseId, 10), days: declineFileToUpdate.tempProlongationDays
            };

            void updateDeadline(updateDeadlinePayload)


        }
        const parentCaseIdToUpdate = caseData.isRejectedCaseParentId === isCaseParentIdRejectedEnum.prepareDeclination;
        if (parentCaseIdToUpdate) {

            try {
                await axios.post(`${baseURL}/UpdateParentCaseIdInfo`, {
                    caseId: caseId,
                    caseParentId: caseData.caseParentId,
                    isRejectedCaseParentId: isCaseParentIdRejectedEnum.Declined
                })
            } catch (error) {
                return;
            }
        }


        const fileToUpdate = caseFiles.find(file => file.decline === CaseFileDeclined.ExtendDaysDocumentActive && file.activeUserId === headOfAgency.id);
        if (fileToUpdate) {

            const updatedFileData = {
                ...fileToUpdate,
                decline: CaseFileDeclined.ExtendDateDocumentInActive,
                shared: fileToUpdate.sharedTemp,
                activeUserId: ''
            };


            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            } catch (error) {
                setAlertMessage('Error updating file shared status');
                setAlertType('error');
                setShowAlert(true);
                return;
            }
        }
        const caseNotificationForExpert = {
            nextStepUserId: deputyHeadOfAgency.id,
            caseId: parseInt(caseId, 10),
            documentId: null,
            action: CaseNotificationEnum.headOfAgencyDeclinedCase.id,
            caseStatus: 8,
            viewed: true,
        };
        await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotificationForExpert);

        const extendDaysApprovedDocumentToUpdate = caseFiles.find(file => file.decline === CaseFileDeclined.ExtendDaysApproved && file.activeUserId === headOfAgency.id && file.tempProlongationDays !== null)
        if (extendDaysApprovedDocumentToUpdate) {

            const prolongationDays = caseFiles.find(file => file.tempProlongationDays !== null && file.creatorId !== caseData.requesterId)

            const updatedFileData = {
                ...extendDaysApprovedDocumentToUpdate,
                decline: CaseFileDeclined.ExtendedDaysApprovedSent,
                shared: extendDaysApprovedDocumentToUpdate.sharedTemp,
                activeUserId: ''
            };

            const updateDeadlinePayload = {
                id: parseInt(caseId, 10), days: prolongationDays.tempProlongationDays
            };

            void updateDeadline(updateDeadlinePayload)


            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);


                const updateStatusPayload = {
                    caseId: caseId,
                    requesterViewed: false,
                    userViewed: false
                };
                await axios.put(`${baseURL}/UpdateCaseREquesterViewdbyCaseId`, updateStatusPayload);

            } catch (error) {
                setAlertMessage('Error updating file shared status');
                setAlertType('error');
                setShowAlert(true);
                return;
            }
        }
        const extendDayDeclinedDocumentToUpdate = caseFiles.find(file => file.decline === CaseFileDeclined.ExtendDaysDeclined && file.activeUserId === headOfAgency.id)
        if (extendDayDeclinedDocumentToUpdate) {
            const updatedFileData = {
                ...extendDayDeclinedDocumentToUpdate,
                decline: CaseFileDeclined.ExtendedDaysDeclinedSent,
                shared: extendDayDeclinedDocumentToUpdate.sharedTemp
            };

            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);

                const updateStatusPayload = {
                    caseId: caseId,
                    requesterViewed: false,
                    userViewed: false
                };
                await axios.put(`${baseURL}/UpdateCaseREquesterViewdbyCaseId`, updateStatusPayload);

            } catch (error) {
                setAlertMessage('Error updating file shared status');
                setAlertType('error');
                setShowAlert(true);
                return;
            }
        }
        const payload = {
            caseId: parseInt(caseId)
        };
        try {
            const response = await axios.post(`${baseURL}/UpdateCaseStatusDecline`, payload);

            let success = false;

            for (let i = 0; i < 10; i++) {
                const caseResponse = await axios.get(`${baseURL}/GetCaseById?Id=${caseId}`);
                if (caseResponse.data.data.status === 4) {
                    success = true;
                    break;
                }
                await axios.post(`${baseURL}/UpdateCaseStatusDecline`, payload);
            }

            if (!success) {
                setAlertMessage('Error updating case status');
                setAlertType('error');
                setShowAlert(true);

            }

            if (response.status === 200) {
                setIsUpdateModalOpen(false);
                await fetchCaseFiles();
                setTimeout(async () => {
                    await fetchCaseData();

                    setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                    setAlertType('success');
                    setShowAlert(true);
                }, 500);
            }
        } catch (error) {
            setAlertMessage('Error updating case status');
            setAlertType('error');
            setShowAlert(true);
        }

        setIsLoading(false)
        setIsLoadingCaseData(false)
        setIsLoadingCaseFiles(false)
    };
    const handleUpdateCaseStatusCondition = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get("id");
        await fetchDateTime()
        const newestDocument = getNewestDocumentWithPermitDate(caseFiles);
        setIsLoading(true)
        setIsLoadingCaseData(true)
        setIsLoadingCaseFiles(true)

        const currentDateTime = await fetchDateTimeForConditionalEnding();
        const formattedDateTime = formatDateTimeToISO(currentDateTime);

        if (!formattedDateTime) {
            throw new Error('Failed to fetch current date and time.');
        }

        await updateSharedFiles();
        await updateCaseConditionDeadline()

        const permitData = {
            caseId: parseInt(caseId),
            termOfPermitDate: newestDocument.termOfPermitDate,
        };
        await axios.post(`${baseURL}/UpdateTermOfPermitDateAndConditionDeadline`, permitData);

        const payload = {
            caseId: parseInt(caseId),
            caseStatus: CaseStatus.ConditionalEnded.id,
            finished: true,
            finishDate: formattedDateTime
        };
        try {
            const response = await axios.post(`${baseURL}/UpdateCaseStatus`, payload);
            if (response.status === 200) {
                setIsUpdateModalOpen(false);
                await fetchCaseFiles();
                setTimeout(async () => {
                    await fetchCaseData();

                    setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                    setAlertType('success');
                    setShowAlert(true);
                }, 500);
            }
        } catch (error) {
            setAlertMessage('Error updating case status');
            setAlertType('error');
            setShowAlert(true);
        }

        setIsLoading(false)
        setIsLoadingCaseData(false)
        setIsLoadingCaseFiles(false)
        setIsUpdateModalOpenForCondition(false)
    };

    const approveDoc = async () => {
        const expertDepartment = await fetchUserDetails(userId)
        const depHeadOfVisager = users.find(user => user.roleName === "HeadOfDepartment" && user.departmentId === expertDepartment.departmentId);

        const caseNotification = {
            nextStepUserId: depHeadOfVisager.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.visagedFile.id,
            caseStatus: 8,
            viewed: false,
        };

        await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);

        const fileHasManagers = caseViewerManagers.filter(caseManager =>
            caseManager.approver === true &&
            caseManager.approverDetalis &&
            caseManager.approverDetalis.split(',').includes(currentFile.id.toString())
        )
        const approvers = caseViewerManagers.filter(caseManager =>
            caseManager.approver === true &&
            caseManager.caseFileId === null
        )
        if (approvers.length - fileHasManagers.length === 1 && currentFile.activeUserId === "ვიზირების მოლოდინში") {
            const updatedFileData = {
                ...currentFile,
                activeUserId: currentFile.tempToUserId,
            };


            const caseNotificationForDeputy = {
                nextStepUserId: currentFile.tempToUserId,
                caseId: parseInt(caseIdMain, 10),
                documentId: currentFile.id,
                action: CaseNotificationEnum.visagedFile.id,
                caseStatus: caseData.status,
                viewed: false
            };
            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotificationForDeputy);

            await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            const filesToUpdate = caseFiles.filter(file => file.parentId === currentFile.id)

            for (const file of filesToUpdate) {
                await sendAttachment(file);
            }

        }


        const record = caseViewerManagers.find(caseViewer => caseViewer.toUserId === userId && caseViewer.approver === true)
        const body = {
            id: record.id,
            caseId: record.caseId,
            fromUserId: record.fromUserId,
            toUserId: record.toUserId,
            dedline: record.dedline,
            status: record.status,
            viewed: record.viewed,
            isReturned: record.isReturned,
            returnComment: record.returnComment,
            caseUserSrartDate: record.caseUserSrartDate,
            caseUserEndDate: record.caseUserEndDate,
            dedlineDays: record.dedlineDays,
            addedBySystem: record.addedBySystem,
            caseUserType: record.caseUserType,
            caseFileId: record.caseFileId,
            approver: record.approver,
            approverStatus: record.approverStatus,
            approverDetalis: record.approverDetalis ? record.approverDetalis + currentFile.id.toString() + ',' : currentFile.id.toString() + ','

        };
        try {
            await axios.put(`${baseURL}/EditCaseUserAllProperty`, body);

        } catch (error) {
        }
        await fetchCaseManagersData()
        await fetchCaseFiles()
        setIsApproveModalOn(false)
    };

    const sendNotification = async (userId) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.removeUser.id,
            caseStatus: 8,
            viewed: true,
            newUserID: userId


        };

        await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
    };
    const sendNotificationDeleteFile = async (fileID) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileID,
            action: CaseNotificationEnum.deletedFile.id,
            caseStatus: 8,
            viewed: true,
        };

        await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
    };
    const sendNotificationInternal = async () => {

        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.visagedFile.id,
            caseStatus: 8,
            viewed: true,
        };

        await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
    };

    const handleDeleteCaseUser = async () => {
        const payload = {id: currentFileCaseUserId.id}
        const deletedUser = users.find(user => user.id === currentFileCaseUserId.toUserId)
        try {
            const response = await axios.post(`${baseURL}/DeleteCaseUser`, payload);
            if (response.status === 200 && response.data.success) {
                let toUserId = null;
                const filesToUpdate = caseFiles.filter(file => file.creatorId === currentFileCaseUserId.toUserId)

                if (deletedUser.roleName.toLowerCase() === "expert") {
                    const expertDepartment = await fetchUserDetails(currentFileCaseUserId.toUserId)
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFDEPARTMENT".toLowerCase() && user.departmentId === expertDepartment.departmentId)
                    toUserId = toUserIdList[0]
                }
                if (deletedUser.roleName.toLowerCase() === "headofdepartment") {
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "DEPUTYHEADOFAGENCY".toLowerCase())
                    toUserId = toUserIdList[0]
                }
                if (deletedUser.roleName.toLowerCase() === "deputyheadofagency") {
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
                    toUserId = toUserIdList[0]
                }
                if (deletedUser.roleName.toLowerCase() === "headofagency") {
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
                    toUserId = toUserIdList[0]
                }
                if (filesToUpdate.length > 0 && toUserId) {
                    const updatePayload = {
                        casefileIds: filesToUpdate.map(file => file.id),
                        caseCreatorId: toUserId.id
                    };
                    await axios.put(`${baseURL}/UpdateCaseFileCreatorId`, updatePayload);
                }
                await sendNotification(currentFileCaseUserId.toUserId)
                await fetchCaseManagersData()
                await fetchCaseFiles()
                setCaseUserDeleteModalOpen(false)
            }


        } catch (error) {
            console.error(error)
        } finally {
            setAlertType('success');
            setAlertMessage('შემსრულებელი წაიშალა!');
            setShowAlert(true);
        }
    };
    const approveDocInternal = async () => {
        const record = caseViewerManagers.find(caseViewer => caseViewer.toUserId === userId && caseViewer.approver === true)
        const body = {
            id: record.id,
            caseId: record.caseId,
            fromUserId: record.fromUserId,
            toUserId: record.toUserId,
            dedline: record.dedline,
            status: record.status,
            viewed: record.viewed,
            isReturned: record.isReturned,
            returnComment: record.returnComment,
            caseUserSrartDate: record.caseUserSrartDate,
            caseUserEndDate: record.caseUserEndDate,
            dedlineDays: record.dedlineDays,
            addedBySystem: record.addedBySystem,
            caseUserType: record.caseUserType,
            caseFileId: record.caseFileId,
            approver: false,
            approverStatus: 4,
            approverDetalis: record.approverDetalis,


        };
        try {
            await axios.put(`${baseURL}/EditCaseUserAllProperty`, body);
        } catch (error) {
        }
        await sendNotificationInternal()
        await fetchCaseManagersData()
        await fetchCaseFiles()
        setIsApproveModalOnInternal(false)
    };

    const handleUpdatePostPone = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get("id");
        const fileToUpdate = caseFiles.find(file => file.postpone === CaseFilesPostPoned.RequestPostPone);
        if (fileToUpdate) {
            const updatedFileData = {
                ...fileToUpdate,
                shared: true,
                status: CaseFilesStatus.Sent,
                postpone: CaseFilesPostPoned.AcceptedPostPone,
            };

            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);

                const postponeDate = new Date(fileToUpdate.postponeDate);
                postponeDate.setDate(postponeDate.getDate() + 1);
                const isoPostponeDate = postponeDate.toISOString();

                const deadlineUpdatePayload = {
                    id: parseInt(caseId),
                    dedline: isoPostponeDate,
                };

                await axios.post(`${baseURL}/UpdateCaseDedline`, deadlineUpdatePayload);


                const payload = {
                    caseId: parseInt(caseId), caseStatus: CaseStatus.Postponed.id, finished: false,
                };

                await axios.post(`${baseURL}/UpdateCaseStatus`, payload);

                setAlertMessage('ოპერაცია წარმატებით დასრულდა ');
                setAlertType('success');
                setShowAlert(true);
                await fetchCaseData();
                await fetchCaseFiles();
                setIsUpdateModalOpenPostPone(false)

                const updateStatusPayload = {
                    caseId: caseId,
                    requesterViewed: false,
                    userViewed: false
                };
                await axios.put(`${baseURL}/UpdateCaseREquesterViewdbyCaseId`, updateStatusPayload);

            } catch (error) {
                setAlertMessage('Error updating file shared status or deadline');
                setAlertType('error');
                setShowAlert(true);

            }
        }
    };

    const updateDeadline = async (updateDeadlinePayload) => {


        try {
            await axios.post(`${baseURL}/UpdateUserFixDeadlinev2`, updateDeadlinePayload);

            for (let i = 0; i < 3; i++) {
                const response = await axios.get(`${baseURL}/GetCaseById?Id=${caseId}`);

                if (response.data.data.userFixDeclinationDate !== updateDeadlinePayload.days) {
                    await axios.post(`${baseURL}/UpdateUserFixDeadlinev2`, updateDeadlinePayload)
                }
                if (response.data.data.userFixDeclinationDate === updateDeadlinePayload.days) {
                    break
                }

            }


        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა');
            setAlertType('error');
            setShowAlert(true);
        }
    };


    const handleUpdateCaseStatusApprove = async () => {

        const urlParams = new URLSearchParams(window.location.search);
        const caseId = urlParams.get("id");


        const fileToUpdate = caseFiles.find(file => file.documentType === 4);
        if (fileToUpdate) {
            const updatedFileData = {...fileToUpdate, shared: true, status: CaseFilesStatus.Sent};

            try {
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            } catch (error) {
                setAlertMessage('Error updating file shared status');
                setAlertType('error');
                setShowAlert(true);
                return;
            }
        }

        const payload = {
            caseId: parseInt(caseId), caseStatus: CaseStatus.Approved.id, finished: true,
        };

        try {
            const response = await axios.post(`${baseURL}/UpdateCaseStatus`, payload);

            if (response.status === 200) {
                setIsUpdateModalOpenToApprove(false);
                await fetchCaseFiles();
                await fetchCaseData();
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setAlertType('success');
                setShowAlert(true);
            } else {
                setAlertMessage('Failed to update case status');
                setAlertType('error');
                setShowAlert(true);
            }
        } catch (error) {
            setAlertMessage('Error updating case status');
            setAlertType('error');
            setShowAlert(true);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchCaseFiles();
            } catch (error) {
            }
        };

        void fetchData();
    }, []);


    useEffect(() => {
        void fetchCaseManagersData();
    }, [roleId, users]);



    const signDocumentByHeadOfAgencyToCancel = async (fileData) => {

        setIsLoading(true)
        const filesToUpdate = caseFiles.filter(file => file.parentId === fileData.id)

        try {


            const isDev = process.env.REACT_APP_API_BASE_URL.toLowerCase() === "https://devtacsa.admi.ge/api"
            const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
            const toUserId = toUserIdList[0]
            const sign = generateSignature(positionsForDoc[roleId], fileData.fullname)
            const document = preprocessHtmlForPdf(fileData.mainInfo)


            const requestBodyForSignedFile = {
                ...fileData,
                caseID: fileData.caseID,
                name: fileData.name,
                ext: fileData.ext,
                mainInfo: fileData.mainInfo,
                additionalInfo: fileData.additionalInfo,
                sharedTemp: true,
                shared: true,
                blank: fileData.blank,
                documentType: fileData.documentType,
                internal: CaseFilesInternal.Yes,
                isExtentionAttachment: false,
                isExtentionAttachmentApprovedByHead: true,
                decline: fileData.decline,
                orderDecision: fileData.orderDecision,
                approvalDocument: fileData.approvalDocument,
                oldDocumentId: fileData.oldDocumentId,
                tempProlongationDays: fileData.tempProlongationDays,
                conditionalDeadLine: fileData.conditionalDeadLine,
                termOfPermitDate: fileData.termOfPermitDate,
                declinedInternalStatus: DeclinedInternal.No,
                postpone: fileData.postpone,
                answerStatus: fileData.answerStatus,
                toUserId: '',
                departamentId: fileData.departamentId,
                isDocumentInternal: fileData.isDocumentInternal,
                pureDays: fileData.pureDays,
                postponeDate: fileData.postponeDate,
                additionalInternalDocumentation: fileData.additionalInternalDocumentation,
                casefileNumber: fileData.casefileNumber,
                status: CaseFilesStatus.SentForVisage,
                activeUserId: toUserId ? `${toUserId.id}` : "",
                isDocumentSigned: true,
                html: document + sign,
                isHTML: true,
                documentSignedUserFullName: fileData.fullname,
                stepHistoryJson: fileData.stepHistoryJson ? fileData.stepHistoryJson + (toUserId ? `, ${toUserId.id}` : "") : (toUserId ? `, ${toUserId.id}` : "")
            };

            const tempSignedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBodyForSignedFile);

            const signRequest = {
                signRequest: {
                    caseFileId: isDev ? 7839 : parseInt(tempSignedFileResponse.data.resultId, 10),
                    documentName: fileData.name
                }
            };

            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: parseInt(tempSignedFileResponse.data.resultId, 10)});

            let signedFileResponse


            if (!isDev) {
                signedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/Sign`, signRequest);
            }


            const requestBody = {
                ...fileData,
                caseID: fileData.caseID,
                name: fileData.name,
                ext: fileData.ext,
                file: !isDev ? signedFileResponse.data.base64 : fileForDev,
                mainInfo: fileData.mainInfo,
                additionalInfo: fileData.additionalInfo,
                sharedTemp: true,
                shared: true,
                blank: fileData.blank,
                documentType: fileData.documentType,
                internal: CaseFilesInternal.Yes,
                isExtentionAttachment: false,
                isExtentionAttachmentApprovedByHead: true,
                decline: fileData.decline,
                orderDecision: fileData.orderDecision,
                approvalDocument: fileData.approvalDocument,
                oldDocumentId: fileData.oldDocumentId,
                tempProlongationDays: fileData.tempProlongationDays,
                conditionalDeadLine: fileData.conditionalDeadLine,
                termOfPermitDate: fileData.termOfPermitDate,
                declinedInternalStatus: DeclinedInternal.No,
                postpone: fileData.postpone,
                answerStatus: fileData.answerStatus,
                toUserId: fileData.toUserId,
                departamentId: fileData.departamentId,
                isDocumentInternal: fileData.isDocumentInternal,
                pureDays: fileData.pureDays,
                postponeDate: fileData.postponeDate,
                additionalInternalDocumentation: fileData.additionalInternalDocumentation,
                casefileNumber: fileData.casefileNumber,
                status: CaseFilesStatus.SentForVisage,
                activeUserId: toUserId ? `${toUserId.id}` : "",
                isDocumentSigned: true,
                documentSignedUserFullName: fileData.fullname,
                stepHistoryJson: fileData.stepHistoryJson ? fileData.stepHistoryJson + (toUserId ? `, ${toUserId.id}` : "") : (toUserId ? `, ${toUserId.id}` : "")
            };

            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: fileData.id});
            const newCaseFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);

            for (const file of filesToUpdate) {
                await editAttachmentFiles(file, newCaseFileResponse.data.resultId);
            }
            const caseNotification = {
                nextStepUserId: toUserId ? `${toUserId.id}` : "",
                caseId: parseInt(caseIdMain, 10),
                documentId: fileData.id,
                action: CaseNotificationEnum.signedTheDocument.id,
                caseStatus: caseData.status,
                viewed: true
            };

            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);
        } catch {

            setAlertMessage('ელექტრონული ხელმოწერის მოწყობილობას აქვს პრობლემა გთხოვთ მიმართოთ IT დახმარების გუნდს!')
            setAlertType('error');
            setShowAlert(true);
        }
        await fetchCaseFiles();
        setIsLoading(false)
    };


    const signDocumentByHeadOfAgency = async (fileData) => {

        setIsLoading(true)
        const filesToUpdate = caseFiles.filter(file => file.parentId === fileData.id)

        try {


            const isDev = process.env.REACT_APP_API_BASE_URL.toLowerCase() === "https://devtacsa.admi.ge/api"
            const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
            const toUserId = toUserIdList[0]
            const sign = generateSignature(positionsForDoc[roleId], fileData.fullname)
            const document = preprocessHtmlForPdf(fileData.mainInfo)

            const requestBodyForSignedFile = {
                ...fileData,
                caseID: fileData.caseID,
                name: fileData.name,
                ext: fileData.ext,
                mainInfo: fileData.mainInfo,
                additionalInfo: fileData.additionalInfo,
                sharedTemp: fileData.sharedTemp,
                shared: fileData.decline === CaseFileDeclined.explosionFile ? true : fileData.shared,
                blank: fileData.blank,
                documentType: fileData.documentType,
                internal: CaseFilesInternal.Yes,
                isExtentionAttachment: false,
                isExtentionAttachmentApprovedByHead: true,
                decline: fileData.decline,
                orderDecision: fileData.orderDecision,
                approvalDocument: fileData.approvalDocument,
                oldDocumentId: fileData.oldDocumentId,
                tempProlongationDays: fileData.tempProlongationDays,
                conditionalDeadLine: fileData.conditionalDeadLine,
                termOfPermitDate: fileData.termOfPermitDate,
                declinedInternalStatus: DeclinedInternal.No,
                postpone: fileData.postpone,
                answerStatus: fileData.answerStatus,
                toUserId: fileData.toUserId,
                departamentId: fileData.departamentId,
                isDocumentInternal: fileData.isDocumentInternal,
                pureDays: fileData.pureDays,
                postponeDate: fileData.postponeDate,
                additionalInternalDocumentation: fileData.additionalInternalDocumentation,
                casefileNumber: fileData.casefileNumber,
                status: CaseFilesStatus.SentForVisage,
                activeUserId: toUserId ? `${toUserId.id}` : "",
                isDocumentSigned: true,
                html: document + sign,
                isHTML: true,
                documentSignedUserFullName: fileData.fullname,
                stepHistoryJson: fileData.stepHistoryJson ? fileData.stepHistoryJson + (toUserId ? `, ${toUserId.id}` : "") : (toUserId ? `, ${toUserId.id}` : "")
            };

            const tempSignedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBodyForSignedFile);

            const signRequest = {
                signRequest: {
                    caseFileId: isDev ? 7839 : parseInt(tempSignedFileResponse.data.resultId, 10),
                    documentName: fileData.name
                }
            };

            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: parseInt(tempSignedFileResponse.data.resultId, 10)});

            let signedFileResponse


            if (!isDev) {
                signedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/Sign`, signRequest);
            }


            const requestBody = {
                ...fileData,
                caseID: fileData.caseID,
                name: fileData.name,
                ext: fileData.ext,
                file: !isDev ? signedFileResponse.data.base64 : fileForDev,
                mainInfo: fileData.mainInfo,
                additionalInfo: fileData.additionalInfo,
                sharedTemp: fileData.sharedTemp,
                shared: fileData.shared,
                blank: fileData.blank,
                documentType: fileData.documentType,
                internal: CaseFilesInternal.Yes,
                isExtentionAttachment: false,
                isExtentionAttachmentApprovedByHead: true,
                decline: fileData.decline,
                orderDecision: fileData.orderDecision,
                approvalDocument: fileData.approvalDocument,
                oldDocumentId: fileData.oldDocumentId,
                tempProlongationDays: fileData.tempProlongationDays,
                conditionalDeadLine: fileData.conditionalDeadLine,
                termOfPermitDate: fileData.termOfPermitDate,
                declinedInternalStatus: DeclinedInternal.No,
                postpone: fileData.postpone,
                answerStatus: fileData.answerStatus,
                toUserId: fileData.toUserId,
                departamentId: fileData.departamentId,
                isDocumentInternal: fileData.isDocumentInternal,
                pureDays: fileData.pureDays,
                postponeDate: fileData.postponeDate,
                additionalInternalDocumentation: fileData.additionalInternalDocumentation,
                casefileNumber: fileData.casefileNumber,
                status: CaseFilesStatus.SentForVisage,
                activeUserId: toUserId ? `${toUserId.id}` : "",
                isDocumentSigned: true,
                documentSignedUserFullName: fileData.fullname,
                stepHistoryJson: fileData.stepHistoryJson ? fileData.stepHistoryJson + (toUserId ? `, ${toUserId.id}` : "") : (toUserId ? `, ${toUserId.id}` : "")
            };
            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: fileData.id});
            const newCaseFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);

            for (const file of filesToUpdate) {
                await editAttachmentFiles(file, newCaseFileResponse.data.resultId);
            }
            const caseNotification = {
                nextStepUserId: toUserId ? `${toUserId.id}` : "",
                caseId: parseInt(caseIdMain, 10),
                documentId: fileData.id,
                action: CaseNotificationEnum.signedTheDocument.id,
                caseStatus: caseData.status,
                viewed: true
            };

            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);
        } catch {

            setAlertMessage('ელექტრონული ხელმოწერის მოწყობილობას აქვს პრობლემა გთხოვთ მიმართოთ IT დახმარების გუნდს!')
            setAlertType('error');
            setShowAlert(true);
        }
        await fetchCaseFiles();
        setIsLoading(false)
    };

    const signDocumentByHeadOfAgencyAndMakeCaseSecret = async (fileData) => {

        setIsLoading(true)
        const filesToUpdate = caseFiles.filter(file => file.parentId === fileData.id)

        try {


            const isDev = process.env.REACT_APP_API_BASE_URL.toLowerCase() === "https://devtacsa.admi.ge/api"
            const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
            const toUserId = toUserIdList[0]
            const sign = generateSignature(positionsForDoc[roleId], fileData.fullname)

            const requestBodyForSignedFile = {
                ...fileData,
                caseID: fileData.caseID,
                name: fileData.name,
                ext: fileData.ext,
                mainInfo: fileData.mainInfo,
                additionalInfo: fileData.additionalInfo,
                sharedTemp: fileData.sharedTemp,
                shared: fileData.decline === CaseFileDeclined.explosionFile ? true : fileData.shared,
                blank: fileData.blank,
                documentType: fileData.documentType,
                internal: CaseFilesInternal.Yes,
                isExtentionAttachment: false,
                isExtentionAttachmentApprovedByHead: true,
                decline: fileData.decline,
                orderDecision: fileData.orderDecision,
                approvalDocument: fileData.approvalDocument,
                oldDocumentId: fileData.oldDocumentId,
                tempProlongationDays: fileData.tempProlongationDays,
                conditionalDeadLine: fileData.conditionalDeadLine,
                termOfPermitDate: fileData.termOfPermitDate,
                declinedInternalStatus: DeclinedInternal.No,
                postpone: fileData.postpone,
                answerStatus: fileData.answerStatus,
                toUserId: fileData.toUserId,
                departamentId: fileData.departamentId,
                isDocumentInternal: fileData.isDocumentInternal,
                pureDays: fileData.pureDays,
                postponeDate: fileData.postponeDate,
                additionalInternalDocumentation: fileData.additionalInternalDocumentation,
                casefileNumber: fileData.casefileNumber,
                status: CaseFilesStatus.SentForVisage,
                activeUserId: toUserId ? `${toUserId.id}` : "",
                isDocumentSigned: true,
                html: fileData.mainInfo + sign,
                isHTML: true,
                documentSignedUserFullName: fileData.fullname,
                stepHistoryJson: fileData.stepHistoryJson ? fileData.stepHistoryJson + (toUserId ? `, ${toUserId.id}` : "") : (toUserId ? `, ${toUserId.id}` : "")
            };

            const tempSignedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBodyForSignedFile);

            const signRequest = {
                signRequest: {
                    caseFileId: isDev ? 7839 : parseInt(tempSignedFileResponse.data.resultId, 10),
                    documentName: fileData.name
                }
            };

            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: parseInt(tempSignedFileResponse.data.resultId, 10)});

            let signedFileResponse


            if (!isDev) {
                signedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/Sign`, signRequest);
            }


            const requestBody = {
                ...fileData,
                caseID: fileData.caseID,
                name: fileData.name,
                ext: fileData.ext,
                file: !isDev ? signedFileResponse.data.base64 : fileForDev,
                mainInfo: fileData.mainInfo,
                additionalInfo: fileData.additionalInfo,
                sharedTemp: fileData.sharedTemp,
                shared: true,
                blank: fileData.blank,
                documentType: fileData.documentType,
                internal: CaseFilesInternal.Yes,
                isExtentionAttachment: false,
                isExtentionAttachmentApprovedByHead: true,
                decline: fileData.decline,
                orderDecision: fileData.orderDecision,
                approvalDocument: fileData.approvalDocument,
                oldDocumentId: fileData.oldDocumentId,
                tempProlongationDays: fileData.tempProlongationDays,
                conditionalDeadLine: fileData.conditionalDeadLine,
                termOfPermitDate: fileData.termOfPermitDate,
                declinedInternalStatus: DeclinedInternal.No,
                postpone: fileData.postpone,
                answerStatus: fileData.answerStatus,
                toUserId: fileData.toUserId,
                departamentId: fileData.departamentId,
                isDocumentInternal: fileData.isDocumentInternal,
                pureDays: fileData.pureDays,
                postponeDate: fileData.postponeDate,
                additionalInternalDocumentation: fileData.additionalInternalDocumentation,
                casefileNumber: fileData.casefileNumber,
                status: CaseFilesStatus.SentForVisage,
                activeUserId: toUserId ? `${toUserId.id}` : "",
                isDocumentSigned: true,
                documentSignedUserFullName: fileData.fullname,
                stepHistoryJson: fileData.stepHistoryJson ? fileData.stepHistoryJson + (toUserId ? `, ${toUserId.id}` : "") : (toUserId ? `, ${toUserId.id}` : "")
            };
            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: fileData.id});
            const newCaseFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);

            for (const file of filesToUpdate) {
                await editAttachmentFiles(file, newCaseFileResponse.data.resultId);
            }


            const caseNotification = {
                nextStepUserId: toUserId ? `${toUserId.id}` : "",
                caseId: parseInt(caseIdMain, 10),
                documentId: fileData.id,
                action: CaseNotificationEnum.signedTheDocument.id,
                caseStatus: caseData.status,
                viewed: true
            };

            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);

            const secretDocumentIsSecret = caseFiles.some(file => file.isSecretDoc === 1)


            if (secretDocumentIsSecret) {
                const makeCaseSecret = {
                    caseID: caseId,
                    isPublic: false
                }

                await axios.post(`${baseURL}/UpdateCaseIsPublicByCaseID`, makeCaseSecret);
            }
            const updateStatusPayload = {
                caseId: caseId,
                requesterViewed: false,
                userViewed: false
            };
            await axios.put(`${baseURL}/UpdateCaseREquesterViewdbyCaseId`, updateStatusPayload);


        } catch {

            setAlertMessage('ელექტრონული ხელმოწერის მოწყობილობას აქვს პრობლემა გთხოვთ მიმართოთ IT დახმარების გუნდს!')
            setAlertType('error');
            setShowAlert(true);
        }
        await fetchCaseFiles();
        await fetchCaseData()
        setIsLoading(false)
    };

    const saveExplosionFile = async (fileData) => {

        setIsLoading(true)

        try {

            const updatedFileData = {
                ...fileData,
                internal: true,
                status: caseMustBeActiveForUploadBuilidngFile ? CaseFilesStatus.New : CaseFilesStatus.SentForVisage,
                isDocumentSigned: true,
                shared: true,
            };
            await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);

            const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
            const toUserId = toUserIdList[0]


            const caseNotification = {
                nextStepUserId: toUserId ? `${toUserId.id}` : "",
                caseId: parseInt(caseIdMain, 10),
                documentId: fileData.id,
                action: CaseNotificationEnum.signedTheDocument.id,
                caseStatus: caseData.status,
                viewed: true
            };

            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);

            const updateStatusPayload = {
                caseId: caseId,
                requesterViewed: false,
                userViewed: false
            };
            await axios.put(`${baseURL}/UpdateCaseREquesterViewdbyCaseId`, updateStatusPayload);

        } catch {

            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!');
            setAlertType('error');
            setShowAlert(true);
        }
        await fetchCaseFiles();
        setIsLoading(false)
    };


    const sendCaseViewerRequest = async (fileData) => {
        setIsLoading(true)
        const flowDataToEdit = flowData.filter(flow => flow.documentId === fileData.id)
        const isDev = process.env.REACT_APP_API_BASE_URL.toLowerCase() === "https://devtacsa.admi.ge/api"

        const payload = {
            id: caseId,
            signStatus: 4
        }
        await axios.post(`${baseURL}/UpdateCaseInternalVisageStatusAndSignStatus`, payload)

        try {
            for (const flowData of flowDataToEdit) {
                const updatedFileData = {
                    ...flowData,
                    caseDocumentInternalFlowStatus: CaseDocumentInternalFlowStatusEnum.SentToAnotherDepartment,
                };

                try {
                    await axios.put(`${baseURL}/EditCaseDocumentInternalFlow`, updatedFileData);
                } catch (error) {
                    setAlertMessage('დაფიქსირდა შეცდომა');
                    setAlertType('error');
                    setShowAlert(true);
                    return;
                }
            }

            const sign = generateSignature(positionsForDoc[roleId], fileData.fullname)
            const document = preprocessHtmlForPdf(fileData.mainInfo)

            const requestBodyForSignedFile = {
                ...fileData,
                stepHistoryJson: fileData.creatorId,
                answerStatus: CaseDocumentInternalFlowStatusEnum.SentToAnotherDepartment,
                internal: CaseFilesInternal.Yes,
                activeUserId: fileData.toUserId,
                status: CaseFilesStatus.SentForVisage,
                documentSignedUserFullName: fileData.fullname,
                html: document + sign,
                isHTML: true,
            };

            const tempSignedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBodyForSignedFile);

            const signRequest = {
                signRequest: {
                    caseFileId: isDev ? 7839 : parseInt(tempSignedFileResponse.data.resultId, 10),
                    documentName: fileData.name
                }
            };

            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: parseInt(tempSignedFileResponse.data.resultId, 10)});


            const signedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/Sign`, signRequest);

            const requestBody = {
                ...fileData,
                stepHistoryJson: fileData.creatorId,
                file: signedFileResponse.data.base64,
                answerStatus: CaseDocumentInternalFlowStatusEnum.SentToAnotherDepartment,
                internal: CaseFilesInternal.Yes,
                activeUserId: fileData.toUserId,
                status: CaseFilesStatus.SentForVisage,
                documentSignedUserFullName: fileData.fullname,

            };
            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: fileData.id});
            const newCaseFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);


            const caseNotification = {
                nextStepUserId: fileData.toUserId,
                caseId: parseInt(caseIdMain, 10),
                documentId: fileData.id,
                action: CaseNotificationEnum.sentToAnotherDepartment.id,
                caseStatus: caseData.status,
                viewed: false
            };

            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);

            const payload = {
                caseId: caseId,
                toUserId: fileData.toUserId,
                status: AddNewCaseViewerEnum.SentToAnotherDepartment,
                dedlineDays: null,
                addedBySystem: false,
                caseUserType: CaseUserStatus.CaseApprover,
                caseFileId: parseInt(newCaseFileResponse.data.resultId, 10)
            };

            const chatUsersPayload = {
                chatName: groupId.chatName,
                chatUsersIds: [...groupId.chatUsersIds, ...[payload.toUserId]],
                id: groupId.id,
                caseNumber: groupId.caseNumber,
                caseID: groupId.caseID
            };

            await axios.post(`${baseURL}/AddNewCaseUser`, payload);
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditChatGroup`, chatUsersPayload);


            const filesToUpdate = caseFiles.filter(file => file.parentId === fileData.id)

            for (const file of filesToUpdate) {
                await editAttachmentFiles(file, newCaseFileResponse.data.resultId);
            }

            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);
        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!');
            setAlertType('error');
            setShowAlert(true);
            console.error(error)
        }
        await fetchCaseFiles()
        await fetchFlowData()
        await fetchCaseManagersData()
        setIsLoading(false)
    };

    const removeCaseFromRegisteryByHead = async (fileData, isAccepted) => {

        setIsLoading(true)

        try {

            const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
            const toUserId = toUserIdList[0]
            const isDev = process.env.REACT_APP_API_BASE_URL.toLowerCase() === "https://devtacsa.admi.ge/api"


            const signRequest = {
                signRequest: {
                    caseFileId: isDev ? 7839 : fileData.id,
                    documentName: fileData.name
                }
            };

            let signedFileResponse


            if (!isDev) {
                signedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/Sign`, signRequest);
            }

            const requestBody = {
                ...fileData,
                caseID: fileData.caseID,
                name: fileData.name,
                ext: fileData.ext,
                file: !isDev ? signedFileResponse.data.base64 : fileForDev,
                mainInfo: fileData.mainInfo,
                additionalInfo: fileData.additionalInfo,
                sharedTemp: true,
                shared: true,
                blank: fileData.blank,
                documentType: fileData.documentType,
                internal: CaseFilesInternal.Yes,
                isExtentionAttachment: false,
                casefileNumber: fileData.casefileNumber,
                isExtentionAttachmentApprovedByHead: true,
                decline: 0,
                orderDecision: fileData.orderDecision,
                approvalDocument: fileData.approvalDocument,
                oldDocumentId: fileData.oldDocumentId,
                tempProlongationDays: fileData.tempProlongationDays,
                conditionalDeadLine: fileData.conditionalDeadLine,
                termOfPermitDate: fileData.termOfPermitDate,
                declinedInternalStatus: DeclinedInternal.No,
                postpone: fileData.postpone,
                answerStatus: fileData.answerStatus,
                toUserId: fileData.toUserId,
                departamentId: fileData.departamentId,
                isDocumentInternal: fileData.isDocumentInternal,
                pureDays: fileData.pureDays,
                postponeDate: fileData.postponeDate,
                additionalInternalDocumentation: fileData.additionalInternalDocumentation,
                status: CaseFilesStatus.SentForVisage,
                activeUserId: toUserId ? `${toUserId.id}` : "",
                isDocumentSigned: true,
                documentSignedUserFullName: fileData.fullname,
                stepHistoryJson: fileData.stepHistoryJson ? fileData.stepHistoryJson + (toUserId ? `, ${toUserId.id}` : "") : (toUserId ? `, ${toUserId.id}` : "")
            };
            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: fileData.id});
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);


            if (isAccepted) {
                const body = {
                    id: caseId
                };
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/RemoveCaseToRegisteryByExpert`, body);
            }

            const requestData = {
                id: parseInt(caseId),
                requestToRemoveObjectFromObjectRegister: 2,
            };
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseRequestToRemoveObjectFromObjectRegister`, requestData);


            const caseNotification = {
                nextStepUserId: toUserId ? `${toUserId.id}` : "",
                caseId: parseInt(caseIdMain, 10),
                documentId: fileData.id,
                action: CaseNotificationEnum.removeCaseFromRegistery.id,
                caseStatus: caseData.status,
                viewed: true
            };

            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);

            const updateStatusPayload = {
                caseId: caseId,
                requesterViewed: false,
                userViewed: false
            };
            await axios.put(`${baseURL}/UpdateCaseREquesterViewdbyCaseId`, updateStatusPayload);

        } catch {

            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!');
            setAlertType('error');
            setShowAlert(true);
        }
        await fetchCaseFiles();
        await fetchCaseData();
        setIsLoading(false)
    };


    const editCaseFile = async (fileData) => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = parseInt(urlParams.get("id"));

        if (roleId !== "DEPUTYHEADOFAGENCY" && departmentID === departmentEnums.building.id) {
            const signStatus = {
                "EXPERT": 2,
                "HEADOFDEPARTMENT": 3,
                "HEADOFAGENCY": 4
            }


            const status = signStatus[roleId]
            if (!status) {
                alert(`Unknown roleId: ${roleId}`)
                return
            }

            const payload = {
                id: caseId,
                signStatus: (fileData.isDocumentInternal && roleId === "HEADOFDEPARTMENT") ? 4 : status
            }

            const updateStatus = async () => {
                try {
                    await axios.post(`${baseURL}/UpdateCaseInternalVisageStatusAndSignStatus`, payload)
                } catch (error) {
                    alert(`Failed to update sign status: ${error}`)
                }
            }

            await updateStatus()
        }


        if (fileData.additionalInternalDocumentation === 1 && roleId !== "EXPERT") {

            const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
            const deputy = users.find(user => user.roleName === "DeputyHeadOfAgency");

            const caseNotification = {
                nextStepUserId: roleId === "HEADOFAGENCY" ? deputy.id : headOfAgency.id,
                caseId: caseId ? parseInt(caseId, 10) : 0,
                documentId: fileData.id,
                action: CaseNotificationEnum.visagedInternalFile.id,
                caseStatus: 8,
                viewed: true,
            };

            const updatedFileData = {
                ...fileData,
                returnComment: "",
                status: CaseFilesStatus.SentForVisage,
                internal: CaseFilesInternal.Yes,
                activeUserId: "შიდა დოკუმენტი",
                declinedInternalStatus: DeclinedInternal.No,
                additionalInternalDocumentation: 2
            };
            await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);

            await fetchCaseFiles();
            return
        }

        if (roleId === "HEADOFAGENCY" && fileData.isUploaded && fileData.decline !== CaseFileDeclined.explosionFile) {

            const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
            const deputy = users.find(user => user.roleName === "DeputyHeadOfAgency");

            const caseNotification = {
                nextStepUserId: roleId === "HEADOFAGENCY" ? deputy.id : headOfAgency.id,
                caseId: caseId ? parseInt(caseId, 10) : 0,
                documentId: fileData.id,
                action: CaseNotificationEnum.visagedInternalFile.id,
                caseStatus: 8,
                viewed: true,
            };

            const updatedFileData = {
                ...fileData,
                returnComment: "",
                status: CaseFilesStatus.SentForVisage,
                internal: CaseFilesInternal.Yes,
                activeUserId: "შიდა დოკუმენტი",
                shared: fileData.sharedTemp,
                declinedInternalStatus: DeclinedInternal.No,
                additionalInternalDocumentation: 2
            };
            await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);

            await fetchCaseFiles();
            return
        }

        if (roleId === "HEADOFAGENCY" && (fileData.decline === CaseFileDeclined.CaseCancellationDocument || fileData.decline === CaseFileDeclined.CaseCancellationDocumentDeclined)) {
            void signDocumentByHeadOfAgency(fileData)
            return
        }

        if (roleId === "HEADOFAGENCY" && (fileData.decline === CaseFileDeclined.secretDocument)) {
            void signDocumentByHeadOfAgencyAndMakeCaseSecret(fileData)
            return
        }

        if (roleId === "HEADOFAGENCY" && fileData.decline === CaseFileDeclined.acceptRemoveFromRegistery) {
            void removeCaseFromRegisteryByHead(fileData, true)
            return
        }
        if (roleId === "HEADOFAGENCY" && fileData.decline === CaseFileDeclined.declineRemoveFromRegistery) {
            void removeCaseFromRegisteryByHead(fileData, false)
            return
        }

        if (roleId === "HEADOFAGENCY" && !(fileData.decline === CaseFileDeclined.RequireCaseCancellationBuildingAnswer || fileData.decline === CaseFileDeclined.RequireCaseCancellationBuildingAnswerDenied)) {
            if (fileData.decline !== CaseFileDeclined.explosionFile) {
                void signDocumentByHeadOfAgency(fileData)
                return
            } else {
                void saveExplosionFile(fileData)
                return
            }

        }

        setIsLoading(true)


        const filesToUpdate = caseFiles.filter(file => file.parentId === fileData.id)
        let toUserId = null;


        try {

            if ((fileData.decline === CaseFileDeclined.RequireCaseCancellationBuildingAnswer
                    || fileData.decline === CaseFileDeclined.RequireCaseCancellationBuildingAnswerDenied)
                && roleId === "HEADOFAGENCY") {


                void signDocumentByHeadOfAgencyToCancel(fileData)

                const updatedFileData = {
                    ...fileData,
                    returnComment: "",
                    status: CaseFilesStatus.SentForVisage,
                    internal: CaseFilesInternal.Yes,
                    activeUserId: "",
                    shared: true
                };

                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
                if (fileData.decline === CaseFileDeclined.RequireCaseCancellationBuildingAnswer) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const caseId = parseInt(urlParams.get("id"));
                    const updateStatusPayload = {
                        caseId: caseId, caseStatus: CaseStatus.Unexamined.id, finished: true
                    };
                    await axios.post(`${baseURL}/UpdateCaseStatus`, updateStatusPayload);

                    await fetchCaseData()
                } else {
                    const urlParams = new URLSearchParams(window.location.search);
                    const caseId = parseInt(urlParams.get("id"));
                    const updateStatusPayload = {
                        caseId: caseId,
                        requesterViewed: false,
                        userViewed: false
                    };
                    await axios.put(`${baseURL}/UpdateCaseREquesterViewdbyCaseId`, updateStatusPayload);
                    await fetchCaseData()
                }


            } else if (allManagersApprovedFileResolution(fileData) && roleId === "HEADOFDEPARTMENT" && fileData.sharedTemp && !fileData.skipVisage) {
                const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "DEPUTYHEADOFAGENCY".toLowerCase())
                toUserId = toUserIdList[0]
                const updatedFileData = {
                    ...fileData,
                    returnComment: "",
                    status: CaseFilesStatus.SentForVisage,
                    internal: CaseFilesInternal.Yes,
                    declinedInternalStatus: DeclinedInternal.No,
                    activeUserId: "ვიზირების მოლოდინში",
                    tempToUserId: toUserId ? `${toUserId.id}` : "",
                    stepHistoryJson: fileData.stepHistoryJson ? fileData.stepHistoryJson + (toUserId ? `, ${toUserId.id}` : "") : (toUserId ? `${toUserId.id}` : "")
                };
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
                const approvers = caseViewerManagers.filter(viewer => viewer.approver && viewer.caseFileId === null)

                if ((roleId === "EXPERT" || roleId === "HEADOFDEPARTMENT") && approvers.length !== 0 && fileData.sharedTemp && !fileData.skipVisage) {
                    await Promise.all(approvers.map((approver) => {
                        const caseNotification = {
                            nextStepUserId: approver.toUserId,
                            caseId: caseId,
                            documentId: fileData.id,
                            action: CaseNotificationEnum.sentToApprove.id,
                            caseStatus: 8,
                            viewed: false
                        };
                        return axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
                    }));
                }

            } else if (fileData.decline === caseFileDeclined.ExpertDoc) {

                const updatedFileData = {
                    ...fileData,
                    decline: caseFileDeclined.ExpertDocSent,
                    internal: true,
                    status: CaseFilesStatus.SentForVisage
                };
                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            } else {
                if (roleId === "EXPERT") {
                    const expertDepartment = await fetchUserDetails(userId)
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFDEPARTMENT".toLowerCase() && user.departmentId === expertDepartment.departmentId)
                    toUserId = toUserIdList[0]
                }
                if (roleId === "HEADOFDEPARTMENT") {
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "DEPUTYHEADOFAGENCY".toLowerCase())
                    toUserId = toUserIdList[0]
                }
                if (roleId === "DEPUTYHEADOFAGENCY") {
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
                    toUserId = toUserIdList[0]
                }
                if (roleId === "HEADOFAGENCY") {
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === "HEADOFAGENCY".toLowerCase())
                    toUserId = toUserIdList[0]
                }
                for (const file of filesToUpdate) {
                    await sendAttachment(file);
                }


                const updatedFileData = {
                    ...fileData,
                    shared: fileData.isExtentionAttachment && fileData.sharedTemp && roleId === "HEADOFAGENCY" ? fileData.sharedTemp : false,
                    internal: CaseFilesInternal.Yes,
                    returnComment: "",
                    declinedInternalStatus: DeclinedInternal.No,
                    isExtentionAttachment: fileData.isExtentionAttachment && roleId === "HEADOFAGENCY" ? false : fileData.isExtentionAttachment,
                    isExtentionAttachmentApprovedByHead: fileData.isExtentionAttachment && roleId === "HEADOFAGENCY" ? true : fileData.isExtentionAttachmentApprovedByHead,
                    status: CaseFilesStatus.SentForVisage,
                    activeUserId: toUserId ? `${toUserId.id}` : "",
                    stepHistoryJson: fileData.stepHistoryJson ? fileData.stepHistoryJson + (toUserId ? `, ${toUserId.id}` : "") : (toUserId ? `, ${toUserId.id}` : "")
                };

                const approvers = caseViewerManagers.filter(viewer => viewer.approver && viewer.caseFileId === null)
                const approversForInsideFile = caseViewerManagers.filter(viewer => viewer.approver && viewer.caseFileId !== null)
                if ((roleId === "EXPERT" || roleId === "HEADOFDEPARTMENT") && approvers.length !== 0 && fileData.sharedTemp) {
                    await Promise.all(approvers.map((approver) => {
                        const caseNotification = {
                            nextStepUserId: approver.toUserId,
                            caseId: caseId,
                            documentId: fileData.id,
                            action: CaseNotificationEnum.sentToApprove.id,
                            caseStatus: 8,
                            viewed: false
                        };


                        return axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
                    }));
                }
                if ((roleId === "EXPERT" || roleId === "HEADOFDEPARTMENT") && approversForInsideFile.length !== 0 && fileData.pureDays !== null) {
                    await Promise.all(approversForInsideFile.map((approver) => {
                        const caseNotification = {
                            nextStepUserId: approver.toUserId,
                            caseId: caseId,
                            documentId: fileData.id,
                            action: CaseNotificationEnum.sentToApprove.id,
                            caseStatus: 8,
                            viewed: false
                        };


                        return axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
                    }));
                }


                const caseNotification = {
                    nextStepUserId: toUserId ? `${toUserId.id}` : "",
                    caseId: parseInt(caseIdMain, 10),
                    documentId: fileData.id,
                    action: CaseNotificationEnum.sentForVisage.id,
                    caseStatus: caseData.status,
                    viewed: false
                };

                await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
                if (roleId !== "HEADOFAGENCY") {
                    await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
                }
            }

            await fetchCaseFiles();
        } catch (error) {
        } finally {
            setAlertType('success');
            setAlertMessage('ოპერაცია წარმეტებით დასრულდა');
            setShowAlert(true);
        }
        setIsLoading(false)
    };

    const sendToVisageInternalFlowBack = async () => {

        const payload = {
            id: caseId,
            signStatus: 4
        }
        await axios.post(`${baseURL}/UpdateCaseInternalVisageStatusAndSignStatus`, payload)

        const fileData = caseFiles.find(file => file.id === fileForInternalFlow.pureDays)

        setIsLoading(true)

        try {

            const sign = generateSignature(positionsForDoc[roleId], fileForInternalFlow.fullname)
            const document = preprocessHtmlForPdf(fileForInternalFlow.mainInfo)


            const requestBodyForSignedFile = {
                ...fileForInternalFlow,
                activeUserId: "",
                stepHistoryJson: fileForInternalFlow.creatorId,
                internal: CaseFilesInternal.Yes,
                status: CaseFilesStatus.SentForVisage,
                documentSignedUserFullName: fileForInternalFlow.fullname,
                html: document + sign,
                isHTML: true,
            };

            const tempSignedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBodyForSignedFile);
            const isDev = process.env.REACT_APP_API_BASE_URL.toLowerCase() === "https://devtacsa.admi.ge/api"
            const signRequest = {
                signRequest: {
                    caseFileId: isDev ? 7839 : parseInt(tempSignedFileResponse.data.resultId, 10),
                    documentName: fileData.name
                }
            };

            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: parseInt(tempSignedFileResponse.data.resultId, 10)});

            const signedFileResponse = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/Sign`, signRequest);

            const headOfDepartment = users.find(
                user => user.roleName.toLowerCase() === "headofdepartment" && user.departmentId === departmentID
            );

            const updatedFileData = {
                ...fileForInternalFlow,
                answerStatus: CaseDocumentInternalFlowStatusEnum.SentBack,
                file: signedFileResponse.data.base64,
                activeUserId: '',
                stepHistoryJson: fileForInternalFlow.creatorId,
                internal: CaseFilesInternal.Yes,
                status: CaseFilesStatus.SentForVisage,
                documentSignedUserFullName: fileForInternalFlow.fullname,
            };
            const newCaseFileResponse = await axios.post(`${baseURL}/AddNewCaseFile`, updatedFileData);
            await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: fileForInternalFlow.id})


            const caseNotificationForHead = {
                nextStepUserId: headOfDepartment.id,
                caseId: parseInt(caseIdMain, 10),
                documentId: fileData.id,
                action: CaseNotificationEnum.answerFromDepartment.id,
                caseStatus: caseData.status,
                viewed: false
            };
            await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotificationForHead);

            const filteredRecordsManagers = caseViewerManagers.filter(record => record.status === 3 && record.toUserId === USER_ID && record.caseFileId === fileForInternalFlow.pureDays);
            const flowDataToEdit = flowData.filter(flow => flow.toUserId === userId && flow.documentId === fileForInternalFlow.pureDays)

            for (const flowData of flowDataToEdit) {
                const updatedFileData = {
                    ...flowData,
                    caseDocumentInternalFlowStatus: CaseDocumentInternalFlowStatusEnum.SentBack,
                };
                try {

                    await axios.put(`${baseURL}/EditCaseDocumentInternalFlow`, updatedFileData);
                } catch (error) {
                    setShowAlert(true);
                    return;
                }
            }
            for (const record of filteredRecordsManagers) {
                await updateCaseViewer(record);
            }
            const filesToUpdate = caseFiles.filter(file => file.parentId === fileForInternalFlow.id)

            for (const file of filesToUpdate) {
                await editAttachmentFiles(file, newCaseFileResponse.data.resultId);
            }

        } catch {
            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!');
            setAlertType('error');
            setShowAlert(true);
        } finally {
            setAlertType('success');
            setAlertMessage('ოპერაცია წარმეტებით დასრულდა');
            setShowAlert(true);
        }
        await fetchCaseFiles()
        await fetchFlowData()
        await fetchCaseManagersData()
        setIsModalToAnswerAnotherDepartment(false)
        setIsLoading(false)
    };

    const denyCancellation = async () => {
        setIsLoading(true)
        const denyCancellationFile = caseFiles.find(file => file.decline === CaseFileDeclined.CaseCancellationDocumentDeclined);
        const updatedFileData = {
            ...denyCancellationFile, shared: true, decline: CaseFileDeclined.CaseCancellationDocumentDeclinedSent
        };
        await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
        await fetchCaseFiles();
        setIsCaseCancellationModalOpen(false)
        setIsLoading(false)
    };
    const handleDeleteCase = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id');
        const payload = {id: parseInt(id, 10)}
        if (id) {
            try {
                const response = await axios.put(`${baseURL}/DeleteAuthoriseUserCaseById`, payload);
                if (response.status === 200 && response.data.success) {
                    setCaseDeleteModalOpen(false)
                    navigate("/dashboard/home");
                }

            } catch (error) {
            }
        } else {
        }
    };


    const UndeclineCaseFile = async (fileData) => {
        setIsLoading(true)
        try {
            await axios.put(`${baseURL}/EditCaseFile`, fileData);
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);


            if (fileToProcess) {
                const caseNotification = {
                    nextStepUserId: fileToProcess.creatorId,
                    caseId: parseInt(caseIdMain, 10),
                    documentId: fileToProcess.id,
                    action: CaseNotificationEnum.sentBack.id,
                    caseStatus: caseData.status,
                    viewed: false
                };

                await axios.post(`${baseURL}/AddNewCaseNotification`, caseNotification);
            }


            await fetchCaseFiles();
        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით');
            setAlertType('error');
            setShowAlert(true);
        }
        setIsLoading(false)
    };


    const UndeclineCaseFileExpert = async (fileData) => {
        setIsLoading(true)
        try {
            await axios.post(`${baseURL}/AddNewCaseDocumentInternalFlow`, fileData);
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);
            await fetchCaseFiles();
            await fetchFlowData();
        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით');
            setAlertType('error');
            setShowAlert(true);
        }
        setIsLoading(false)
    };

    const UnDenyCaseFile = async (fileData) => {
        try {
            const updatedFileData = {
                ...fileData, decline: CaseFileDeclined.No
            };
            await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);
            if (declinedDocCount === 1) {
                await deleteDeclinedFile();
                await deleteDeclinedFileAttachment()
            }
            clearSelectedDocuments();
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);
            await fetchCaseFiles();
        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით');
            setAlertType('error');
            setShowAlert(true);
        }
    };

    const removeConditionFromCaseFile = async (fileData) => {
        try {
            const updatedFileData = {
                ...fileData, decline: CaseFileDeclined.No
            };
            await axios.put(`${baseURL}/EditCaseFile`, updatedFileData);

            if (conditionDocCount === 1) {
                await deleteConditionFile();
            }
            clearSelectedDocuments();
            setAlertMessage('ოპერაცია წარმატებით დასრულდა');
            setAlertType('success');
            setShowAlert(true);
            await fetchCaseFiles();
        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვინაებით');
            setAlertType('error');
            setShowAlert(true);
        }
    };


    const addNewCaseUser = async (fromUserId, caseId) => {
        await fetchDateTime();
        const payload = {
            caseId: parseInt(caseId), toUserId: fromUserId, status: 1, addedBySystem: false
        };
        const lastUser = caseManagers.length > 0 ? caseManagers[caseManagers.length - 1].id : null;
        if (lastUser !== null) {
            const formattedDate = new Date(dateTime).toISOString();

            const updatePayload = {
                id: lastUser, caseUserEndDate: formattedDate
            };
            try {
                await axios.put(`${baseURL}/EditCaseUserEndDate`, updatePayload);
            } catch (error) {
            }
        }
        try {
            await axios.post(`${baseURL}/AddNewCaseUser`, payload);
        } catch (error) {
        }
    };

    const checkAndHandleDocumentSubmission = async () => {
        try {
            const response = await axios.get(`${baseURL}/GetSettingByKeyWord?Keyword=DefaultBackFlowActivated`);
            const setting = response.data.data.data[0];

            if (setting && setting.value === "true") {
                await fetchAndLogMatchingCaseUsers();
            } else {
                await sendAllDocumentsForVisage();
            }
            await updateCaseStatusWaitingForVisage();
            await fetchCaseData()
        } catch (error) {
        }
    };


    const updateCaseStatusWaitingForVisage = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const caseId = parseInt(urlParams.get("id"));
        const updateStatusPayload = {
            caseId: caseId, caseStatus: CaseStatus.waitingForVisage.id, finished: false
        };
        await axios.post(`${baseURL}/UpdateCaseStatus`, updateStatusPayload);
    };

    const fetchAndLogMatchingCaseUsers = async () => {
        if (!caseData || !caseData.permitTypeId) {
            setAlertMessage("ფლოუ არ არის დაკონფიგურერბული, მიმართეთ ადმინისტრაციას");
            setAlertType("error");
            setShowAlert(true);
            return;
        }
        try {
            await fetchDateTime();
            const lastUser = caseManagers.length > 0 ? caseManagers[caseManagers.length - 1].id : null;
            const formattedDate = new Date(dateTime).toISOString();

            const updatePayload = {
                id: lastUser, caseUserEndDate: formattedDate
            };
            try {
                await axios.put(`${baseURL}/EditCaseUserEndDate`, updatePayload);
            } catch (error) {
            }

            const response = await axios.get(`${baseURL}/GetAllCaseUserDefault`);
            const records = response.data.data;
            const matchingRecords = records.filter(record => record.fromRole.toLowerCase() === roleId.toLowerCase() && record.isDeleted === false);
            const caseIdFromURL = new URLSearchParams(window.location.search).get("id");

            if (matchingRecords.length > 0) {
                if (roleId !== "EXPERT") {

                    const record = matchingRecords[0];
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === record.toRoleName.toLowerCase())
                    const toUserId = toUserIdList[0]
                    const payload = {
                        caseId: parseInt(caseIdFromURL), toUserId: toUserId.id, status: 1, addedBySystem: false
                    };
                    try {
                        await axios.post(`${baseURL}/AddNewCaseUser`, payload);
                        setIsSendAllConfirmationModalOpen(false);
                        await fetchCaseManagersData();
                        await fetchCaseFiles();
                        setAlertMessage("ოპერაცია წარმატებით დასრულდა");
                        setAlertType("success");
                        setShowAlert(true);
                    } catch (error) {
                        setAlertMessage("ფლოუ არ არის დაკონფიგურერბული, მიმართეთ ადმინისტრაციას");
                        setAlertType("error");
                        setShowAlert(true);
                    }
                } else {
                    const token = localStorage.getItem('jwtToken');
                    const decoded = jwtDecode(token);
                    const USER_ID = decoded.UserId;
                    const expertDepartment = await fetchUserDetails(USER_ID)
                    const record = matchingRecords[0];
                    const toUserIdList = users.filter(user => user.roleName.toLowerCase() === record.toRoleName.toLowerCase() && user.departmentId === expertDepartment.departmentId)
                    const toUserId = toUserIdList[0]
                    const payload = {
                        caseId: parseInt(caseIdFromURL), toUserId: toUserId.id, status: 1, addedBySystem: false
                    };
                    try {
                        await axios.post(`${baseURL}/AddNewCaseUser`, payload);
                        setIsSendAllConfirmationModalOpen(false);
                        await fetchCaseManagersData();
                        await fetchCaseFiles();
                        setAlertMessage("ოპერაცია წარმატებით დასრულდა");
                        setAlertType("success");
                        setShowAlert(true);
                    } catch (error) {
                        setAlertMessage("ფლოუ არ არის დაკონფიგურერბული, მიმართეთ ადმინისტრაციას");
                        setAlertType("error");
                        setShowAlert(true);
                    }
                }

            } else {
                setAlertMessage("ფლოუ არ არის დაკონფიგურერბული, მიმართეთ ადმინისტრაციას");
                setAlertType("error");
                setShowAlert(true);
            }
        } catch (error) {
            setAlertMessage("ფლოუ არ არის დაკონფიგურერბული, მიმართეთ ადმინისტრაციას");
            setAlertType("error");
            setShowAlert(true);
        }
        setIsSendAllConfirmationModalOpen(false);
    };


    const sendAllDocumentsForVisage = async () => {

        setIsSendAllConfirmationModalOpen(false);
        const caseIdFromURL = new URLSearchParams(window.location.search).get("id");
        let actionCompleted = false;
        const token = localStorage.getItem('jwtToken');
        if (token) {

            try {
                const decoded = jwtDecode(token);
                const USER_ID = decoded.UserId;


                const manager = caseManagersForVisage.find(mgr => mgr.status === 0 && mgr.toUserId === USER_ID && mgr.isReturned !== true);
                if (manager) {
                    try {
                        await addNewCaseUser(manager.fromUserId, caseIdFromURL);
                        actionCompleted = true;
                    } catch (error) {
                    }
                }

                if (actionCompleted) {
                    await fetchCaseManagersData();
                    await fetchCaseFiles();
                }
            } catch (error) {
            }
        }
    };

    useEffect(() => {
        if (roleId !== null) {
            void fetchCaseFiles();
            void fetchCaseData();
        }
    }, [roleId, caseId]);

    const fetchCaseDetails = async () => {
        try {
            const queryParams = new URLSearchParams(location.search);
            const caseId = queryParams.get('id');
            const response = await axios.get(`${baseURL}/GetCaseDetails?CaseId=${caseId}`);
            if (response.data.success) {
                const details = response.data.data.result;
                details.sort((a, b) => {
                    const aHigh = a.inputType === 3 || firstOptions.includes(a.key);
                    const bHigh = b.inputType === 3 || firstOptions.includes(b.key);
                    if (aHigh && !bHigh) return -1;
                    if (!aHigh && bHigh) return 1;
                    return 0;
                });
                setCaseDetails(details);
            }
        } catch (error) {
        } finally {
        }
    };

    useEffect(() => {
        void fetchCaseDetails()
    }, [caseId]);


    const handleDeclineAllDetails = async () => {

        const declinedDetails = caseDetails.filter(detail => detail.declined === 1);
        const updatePromises = declinedDetails.map(detail => axios.post(`${baseURL}/UpdateCaseDetails`, {
            id: detail.id, value: detail.value, declined: 2,
        }));
        try {
            await Promise.all(updatePromises);
            setAlertType('success');
            setAlertMessage('ოპერაცია წარამტებით დასრულდა');
        } catch (error) {
            setAlertType('error');
            setAlertMessage('Error updating all declined details: ' + error.message);
        } finally {
            setShowAlert(true);
        }
    };

    const fetchCaseFiles = async () => {
        setIsLoadingCaseFiles(true);
        const token = localStorage.getItem("jwtToken");
        if (!token) {
            setIsLoadingCaseFiles(false);
            return;
        }

        const id = new URLSearchParams(window.location.search).get("id");
        if (!id) {
            setIsLoadingCaseFiles(false);
            return;
        }
        try {
            let endpoint;
            if (roleId === 'USER') {
                endpoint = `${baseURL}/GetAllCaseSharedFileByCaseID?CaseId=${id}`;
            } else if (roleId !== null) {
                endpoint = `${baseURL}/GetAllCaseFileByCaseID?CaseId=${id}`;
            }
            if (roleId !== 'USER') {
                axios.get(`${baseURL}/GetAllDeletedCaseFileByCaseId?CaseId=${caseId}`)
                    .then(response => {
                        if (response.data.success && response.data.data) {
                            setDeletedFiles(response.data.data.resultItems);
                        } else {
                            console.error('Failed to fetch data:', response.data.errors);
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching data:', error);
                    });
            }


            const response = await axios.get(endpoint);

            let data;
            if (roleId === 'USER') {
                data = response.data.data;
            } else {
                data = response.data.data.resultItems;
            }

            if (Array.isArray(data)) {
                const sortedData = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setCaseFiles(sortedData);
                setCaseFilesAreFetched(true);
            } else {
            }
        } catch (error) {
        } finally {
            setIsLoadingCaseFiles(false);
            setIsLoadingCaseFilesInitialLoading(false)
        }
    };


    const handleCheckboxChange = (event, file) => {
        const newSelectedDocuments = {...selectedDocuments};
        if (event.target.checked) {
            newSelectedDocuments[file.id] = file;
        } else {
            delete newSelectedDocuments[file.id];
        }
        setSelectedDocuments(newSelectedDocuments);
    };


    const refreshCaseManagers = () => {
        void fetchCaseManagersData();
        if (roleId && roleId !== "USER") {
            void getGroupId();
        }
    }
    const refreshChat = () => {
        if (roleId && roleId !== "USER") {
            void getGroupId();
        }
    }
    const refreshCaseDetails = () => {
        void fetchCaseDetails();
    };


    const refreshCaseDataOnFileUpload = () => {
        void fetchCaseData();
    };

    const clearSelectedDocuments = () => {
        setSelectedDocuments({})
    }
    useEffect(() => {
        if (userId && roleId && roleId !== "USER") {
            fetchUserDetails(userId).then(setCaseManager)
        }
    }, [userId, roleId])


    const fetchUserDetails = async (userId) => {
        try {
            const response = await axios.get(`${baseURL}/User/GetOneUserByID?UserID=${userId}`);
            const data = response.data;
            return data.data;
        } catch (error) {
            return null;
        }
    };

    const formatDate = (dateString) => {
        if (dateString === '0001-01-01T00:00:00') {
            return '';
        }

        const date = new Date(dateString);
        if (isNaN(date)) {
            return '';
        }

        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    };


    const deleteDeclinedFile = async () => {
        setIsLoading(true)
        const fileToDelete = caseFiles.find(file => file.decline === CaseFileDeclined.DeclinationDocument);
        try {
            const response = await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: fileToDelete.id});

            if (response.status === 200) {
                await fetchCaseFiles();
            } else {
            }
        } catch (error) {
        }
        setIsLoading(false)
    };
    const deleteConditionFile = async () => {
        setIsLoading(true)
        const fileToDelete = caseFiles.find(file => file.decline === CaseFileDeclined.ConditionalFileAct);
        try {
            const response = await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: fileToDelete.id});

            if (response.status === 200) {
                await fetchCaseFiles();
            } else {
            }
        } catch (error) {
        }
        setIsLoading(false)
    };
    const deleteDeclinedFileAttachment = async () => {
        setIsLoading(true)
        const fileToDelete = caseFiles.find(file => file.documentType === 1);
        try {
            const response = await axios.put(`${baseURL}/DeleteCaseFile`, {caseFileId: fileToDelete.id});
            if (response.status === 200) {
                await fetchCaseFiles();
            }
        } catch (error) {
        }
        setIsLoading(false)
    };


    const fetchDocumentTypeName = (documentTypeId) => {
        if (documentTypeId === 0) {
            return "";
        }

        try {
            const docName = documentTypesForEditor.find(doc => doc.id === documentTypeId)
            return docName.name
        } catch (error) {
            return '';
        }
    };


    const hasActiveManager = (fileId) => {
        const fileHasManagers = caseViewerManagers.filter(caseManager => caseManager.caseFileId === fileId && caseManager.toUserId !== userId)
        return fileHasManagers.length === 0
    };
    const isActiveManager = (fileId) => {
        return caseViewerManagers.find(caseManager => caseManager.caseFileId === fileId && caseManager.toUserId === userId && caseManager.approver === false && caseManager.approverStatus === approverStatusEnum.worker)
    };
    const allManagersApprovedFile = (file) => {
        const fileHasManagers = caseViewerManagers.filter(caseManager => caseManager.caseFileId === file.pureDays && caseManager.approver === true)
        return fileHasManagers.length === 0
    };

    const hasManagerApprovedFile = (file) => {
        const fileHasManagers = caseViewerManagers.find(caseManager =>
            caseManager.approver === true &&
            caseManager.toUserId === userId
        );
        if (fileHasManagers.approverDetalis) {
            return !fileHasManagers.approverDetalis.split(',').includes(file.id.toString())
        } else {
            return true
        }
    };

    const allManagersApprovedFileResolution = (file) => {
        const fileHasManagers = caseViewerManagers.filter(caseManager =>
            caseManager.approver === true &&
            caseManager.approverDetalis &&
            caseManager.approverDetalis.split(',').includes(file.id.toString())
        )
        const approvers = caseViewerManagers.filter(caseManager =>
            caseManager.approver === true &&
            caseManager.caseFileId === null
        )

        return !(approvers.length === fileHasManagers.length)

    };


    const expertHasDeclinedFile = (fileId) => {
        const expertFile = flowData.filter(flow => flow.requesterId === userId && flow.documentId === fileId)
        return expertFile.length === 0
    };

    const displayFlowDataForExpert = (fileId) => {
        return flowData.find(flow => flow.flowTypeStatus === 1 && flow.requesterId === userId && flow.documentId === fileId)
    };


    const displayFlowDataForHeadOfDepartment = (fileId) => {
        return flowData.filter(flow => flow.flowTypeStatus === 1 && flow.toUserId === userId && flow.documentId === fileId)
    };


    const answerFileExists = (file) => {
        const answerFiles = caseFiles.filter(caseFile => caseFile.pureDays === file.id)
        return answerFiles.length === 0
    };

    const ShouldApproveInsideFile = (file) => {
        const answerFiles = caseViewerManagers.filter(
            manager => manager.approver === true &&
                manager.caseFileId === file.pureDays &&
                manager.status === AddNewCaseViewerEnum.SentToAnotherDepartment &&
                manager.toUserId === userId)

        return answerFiles.length !== 0
    };

    const allManagersApproved = () => {
        return caseViewerManagers.filter(manager => manager.needApproval).length < 1 ? true : caseViewerManagers.filter(manager => manager.needApproval && manager.approved)?.length > 0;
    };

    const canDeleteManager = (userId) => {
        const rolePriority = {
            'headofagency': 4,
            'deputyheadofagency': 3,
            'headofdepartment': 2,
            'expert': 1
        };
        const userToDeleteRole = users.find(user => user.id === userId)
        if (userToDeleteRole) {
            return rolePriority[userToDeleteRole.roleName.toLowerCase()] < rolePriority[roleId.toLowerCase()]
        }
    };

    const canDeleteCaseViewer = (userId) => {
        const manager = users.find(user => user.id === userId)

        if ((roleId === "HEADOFAGENCY" || roleId === "DEPUTYHEADOFAGENCY") && (manager.roleName === "Expert" || manager.roleName.toLowerCase() === "HEADOFDEPARTMENT".toLowerCase())) {
            return true
        }


        if (manager && roleId === "HEADOFDEPARTMENT" && manager.roleName === "Expert") {
            return loggedUserDepartment === manager.departmentId
        }
    };


    const refreshCaseFiles = () => {
        void fetchCaseFiles();
        setEditModalIsOpen(false)
        setAlertType('success');
        setAlertMessage('ოპერაცია წარმეტებით დასრულდა');
        setShowAlert(true);
    };





    const generateSignature = (department) => {
        try {
            const mainToken = localStorage.getItem("jwtTokenMain")
            const secondaryToken = localStorage.getItem("jwtToken")
            const isReplacer = mainToken !== secondaryToken

            const decodedUserId = decodeJwtTokenFromArgument('jwtTokenMain') || ""
            const replacerTitle = "პირველადი სტრუქტურული ერთეულის დროებით მოვალეობის შემსრულებელი"

            const replacerUser = users.find(u => u.id === decodedUserId.UserId)
            const departmentTitle = isReplacer ? replacerTitle : department
            const managerName = isReplacer
                ? `${replacerUser.firstName} ${replacerUser.lastName}`
                : `${caseManager.firstName} ${caseManager.lastName}`

            return `
            <div style="display: table; width: 100%; font-family: Sylfaen, serif; margin-top: 20px;">
              <div style="display: table-cell; width: 33.3%; vertical-align: middle; text-align: left;">${departmentTitle}</div>
              <div style="display: table-cell; width: 33.3%; vertical-align: middle; text-align: center;">
                <img src="${signImage}" alt="signature" style="height: 80px;" />
              </div>
              <div style="display: table-cell; width: 33.3%; vertical-align: middle; text-align: center;">${managerName}</div>
            </div>
        `
        } catch (error) {
            console.log(error)
        }
    }


    const mergeCases = async () => {
        setIsObjectRegisteryDialogOpen(false)
        const payload = {
            caseId: caseId,
            requesttomovetoobjectregistrybyexpert: false,
            requesttomovetoobjectregistrybyexpertDenide: '',
            answerOfHeadOfDepartment: false
        };


        const currentDateTime = await fetchDateTimeForConditionalEnding();
        const formattedDateTime = formatDateTimeToISO(currentDateTime);
        const finishCase = {
            caseId: parseInt(caseId),
            caseStatus: CaseStatus.Approved.id,
            finished: true,
            finishDate: formattedDateTime
        };
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UpdateRequesttomovetoobjectregistrybyexpert`, payload)
        await axios.post(`${baseURL}/UpdateCaseStatus`, finishCase);
        await uploadObjectFile()
        void fetchCaseData();
        void fetchCaseFiles();
        void fetchCaseDetails();
        setIsMerging(false)

        setShowSuccessAlertMergeRequest(true);
        setTimeout(() => setShowSuccessAlertMergeRequest(false), 3000);

    };

    const mergeCasesByHead = () => {
        setIsMerging(true)
        setIsObjectRegisteryDialogOpen(false)
        void fetchCaseData();
        void fetchCaseFiles();
        void fetchCaseDetails();
        setShowSuccessAlert(true);
        setIsMerging(false)
        setTimeout(() => setShowSuccessAlert(false), 3000);
    };
    const uploadCertificate = () => {
        void fetchCaseData();
        void fetchCaseFiles();
    };
    const refreshFlow = () => {
        void fetchFlowData();
    };


    const getBackgroundColor = (file) => {
        if (caseData && roleId) {
            if (file.declinedInternalStatus === DeclinedInternal.Yes) {
                return '#E6E6E6';
            } else if (file.parentId !== null) {
                return '#BFBFBF';
            } else if (file.decline === CaseFileDeclined.Yes && roleId !== "USER") {
                return '#FF9999';
            } else if (file.decline === CaseFileDeclined.Yes && roleId === "USER" && caseData.finished) {
                return '#FF9999';
            } else {
                switch (file.decline) {
                    case CaseFileDeclined.isConditionalFile:
                        return '#FFE3B3';
                    case CaseFileDeclined.DeclinedInternalFile:
                        return '#E6E6E6';
                    case CaseFileDeclined.PreviouslyDeclinedFile:
                        return '#FF9999';
                    case CaseFileDeclined.ReuploadedFile:
                        return '#FFF2CC';
                    case CaseFileDeclined.ReuploadedFileAccepted:
                        return '#CCFFCC';
                    case CaseFileDeclined.ReuploadedFileDeclined:
                        return '#FF9999';
                    default:
                        return '#FFFFFF';
                }
            }
        }
    };


    const closeFilesPopup = () => {
        setShowFilesPopup(false);
    };


    const deleteDocument = async (fileID) => {
        const childrenDocuments = caseFiles.filter(file => file.parentId === fileID)
        const docToDelete = caseFiles.find(file => file.id === fileID)
        await sendNotificationDeleteFile(fileID)
        setIsLoading(true)
        try {

            for (const file of Object.values(childrenDocuments)) {
                const requestBody = {
                    caseFileId: file.id,
                };

                try {
                    await axios.put(`${baseURL}/DeleteCaseFile`, requestBody);

                } catch (error) {
                }
            }

            if (docToDelete && docToDelete.decline === CaseFileDeclined.DeclinationDocument) {
                const declinedFiles = caseFiles.filter(file => file.decline === CaseFileDeclined.Yes)
                if (declinedFiles.length > 0) {
                    for (const file of Object.values(declinedFiles)) {
                        void unDeclineFile(file)
                    }
                }

            }

            if (docToDelete && docToDelete.decline === CaseFileDeclined.ConditionalFileAct) {
                const conditionalFiles = caseFiles.filter(file => file.decline === CaseFileDeclined.isConditionalFile)
                if (conditionalFiles.length > 0) {
                    for (const file of Object.values(conditionalFiles)) {
                        void unDeclineFile(file)
                    }
                }

            }

            await axios.put(`${baseURL}/DeleteCaseFile`, {
                caseFileId: fileID
            });
            setAlertMessage('დოკუმენტი წაიშალა');
            setAlertType('success');
            setShowAlert(true);


        } catch (error) {
            setAlertMessage('დაფიქსირდა შეცოდმა');
            setAlertType('error');
            setShowAlert(true);
        }
        await fetchCaseFiles()
        setIsLoading(false)


    };

    const contentMap = {
        "დოკუმენტები": (<div>
                {isLoadingCaseData || isLoading || isLoadingCaseFiles ? (
                    <DocumentsLoader/>
                ) : (
                    <div className="dashboard-table-container">
                        {users.length !== 0 && caseFiles.length !== 0 && (
                            <CaseFileDialog caseFiles={caseFiles} open={dialogOpen} onClose={handleCloseDialog}
                                            caseFile={selectedCertificateId} users={users}/>
                        )}
                        {caseData && caseData.requesterId && (
                            <UserDataPopup open={userDialogOpen} onClose={handleCloseUserDialog}
                                           userId={caseData.requesterId}/>
                        )}
                        {caseData && rewriteUserId && (
                            <UserDataPopup open={rewriteRequestUserDialogOpen} onClose={handleCloseRewriteRequestDialog}
                                           userId={rewriteUserId}/>
                        )}
                        {caseData && users.length !== 0 && caseViewerManagers.length !== 0 && visageFileId && (
                            <VisagersPopup open={isVisagersPopupIsOpen} onClose={handleCloseVisagersPopup}
                                           fileId={visageFileId}
                                           caseVisagers={caseViewerManagers.filter(viewer => viewer.approver === true)}
                                           users={users}/>
                        )}

                        <AnswerToMergeCase
                            open={isMergeRequestDialogByCaseIdOpen}
                            onClose={() => setIsMergeRequestDialogByCaseIdOpen(false)}
                            onMerge={mergeCases}
                            onDeny={mergeCasesByHead}
                            caseData={caseData}
                            users={users}
                            previewHtml={objectHtml}
                            dateTime={new Date().toLocaleDateString('en-GB')}
                            fullName={objectOwner}

                        />
                        {editModalIsOpen && (
                            <>
                                <Dialog
                                    fullWidth={true}
                                    maxWidth="xl"
                                    style={{
                                        zIndex: 4,
                                        width: '100%',
                                        maxHeight: '100vh'
                                    }}
                                    open={editModalIsOpen}
                                    onClose={handleCloseCaseDetailsToChangeCaseOwner}
                                >
                                    <DialogContent style={{height: 'calc(100vh - 64px)'}}>
                                        <CaseDetails
                                            role={roleId}
                                            caseFinished={caseData.finished}
                                            caseInfo={caseData}
                                            permitTypeId={caseData.permitTypeId}
                                            caseMustBeActive={caseMustBeActive}
                                            caseDetails={caseDetails}
                                            onDetailChange={refreshCaseDetails}
                                            caseFiles={caseFiles}
                                            documentToChangeId={documentToChangeId}
                                            onFileAdded={refreshCaseFiles}
                                            onCaseStatusChange={refreshCaseDataOnFileUpload}
                                            isButtonVisible={isReuploadble}
                                            caseGeography={caseGeography}
                                            isObjectInRegistery={isObjectInRegistery}
                                            geoIds={geoIds}
                                            caseParentId={caseData.caseParentId}
                                            isCaseParentIdRejected={caseData.isRejectedCaseParentId}
                                            onCaseParentIdRejection={refreshCaseDataOnFileUpload}
                                            caseData={caseDataForDocument}
                                            users={users}
                                            isAddressRejected={caseData.addressDeclinedStatus}
                                            isCadastralCodeRejected={caseData.cadastralCodeDenclinedStatus}
                                            orderDepartment={orderDepartment}
                                            hideDeclineButton={true}
                                        />
                                    </DialogContent>
                                </Dialog>
                            </>
                        )}


                        <div className="new-document-button">
                            {(caseData &&
                                    caseData.moveCaseToAgencyRegisterByExpert &&
                                    (caseData.status === caseStatus.Approved.id) &&
                                    userId &&
                                    objectsOfRegistery.length !== 0 &&
                                    checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId) &&
                                    ((roleId === "EXPERT" && permission) || (roleId === "HEADOFAGENCY" || roleId === "DEPUTYHEADOFAGENCY" || roleId === "HEADOFDEPARTMENT")))
                                && (
                                    <div className="new-document-button">
                                        <button className={"document-buttonn"}
                                                onClick={toggleUploadPopupInspection}>ინსპექტირების
                                            ოქმის ატვირთვა
                                        </button>
                                        <button

                                            className="document-buttonn small-font"
                                            onClick={toggleUploadPopupAdmin}>
                                            ადმინისტრაციული ოქმის ატვირთვა
                                        </button>

                                        <button className={"document-buttonn"}
                                                onClick={toggleUploadPopupCertificate}>ინსპექტირების სერტიფიკატის
                                            დოკუმენტის
                                            ატვირთვა
                                        </button>


                                        {roleId !== "EXPERT" && (caseData &&
                                            caseData.moveCaseToAgencyRegisterByExpert &&
                                            (caseData.status === caseStatus.Approved.id || caseData.creteByExpert) &&
                                            userId &&
                                            objectsOfRegistery.length !== 0 &&
                                            checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId)
                                        ) && (
                                            <button className={"document-buttonn-red"}
                                                    onClick={toggleShowRemoveFromObjectRegisteryPopup}>ობიექტის ამოშლა
                                                უწყებრივი რეესტრიდან
                                            </button>
                                        )}
                                    </div>
                                )}
                            {roleId && roleId !== 'USER' && caseMustBeActiveForInternalFile && (
                                <button className={"document-buttonn"} onClick={toggleUploadInsideFilePopup}>
                                    შიდა დოკუმენტის ატვირთვა
                                </button>
                            )}

                            {caseData &&
                                userId &&
                                users.length !== 0 &&
                                !caseData.creteByExpert &&
                                caseMustBeActiveForRegistery &&
                                !caseData.moveCaseToAgencyRegisterByExpert &&
                                objectsOfRegistery.length !== 0 &&
                                checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId) &&
                                ((roleId === "EXPERT" && permission && caseData.requesttomovetoobjectregistrybyexpert !== true) ||
                                    (roleId === "HEADOFAGENCY" || roleId === "HEADOFDEPARTMENT" || roleId === "DEPUTYHEADOFAGENCY")) &&
                                (
                                    <>


                                        <div>
                                            <button className="document-buttonn"
                                                    onClick={handleDialogOpenObjectRegisteryDialog}>
                                                ობიექტის გადატანა უწყებრივ რეესტრში
                                            </button>
                                        </div>


                                        <Dialog
                                            open={isObjectRegisteryDialogOpen}
                                            onClose={handleDialogCloseObjectRegistery}
                                            maxWidth="sm"
                                        >
                                            <DialogContent className="merge-dialog-content">
                                                {roleId === "HEADOFDEPARTMENT" && (

                                                    <Button
                                                        style={{
                                                            marginBottom: 20,
                                                            width: 350,
                                                            marginTop: 40
                                                        }}
                                                        disabled={caseData.requesttomovetoobjectregistrybyexpert !== true}
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => setIsMergeRequestDialogByCaseIdOpen(true)}
                                                        className="merge-dialog-button"
                                                        startIcon={<MdQuestionAnswer/>}
                                                    >
                                                        ობიექტის რეესრში გადატანაზე პასუხი
                                                    </Button>
                                                )}

                                                <Button
                                                    style={{
                                                        marginBottom: 20,
                                                        width: roleId === "EXPERT" ? 450 : 350,
                                                    }}
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={caseData.requesttomovetoobjectregistrybyexpert === true && roleId === "HEADOFDEPARTMENT"}
                                                    className="merge-dialog-button"
                                                    onClick={() => setIsUpdateCaseRegisterModalOpen(true)}
                                                    startIcon={<Add/>}
                                                >
                                                    {roleId === "EXPERT" ? "ობიექტის  უწყებრივ რეესტრში გადატანის მოთხოვნა" : "ობიექტის გადატანა უწყებრივ რეესტრში"}

                                                </Button>

                                                <Button
                                                    style={{
                                                        marginBottom: roleId === "EXPERT" ? 0 : 20,
                                                        width: roleId === "EXPERT" ? 450 : 350
                                                    }}
                                                    variant="contained"
                                                    color="secondary"
                                                    disabled={caseData.requesttomovetoobjectregistrybyexpert === true && roleId === "HEADOFDEPARTMENT"}
                                                    className="merge-dialog-button"
                                                    onClick={() => setIsMergeDialogByCaseIdOpen(true)}
                                                    startIcon={<MergeType/>}
                                                >

                                                    {roleId === "EXPERT" ? "განაცხადის გაერთიანების მოთხოვნის გაგზავნა" : "განაცხადის გაერთიანება"}
                                                </Button>
                                                <MergeCaseDialogByCaseId
                                                    open={isMergeDialogByCaseIdOpen}
                                                    onClose={() => setIsMergeDialogByCaseIdOpen(false)}
                                                    onMerge={mergeCases}
                                                    userId={userId}
                                                    onExpertMerge={mergeCasesByHead}
                                                    users={users}
                                                    roleId={roleId}
                                                    setIsMerging={setIsMerging}
                                                    previewHtml={objectHtml}
                                                    dateTime={new Date().toLocaleDateString('en-GB')}
                                                    fullName={objectOwner}
                                                />
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleDialogCloseObjectRegistery}
                                                        color="primary">
                                                    გაუქმება
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </>


                                )}


                            {roleId !== 'USER' && caseMustBeActive || (roleId !== "USER" && caseData.creteByExpert) ? (
                                <div className={"document-button-container"}>
                                    <div className="new-document-button">
                                        {documentTypesForEditor &&
                                            caseData &&
                                            caseFiles &&
                                            caseDetails.length > 0 &&
                                            users &&
                                            orderDepartment &&
                                            userId &&
                                            objectOwner &&
                                            roleId &&
                                            barcode &&
                                            ownerIdentificationTemplateString &&
                                            exploitationIdentificationTemplateString &&
                                            permitTypeTitle &&
                                            caseDataForDocument &&
                                            userAddress &&
                                            holidays.length > 0 && (
                                                <DocumentPopup documentTypes={documentTypesForEditor}
                                                               refreshCaseFiles={refreshCaseFiles}
                                                               declinedDetails={declinedDetails}
                                                               userProlongationDays={prolongationInfo.prolongationDays}
                                                               clearSelectedDocuments={clearSelectedDocuments}
                                                               refreshFlow={refreshFlow}
                                                               declinationDocExist={declinationDocExist}
                                                               selectedDocuments={selectedDocuments}
                                                               isDenyButtonDisabled={isDenyButtonDisabled}
                                                               isDenyButtonDisabledDetail={isDenyButtonDisabledDetail}
                                                               isDenyButtonDisabledGeo={isDenyButtonDisabledGeo}
                                                               caseGeography={caseGeography}
                                                               documentTypesForEditor={documentTypesForEditor}
                                                               currentUserId={currentUserId}
                                                               isDenyButtonDisabledParentId={isDenyButtonDisabledParentId}
                                                               permitTypeId={caseData.permitTypeId}
                                                               disableAdditionalFileRequest={disableAdditionalFileRequest}
                                                               disablePostponeDocCreation={disablePostponeDocCreation}
                                                               hideRequireCaseCancellationButtonInternal={hideRequireCaseCancellationButtonInternal}
                                                               hideRequireCaseCancellationButton={hideRequireCaseCancellationButton}
                                                               declineDaysExtension={declineDaysExtension}
                                                               caseFiles={caseFiles}
                                                               extendFileExists={extendFileExists}
                                                               isConditionButtonDisabled={isConditionButtonDisabled}
                                                               hasConditionalDeadline={hasConditionalDeadline}
                                                               caseData={caseDataForDocument}
                                                               users={users}
                                                               userId={userId}
                                                               objectOwner={objectOwner}
                                                               roleId={roleId}
                                                               barcode={barcode}
                                                               departments={departments}
                                                               hasExtention={hasExtention}
                                                               holidays={holidays}
                                                               caseInfo={caseData}
                                                               hasOrderDate={hasOrderDate}
                                                               orderDepartment={orderDepartment}
                                                               declineRequestStatus={declineRequestStatus}
                                                               permitTypeTitle={permitTypeTitle}
                                                               ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                                                               exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                                                               isAddressRejected={isAddressRejected}
                                                               isCadastralCodeRejected={isCadastralCodeRejected}
                                                               address={caseData.address}
                                                               cadastralCodeArray={caseData.cadastralCode}
                                                               userAddress={userAddress}


                                                />
                                            )}


                                        {caseFiles.length !== 0 && (
                                            <button className={"document-buttonn"}
                                                    onClick={() => setShowFilesPopup(true)}>დოკუმენტების
                                                გადმოწერა
                                            </button>
                                        )}


                                        <button className={"document-buttonn"} onClick={toggleUploadPopup}>
                                            დოკუმენტის ატვირთვა
                                        </button>


                                        {
                                            (caseData &&
                                                caseData.moveCaseToAgencyRegisterByExpert &&
                                                userId &&
                                                caseData.status !== caseStatus.Approved.id &&
                                                objectsOfRegistery.length !== 0 &&
                                                checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId) &&
                                                ((roleId === "EXPERT" && permission) || (roleId === "HEADOFAGENCY" || roleId === "DEPUTYHEADOFAGENCY" || roleId === "HEADOFDEPARTMENT")))
                                            && (
                                                <div className="new-document-button">
                                                    <button className={"document-buttonn"}
                                                            onClick={toggleUploadPopupInspection}>ინსპექტირების
                                                        ოქმის ატვირთვა
                                                    </button>
                                                    <button
                                                        className="document-buttonn small-font"
                                                        onClick={toggleUploadPopupAdmin}>
                                                        ადმინისტრაციული ოქმის ატვირთვა
                                                    </button>
                                                    <button className={"document-buttonn"}
                                                            onClick={toggleUploadPopupCertificate}>ინსპექტირების
                                                        სერტიფიკატის
                                                        დოკუმენტის
                                                        ატვირთვა
                                                    </button>
                                                    {roleId !== "EXPERT" && (
                                                        <button className={"document-buttonn-red"}
                                                                onClick={toggleShowRemoveFromObjectRegisteryPopup}>ობიექტის
                                                            ამოშლა
                                                            უწყებრივი რეესტრიდან
                                                        </button>
                                                    )}
                                                </div>
                                            )}


                                        {orderDepartment && orderDepartment === NomenclatureEnum.explosion &&
                                            (
                                                <Tooltip
                                                    title={!approvalDocumentExists ? "სანებართვო მოწმობის ატვირთვისთვის ხელი უნდა მოეწეროს ბრძანებას!" : explosionFileExists ?
                                                        "სანებართვო მოწმობის დოკუმენტი უკვე შექმნილია!" :
                                                        orderFileExists ? "უარყოფითი პასუხის ბრძანება შექმნილია!" :
                                                            ""}>
                                                    <span>
                                                        <button
                                                            disabled={!approvalDocumentExists || explosionFileExists || orderFileExists}
                                                            className={"document-buttonn"}
                                                            onClick={toggleExplosionUploadPopup}>
                                                            სანებართვო მოწმობის ატვირთვა
                                                        </button>
                                                    </span>
                                                </Tooltip>
                                            )}


                                        {approvalDocWasChecked && users.length !== 0 && isDenyButtonDisabled && caseFiles && roleId === "HEADOFAGENCY" && caseData && caseDataForDocument && (
                                            <div className={allManagersApproved() ? "" : "caseinsidetable-tooltip"}>
                                                <MakeDecision caseFiles={caseFiles}
                                                              disabledBecauseOfdeclinedFiles={(hasReuploadedDeclinedFiles || declinedDocHasAnswer)}
                                                              disabled={!approvalDocumentExists}
                                                              onStatusChange={refreshCaseDataOnFileUpload}
                                                              onDecisionMake={refreshCaseFiles}
                                                              disableCaseFinishButtonForExplosion={disableCaseFinishButtonForExplosion}
                                                              permitTypeId={caseData.permitTypeId}
                                                              caseData={caseData}
                                                              hasConditionalDeadline={hasConditionalDeadline}
                                                              conditionButtonActButtonExists={conditionalFileExists}
                                                              onConditionAct={() => setIsUpdateModalOpenForCondition(true)}
                                                              permitType={caseDataForDocument}
                                                              isObjectRegistery={isObjectInRegistery}
                                                              isObjectMovedToRegistery={caseData.moveCaseToAgencyRegisterByExpert}
                                                              users={users}
                                                />
                                            </div>

                                        )}
                                    </div>
                                    <div className={"deny-button-container"}>
                                        {roleId === 'HEADOFAGENCY' && (
                                            <>
                                                <Tooltip
                                                    title={(isDenyButtonDisabled || DisableDenyButton || DisableDenyButtonAfterSent || declinePendingDocExists) ? "დახარვეზებისთვის შექმენით დახარვეზების აქტი" : ""}>
                                                    <button className={"document-buttonn-red"}
                                                            disabled={isDenyButtonDisabled || DisableDenyButton || DisableDenyButtonAfterSent || declinePendingDocExists}
                                                            onClick={() => {
                                                                setIsUpdateModalOpen(true);
                                                            }}>
                                                        დახარვეზების აქტზე თანხმობა
                                                    </button>
                                                </Tooltip>
                                            </>

                                        )}


                                        {roleId === 'HEADOFAGENCY' && !isPostPoneButtonDisabled && !DisablePostPoneButton && (
                                            <button className={"document-buttonn-green"}
                                                    disabled={isPostPoneButtonDisabled || DisablePostPoneButton}
                                                    onClick={() => setIsUpdateModalOpenPostPone(true)}>
                                                წარმოების ვადის გაგრძელება
                                            </button>)}

                                        {roleId === 'HEADOFAGENCY' && !hasReuploadedDeclinedFiles && declinedDocHasAnswer && (
                                            <button className="document-buttonn-green"
                                                    onClick={() => setIsEndDeclinationModalOpen(true)}>
                                                დახარვეზებული დოკუმენტეზბე პასუხის გაცემა
                                            </button>
                                        )}

                                        {roleId === 'HEADOFAGENCY' && disableAdditionalFileRequestForHead && (
                                            <button className="document-buttonn-green"
                                                    onClick={() => setIsAddDocumentModalOpen(true)}>
                                                დამატებითი დოკუმენტების ატვირთვის აქტის გაგზავნა
                                            </button>)}
                                        {extendDaysApproved && roleId === "HEADOFAGENCY" && (
                                            <button className={"document-buttonn-green"}
                                                    onClick={() => setIsUpdateModalOpen(true)}>
                                                დახარვეზების დღეების გახანგრძლივება
                                            </button>)}
                                        {extendDaysDeclined && roleId === "HEADOFAGENCY" && (
                                            <button className={"document-buttonn-red"}
                                                    onClick={() => setIsUpdateModalOpen(true)}>
                                                დახარვეზების დღეების გახანგრძლივებაზე უარის თქმა
                                            </button>)}


                                    </div>
                                </div>) : (<div className={"document-button-container"}>
                                <div className="new-document-button">
                                    {caseFiles.length !== 0 && (
                                        <button className={"document-buttonn"}
                                                onClick={() => setShowFilesPopup(true)}>დოკუმენტების
                                            გადმოწერა
                                        </button>
                                    )}
                                    {caseData && userAddress &&  objectOwner && caseFiles.length !== 0 && caseData.requestToRemoveObjectFromObjectRegister === 1 && getUserDepartmentForRemovingObjectFromRegistery() && caseData && permitTypeTitle && ownerIdentificationTemplateString && exploitationIdentificationTemplateString && documentTypesForEditor && (
                                        <div style={{marginRight: 15}}>
                                            <RemoveObjectDoc
                                                caseFiles={caseFiles}
                                                objectOwner={objectOwner}
                                                documentTypes={documentTypesForEditor}
                                                refreshCaseFiles={refreshCaseFiles}
                                                clearSelectedDocuments={clearSelectedDocuments}
                                                refreshFlow={refreshFlow}
                                                selectedDocuments={selectedDocuments}
                                                isDenyButtonDisabled={isDenyButtonDisabled}
                                                isDenyButtonDisabledDetail={isDenyButtonDisabledDetail}
                                                isDenyButtonDisabledGeo={isDenyButtonDisabledGeo}
                                                caseGeography={caseGeography}
                                                documentTypesForEditor={documentTypesForEditor}
                                                currentUserId={currentUserId}
                                                isDenyButtonDisabledParentId={isDenyButtonDisabledParentId}
                                                permitTypeId={caseData.permitTypeId}
                                                disableAdditionalFileRequest={disableAdditionalFileRequest}
                                                disablePostponeDocCreation={disablePostponeDocCreation}
                                                hideRequireCaseCancellationButtonInternal={hideRequireCaseCancellationButtonInternal}
                                                hideRequireCaseCancellationButton={hideRequireCaseCancellationButton}
                                                declineDaysExtension={declineDaysExtension}
                                                extendFileExists={extendFileExists}
                                                isConditionButtonDisabled={isConditionButtonDisabled}
                                                hasConditionalDeadline={hasConditionalDeadline}
                                                caseData={caseDataForDocument}
                                                users={users}
                                                userId={userId}
                                                roleId={roleId}
                                                barcode={barcode}
                                                departments={departments}
                                                hasExtention={hasExtention}
                                                holidays={holidays}
                                                caseInfo={caseData}
                                                permitTypeTitle={permitTypeTitle}
                                                ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                                                exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                                                userAddress={userAddress}

                                            />
                                        </div>
                                    )}
                                    {caseData &&
                                        userId &&
                                        caseData.requesterId === userId &&
                                        caseData.moveCaseToAgencyRegisterByExpert &&
                                        caseData.requestToRemoveObjectFromObjectRegister !== 1 && caseData.requestToRemoveObjectFromObjectRegister !== 2 && (
                                            <RequestToRemoveObject
                                                onFileAdded={refreshCaseFiles}
                                                onCaseStatusChange={refreshCaseDataOnFileUpload}
                                            />

                                        )}

                                    {caseMustBeActiveForUploadBuilidngFile && canUploadDocumentForBuilding && (
                                        <Tooltip
                                            title={explosionFileExists ? "სანებართვო მოწმობის დოკუმენტი უკვე შექმნილია!" : ""}>
                                            <span>
                                                <button
                                                    disabled={explosionFileExists}
                                                    className={"document-buttonn"}
                                                    onClick={toggleExplosionUploadPopup}>
                                                    სანებართვო მოწმობის ატვირთვა
                                                </button>
                                            </span>
                                        </Tooltip>
                                    )}


                                    {
                                        caseData &&
                                        userId &&
                                        caseData.requesterId === userId &&
                                        hideRequireCaseCancellationButton &&
                                        roleId === "USER" &&
                                        daysForCancel !== null &&
                                        daysForCancel <= 3 &&
                                        (caseData.declineREquestStatus !== DeclineRequestStatusEnum.declineRequested) &&
                                        (
                                            caseData.status === caseStatus.CaseCreatedWithFiles.id ||
                                            caseData.status === caseStatus.WaitingForVisageCond.id ||
                                            caseData.status === caseStatus.UserIsAbleToAddFiles.id ||
                                            caseData.status === caseStatus.Sent.id) &&
                                        (
                                            <CaseCancelForBuilding
                                                onFileAdded={refreshCaseFiles}
                                                onCaseStatusChange={refreshCaseDataOnFileUpload}
                                            />)}
                                    {
                                        userId &&
                                        caseData.requesterId === userId &&
                                        !secretFileExist &&
                                        (
                                            <HideCaseRequest
                                                onFileAdded={refreshCaseFiles}
                                                onCaseStatusChange={refreshCaseDataOnFileUpload}
                                            />
                                        )
                                    }
                                    {caseCanBeCanceled &&
                                        roleId === "USER" &&
                                        orderDepartment &&
                                        hideRequireCaseCancellationButton &&
                                        (
                                            <RequireCaseCancellation
                                                onFileAdded={refreshCaseFiles}
                                                onCaseStatusChange={refreshCaseDataOnFileUpload}
                                                orderDepartment={orderDepartment}
                                            />
                                        )}
                                    {userAddress && caseMustBeActiveForCancel && objectOwner && !hideRequireCaseCancellationButton && permitTypeTitle && ownerIdentificationTemplateString && exploitationIdentificationTemplateString && (
                                        <CaseCancelPopup documentTypes={documentTypesForEditor}
                                                         refreshCaseFiles={refreshCaseFiles}
                                                         documentTypesForEditor={documentTypesForEditor}
                                                         hideRequireCaseCancellationButtonInternal={hideRequireCaseCancellationButtonInternal}
                                                         users={users}
                                                         objectOwner={objectOwner}
                                                         userId={userId}
                                                         barcode={barcode}
                                                         caseInfo={caseData}
                                                         hasOrderDate={hasOrderDate}
                                                         permitTypeTitle={permitTypeTitle}
                                                         ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                                                         exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                                                         userAddress={userAddress}

                                        />
                                    )}

                                    {caseCanceled && roleId === "HEADOFAGENCY" && (
                                        <button className={"document-buttonn-red"}
                                                onClick={() => setIsCancelModalOpen(true)}>
                                            განაცხადის ძალადაკარგულად გამოცხადება
                                        </button>)}
                                    {caseCancelDecline && roleId === "HEADOFAGENCY" && hideCancelButton && (
                                        <button className={"document-buttonn-red"}
                                                onClick={() => setIsCaseCancellationModalOpen(true)}>
                                            განაცხადის ძალადაკარგულად გამოცხადებაზე უარის თქმა
                                        </button>)}


                                    {roleId === "USER" && caseData && caseData.status === caseStatus.CaseCreatedWithoutFiles.id && caseData && userId && userId === caseData.requesterId && (
                                        <button onClick={() => setCaseDeleteModalOpen(true)}
                                                className={"document-buttonn-green"}>განაცხადის წაშლა</button>
                                    )}

                                    {showUploadMissingFiles && (
                                        <UploadMissingFiles
                                            caseFiles={caseFiles}
                                            permitTypeId={caseData.permitTypeId}
                                            onClose={toggleUploadMissingFiles}
                                            onFileAdded={refreshCaseFiles}
                                            showUploadMissingFiles={showUploadMissingFiles}
                                            onCaseStatusChange={refreshCaseDataOnFileUpload}
                                            cityIdFromUrl={caseData.city}
                                        />)}
                                    {isReuploadble && (
                                        <>
                                            <button onClick={handleClickOpenCaseDetails}
                                                    className="document-buttonn-red">
                                                დახარვეზებული დოკუმენტები ატვირთვა
                                            </button>
                                            <Dialog
                                                fullWidth={true}
                                                maxWidth="xl"
                                                style={{
                                                    zIndex: 4,
                                                    width: '100%',
                                                    maxHeight: '100vh'
                                                }}
                                                open={openCaseDetailsPopup}
                                                onClose={handleCloseCaseDetails}
                                            >
                                                <DialogContent style={{height: 'calc(100vh - 64px)'}}>
                                                    {caseData && roleId && orderDepartment && caseDetails && caseFiles && caseDataForDocument && isObjectInRegistery !== null && (
                                                        <CaseDetails
                                                            role={roleId}
                                                            caseFinished={caseData.finished}
                                                            caseInfo={caseData}
                                                            permitTypeId={caseData.permitTypeId}
                                                            caseMustBeActive={caseMustBeActive}
                                                            caseDetails={caseDetails}
                                                            onDetailChange={refreshCaseDetails}
                                                            caseFiles={caseFiles}
                                                            onFileAdded={refreshCaseFiles}
                                                            onCaseStatusChange={refreshCaseDataOnFileUpload}
                                                            isButtonVisible={isReuploadble}
                                                            caseGeography={caseGeography}
                                                            isObjectInRegistery={isObjectInRegistery}
                                                            geoIds={geoIds}
                                                            caseParentId={caseData.caseParentId}
                                                            isCaseParentIdRejected={caseData.isRejectedCaseParentId}
                                                            onCaseParentIdRejection={refreshCaseDataOnFileUpload}
                                                            caseData={caseDataForDocument}
                                                            users={users}
                                                            isAddressRejected={caseData.addressDeclinedStatus}
                                                            isCadastralCodeRejected={caseData.cadastralCodeDenclinedStatus}
                                                            orderDepartment={orderDepartment}
                                                            isPopup={true}
                                                            objectsOfRegistery={objectsOfRegistery}
                                                        />
                                                    )}
                                                </DialogContent>
                                            </Dialog>
                                        </>


                                    )}

                                    {showUploadMissingFilesExpert && (
                                        <UploadMissingFilesExpert
                                            caseFiles={caseFiles}
                                            permitTypeId={caseData.permitTypeId}
                                            onClose={toggleUploadMissingFilesExpert}
                                            onFileAdded={refreshCaseFiles}
                                            showUploadMissingFiles={showUploadMissingFilesExpert}
                                            onCaseStatusChange={refreshCaseDataOnFileUpload}
                                        />)}

                                    {caseData && orderDepartment && caseData.finished && roleId === 'USER' && caseData.status === caseStatus.Declined.id && (<>
                                        {makeExtensionImpossible && (
                                            <DeclineDaysExtension
                                                files={caseFiles}
                                                onFileAdded={refreshCaseFiles}
                                                onCaseStatusChange={refreshCaseDataOnFileUpload}
                                                prolongationDaysForInput={prolongationInfo.prolongationDays}
                                                nomenclautureId={orderDepartment}
                                            />)}
                                    </>)}
                                    {(caseData && caseData.status === caseStatus.CaseCreatedWithoutFiles.id && roleId === 'USER' && caseData && userId && userId === caseData.requesterId)
                                        && (
                                            <button className="document-buttonn"
                                                    onClick={toggleUploadMissingFiles}>დარჩენილი
                                                დოკუმენტების ატვირთვა</button>)}


                                    {caseData && caseData.creteByExpert && showMissingFilesPopup && roleId !== 'USER'
                                        && (
                                            <button className="document-buttonn"
                                                    onClick={toggleUploadMissingFilesExpert}>

                                                განაცხადის დოკუმენტაციის ატვირთვა
                                            </button>)}


                                    {caseData &&
                                        !caseData.creteByExpert &&
                                        caseMustBeActiveForRegistery &&
                                        caseData.creteByExpertCaseNumber &&
                                        roleId !== 'USER' &&
                                        !caseData.moveCaseToAgencyRegisterByExpert
                                        && (
                                            <div>
                                                <button className="document-buttonn"
                                                        onClick={() => setIsUpdateCaseRegisterModalOpen(true)}>
                                                    ობიექტის გადატანა უწყებრივ რეესტრში
                                                </button>

                                            </div>

                                        )}


                                    {caseData && caseData.creteByExpert && roleId !== 'USER'
                                        && (
                                            <>
                                                <button className={"document-buttonn"}
                                                        onClick={toggleUploadPopupExpert}>დოკუმენტის
                                                    ატვირთვა
                                                </button>
                                                {showUploadPopupExpert && users.length !== 0 && (
                                                    <UploadSingleFile onClose={toggleUploadPopupExpert}
                                                                      onFileUpload={refreshCaseFiles}
                                                                      caseData={caseDataForDocument}
                                                                      isCaseCreatedByExpert={true}
                                                                      users={users}
                                                    />
                                                )}

                                            </>
                                        )}
                                    {userAddress && roleId !== 'USER' && caseData && objectOwner && caseData.creteByExpert && ownerIdentificationTemplateString && exploitationIdentificationTemplateString && permitTypeTitle && (
                                        <ExpertFilesPopup
                                            documentTypes={documentTypesForEditor}
                                            objectOwner={objectOwner}
                                            refreshCaseFiles={refreshCaseFiles}
                                            clearSelectedDocuments={clearSelectedDocuments}
                                            refreshFlow={refreshFlow}
                                            selectedDocuments={selectedDocuments}
                                            isDenyButtonDisabled={isDenyButtonDisabled}
                                            isDenyButtonDisabledDetail={isDenyButtonDisabledDetail}
                                            isDenyButtonDisabledGeo={isDenyButtonDisabledGeo}
                                            caseGeography={caseGeography}
                                            documentTypesForEditor={documentTypesForEditor}
                                            currentUserId={currentUserId}
                                            isDenyButtonDisabledParentId={isDenyButtonDisabledParentId}
                                            permitTypeId={caseData.permitTypeId}
                                            disableAdditionalFileRequest={disableAdditionalFileRequest}
                                            disablePostponeDocCreation={disablePostponeDocCreation}
                                            hideRequireCaseCancellationButtonInternal={hideRequireCaseCancellationButtonInternal}
                                            hideRequireCaseCancellationButton={hideRequireCaseCancellationButton}
                                            declineDaysExtension={declineDaysExtension}
                                            caseFiles={caseFiles}
                                            extendFileExists={extendFileExists}
                                            isConditionButtonDisabled={isConditionButtonDisabled}
                                            hasConditionalDeadline={hasConditionalDeadline}
                                            caseData={caseDataForDocument}
                                            users={users}
                                            userId={userId}
                                            roleId={roleId}
                                            barcode={barcode}
                                            departments={departments}
                                            hasExtention={hasExtention}
                                            holidays={holidays}
                                            caseInfo={caseData}
                                            permitTypeTitle={permitTypeTitle}
                                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                                            userAddress={userAddress}
                                        />
                                    )}
                                    {roleId === 'USER' && caseData && caseData.status === CaseStatus.ConditionalEnded.id && (
                                        <button className="document-buttonn"
                                                onClick={toggleUploadConditionFiles}>
                                            პირობიანი დოკუმენტის ატვირთვა
                                        </button>)}


                                    {roleId === "USER" && caseData && caseData.status === CaseStatus.UserIsAbleToAddFiles.id && (
                                        <UploadAdditionalFiles
                                            additionalFiles={caseFiles}
                                            onFileAdded={refreshCaseFiles}
                                            onCaseStatusChange={refreshCaseDataOnFileUpload}
                                            prolongationDaysForInput={prolongationInfo.prolongationDays}
                                        />)}

                                </div>

                            </div>)}
                            {userAddress && caseMustBeActiveToMakeItSecret && !disabledBecauseSecretOrderExist && orderDepartment && caseData && caseDataForDocument && objectOwner && !hideMakeCaseSecretButton && permitTypeTitle && ownerIdentificationTemplateString && exploitationIdentificationTemplateString && (
                                <HideCasePopup documentTypes={documentTypesForEditor}
                                               refreshCaseFiles={refreshCaseFiles}
                                               documentTypesForEditor={documentTypesForEditor}
                                               hideRequireCaseCancellationButtonInternal={hideRequireCaseCancellationButtonInternal}
                                               users={users}
                                               objectOwner={objectOwner}
                                               userId={userId}
                                               barcode={barcode}
                                               caseInfo={caseData}
                                               hasOrderDate={hasOrderDate}
                                               permitTypeTitle={permitTypeTitle}
                                               ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                                               exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                                               permitTypeId={caseData.permitTypeId}
                                               caseData={caseDataForDocument}
                                               orderDepartment={orderDepartment}
                                               disabledBecauseSecretOrderExist={disabledBecauseSecretOrderExist}
                                               userAddress={userAddress}



                                />
                            )}
                        </div>
                        <div>
                            {showFilesPopup && roleId && caseData && caseFiles && (<>
                                <div className="overlay" onClick={closeFilesPopup}></div>
                                <FilesPopup
                                    userCaseFiles={caseFiles}
                                    selectedDocuments={selectedFilesPopupDocuments}
                                    handleCheckboxChange={handleFilesPopupCheckboxChange}
                                    onClose={closeFilesPopup}
                                    role={roleId}
                                    caseNumber={caseData.caseNumber}

                                />
                            </>)}
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>

                                            {caseMustBeActive && (<TableCell style={{
                                                textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"
                                            }}>არჩევა</TableCell>)}
                                            <TableCell style={{
                                                textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"
                                            }}>დოკუმენტის ნომერი</TableCell>
                                            {roleId !== 'USER' && (<TableCell style={{
                                                textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"
                                            }}>დოკუმენტის შემქმნელი</TableCell>)}
                                            <TableCell style={{textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"}}>დოკუმენტის
                                                სახელი</TableCell>
                                            <TableCell style={{textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"}}>დამატებითი
                                                ინფორმაცია</TableCell>
                                            {roleId !== 'USER' && (<TableCell style={{
                                                textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"
                                            }}>აქტიური მომხარებელი</TableCell>)}
                                            <TableCell style={{textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"}}>დოკუმენტის
                                                ტიპი</TableCell>

                                            <TableCell style={{
                                                textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"
                                            }}>საჯარო</TableCell>
                                            {roleId !== "USER" && (<>
                                                <TableCell style={{
                                                    textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"
                                                }}>დოკუმენტი შეიქმნა</TableCell>
                                                <TableCell style={{
                                                    textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"
                                                }}>დოკუმენტი დარედაქტირდა</TableCell>
                                            </>)}


                                            {roleId !== 'USER' && (<TableCell style={{
                                                textAlign: 'center', fontFamily: "'FiraGO-SemiBold'"
                                            }}>ქმედება</TableCell>)}

                                        </TableRow>
                                    </TableHead>
                                    {mainFiles.length === 0 && caseFilesAreFetched ? (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={12} style={{textAlign: "center"}}>
                                                    <div className="no-files-found">
                                                        <RiFolderForbidFill className="icon"/>
                                                        <p>განაცხადს არ აქვს მიბმული დოკუმენტები!</p>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>) : (
                                        <TableBody>
                                            {mainFiles.map((file) => (
                                                <React.Fragment key={file.id}>
                                                    <TableRow>
                                                        {caseMustBeActive && (
                                                            <TableCell style={{
                                                                height: 40,
                                                                textAlign: 'center',
                                                                backgroundColor: getBackgroundColor(file),
                                                                pointerEvents: file.decline === CaseFileDeclined.No && file.shared === true && file.creatorId === caseData.requesterId && (file.postpone !== 0 && file.postpone !== 1) && !file.internal ? 'auto' : 'none'
                                                            }}>
                                                                {
                                                                    file.decline === CaseFileDeclined.No
                                                                    && file.shared === true
                                                                    && file.creatorId === caseData.requesterId
                                                                    && (file.postpone !== 0 && file.postpone !== 1)
                                                                    && !file.internal ? (
                                                                        <input
                                                                            type="checkbox"
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                transform: 'scale(1.5)', // Scale up the checkbox
                                                                                margin: '5px', // Add some margin around the checkbox
                                                                                borderRadius: '3px', // Optional: round corners for visual effect
                                                                                border: '1px solid #ccc' // Optional: add a border
                                                                            }}
                                                                            checked={Object.keys(selectedDocuments).includes(file.id.toString())}
                                                                            onChange={(e) => handleCheckboxChange(e, file)}
                                                                            disabled={file.postpone === 0 || file.postpone === 1}
                                                                        />

                                                                    ) : (<div></div>)
                                                                }
                                                            </TableCell>
                                                        )}

                                                        {
                                                            caseData && file.creatorId === caseData.requesterId && file.casefileNumber === null ? (
                                                                    <TableCell
                                                                        className="lightblue-link"
                                                                        style={{
                                                                            height: 40,
                                                                            textAlign: 'center',
                                                                            backgroundColor: getBackgroundColor(file),
                                                                        }}
                                                                        title={file.casefileNumber}
                                                                    >
                                                                    </TableCell>
                                                                ) :
                                                                ((file.isInspectFile || file.isSertificatFile || file.inpectOrderAttachment)) ? (
                                                                        <TableCell
                                                                            className="lightblue-link"
                                                                            style={{
                                                                                height: 40,
                                                                                textAlign: 'center',
                                                                                backgroundColor: getBackgroundColor(file),
                                                                            }}
                                                                            title={file.casefileNumber}
                                                                        >
                                                                            <a href={file.path} target="_blank"
                                                                               download
                                                                               rel="noopener noreferrer"
                                                                               className="lightblue-link">
                                                                                {file.casefileNumber}
                                                                            </a>
                                                                        </TableCell>
                                                                    ) :


                                                                    file.casefileNumber && file.casefileNumber.length > 7 ? (
                                                                        <TableCell
                                                                            className="lightblue-link"
                                                                            style={{
                                                                                height: 40,
                                                                                textAlign: 'center',
                                                                                backgroundColor: getBackgroundColor(file),
                                                                            }}
                                                                            title={file.casefileNumber}
                                                                        >

                                                                            <a href={file.path} target="_blank"
                                                                               download
                                                                               rel="noopener noreferrer"
                                                                               className="lightblue-link">
                                                                                {file.casefileNumber}
                                                                            </a>
                                                                        </TableCell>

                                                                    ) : (file.casefileNumber && file.casefileNumber.charAt(0)) || (file.casefileNumber && file.casefileNumber.charAt(0)) === "/" ? (
                                                                            <TableCell
                                                                                className="lightblue-link"
                                                                                style={{
                                                                                    height: 40,
                                                                                    textAlign: 'center',
                                                                                    backgroundColor: getBackgroundColor(file),
                                                                                }}
                                                                                title={file.documentNumber + (file.casefileNumber ? file.casefileNumber : "")}
                                                                            >

                                                                                <a href={file.path} target="_blank"
                                                                                   download
                                                                                   rel="noopener noreferrer"
                                                                                   className="lightblue-link">
                                                                                    {file.documentNumber + (file.casefileNumber ? file.casefileNumber : "")}
                                                                                </a>
                                                                            </TableCell>

                                                                        ) :
                                                                        file.casefileNumber && file.casefileNumber.charAt(0) !== "/" ?
                                                                            (<TableCell
                                                                                className="lightblue-link"
                                                                                style={{
                                                                                    height: 40,
                                                                                    textAlign: 'center',
                                                                                    backgroundColor: getBackgroundColor(file),
                                                                                }}
                                                                                title={(file.casefileNumber ? file.casefileNumber : "") + file.documentNumber}
                                                                            >

                                                                                <a href={file.path} target="_blank"
                                                                                   download
                                                                                   rel="noopener noreferrer"
                                                                                   className="lightblue-link">
                                                                                    {(file.casefileNumber ? file.casefileNumber : "") + file.documentNumber}
                                                                                </a>
                                                                            </TableCell>) : (
                                                                                <TableCell
                                                                                    className="lightblue-link"
                                                                                    style={{
                                                                                        height: 40,
                                                                                        textAlign: 'center',
                                                                                        backgroundColor: getBackgroundColor(file),
                                                                                    }}
                                                                                    title={file.documentNumber + (file.casefileNumber ? file.casefileNumber : "")}
                                                                                >

                                                                                    <a href={file.path} target="_blank"
                                                                                       download
                                                                                       rel="noopener noreferrer"
                                                                                       className="lightblue-link">
                                                                                        {file.documentNumber + (file.casefileNumber ? file.casefileNumber : "")}
                                                                                    </a>
                                                                                </TableCell>

                                                                            )

                                                        }
                                                        {roleId !== 'USER' && (
                                                            <>
                                                                {file.documentSignedUserFullName ? (
                                                                    <TableCell
                                                                        style={{
                                                                            height: 40,
                                                                            textAlign: 'center',
                                                                            backgroundColor: getBackgroundColor(file),
                                                                        }}
                                                                        title={file.documentSignedUserFullName}
                                                                    >
                                                                        {file.documentSignedUserFullName}
                                                                    </TableCell>

                                                                ) : (
                                                                    <TableCell
                                                                        style={{
                                                                            height: 40,
                                                                            textAlign: 'center',
                                                                            backgroundColor: getBackgroundColor(file),
                                                                        }}
                                                                        title={file.fullname}
                                                                    >
                                                                        {file.fullname}


                                                                    </TableCell>

                                                                )}

                                                            </>
                                                        )}
                                                        <TableCell
                                                            style={{
                                                                backgroundColor: getBackgroundColor(file),


                                                            }}
                                                        >
                                                            <div style={{display: "flex"}}>
                                                                {roleId === "USER" ? (
                                                                    <>
                                                                        <Tooltip title={file.name}>
                                                                            <a href={file.path} target="_blank"
                                                                               download
                                                                               rel="noopener noreferrer"
                                                                               className="lightblue-link">
                                                                                {file.name.length > 80 ? `${file.name.substring(0, 70)}...` : file.name}
                                                                            </a>
                                                                        </Tooltip>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <Tooltip title={file.name}>
                                                                            <a href={file.path} target="_blank"
                                                                               download
                                                                               rel="noopener noreferrer"
                                                                               className="lightblue-link">
                                                                                {file.name.length > 50 ? `${file.name.substring(0, 47)}...` : file.name}
                                                                            </a>
                                                                        </Tooltip>
                                                                    </>
                                                                )}

                                                                {flowData.some(flow => flow.childDocumentId === file.id && roleId !== "USER" &&
                                                                    flow.caseDocumentInternalFlowStatus === CaseDocumentInternalFlowStatusEnum.SentToAnotherDepartment) && (
                                                                    <FiAlertTriangle
                                                                        style={{
                                                                            color: "black",
                                                                            fontSize: 20,
                                                                            marginLeft: 5
                                                                        }}/>
                                                                )}

                                                                {file.tempProlongationDays && roleId !== "USER" && (

                                                                    <div style={{marginLeft: 5}}
                                                                    >
                                                                        <Tooltip
                                                                            title={file.tempProlongationDays + " დღე"}>
                                                                            <span>
                                                                                <MdOutlineTimer
                                                                                    className={"alert-icon-return_comment"}/>
                                                                            </span>
                                                                        </Tooltip>
                                                                    </div>
                                                                )}
                                                                {file.decline === CaseFileDeclined.RewriteDocument && roleId !== "USER" && (
                                                                    <FaInfoCircle
                                                                        className="user-info-icon"
                                                                        onClick={() => handleOpenRewriteRequestDialog(file.creatorId)}
                                                                    />
                                                                )}

                                                                {file.isSertificatFile && roleId !== "USER" && (
                                                                    <span style={{marginLeft: 5}}>
                                                                        <Tooltip
                                                                            title="ინსპეტირების სერტიფიკატის დოკუმენტის ინფორმაცია">
                                                                            <FaInfoCircle
                                                                                onClick={() => handleOpenDialog(file)}
                                                                                className={"alert-icon-return_comment"}/>
                                                                        </Tooltip>
                                                                    </span>
                                                                )}

                                                                {roleId !== "USER" && file.expertIdsWhoWorking !== null && (
                                                                    <span style={{marginLeft: 5}}>
                                                                        <Tooltip
                                                                            title="ინსპეტირების დოკუმენტის ინფორმაცია">
                                                                            <FaInfoCircle
                                                                                onClick={() => handleOpenDialog(file)}
                                                                                className={"alert-icon-return_comment"}/>
                                                                        </Tooltip>
                                                                    </span>
                                                                )}
                                                                {file.inActiveIsInspectionSertificate && !file.isSertificatFile && roleId !== "USER" && (
                                                                    <span style={{marginLeft: 5}}>
                                                                        <Tooltip
                                                                            title="ინსპექტირტების სერტიფიკატის მონაცემების შეყვანა">
                                                                            <span>
                                                                                <FaEdit
                                                                                    onClick={() => toggleEditPopupCertificate(file)}
                                                                                    className={"alert-icon-return_comment"}/>
                                                                            </span>

                                                                        </Tooltip>
                                                                    </span>
                                                                )}
                                                                {file.registeryDocumentType === 1 && file.expertIdsWhoWorking === null && roleId !== "USER" && (
                                                                    <span style={{marginLeft: 5}}>
                                                                        <Tooltip
                                                                            title="ინსპექტირტების ოქმის მონაცემების შეყვანა">
                                                                            <span>
                                                                                <FaEdit
                                                                                    onClick={() => toggleEditPopupInspection(file)}
                                                                                    className={"alert-icon-return_comment"}/>
                                                                            </span>

                                                                        </Tooltip>
                                                                    </span>
                                                                )}

                                                                {file.activeUserId === "ვიზირების მოლოდინში" && roleId === "HEADOFDEPARTMENT" && (
                                                                    <Tooltip title={"ვიზირების მოლოდინში"}>
                                                                        <span>
                                                                            <CgSandClock
                                                                                className={"alert-icon-return_comment"}/>
                                                                        </span>
                                                                    </Tooltip>

                                                                )}

                                                                {file.postponeDate && roleId !== "USER" && (
                                                                    <Tooltip title={formatDate(file.postponeDate)}>
                                                                        <span style={{marginLeft: 5}}
                                                                        >
                                                                            <MdOutlineTimer
                                                                                className={"alert-icon-return_comment"}/>

                                                                        </span>
                                                                    </Tooltip>
                                                                )}
                                                                {file.inpectOrderAttachmentDate && roleId !== "USER" && (

                                                                    <Tooltip
                                                                        title={formatDate(file.inpectOrderAttachmentDate)}>
                                                                        <span style={{marginLeft: 5}}>
                                                                            <MdOutlineTimer
                                                                                className={"alert-icon-return_comment"}/>
                                                                        </span>
                                                                    </Tooltip>

                                                                )}
                                                                <ReturnCommentPopup file={file} roleId={roleId}/>
                                                                {userId && flowData && (
                                                                    <ReturnCommentPopupFlow
                                                                        flow={displayFlowDataForExpert(file.id)}
                                                                        userId={userId}
                                                                        fileId={file.id}/>
                                                                )}
                                                                {displayFlowDataForHeadOfDepartment(file.id).length !== 0 &&
                                                                    (
                                                                        <ReturnCommentPopupFlowHeadOfDepartment
                                                                            flow={displayFlowDataForHeadOfDepartment(file.id)}
                                                                            userId={userId} fileId={file.id}/>

                                                                    )}

                                                                {file.name === "დახარვეზების დღეების გახანგრძლივება" && roleId !== "USER" && (
                                                                    <Tooltip title={file.prolongationDays + " დღე"}>
                                                                        <span style={{marginLeft: 5}}
                                                                        >
                                                                            <MdOutlineTimer
                                                                                className={"alert-icon-return_comment"}/>
                                                                        </span>
                                                                    </Tooltip>

                                                                )}
                                                                <ConditionalIcon file={file} roleId={roleId}/>
                                                                {file.conditionalDeadLine === null && file.termOfPermitDate && roleId !== "USER" && (
                                                                    <>
                                                                        <Tooltip
                                                                            title={`ნებართვის ვადა: ${formatDate(file.termOfPermitDate)}`}>
                                                                            <span style={{marginLeft: 5}}>
                                                                                <MdOutlineTimer
                                                                                    className="alert-icon-return_comment"/>
                                                                            </span>
                                                                        </Tooltip>
                                                                    </>
                                                                )}

                                                                {file.decline === CaseFileDeclined.CaseCancellationDocument && roleId !== "USER" && (
                                                                    <span style={{marginLeft: 5}}
                                                                          title={"დადებითი პასუხი"}>
                                                                        <FaInfoCircle
                                                                            className="alert-icon-return_comment"/>
                                                                    </span>
                                                                )}
                                                                {file.decline === CaseFileDeclined.CaseCancellationDocumentDeclined && roleId !== "USER" && (
                                                                    <span style={{marginLeft: 5}}
                                                                          title={"განაცხადის ძალადაკარგულად გამოცხადებაზე უარის თქმა"}>
                                                                        <FaInfoCircle
                                                                            className="alert-icon-return_comment"/>
                                                                    </span>
                                                                )}
                                                                {file.decline === CaseFileDeclined.RequireCaseCancellationBuildingAnswer && roleId !== "USER" && (
                                                                    <span style={{marginLeft: 5}}
                                                                          title={"დადებითი პასუხი"}>
                                                                        <FaInfoCircle
                                                                            className="alert-icon-return_comment"/>
                                                                    </span>
                                                                )}
                                                                {file.decline === CaseFileDeclined.RequireCaseCancellationBuildingAnswerDenied && roleId !== "USER" && (
                                                                    <span style={{marginLeft: 5}}
                                                                          title={"განაცხადის ძალადაკარგულად გამოცხადებაზე უარის თქმა"}>
                                                                        <FaInfoCircle
                                                                            className="alert-icon-return_comment"/>
                                                                    </span>
                                                                )}
                                                            </div>


                                                        </TableCell>

                                                        <TableCell
                                                            style={{backgroundColor: getBackgroundColor(file)}}
                                                            title={file.additionalInfo}
                                                        >
                                                            {file.additionalInfo.length > 30 ? `${file.additionalInfo.substring(0, 35)}...` : file.additionalInfo}
                                                        </TableCell>
                                                        {roleId && roleId !== "USER" && (
                                                            <TableCell
                                                                style={{
                                                                    height: 40,
                                                                    textAlign: 'center',
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                                title={file.additionalInfo}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: 10

                                                                    }}
                                                                >
                                                                    {file && file.activeUserId && !file.isDocumentSigned && (
                                                                        <>
                                                                            {getUserFullNameById(file.activeUserId).length > 30
                                                                                ? getUserFullNameById(file.activeUserId)
                                                                                : getUserFullNameById(file.activeUserId)
                                                                            }
                                                                        </>
                                                                    )}

                                                                    {!file.skipVisage && (file.activeUserId === "ვიზირების მოლოდინში" || isUserHeadOfDepartmentAndCaseHasCaseVisagers(file)) &&
                                                                        (
                                                                            <>
                                                                                <Tooltip title={"ვიზატორები"}>
                                                                                    <div>
                                                                                        <LiaFileSignatureSolid
                                                                                            onClick={() => {
                                                                                                setVisageFileId(file.id)
                                                                                                handleOpenVisagersPopup()
                                                                                            }}
                                                                                            className="file-signature-icon"/>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            </>
                                                                        )
                                                                    }
                                                                </div>
                                                            </TableCell>
                                                        )}

                                                        {!file.internal &&
                                                        caseData &&
                                                        userId &&
                                                        file.creatorId !== userId &&
                                                        file.creatorId !== caseData.requesterId &&
                                                        !file.shared ?
                                                            (<TableCell
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        backgroundColor: getBackgroundColor(file),
                                                                        verticalAlign: 'top', // Ensures content starts from the top
                                                                    }}
                                                                    title={documentTypes[file.documentType] || ''}
                                                                >
                                                                    <div>
                                                                        {documentTypes[file.documentType] || ''}

                                                                        <div className="draft-document-title">
                                                                            (DRAFT)
                                                                        </div>
                                                                    </div>
                                                                </TableCell>
                                                            )
                                                            :
                                                            (
                                                                <TableCell
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}
                                                                    title={documentTypes[file.documentType] || ''}
                                                                >
                                                                    <div>
                                                                        {documentTypes[file.documentType] || ''}

                                                                    </div>
                                                                </TableCell>)}


                                                        {caseData && file.creatorId === caseData.requesterId && canHideDocs ? (
                                                            <TableCell
                                                                style={{
                                                                    textAlign: 'center',
                                                                    backgroundColor: getBackgroundColor(file),
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    minHeight: 62,
                                                                    gap: '10px',
                                                                    cursor: "pointer"
                                                                }}
                                                                onClick={() => changeCaseFileSharedStatus(file.id)}
                                                                title={file.shared ? "კი" : "არა"}
                                                                className="shared-file-cell"
                                                            >
                                                                {file.shared ? (
                                                                    <>
                                                                        <Visibility className="shared-file-icon"/>
                                                                        კი
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <VisibilityOff className="shared-file-icon"/>
                                                                        არა
                                                                    </>
                                                                )}
                                                            </TableCell>) : (
                                                            <TableCell
                                                                style={{
                                                                    textAlign: 'center',
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                                title={file.shared ? "კი" : "არა"}
                                                            >
                                                                {file.shared ? "კი" : "არა"}
                                                            </TableCell>
                                                        )}


                                                        {roleId !== "USER" && (

                                                            <>
                                                                <TableCell
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}
                                                                    title={formatDateAndTime(file.createdAt, "aaa")}
                                                                >
                                                                    <div>
                                                                        {file.documentDatesActions.length > 0 ? formatDateAndTime(file.documentDatesActions[0].createdAt, 'aaa') : formatDateAndTime(file.createdAt, "aaa")}
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell
                                                                    style={{
                                                                        textAlign: 'center',
                                                                        backgroundColor: getBackgroundColor(file),
                                                                        cursor: "help",
                                                                    }}
                                                                >
                                                                    <Tooltip
                                                                        title={<React.Fragment>
                                                                            {file.documentDatesActions.map((action, index) => (
                                                                                <div
                                                                                    key={action.id}>{index + 1}: {formatDateAndTime(action.createdAt, 'aaa')}</div>
                                                                            ))}
                                                                        </React.Fragment>}
                                                                        placement="top"
                                                                        arrow
                                                                    >
                                                                        <div>
                                                                            {file.documentDatesActions.length > 1 ? formatDateAndTime(file.documentDatesActions[file.documentDatesActions.length - 1].createdAt, 'aaa') : ''}
                                                                        </div>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            </>
                                                        )}

                                                        {file.decline === CaseFileDeclined.ReuploadedFile && roleId !== "USER" && (
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >
                                                                <Tooltip title="დადასტურება" enterDelay={500}
                                                                         leaveDelay={200}>
                                                                    <IconButton
                                                                        color="primary"
                                                                        onClick={() => handleConfirmButtonClick(file, 'accept')}
                                                                        style={{marginRight: "10px"}}
                                                                    >
                                                                        <MdCheckCircle size="28px"/>
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="დახარვეზება" enterDelay={500}
                                                                         leaveDelay={200}>
                                                                    <IconButton
                                                                        color="error"
                                                                        onClick={() => handleConfirmButtonClick(file, 'decline')}
                                                                    >
                                                                        <MdCancel size="28px"/>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        )}

                                                        {file.decline === CaseFileDeclined.ReuploadedFileDeclined && roleId !== "USER" && (
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >
                                                                <Tooltip title="დადასტურება" enterDelay={500}
                                                                         leaveDelay={200}>
                                                                    <IconButton
                                                                        color="primary"
                                                                        onClick={() => handleConfirmButtonClick(file, 'accept')}
                                                                        style={{marginRight: "10px"}}
                                                                    >
                                                                        <MdCheckCircle size="28px"/>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        )}
                                                        {showConfirmationButton &&
                                                            caseData && roleId && roleId !== "EXPERT" &&
                                                            filteredRecords.length !== 0 &&
                                                            file.activeUserId === userId &&
                                                            hasActiveManager(file.id) &&
                                                            answerFileExists(file) &&
                                                            users.length !== 0 &&
                                                            (

                                                                file.isDocumentInternal ? (
                                                                    <TableCell
                                                                        style={{
                                                                            height: 40,
                                                                            backgroundColor: getBackgroundColor(file),
                                                                        }}
                                                                    >
                                                                        <div style={{display: "flex", gap: 15}}>
                                                                            <AddressingPopupViewer
                                                                                roleName={roleId}
                                                                                onManagerAdded={refreshCaseManagers}
                                                                                caseManagers={caseManagers}
                                                                                caseDataDays={caseData.days}
                                                                                fileId={file.id}
                                                                                internalUsers={users}
                                                                                groupId={groupId}

                                                                            />

                                                                            {documentTypesForEditor &&
                                                                                caseData &&
                                                                                caseFiles &&
                                                                                users &&
                                                                                userId &&
                                                                                roleId &&
                                                                                objectOwner &&
                                                                                departments.length > 0 &&
                                                                                barcode &&
                                                                                ownerIdentificationTemplateString &&
                                                                                exploitationIdentificationTemplateString &&
                                                                                permitTypeTitle &&
                                                                                departmentID &&
                                                                                userAddress &&
                                                                                caseDataForDocument &&
                                                                                holidays.length > 0 && (
                                                                                    <DocumentPopupInternalFiles
                                                                                        documentTypes={documentTypesForEditor}
                                                                                        refreshCaseFiles={refreshCaseFiles}
                                                                                        clearSelectedDocuments={clearSelectedDocuments}
                                                                                        refreshFlow={refreshFlow}
                                                                                        objectOwner={objectOwner}
                                                                                        selectedDocuments={selectedDocuments}
                                                                                        isDenyButtonDisabled={isDenyButtonDisabled}
                                                                                        isDenyButtonDisabledDetail={isDenyButtonDisabledDetail}
                                                                                        isDenyButtonDisabledGeo={isDenyButtonDisabledGeo}
                                                                                        caseGeography={caseGeography}
                                                                                        documentTypesForEditor={documentTypesForEditor}
                                                                                        currentUserId={currentUserId}
                                                                                        isDenyButtonDisabledParentId={isDenyButtonDisabledParentId}
                                                                                        permitTypeId={caseData.permitTypeId}
                                                                                        disableAdditionalFileRequest={disableAdditionalFileRequest}
                                                                                        disablePostponeDocCreation={disablePostponeDocCreation}
                                                                                        hideRequireCaseCancellationButtonInternal={hideRequireCaseCancellationButtonInternal}
                                                                                        hideRequireCaseCancellationButton={hideRequireCaseCancellationButton}
                                                                                        declineDaysExtension={declineDaysExtension}
                                                                                        caseFiles={caseFiles}
                                                                                        extendFileExists={extendFileExists}
                                                                                        isConditionButtonDisabled={isConditionButtonDisabled}
                                                                                        hasConditionalDeadline={hasConditionalDeadline}
                                                                                        caseData={caseDataForDocument}
                                                                                        users={users}
                                                                                        userId={userId}
                                                                                        roleId={roleId}
                                                                                        barcode={barcode}
                                                                                        departments={departments}
                                                                                        hasExtention={hasExtention}
                                                                                        holidays={holidays}
                                                                                        fileId={file.id}
                                                                                        caseInfo={caseData}
                                                                                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                                                                                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                                                                                        permitTypeTitle={permitTypeTitle}
                                                                                        departmentId={departmentID}
                                                                                        userAddress={userAddress}
                                                                                    />
                                                                                )}

                                                                        </div>

                                                                    </TableCell>
                                                                ) : (<div></div>)

                                                            )}
                                                        {showConfirmationButton && caseData && roleId && roleId === "EXPERT" && filteredRecords.length !== 0 && isActiveManager(file.id) && answerFileExists(file) && (
                                                            file.isDocumentInternal ? (
                                                                <TableCell
                                                                    style={{
                                                                        height: 40,
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}
                                                                >

                                                                    {userAddress && permitTypeTitle && documentTypesForEditor && departments.length > 0 && objectOwner && caseData && caseFiles && users && userId && roleId && barcode && caseDataForDocument && departmentID && (
                                                                        <DocumentPopupInternalFiles
                                                                            documentTypes={documentTypesForEditor}
                                                                            refreshCaseFiles={refreshCaseFiles}
                                                                            clearSelectedDocuments={clearSelectedDocuments}
                                                                            refreshFlow={refreshFlow}
                                                                            objectOwner={objectOwner}
                                                                            selectedDocuments={selectedDocuments}
                                                                            isDenyButtonDisabled={isDenyButtonDisabled}
                                                                            isDenyButtonDisabledDetail={isDenyButtonDisabledDetail}
                                                                            isDenyButtonDisabledGeo={isDenyButtonDisabledGeo}
                                                                            caseGeography={caseGeography}
                                                                            documentTypesForEditor={documentTypesForEditor}
                                                                            currentUserId={currentUserId}
                                                                            isDenyButtonDisabledParentId={isDenyButtonDisabledParentId}
                                                                            permitTypeId={caseData.permitTypeId}
                                                                            disableAdditionalFileRequest={disableAdditionalFileRequest}
                                                                            disablePostponeDocCreation={disablePostponeDocCreation}
                                                                            hideRequireCaseCancellationButtonInternal={hideRequireCaseCancellationButtonInternal}
                                                                            hideRequireCaseCancellationButton={hideRequireCaseCancellationButton}
                                                                            declineDaysExtension={declineDaysExtension}
                                                                            caseFiles={caseFiles}
                                                                            extendFileExists={extendFileExists}
                                                                            isConditionButtonDisabled={isConditionButtonDisabled}
                                                                            hasConditionalDeadline={hasConditionalDeadline}
                                                                            caseData={caseDataForDocument}
                                                                            users={users}
                                                                            userId={userId}
                                                                            roleId={roleId}
                                                                            barcode={barcode}
                                                                            departments={departments}
                                                                            hasExtention={hasExtention}
                                                                            holidays={holidays}
                                                                            fileId={file.id}
                                                                            caseInfo={caseData}
                                                                            departmentId={departmentID}
                                                                            permitTypeTitle={permitTypeTitle}
                                                                            userAddress={userAddress}
                                                                        />
                                                                    )}


                                                                </TableCell>
                                                            ) : (<div></div>)

                                                        )}


                                                        {file.decline === CaseFileDeclined.ReuploadedFileAccepted && roleId !== "USER" && (
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >
                                                                <Tooltip title="დახარვეზება" enterDelay={500}
                                                                         leaveDelay={200}>
                                                                    <IconButton
                                                                        color="error"
                                                                        onClick={() => handleConfirmButtonClick(file, 'decline')}
                                                                    >
                                                                        <MdCancel size="28px"/>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>
                                                        )}
                                                        {(orderDepartment === NomenclatureEnum.building && caseMustBeActive && roleId && roleId === "HEADOFDEPARTMENT" && file.answerStatus === CaseDocumentInternalFlowStatusEnum.SentBack)
                                                            && (
                                                                <TableCell
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}
                                                                >
                                                                    <Tooltip title={"შემსრულებლის შეცვლა"}>
                                                                        <div>
                                                                            <AiOutlineUserSwitch
                                                                                style={{padding: 5}}
                                                                                className="caseUser-icon caseUser-icon-switch"
                                                                                onClick={() => {
                                                                                    handleClickOpenCaseUserPopupInternalFlow(file);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            )}

                                                        {file.internal === true && file.declinedInternalStatus === declinedInternalEnum.No && roleId !== "USER" && roleId !== "EXPERT" && userId && file.creatorId !== userId && !file.shared && file.activeUserId === userId && showConfirmationButton && filteredRecords.length !== 0 && file.answerStatus !== CaseDocumentInternalFlowStatusEnum.SentToAnotherDepartment && (
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: 20,
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >
                                                                <div>
                                                                    <Tooltip title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                        <div>
                                                                            <IoArrowBackCircleSharp
                                                                                className={"delete-doc-button"}
                                                                                onClick={() => handleConfirmButtonClickInternal(file, 'decline')}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>
                                                                    <Dialog
                                                                        open={isDialogOpen}
                                                                        onClose={handleDialogClose}
                                                                        maxWidth="md"
                                                                        fullWidth
                                                                    >
                                                                        <DialogTitle>უკან დაბრუნების
                                                                            მიზეზი</DialogTitle>
                                                                        <DialogContent>

                                                                            <TextField
                                                                                autoFocus
                                                                                margin="dense"
                                                                                label="უკან დაბრუნების მიზეზი"
                                                                                fullWidth
                                                                                multiline
                                                                                rows={8}
                                                                                value={returnComment}
                                                                                onChange={(e) => setReturnComment(e.target.value)}
                                                                            />
                                                                        </DialogContent>
                                                                        <DialogActions>
                                                                            <Button onClick={handleDialogClose}
                                                                                    color="primary">
                                                                                გაუქმება
                                                                            </Button>
                                                                            <Button onClick={handleDialogSubmit}
                                                                                    color="primary">
                                                                                გაგზავნა
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </Dialog>
                                                                </div>
                                                                {
                                                                    file.isDocumentInternal && file.answerStatus === CaseDocumentInternalFlowStatusEnum.HeadOfDepartmentResponded && caseMustBeActive && roleId === "HEADOFDEPARTMENT" && file.internal === true ? (
                                                                        <Tooltip
                                                                            title={"სხვა დეპარტამენში პასუხის დაბრუნება"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <IoSend
                                                                                    className={"send-for-visage-doc-button"}
                                                                                    onClick={() => {
                                                                                        setCurrentFileForInternalVisage(file);
                                                                                        setIsConfirmModalOpenForSendingToAnotherDep(true);
                                                                                    }}
                                                                                >
                                                                                </IoSend>
                                                                            </div>
                                                                        </Tooltip>
                                                                    ) : roleId !== "HEADOFAGENCY" && allManagersApprovedFile(file) ? (
                                                                        <Tooltip
                                                                            title={"სხვა დეპარტამენში პასუხის დაბრუნება"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <IoSend
                                                                                    className={"send-for-visage-doc-button"}
                                                                                    onClick={() => {
                                                                                        setFileForInternalFlow(file)
                                                                                        setIsModalToAnswerAnotherDepartment(true);
                                                                                    }}
                                                                                >
                                                                                </IoSend>
                                                                            </div>
                                                                        </Tooltip>
                                                                    ) : roleId !== "HEADOFAGENCY" && !allManagersApprovedFile(file) ?
                                                                        (<Tooltip
                                                                            title={"დოკუმენტი ელოდება ვიზირებას"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <IoSend
                                                                                    className={"send-for-visage-doc-button-disabled"}
                                                                                >
                                                                                </IoSend>
                                                                            </div>
                                                                        </Tooltip>)
                                                                        :
                                                                        (
                                                                            <div></div>
                                                                        )

                                                                }


                                                            </TableCell>
                                                        )}
                                                        {ShouldApproveInsideFile(file) && (
                                                            <TableCell
                                                                style={{alignContent: 'center', display: "flex"}}>
                                                                <div>
                                                                    <Tooltip title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                        <div>
                                                                            <IoArrowBackCircleSharp
                                                                                className={"delete-doc-button"}
                                                                                onClick={() => handleConfirmButtonClickInternal(file, 'decline')}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>
                                                                    <Dialog
                                                                        open={isDialogOpen}
                                                                        onClose={handleDialogClose}
                                                                        maxWidth="md"
                                                                        fullWidth
                                                                    >
                                                                        <DialogTitle>უკან დაბრუნების
                                                                            მიზეზი</DialogTitle>
                                                                        <DialogContent>

                                                                            <TextField
                                                                                autoFocus
                                                                                margin="dense"
                                                                                label="უკან დაბრუნების მიზეზი"
                                                                                fullWidth
                                                                                multiline
                                                                                rows={8}
                                                                                value={returnComment}
                                                                                onChange={(e) => setReturnComment(e.target.value)}
                                                                            />
                                                                        </DialogContent>
                                                                        <DialogActions>
                                                                            <Button onClick={handleDialogClose}
                                                                                    color="primary">
                                                                                გაუქმება
                                                                            </Button>
                                                                            <Button onClick={handleDialogSubmit}
                                                                                    color="primary">
                                                                                გაგზავნა
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </Dialog>
                                                                </div>
                                                                <Tooltip title={"დოკუმენტის ვიზირება"}>
                                                                    <div>
                                                                        <IoCheckmarkCircle
                                                                            className="approved-icon"
                                                                            onClick={() => {
                                                                                setIsApproveModalOnInternal(true);
                                                                            }}>
                                                                        </IoCheckmarkCircle>
                                                                    </div>
                                                                </Tooltip>

                                                            </TableCell>
                                                        )}

                                                        {
                                                            caseMustBeActiveForInternalFile &&
                                                            file.additionalInternalDocumentation === 1 &&
                                                            file.creatorId === userId &&
                                                            file.status === 5 &&
                                                            roleId === "EXPERT" &&
                                                            (
                                                                <>

                                                                    <TableCell
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            gap: 20,
                                                                            backgroundColor: getBackgroundColor(file),
                                                                        }}>
                                                                        <Tooltip
                                                                            title={"დოკუმენტის წაშლა"}>
                                                                            <div>
                                                                                <MdDeleteForever
                                                                                    className={"delete-doc-button"}
                                                                                    onClick={() => {
                                                                                        setFileToDelete(file);
                                                                                        setIsDeleteConfirmModalOpen(true);
                                                                                    }}
                                                                                >
                                                                                </MdDeleteForever>
                                                                            </div>
                                                                        </Tooltip>
                                                                        <Tooltip
                                                                            title={"დასავიზირებლად გაგზავნა"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <IoSend
                                                                                    className={"send-for-visage-doc-button"}
                                                                                    onClick={() => {
                                                                                        setCurrentFile(file);
                                                                                        setIsConfirmationModalOpen(true);
                                                                                        clearSelectedDocuments();
                                                                                    }}
                                                                                >
                                                                                    გაგზავნა
                                                                                </IoSend>

                                                                            </div>
                                                                        </Tooltip>


                                                                    </TableCell>

                                                                </>
                                                            )


                                                        }
                                                        {
                                                            caseMustBeActiveForInternalFile &&
                                                            file.additionalInternalDocumentation === 1 &&
                                                            file.creatorId !== userId &&
                                                            file.status !== 5 &&
                                                            roleId !== "EXPERT" &&
                                                            (
                                                                <>

                                                                    <TableCell
                                                                        style={{
                                                                            display: "flex",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            gap: 20,
                                                                            backgroundColor: getBackgroundColor(file),
                                                                        }}>
                                                                        <div>
                                                                            <Tooltip
                                                                                title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                                <div>
                                                                                    <IoArrowBackCircleSharp
                                                                                        className={"delete-doc-button"}
                                                                                        onClick={() => handleConfirmButtonClickInternal(file, 'decline')}
                                                                                    />
                                                                                </div>
                                                                            </Tooltip>
                                                                            <Dialog
                                                                                open={isDialogOpen}
                                                                                onClose={handleDialogClose}
                                                                                maxWidth="md"
                                                                                fullWidth
                                                                            >
                                                                                <DialogTitle>უკან დაბრუნების
                                                                                    მიზეზი</DialogTitle>
                                                                                <DialogContent>

                                                                                    <TextField
                                                                                        autoFocus
                                                                                        margin="dense"
                                                                                        label="უკან დაბრუნების მიზეზი"
                                                                                        fullWidth
                                                                                        multiline
                                                                                        rows={8}
                                                                                        value={returnComment}
                                                                                        onChange={(e) => setReturnComment(e.target.value)}
                                                                                    />
                                                                                </DialogContent>
                                                                                <DialogActions>
                                                                                    <Button onClick={handleDialogClose}
                                                                                            color="primary">
                                                                                        გაუქმება
                                                                                    </Button>
                                                                                    <Button onClick={handleDialogSubmit}
                                                                                            color="primary">
                                                                                        გაგზავნა
                                                                                    </Button>
                                                                                </DialogActions>
                                                                            </Dialog>
                                                                        </div>
                                                                        <Tooltip
                                                                            title={(file.additionalInternalDocumentation === 1 && roleId !== "EXPERT") ? "შიდა დოკუმენტის დადასტურება" : "დასავიზირებლად გაგზავნა"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <IoSend
                                                                                    className={"send-for-visage-doc-button"}
                                                                                    onClick={() => {
                                                                                        setCurrentFile(file);
                                                                                        setIsConfirmationModalOpen(true);
                                                                                        clearSelectedDocuments();
                                                                                    }}
                                                                                >
                                                                                </IoSend>
                                                                            </div>
                                                                        </Tooltip>


                                                                    </TableCell>

                                                                </>
                                                            )


                                                        }

                                                        {file.internal === true &&
                                                            roleId !== "USER" &&
                                                            roleId !== "EXPERT" &&
                                                            userId &&
                                                            file.creatorId !== userId &&
                                                            !file.shared &&
                                                            file.additionalInternalDocumentation !== 1 &&
                                                            file.activeUserId === userId &&
                                                            caseMustBeActiveForCancel &&
                                                            (file.decline === CaseFileDeclined.CaseCancellationDocument || file.decline === CaseFileDeclined.CaseCancellationDocumentDeclined) && (
                                                                <TableCell
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        gap: 20,
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}>
                                                                    <div>
                                                                        <Tooltip
                                                                            title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                            <div>
                                                                                <IoArrowBackCircleSharp
                                                                                    className={"delete-doc-button"}
                                                                                    onClick={() => handleConfirmButtonClickInternal(file, 'decline')}
                                                                                />
                                                                            </div>
                                                                        </Tooltip>
                                                                        <Dialog
                                                                            open={isDialogOpen}
                                                                            onClose={handleDialogClose}
                                                                            maxWidth="md"
                                                                            fullWidth
                                                                        >
                                                                            <DialogTitle>უკან დაბრუნების
                                                                                მიზეზი</DialogTitle>
                                                                            <DialogContent>

                                                                                <TextField
                                                                                    autoFocus
                                                                                    margin="dense"
                                                                                    label="უკან დაბრუნების მიზეზი"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={8}
                                                                                    value={returnComment}
                                                                                    onChange={(e) => setReturnComment(e.target.value)}
                                                                                />
                                                                            </DialogContent>
                                                                            <DialogActions>
                                                                                <Button onClick={handleDialogClose}
                                                                                        color="primary">
                                                                                    გაუქმება
                                                                                </Button>
                                                                                <Button onClick={handleDialogSubmit}
                                                                                        color="primary">
                                                                                    გაგზავნა
                                                                                </Button>
                                                                            </DialogActions>
                                                                        </Dialog>
                                                                    </div>
                                                                    {(file.decline === 18 || file.decline === 19) && roleId === "HEADOFAGENCY" && (
                                                                        <Tooltip
                                                                            title={"ხელმოწერა"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <FaFileSignature
                                                                                    className={"send-for-visage-doc-button"}
                                                                                    onClick={() => {
                                                                                        setCurrentFile(file);
                                                                                        setIsConfirmationModalOpen(true);
                                                                                        clearSelectedDocuments();
                                                                                    }}
                                                                                >
                                                                                </FaFileSignature>
                                                                            </div>
                                                                        </Tooltip>

                                                                    )}

                                                                    {
                                                                        (file.sharedTemp && roleId !== "HEADOFAGENCY") ? (
                                                                                <Tooltip
                                                                                    title={"დასავიზირებლად გაგზავნა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}
                                                                                            onClick={() => {
                                                                                                setCurrentFile(file);
                                                                                                setIsConfirmationModalOpen(true);
                                                                                                clearSelectedDocuments();
                                                                                            }}
                                                                                        >
                                                                                            გაგზავნა
                                                                                        </IoSend>

                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) :

                                                                            file.isDocumentInternal && file.answerStatus === CaseDocumentInternalFlowStatusEnum.HeadOfDepartmentResponded && caseMustBeActive && roleId === "HEADOFDEPARTMENT" && file.internal === true ? (
                                                                                <Tooltip
                                                                                    title={"სხვა დეპარტამენტში გაგზავნა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}

                                                                                            onClick={() => {
                                                                                                setCurrentFileForInternalVisage(file);
                                                                                                setIsConfirmModalOpenForSendingToAnotherDep(true);
                                                                                            }}
                                                                                        >
                                                                                        </IoSend>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) : file.additionalInternalDocumentation === 1 ? (
                                                                                <Tooltip
                                                                                    title={(file.additionalInternalDocumentation === 1 && roleId !== "EXPERT") ? "შიდა დოკუმენტის დადასტურება" : "დასავიზირებლად გაგზავნა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}
                                                                                            onClick={() => {
                                                                                                setCurrentFile(file);
                                                                                                setIsConfirmationModalOpen(true);
                                                                                                clearSelectedDocuments();
                                                                                            }}
                                                                                        >
                                                                                        </IoSend>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) : roleId === "HEADOFAGENCY" && file.isExtentionAttachment ? (
                                                                                    <Tooltip title={"დადასტურება"}>
                                                                                        <div style={{marginRight: 9}}>
                                                                                            <IoCheckmarkCircle
                                                                                                className={"approved-icon"}
                                                                                                onClick={() => {
                                                                                                    setCurrentFile(file);
                                                                                                    setIsConfirmationModalOpen(true);
                                                                                                    clearSelectedDocuments();
                                                                                                }}
                                                                                            >
                                                                                            </IoCheckmarkCircle>
                                                                                        </div>
                                                                                    </Tooltip>
                                                                                ) :
                                                                                (<div></div>)

                                                                    }


                                                                </TableCell>
                                                            )}
                                                        {file.internal === true &&
                                                            roleId !== "USER" &&
                                                            roleId !== "EXPERT" &&
                                                            file.decline !== CaseFileDeclined.secretDocument &&
                                                            userId &&
                                                            file.creatorId !== userId &&
                                                            !file.shared &&
                                                            file.additionalInternalDocumentation !== 1 &&
                                                            file.activeUserId === userId &&
                                                            caseMustBeActiveToMakeItSecret &&
                                                            (file.decline === CaseFileDeclined.secretDocument) && (
                                                                <TableCell
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        gap: 20,
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}>
                                                                    <div>
                                                                        <Tooltip
                                                                            title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                            <div>
                                                                                <IoArrowBackCircleSharp
                                                                                    className={"delete-doc-button"}
                                                                                    onClick={() => handleConfirmButtonClickInternal(file, 'decline')}
                                                                                />
                                                                            </div>
                                                                        </Tooltip>
                                                                        <Dialog
                                                                            open={isDialogOpen}
                                                                            onClose={handleDialogClose}
                                                                            maxWidth="md"
                                                                            fullWidth
                                                                        >
                                                                            <DialogTitle>უკან დაბრუნების
                                                                                მიზეზი</DialogTitle>
                                                                            <DialogContent>

                                                                                <TextField
                                                                                    autoFocus
                                                                                    margin="dense"
                                                                                    label="უკან დაბრუნების მიზეზი"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={8}
                                                                                    value={returnComment}
                                                                                    onChange={(e) => setReturnComment(e.target.value)}
                                                                                />
                                                                            </DialogContent>
                                                                            <DialogActions>
                                                                                <Button onClick={handleDialogClose}
                                                                                        color="primary">
                                                                                    გაუქმება
                                                                                </Button>
                                                                                <Button onClick={handleDialogSubmit}
                                                                                        color="primary">
                                                                                    გაგზავნა
                                                                                </Button>
                                                                            </DialogActions>
                                                                        </Dialog>
                                                                    </div>
                                                                    {(file.decline === CaseFileDeclined.secretDocument) && roleId === "HEADOFAGENCY" ? (
                                                                            <Tooltip
                                                                                title={"ხელმოწერა"}>
                                                                                <div style={{marginRight: 9}}>
                                                                                    <FaFileSignature
                                                                                        className={"send-for-visage-doc-button"}
                                                                                        onClick={() => {
                                                                                            setCurrentFile(file);
                                                                                            setIsConfirmationModalOpen(true);
                                                                                            clearSelectedDocuments();
                                                                                        }}
                                                                                    >
                                                                                    </FaFileSignature>
                                                                                </div>
                                                                            </Tooltip>

                                                                        ) :


                                                                        file.sharedTemp ? (
                                                                                <Tooltip
                                                                                    title={"დასავიზირებლად გაგზავნა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}
                                                                                            onClick={() => {
                                                                                                setCurrentFile(file);
                                                                                                setIsConfirmationModalOpen(true);
                                                                                                clearSelectedDocuments();
                                                                                            }}
                                                                                        >
                                                                                            გაგზავნა
                                                                                        </IoSend>

                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) :

                                                                            file.isDocumentInternal && file.answerStatus === CaseDocumentInternalFlowStatusEnum.HeadOfDepartmentResponded && caseMustBeActive && roleId === "HEADOFDEPARTMENT" && file.internal === true ? (
                                                                                <Tooltip
                                                                                    title={"სხვა დეპარტამენტში გაგზავნა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}

                                                                                            onClick={() => {
                                                                                                setCurrentFileForInternalVisage(file);
                                                                                                setIsConfirmModalOpenForSendingToAnotherDep(true);
                                                                                            }}
                                                                                        >
                                                                                        </IoSend>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) : file.additionalInternalDocumentation === 1 ? (
                                                                                <Tooltip
                                                                                    title={(file.additionalInternalDocumentation === 1 && roleId !== "EXPERT") ? "შიდა დოკუმენტის დადასტურება" : "დასავიზირებლად გაგზავნა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}
                                                                                            onClick={() => {
                                                                                                setCurrentFile(file);
                                                                                                setIsConfirmationModalOpen(true);
                                                                                                clearSelectedDocuments();
                                                                                            }}
                                                                                        >
                                                                                        </IoSend>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) : roleId === "HEADOFAGENCY" && file.isExtentionAttachment ? (
                                                                                    <Tooltip title={"დადასტურება"}>
                                                                                        <div style={{marginRight: 9}}>
                                                                                            <IoCheckmarkCircle
                                                                                                className={"approved-icon"}
                                                                                                onClick={() => {
                                                                                                    setCurrentFile(file);
                                                                                                    setIsConfirmationModalOpen(true);
                                                                                                    clearSelectedDocuments();
                                                                                                }}
                                                                                            >
                                                                                            </IoCheckmarkCircle>
                                                                                        </div>
                                                                                    </Tooltip>
                                                                                ) :
                                                                                (<div></div>)

                                                                    }


                                                                </TableCell>
                                                            )}


                                                        {file.internal === true &&
                                                            file.declinedInternalStatus === declinedInternalEnum.No &&
                                                            roleId !== "USER" &&
                                                            roleId !== "EXPERT" &&
                                                            userId &&
                                                            file.creatorId !== userId &&
                                                            !file.shared &&
                                                            file.additionalInternalDocumentation !== 1 &&
                                                            file.activeUserId === userId &&
                                                            caseMustBeActive &&
                                                            file.answerStatus !== CaseDocumentInternalFlowStatusEnum.SentToAnotherDepartment &&
                                                            !file.isExtentionAttachmentApprovedByHead && (
                                                                <TableCell
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        gap: 20,
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}
                                                                >
                                                                    <div>
                                                                        <Tooltip
                                                                            title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                            <div>
                                                                                <IoArrowBackCircleSharp
                                                                                    className={"delete-doc-button"}
                                                                                    onClick={() => handleConfirmButtonClickInternal(file, 'decline')}
                                                                                />
                                                                            </div>
                                                                        </Tooltip>
                                                                        <Dialog
                                                                            open={isDialogOpen}
                                                                            onClose={handleDialogClose}
                                                                            maxWidth="md"
                                                                            fullWidth
                                                                        >
                                                                            <DialogTitle>უკან დაბრუნების
                                                                                მიზეზი</DialogTitle>
                                                                            <DialogContent>

                                                                                <TextField
                                                                                    autoFocus
                                                                                    margin="dense"
                                                                                    label="უკან დაბრუნების მიზეზი"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={8}
                                                                                    value={returnComment}
                                                                                    onChange={(e) => setReturnComment(e.target.value)}
                                                                                />
                                                                            </DialogContent>
                                                                            <DialogActions>
                                                                                <Button onClick={handleDialogClose}
                                                                                        color="primary">
                                                                                    გაუქმება
                                                                                </Button>
                                                                                <Button onClick={handleDialogSubmit}
                                                                                        color="primary">
                                                                                    გაგზავნა
                                                                                </Button>
                                                                            </DialogActions>
                                                                        </Dialog>
                                                                    </div>
                                                                    {roleId === "HEADOFAGENCY" && (
                                                                        <>
                                                                            {file.decline === CaseFileDeclined.explosionFile ? (
                                                                                <Tooltip
                                                                                    title={"სანებართვო მოწმობის დადასტურება"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}
                                                                                            onClick={() => {
                                                                                                setCurrentFile(file);
                                                                                                setIsConfirmationModalOpen(true);
                                                                                                clearSelectedDocuments();
                                                                                            }}
                                                                                        >
                                                                                        </IoSend>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) : (
                                                                                <Tooltip
                                                                                    title={"ხელმოწერა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <FaFileSignature
                                                                                            className={"send-for-visage-doc-button"}
                                                                                            onClick={() => {
                                                                                                setCurrentFile(file);
                                                                                                setIsConfirmationModalOpen(true);
                                                                                                clearSelectedDocuments();
                                                                                            }}
                                                                                        >
                                                                                        </FaFileSignature>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            )}


                                                                        </>

                                                                    )}
                                                                    {
                                                                        allManagersApprovedFileResolution(file) && file.sharedTemp && roleId !== "HEADOFAGENCY" ? (
                                                                                <Tooltip
                                                                                    title={"დასავიზირებლად გაგზავნა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}
                                                                                            onClick={() => {
                                                                                                setCurrentFile(file);
                                                                                                setIsConfirmationModalOpen(true);
                                                                                                clearSelectedDocuments();
                                                                                            }}
                                                                                        >
                                                                                            გაგზავნა
                                                                                        </IoSend>

                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) :

                                                                            file.isDocumentInternal && file.answerStatus === CaseDocumentInternalFlowStatusEnum.HeadOfDepartmentResponded && caseMustBeActive && roleId === "HEADOFDEPARTMENT" && file.internal === true ? (
                                                                                <Tooltip
                                                                                    title={"სხვა დეპარტამენტში გაგზავნა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}

                                                                                            onClick={() => {
                                                                                                setCurrentFileForInternalVisage(file);
                                                                                                setIsConfirmModalOpenForSendingToAnotherDep(true);
                                                                                            }}
                                                                                        >
                                                                                        </IoSend>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) : roleId !== "HEADOFAGENCY" ? (
                                                                                <Tooltip
                                                                                    title={(file.additionalInternalDocumentation === 1 && roleId === "HEADOFDEPARTMENT") ?
                                                                                        "შიდა დოკუმენტის დადასტურება" :
                                                                                        (file.decline === 29 && roleId === "HEADOFDEPARTMENT") ? "განუხილველად დატოვება" :
                                                                                            (file.decline === 30 && roleId === "HEADOFDEPARTMENT") ? "განუხილველად დატოვებაზე უარის თქმა" :
                                                                                                "დასავიზირებლად გაგზავნა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}
                                                                                            onClick={() => {
                                                                                                setCurrentFile(file);
                                                                                                setIsConfirmationModalOpen(true);
                                                                                                clearSelectedDocuments();
                                                                                            }}
                                                                                        >
                                                                                        </IoSend>
                                                                                    </div>
                                                                                </Tooltip>
                                                                            ) : roleId === "HEADOFAGENCY" && file.isExtentionAttachment ? (
                                                                                    <Tooltip title={"დადასტურება"}>
                                                                                        <div style={{marginRight: 9}}>
                                                                                            <IoCheckmarkCircle
                                                                                                className={"approved-icon"}
                                                                                                onClick={() => {
                                                                                                    setCurrentFile(file);
                                                                                                    setIsConfirmationModalOpen(true);
                                                                                                    clearSelectedDocuments();
                                                                                                }}
                                                                                            >
                                                                                            </IoCheckmarkCircle>
                                                                                        </div>
                                                                                    </Tooltip>
                                                                                ) :
                                                                                (<div></div>)

                                                                    }


                                                                </TableCell>
                                                            )}

                                                        {file.status === 5 && roleId !== "USER" && userId && file.creatorId === userId && showConfirmationButton && filteredRecords.length !== 0 && !file.internal && (
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: 20,
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >
                                                                {file.pureDays !== 0 && roleId === "HEADOFDEPARTMENT" ? (
                                                                    <Tooltip
                                                                        title={"სხვა დეპარტამენში პასუხის დაბრუნება"}>
                                                                        <div style={{marginRight: 9}}>
                                                                            <IoSend
                                                                                className={"send-for-visage-doc-button"}
                                                                                onClick={() => {
                                                                                    setFileForInternalFlow(file)
                                                                                    setIsModalToAnswerAnotherDepartment(true);
                                                                                }}
                                                                            >
                                                                            </IoSend>
                                                                        </div>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <Tooltip
                                                                        title={roleId === "HEADOFAGENCY" ? "შენახვა" : "დასავიზირებლად გაგზავნა"}>
                                                                        <div style={{marginRight: 9}}>
                                                                            <IoSend
                                                                                className={"send-for-visage-doc-button"}
                                                                                onClick={() => {
                                                                                    setCurrentFile(file);
                                                                                    setIsConfirmationModalOpen(true);
                                                                                    clearSelectedDocuments();
                                                                                }}
                                                                            >
                                                                            </IoSend>
                                                                        </div>
                                                                    </Tooltip>
                                                                )}

                                                                {barcode && holidays.length > 0 && users && userId && (
                                                                    <EditCaseDocument
                                                                        onFileAdded={refreshCaseFiles}
                                                                        getFileId={file.id}
                                                                        documentTypes={documentTypesForEditor}
                                                                        caseFiles={caseFiles}
                                                                        barcode={barcode}
                                                                        departments={departments}
                                                                        holidays={holidays}
                                                                        users={users}
                                                                        userId={userId}
                                                                        onFileUpload={refreshCaseFiles}
                                                                        permitTypeId={caseData.permitTypeId}
                                                                        caseData={caseDataForDocument}
                                                                    />
                                                                )}

                                                                <Tooltip
                                                                    title={"დოკუმენტის წაშლა"}>
                                                                    <div>
                                                                        <MdDeleteForever
                                                                            className={"delete-doc-button"}
                                                                            onClick={() => {
                                                                                setFileToDelete(file);
                                                                                setIsDeleteConfirmModalOpen(true);
                                                                            }}
                                                                        >
                                                                        </MdDeleteForever>
                                                                    </div>
                                                                </Tooltip>
                                                            </TableCell>
                                                        )}
                                                        {(userId && file.creatorId === userId || roleId === "HEADOFAGENCY")
                                                            && file.creatorId !== caseData.requesterId
                                                            && roleId !== "USER" &&
                                                            (file.isInspectFile || file.isSertificatFile || file.inpectOrderAttachment) &&

                                                            (
                                                                <TableCell style={{

                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}>
                                                                    <Tooltip
                                                                        title={"დოკუმენტის წაშლა"}>
                                                                        <div>
                                                                            <MdDeleteForever
                                                                                className={"delete-doc-button"}
                                                                                onClick={() => {
                                                                                    setFileToDelete(file);
                                                                                    setIsDeleteConfirmModalOpen(true);
                                                                                }}
                                                                            >
                                                                            </MdDeleteForever>
                                                                        </div>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            )}


                                                        {file.status === 5 &&
                                                            roleId !== "USER" &&
                                                            userId &&
                                                            file.creatorId === userId &&
                                                            !file.internal &&
                                                            (file.decline === CaseFileDeclined.CaseCancellationDocument || file.decline === CaseFileDeclined.CaseCancellationDocumentDeclined) &&

                                                            (
                                                                <TableCell
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        gap: 20,
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}
                                                                >
                                                                    {file.pureDays !== 0 && roleId === "HEADOFDEPARTMENT" ? (
                                                                        <Tooltip
                                                                            title={"სხვა დეპარტამენში პასუხის დაბრუნება"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <IoSend
                                                                                    className={"send-for-visage-doc-button"}
                                                                                    onClick={() => {
                                                                                        setFileForInternalFlow(file)
                                                                                        setIsModalToAnswerAnotherDepartment(true);
                                                                                    }}
                                                                                >
                                                                                </IoSend>
                                                                            </div>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Tooltip
                                                                            title={roleId === "HEADOFAGENCY" ? "შენახვა" : "დასავიზირებლად გაგზავნა"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <IoSend
                                                                                    className={"send-for-visage-doc-button"}
                                                                                    onClick={() => {
                                                                                        setCurrentFile(file);
                                                                                        setIsConfirmationModalOpen(true);
                                                                                        clearSelectedDocuments();
                                                                                    }}
                                                                                >
                                                                                </IoSend>
                                                                            </div>
                                                                        </Tooltip>
                                                                    )}

                                                                    {barcode && holidays.length > 0 && users && userId && (
                                                                        <EditCaseDocument
                                                                            onFileAdded={refreshCaseFiles}
                                                                            getFileId={file.id}
                                                                            documentTypes={documentTypesForEditor}
                                                                            caseFiles={caseFiles}
                                                                            barcode={barcode}
                                                                            departments={departments}
                                                                            holidays={holidays}
                                                                            users={users}
                                                                            userId={userId}
                                                                            onFileUpload={refreshCaseFiles}
                                                                            permitTypeId={caseData.permitTypeId}
                                                                            caseData={caseDataForDocument}
                                                                        />
                                                                    )}

                                                                    <Tooltip
                                                                        title={"დოკუმენტის წაშლა"}>
                                                                        <div>
                                                                            <MdDeleteForever
                                                                                className={"delete-doc-button"}
                                                                                onClick={() => {
                                                                                    setFileToDelete(file);
                                                                                    setIsDeleteConfirmModalOpen(true);
                                                                                }}
                                                                            >
                                                                            </MdDeleteForever>
                                                                        </div>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            )}

                                                        {file.status === 5 &&
                                                            roleId !== "USER" &&
                                                            userId &&
                                                            file.creatorId === userId &&
                                                            !file.internal &&
                                                            (file.decline === CaseFileDeclined.secretDocument) &&

                                                            (
                                                                <TableCell
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        gap: 20,
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}
                                                                >
                                                                    {file.pureDays !== 0 && roleId === "HEADOFDEPARTMENT" ? (
                                                                        <Tooltip
                                                                            title={"სხვა დეპარტამენში პასუხის დაბრუნება"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <IoSend
                                                                                    className={"send-for-visage-doc-button"}
                                                                                    onClick={() => {
                                                                                        setFileForInternalFlow(file)
                                                                                        setIsModalToAnswerAnotherDepartment(true);
                                                                                    }}
                                                                                >
                                                                                </IoSend>
                                                                            </div>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Tooltip
                                                                            title={roleId === "HEADOFAGENCY" ? "შენახვა" : "დასავიზირებლად გაგზავნა"}>
                                                                            <div style={{marginRight: 9}}>
                                                                                <IoSend
                                                                                    className={"send-for-visage-doc-button"}
                                                                                    onClick={() => {
                                                                                        setCurrentFile(file);
                                                                                        setIsConfirmationModalOpen(true);
                                                                                        clearSelectedDocuments();
                                                                                    }}
                                                                                >
                                                                                </IoSend>
                                                                            </div>
                                                                        </Tooltip>
                                                                    )}

                                                                    {barcode && holidays.length > 0 && users && userId && (
                                                                        <EditCaseDocument
                                                                            onFileAdded={refreshCaseFiles}
                                                                            getFileId={file.id}
                                                                            documentTypes={documentTypesForEditor}
                                                                            caseFiles={caseFiles}
                                                                            barcode={barcode}
                                                                            departments={departments}
                                                                            holidays={holidays}
                                                                            users={users}
                                                                            userId={userId}
                                                                            onFileUpload={refreshCaseFiles}
                                                                            permitTypeId={caseData.permitTypeId}
                                                                            caseData={caseDataForDocument}
                                                                        />
                                                                    )}

                                                                    <Tooltip
                                                                        title={"დოკუმენტის წაშლა"}>
                                                                        <div>
                                                                            <MdDeleteForever
                                                                                className={"delete-doc-button"}
                                                                                onClick={() => {
                                                                                    setFileToDelete(file);
                                                                                    setIsDeleteConfirmModalOpen(true);
                                                                                }}
                                                                            >
                                                                            </MdDeleteForever>
                                                                        </div>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            )}


                                                        {roleId !== "USER" && userId && file.creatorId === userId && file.decline === CaseFileDeclined.ExpertDoc && (
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: 20,
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >
                                                                {file.pureDays !== 0 && roleId === "HEADOFDEPARTMENT" ? (
                                                                    <Tooltip
                                                                        title={"სხვა დეპარტამენში პასუხის დაბრუნება"}>
                                                                        <div style={{marginRight: 9}}>
                                                                            <IoSend
                                                                                className={"send-for-visage-doc-button"}
                                                                                onClick={() => {
                                                                                    setFileForInternalFlow(file)
                                                                                    setIsModalToAnswerAnotherDepartment(true);
                                                                                }}
                                                                            >
                                                                            </IoSend>
                                                                        </div>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <Tooltip
                                                                        title={roleId === "HEADOFAGENCY" ? "შენახვა" : "შენახვა"}>
                                                                        <div style={{marginRight: 9}}>
                                                                            <IoSend
                                                                                className={"send-for-visage-doc-button"}
                                                                                onClick={() => {
                                                                                    setCurrentFile(file);
                                                                                    setIsConfirmationModalOpen(true);
                                                                                    clearSelectedDocuments();
                                                                                }}
                                                                            >
                                                                            </IoSend>
                                                                        </div>
                                                                    </Tooltip>
                                                                )}

                                                                {barcode && holidays.length > 0 && users && userId && (
                                                                    <EditCaseDocument
                                                                        onFileAdded={refreshCaseFiles}
                                                                        getFileId={file.id}
                                                                        documentTypes={documentTypesForEditor}
                                                                        caseFiles={caseFiles}
                                                                        barcode={barcode}
                                                                        departments={departments}
                                                                        holidays={holidays}
                                                                        users={users}
                                                                        userId={userId}
                                                                        onFileUpload={refreshCaseFiles}
                                                                        permitTypeId={caseData.permitTypeId}
                                                                        caseData={caseDataForDocument}
                                                                    />
                                                                )}

                                                                <Tooltip
                                                                    title={"დოკუმენტის წაშლა"}>
                                                                    <div>
                                                                        <MdDeleteForever
                                                                            className={"delete-doc-button"}
                                                                            onClick={() => {
                                                                                setFileToDelete(file);
                                                                                setIsDeleteConfirmModalOpen(true);
                                                                            }}
                                                                        >
                                                                        </MdDeleteForever>
                                                                    </div>
                                                                </Tooltip>
                                                            </TableCell>
                                                        )}

                                                        {caseMustBeActiveForUploadBuilidngFile && userId && file.creatorId !== userId && file.activeUserId === userId && file.status === CaseFilesStatus.SentForVisage && ((file.decline === CaseFileDeclined.explosionFile && !file.shared) || file.decline === CaseFileDeclined.acceptRemoveFromRegistery || file.decline === CaseFileDeclined.declineRemoveFromRegistery) && (
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: 20,
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >

                                                                <div>
                                                                    <Tooltip title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                        <div>
                                                                            <IoArrowBackCircleSharp
                                                                                className={"delete-doc-button"}
                                                                                onClick={() => handleConfirmButtonClickInternal(file, 'decline')}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>
                                                                    <Dialog
                                                                        open={isDialogOpen}
                                                                        onClose={handleDialogClose}
                                                                        maxWidth="md"
                                                                        fullWidth
                                                                    >
                                                                        <DialogTitle>უკან დაბრუნების
                                                                            მიზეზი</DialogTitle>
                                                                        <DialogContent>

                                                                            <TextField
                                                                                autoFocus
                                                                                margin="dense"
                                                                                label="უკან დაბრუნების მიზეზი"
                                                                                fullWidth
                                                                                multiline
                                                                                rows={8}
                                                                                value={returnComment}
                                                                                onChange={(e) => setReturnComment(e.target.value)}
                                                                            />
                                                                        </DialogContent>
                                                                        <DialogActions>
                                                                            <Button onClick={handleDialogClose}
                                                                                    color="primary">
                                                                                გაუქმება
                                                                            </Button>
                                                                            <Button onClick={handleDialogSubmit}
                                                                                    color="primary">
                                                                                გაგზავნა
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </Dialog>
                                                                </div>

                                                                <Tooltip
                                                                    title={
                                                                        roleId === "HEADOFAGENCY" && file.decline === CaseFileDeclined.acceptRemoveFromRegistery ? "ობიექტის ამოღება უწყებრივი რეესტრიდან" :
                                                                            roleId === "HEADOFAGENCY" && file.decline === CaseFileDeclined.declineRemoveFromRegistery ? "ობიექტის უწყებრივი რეესტრიდან ამოღებაზე უარი" :
                                                                                roleId === "HEADOFAGENCY" ? "შენახვა" :
                                                                                    "დასავიზირებლად გაგზავნა"}>
                                                                    <div style={{marginRight: 9}}>
                                                                        <IoSend
                                                                            className={"send-for-visage-doc-button"}
                                                                            onClick={() => {
                                                                                setCurrentFile(file);
                                                                                setIsConfirmationModalOpen(true);
                                                                                clearSelectedDocuments();
                                                                            }}
                                                                        >
                                                                        </IoSend>
                                                                    </div>
                                                                </Tooltip>
                                                            </TableCell>
                                                        )}


                                                        {caseMustBeActiveForUploadBuilidngFile && userId && file.creatorId === userId && file.status === 5 && (file.decline === CaseFileDeclined.explosionFile || file.decline === CaseFileDeclined.acceptRemoveFromRegistery || file.decline === CaseFileDeclined.declineRemoveFromRegistery) && (
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: 20,
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >
                                                                <Tooltip
                                                                    title={"დოკუმენტის წაშლა"}>
                                                                    <div>
                                                                        <MdDeleteForever
                                                                            className={"delete-doc-button"}
                                                                            onClick={() => {
                                                                                setFileToDelete(file);
                                                                                setIsDeleteConfirmModalOpen(true);
                                                                            }}
                                                                        >
                                                                        </MdDeleteForever>
                                                                    </div>
                                                                </Tooltip>

                                                                <Tooltip
                                                                    title={

                                                                        roleId === "HEADOFAGENCY" ? "შენახვა" :
                                                                            "დასავიზირებლად გაგზავნა"}>
                                                                    <div style={{marginRight: 9}}>
                                                                        <IoSend
                                                                            className={"send-for-visage-doc-button"}
                                                                            onClick={() => {
                                                                                setCurrentFile(file);
                                                                                setIsConfirmationModalOpen(true);
                                                                                clearSelectedDocuments();
                                                                            }}
                                                                        >
                                                                        </IoSend>
                                                                    </div>
                                                                </Tooltip>
                                                            </TableCell>
                                                        )}

                                                        {file.status === 5 && file.decline !== caseFileDeclined.secretDocument && file.additionalInternalDocumentation !== 1 && roleId !== "USER" && userId && file.creatorId === userId && caseMustBeActive && (

                                                            <TableCell
                                                                style={{
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >
                                                                <div style={{

                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    gap: 20,
                                                                }}>

                                                                    {file.isDocumentInternal && roleId !== "EXPERT" ? (
                                                                            <Tooltip title={"სხვა დეპარტამენტში გაგზავნა"}>
                                                                                <div style={{marginRight: 9}}>
                                                                                    <IoSend
                                                                                        className={"send-for-visage-doc-button"}

                                                                                        onClick={() => {
                                                                                            setCurrentFileForInternalVisage(file);
                                                                                            setIsConfirmModalOpenForSendingToAnotherDep(true);
                                                                                        }}
                                                                                    >
                                                                                    </IoSend>
                                                                                </div>
                                                                            </Tooltip>
                                                                        ) :
                                                                        roleId === "HEADOFAGENCY" && (file.decline === CaseFileDeclined.RequireCaseCancellationBuildingAnswer) ?
                                                                            (<Tooltip
                                                                                title={"განაცხადის განუხილველად დატოვება"}>
                                                                                <div style={{marginRight: 9}}>
                                                                                    <IoSend
                                                                                        className={"send-for-visage-doc-button"}
                                                                                        onClick={() => {
                                                                                            setCurrentFile(file);
                                                                                            setIsConfirmationModalOpen(true);
                                                                                            clearSelectedDocuments();
                                                                                        }}
                                                                                    >
                                                                                    </IoSend>
                                                                                </div>
                                                                            </Tooltip>) :
                                                                            roleId !== "HEADOFAGENCY" && (file.decline === CaseFileDeclined.RequireCaseCancellationBuildingAnswerDenied) ?
                                                                                (<Tooltip
                                                                                    title={"განაცხადის განუხილველად დატოვებაზე უარის თქმა"}>
                                                                                    <div style={{marginRight: 9}}>
                                                                                        <IoSend
                                                                                            className={"send-for-visage-doc-button"}
                                                                                            onClick={() => {
                                                                                                setCurrentFile(file);
                                                                                                setIsConfirmationModalOpen(true);
                                                                                                clearSelectedDocuments();
                                                                                            }}
                                                                                        >
                                                                                        </IoSend>
                                                                                    </div>
                                                                                </Tooltip>) :

                                                                                (
                                                                                    <>
                                                                                        {file.declinedInternalStatus === 1 ? (
                                                                                            <Tooltip
                                                                                                title={roleId === "HEADOFAGENCY" ? "შენახვა" : file.declinedInternalStatus === 1 ? "დაარედაქტირეთ დოკუმენტი" : "დასავიზირებლად გაგზავნა"}>
                                                                                                <div
                                                                                                    style={{marginRight: 9}}>
                                                                                                    <IoSend
                                                                                                        className={"send-for-visage-doc-button-disabled"}

                                                                                                    >
                                                                                                    </IoSend>
                                                                                                </div>
                                                                                            </Tooltip>
                                                                                        ) : (
                                                                                            <Tooltip
                                                                                                title={roleId === "HEADOFAGENCY" ? "შენახვა" : file.declinedInternalStatus === 1 ? "დაარედაქტირეთ დოკუმენტი" : "დასავიზირებლად გაგზავნა"}>
                                                                                                <div
                                                                                                    style={{marginRight: 9}}>
                                                                                                    <IoSend
                                                                                                        className={"send-for-visage-doc-button"}
                                                                                                        disabled={file.declinedInternalStatus === 1}
                                                                                                        onClick={() => {
                                                                                                            setCurrentFile(file);
                                                                                                            setIsConfirmationModalOpen(true);
                                                                                                            clearSelectedDocuments();
                                                                                                        }}
                                                                                                    >
                                                                                                    </IoSend>
                                                                                                </div>
                                                                                            </Tooltip>
                                                                                        )}
                                                                                    </>
                                                                                )}


                                                                    {barcode && departments && users.length !== 0 && userId && (
                                                                        <EditCaseDocument
                                                                            onFileAdded={refreshCaseFiles}
                                                                            getFileId={file.id}
                                                                            documentTypes={documentTypesForEditor}
                                                                            caseFiles={caseFiles}
                                                                            barcode={barcode}
                                                                            departments={departments}
                                                                            holidays={holidays}
                                                                            users={users}
                                                                            userId={userId}
                                                                            onFileUpload={refreshCaseFiles}
                                                                            permitTypeId={caseData.permitTypeId}
                                                                            caseData={caseDataForDocument}
                                                                        />
                                                                    )}
                                                                    <Tooltip
                                                                        title={"დოკუმენტის წაშლა"}>
                                                                        <div>
                                                                            <MdDeleteForever
                                                                                className={"delete-doc-button"}
                                                                                onClick={() => {
                                                                                    setFileToDelete(file);
                                                                                    setIsDeleteConfirmModalOpen(true);
                                                                                }}
                                                                            >
                                                                            </MdDeleteForever>
                                                                        </div>
                                                                    </Tooltip>


                                                                </div>
                                                            </TableCell>

                                                        )}
                                                        {file.decline !== CaseFileDeclined.RewriteDocument && roleId && (roleId !== "USER") && file.changeDocumentStatus !== null && (
                                                            <TableCell

                                                            >
                                                                <>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        style={{
                                                                            height: "50px",
                                                                            width: "150px",
                                                                            marginRight: "10px",
                                                                        }}
                                                                        disabled={file.changeDocumentStatus !== 1}
                                                                        onClick={() => {
                                                                            setEditModalIsOpen(true);
                                                                            setDocumentToChangeId(file);
                                                                        }}
                                                                    >
                                                                        ველების რედაქტირება
                                                                    </Button>
                                                                </>

                                                            </TableCell>
                                                        )}


                                                        {file.decline === CaseFileDeclined.RewriteDocument && roleId && (roleId !== "USER" && roleId !== "EXPERT") && (
                                                            <TableCell
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >
                                                                <>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        style={{
                                                                            height: "50px",
                                                                            width: "150px",
                                                                            marginRight: "10px",
                                                                        }}
                                                                        disabled={file.changeDocumentStatus !== 1}
                                                                        onClick={() => {
                                                                            setEditModalIsOpen(true);
                                                                            setDocumentToChangeId(file);
                                                                        }}
                                                                    >
                                                                        ველების რედაქტირება
                                                                    </Button>
                                                                </>
                                                                <Button
                                                                    variant="contained"
                                                                    color="primary"
                                                                    style={{
                                                                        height: "50px",
                                                                        width: "150px",
                                                                        marginRight: "10px",
                                                                        backgroundColor: "green",
                                                                    }}
                                                                    onClick={() => setIsModalOpen(true)}
                                                                >
                                                                    განაცხადის გადაწერა
                                                                </Button>
                                                                <Button
                                                                    variant="contained"
                                                                    color="error"
                                                                    style={{
                                                                        height: "50px",
                                                                        width: "150px",
                                                                        marginRight: "10px",
                                                                    }}
                                                                    onClick={() => setIsModalOpenDeny(true)}
                                                                >
                                                                    უარის თქმა
                                                                </Button>
                                                            </TableCell>
                                                        )}

                                                        {caseMustBeActiveForViewer && fileActiveManagerIsDeputyOrHeadOfAgency(file) && !file.shared && file.sharedTemp && userId && hasManagerApprovedFile(file) && roleId === "HEADOFDEPARTMENT" && (
                                                            <TableCell
                                                                style={{alignContent: 'center', display: "flex"}}>
                                                                <div>
                                                                    <Tooltip title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                        <div>
                                                                            <IoArrowBackCircleSharp
                                                                                className={"delete-doc-button"}
                                                                                onClick={() => handleConfirmButtonClickInternal(file, 'decline')}
                                                                            />
                                                                        </div>
                                                                    </Tooltip>

                                                                    <Dialog
                                                                        open={isDialogOpen}
                                                                        onClose={handleDialogClose}
                                                                        maxWidth="md"
                                                                        fullWidth
                                                                    >
                                                                        <DialogTitle>უკან დაბრუნების
                                                                            მიზეზი</DialogTitle>
                                                                        <DialogContent>

                                                                            <TextField
                                                                                autoFocus
                                                                                margin="dense"
                                                                                label="უკან დაბრუნების მიზეზი"
                                                                                fullWidth
                                                                                multiline
                                                                                rows={8}
                                                                                value={returnComment}
                                                                                onChange={(e) => setReturnComment(e.target.value)}
                                                                            />
                                                                        </DialogContent>
                                                                        <DialogActions>
                                                                            <Button onClick={handleDialogClose}
                                                                                    color="primary">
                                                                                გაუქმება
                                                                            </Button>
                                                                            <Button onClick={handleDialogSubmit}
                                                                                    color="primary">
                                                                                გაგზავნა
                                                                            </Button>
                                                                        </DialogActions>
                                                                    </Dialog>
                                                                </div>
                                                                <Tooltip title={"დოკუმენტის ვიზირება"}>
                                                                    <div>
                                                                        <IoCheckmarkCircle
                                                                            className="approved-icon"
                                                                            onClick={() => {
                                                                                setCurrentFile(file);
                                                                                setIsApproveModalOn(true);
                                                                            }}>

                                                                        </IoCheckmarkCircle>
                                                                    </div>
                                                                </Tooltip>


                                                            </TableCell>
                                                        )}
                                                        {caseMustBeActiveForViewer &&
                                                            file.sharedTemp &&
                                                            !file.shared &&
                                                            fileActiveManagerIsDeputyOrHeadOfAgency(file) &&
                                                            userId &&
                                                            hasManagerApprovedFile(file) &&
                                                            roleId !== "HEADOFDEPARTMENT" &&
                                                            expertHasDeclinedFile(file.id) &&
                                                            (
                                                                <TableCell
                                                                    style={{
                                                                        alignContent: 'center',
                                                                        display: "flex",
                                                                        textAlign: 'center'
                                                                    }}>
                                                                    <div>
                                                                        <Tooltip
                                                                            title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                            <div>
                                                                                <IoArrowBackCircleSharp
                                                                                    className={"delete-doc-button"}
                                                                                    onClick={() => handleConfirmButtonClickInternal(file, 'decline')}
                                                                                />
                                                                            </div>
                                                                        </Tooltip>
                                                                        <Dialog
                                                                            open={isDialogOpen}
                                                                            onClose={handleDialogClose}
                                                                            maxWidth="md"
                                                                            fullWidth
                                                                        >
                                                                            <DialogTitle>უკან დაბრუნების
                                                                                მიზეზი</DialogTitle>
                                                                            <DialogContent>

                                                                                <TextField
                                                                                    autoFocus
                                                                                    margin="dense"
                                                                                    label="უკან დაბრუნების მიზეზი"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={8}
                                                                                    value={returnComment}
                                                                                    onChange={(e) => setReturnComment(e.target.value)}
                                                                                />
                                                                            </DialogContent>
                                                                            <DialogActions>
                                                                                <Button onClick={handleDialogClose}
                                                                                        color="primary">
                                                                                    გაუქმება
                                                                                </Button>
                                                                                <Button onClick={handleDialogSubmit}
                                                                                        color="primary">
                                                                                    გაგზავნა
                                                                                </Button>
                                                                            </DialogActions>
                                                                        </Dialog>
                                                                    </div>
                                                                    <Tooltip title={"დოკუმენტის ვიზირება"}>
                                                                        <div>
                                                                            <IoCheckmarkCircle
                                                                                className="approved-icon"
                                                                                onClick={() => {
                                                                                    setCurrentFile(file);
                                                                                    setIsApproveModalOn(true);
                                                                                }}>

                                                                            </IoCheckmarkCircle>
                                                                        </div>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            )}
                                                        {caseMustBeActiveForViewerForInternalFile &&
                                                            file.sharedTemp &&
                                                            userId &&
                                                            hasManagerApprovedFile(file) &&
                                                            roleId !== "HEADOFDEPARTMENT" &&
                                                            expertHasDeclinedFile(file.id) &&
                                                            file.pureDays &&
                                                            (
                                                                <TableCell
                                                                    style={{
                                                                        alignContent: 'center',
                                                                        display: "flex",
                                                                        textAlign: 'center'
                                                                    }}>
                                                                    <div>
                                                                        <Tooltip
                                                                            title={"შიდა დოკუმენტის უკან დაბრუნება"}>
                                                                            <div>
                                                                                <IoArrowBackCircleSharp
                                                                                    className={"delete-doc-button"}
                                                                                    onClick={() => handleConfirmButtonClickInternalExpert(file, 'decline')}
                                                                                />
                                                                            </div>
                                                                        </Tooltip>
                                                                        <Dialog
                                                                            open={isDialogOpenExpert}
                                                                            onClose={handleDialogClose}
                                                                            maxWidth="md"
                                                                            fullWidth
                                                                        >
                                                                            <DialogTitle>უკან დაბრუნების
                                                                                მიზეზი</DialogTitle>
                                                                            <DialogContent>

                                                                                <TextField
                                                                                    autoFocus
                                                                                    margin="dense"
                                                                                    label="უკან დაბრუნების მიზეზი"
                                                                                    fullWidth
                                                                                    multiline
                                                                                    rows={25}
                                                                                    value={returnCommentExpert}
                                                                                    onChange={(e) => setReturnCommentExpert(e.target.value)}
                                                                                />
                                                                            </DialogContent>
                                                                            <DialogActions>
                                                                                <Button
                                                                                    onClick={handleDialogCloseExpert}
                                                                                    color="primary">
                                                                                    გაუქმება
                                                                                </Button>
                                                                                <Button
                                                                                    onClick={handleDialogSubmitExpert}
                                                                                    color="primary">
                                                                                    გაგზავნა
                                                                                </Button>
                                                                            </DialogActions>
                                                                        </Dialog>
                                                                    </div>
                                                                    <Tooltip title={"დოკუმენტის ვიზირება"}>
                                                                        <div>
                                                                            <IoCheckmarkCircle
                                                                                className="approved-icon"
                                                                                onClick={() => {
                                                                                    setCurrentFile(file);
                                                                                    setIsApproveModalOn(true);
                                                                                }}>

                                                                            </IoCheckmarkCircle>
                                                                        </div>
                                                                    </Tooltip>
                                                                </TableCell>
                                                            )}

                                                        {childrenByParentId[file.id] && (
                                                            <TableCell style={{textAlign: 'center'}}>
                                                                <Tooltip
                                                                    title={visibility[file.id] ? "ჩაკეცვა" : "თან დართული დოკუმენტების ნახვა"}>
                                                                    <div>
                                                                        {visibility[file.id] ? (
                                                                            <MdOutlineExpandLess
                                                                                className="expand-more-icon"
                                                                                onClick={() => toggleVisibility(file.id)}>
                                                                            </MdOutlineExpandLess>
                                                                        ) : (
                                                                            <MdOutlineExpandMore
                                                                                className="expand-more-icon"
                                                                                onClick={() => toggleVisibility(file.id)}>
                                                                            </MdOutlineExpandMore>
                                                                        )}
                                                                    </div>
                                                                </Tooltip>
                                                            </TableCell>
                                                        )}

                                                    </TableRow>

                                                    {visibility[file.id] && childrenByParentId[file.id] && childrenByParentId[file.id].map((file) => (
                                                        <TableRow key={file.id}
                                                                  style={{paddingLeft: '20px'}}>
                                                            {caseMustBeActive && (
                                                                <TableCell
                                                                    style={{
                                                                        height: 40,
                                                                        textAlign: 'center',
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}
                                                                >
                                                                </TableCell>
                                                            )}
                                                            <TableCell
                                                                style={{
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                            >

                                                            </TableCell>


                                                            {roleId !== "USER" && (
                                                                <TableCell
                                                                    style={{
                                                                        height: 40,
                                                                        textAlign: 'center',
                                                                        backgroundColor: getBackgroundColor(file),
                                                                    }}
                                                                    title={file.fullname}
                                                                >
                                                                    {file.fullname}
                                                                </TableCell>
                                                            )}

                                                            <TableCell
                                                                style={{
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                                title={file.name}
                                                            >
                                                                <a href={file.path} target="_blank"
                                                                   download
                                                                   rel="noopener noreferrer"
                                                                   className="lightblue-link">
                                                                    {file.name.length > 50 ? `${file.name.substring(0, 47)}...` : file.name}
                                                                </a>

                                                            </TableCell>

                                                            <TableCell
                                                                style={{backgroundColor: getBackgroundColor(file)}}
                                                                title={file.additionalInfo}
                                                            >
                                                                {file.additionalInfo.length > 30 ? `${file.additionalInfo.substring(0, 35)}...` : file.additionalInfo}
                                                            </TableCell>
                                                            {roleId && roleId !== "USER" && (
                                                                <TableCell
                                                                    style={{backgroundColor: getBackgroundColor(file)}}>
                                                                </TableCell>
                                                            )}
                                                            <TableCell
                                                                style={{
                                                                    textAlign: 'center',
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                                title={documentTypes[file.documentType] || ''}
                                                            >
                                                                {documentTypes[file.documentType] || ''}
                                                            </TableCell>
                                                            <TableCell
                                                                style={{
                                                                    textAlign: 'center',
                                                                    backgroundColor: getBackgroundColor(file),
                                                                }}
                                                                title={file.shared ? "კი" : "არა"}
                                                            >
                                                                {file.shared ? "კი" : "არა"}
                                                            </TableCell>
                                                            {roleId !== "USER" && (
                                                                <>
                                                                    <TableCell
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            backgroundColor: getBackgroundColor(file),
                                                                        }}
                                                                        title={formatDateAndTime(file.createdAt, "aaa")}
                                                                    >
                                                                        <div>
                                                                            {file.documentDatesActions.length > 0 ? formatDateAndTime(file.documentDatesActions[0].createdAt, 'aaa') : formatDateAndTime(file.createdAt, "aaa")}
                                                                        </div>
                                                                    </TableCell>
                                                                    <TableCell
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            backgroundColor: getBackgroundColor(file),
                                                                            cursor: "help",
                                                                        }}
                                                                    >
                                                                        <Tooltip
                                                                            title={<React.Fragment>
                                                                                {file.documentDatesActions.map((action, index) => (
                                                                                    <div
                                                                                        key={action.id}>{index + 1}: {formatDateAndTime(action.createdAt, 'aaa')}</div>
                                                                                ))}
                                                                            </React.Fragment>}
                                                                            placement="top"
                                                                            arrow
                                                                        >
                                                                            <div>
                                                                                {file.documentDatesActions.length > 1 ? formatDateAndTime(file.documentDatesActions[file.documentDatesActions.length - 1].createdAt, 'aaa') : ''}
                                                                            </div>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </>

                                                            )}


                                                        </TableRow>
                                                    ))}
                                                </React.Fragment>
                                            ))}
                                        </TableBody>
                                    )}


                                </Table>
                            </TableContainer>
                        </div>

                        {isConfirmationModalOpen && (
                            <ConfirmationModal
                                isOpen={isConfirmationModalOpen}
                                onRequestClose={() => setIsConfirmationModalOpen(false)}
                                onConfirm={() => {
                                    void editCaseFile(currentFile);
                                    setIsConfirmationModalOpen(false);
                                }}
                            />)}
                        {isConfirmationModalOpenForDeny && (
                            <ConfirmationModal
                                isOpen={isConfirmationModalOpenForDeny}
                                onRequestClose={() => setIsConfirmationModalOpenForDeny(false)}
                                onConfirm={() => {
                                    void UnDenyCaseFile(currentFile);
                                    setIsConfirmationModalOpenForDeny(false);
                                }}
                            />)}
                        {isConfirmationModalOpenForConditionalFinish && (
                            <ConfirmationModal
                                isOpen={isConfirmationModalOpenForConditionalFinish}
                                onRequestClose={() => setIsConfirmationModalOpenForConditionalFinish(false)}
                                onConfirm={() => {
                                    void removeConditionFromCaseFile(currentFile);
                                    setIsConfirmationModalOpenForConditionalFinish(false);
                                }}
                            />)}

                    </div>)}
            </div>

        ), "განაცხადის მენეჯერები": (<>
                <div className="dashboard-table-container">
                    {users.length > 0 && managerToEdit && departmentID && (
                        <ChangeCaseUserPopup
                            open={openChangeCaseUserPopup}
                            handleClose={handleCloseCaseUserPopup}
                            users={users}
                            caseManager={managerToEdit}
                            caseManagers={caseManagers}
                            onUpdate={fetchCaseManagersData}
                            caseFiles={caseFiles}
                            onFileUpdate={refreshCaseFiles}
                            departmentId={departmentID}

                        />
                    )}
                    {users.length > 0 && managerToEdit && loggedUserDepartment && (
                        <ChangeCaseViewerPopup
                            open={openChangeCaseUserViewerPopup}
                            handleClose={handleCloseCaseUserViewerPopup}
                            users={users}
                            caseManager={managerToEdit}
                            caseManagers={caseManagers.concat(caseViewerManagers)}
                            onUpdate={fetchCaseManagersData}
                            caseFiles={caseFiles}
                            onFileUpdate={refreshCaseFiles}
                            departmentId={loggedUserDepartment}
                        />
                    )}

                    {caseData && (caseMustBeActive || caseMustBeActiveToMakeItSecret || caseMustBeActiveToRemoveOrder) && (
                        <div style={{display: "flex"}}>
                            {roleId && users.length !== 0 && roleId !== "EXPERT" && (caseMustBeActive || caseMustBeActiveToMakeItSecret || caseMustBeActiveToRemoveOrder) && departmentID && holidays.length !== 0 && (
                                <>
                                    {checkIfThereAreAllTheCaseManagers(caseManagers) ? (
                                            <>
                                                {roleId === "HEADOFDEPARTMENT" ? (
                                                    <AddressingPopupHeadOFDepartment
                                                        roleName={roleId}
                                                        onManagerAdded={refreshCaseManagers}
                                                        caseManagers={caseManagers}
                                                        caseDataDays={caseData.days}
                                                        departmentId={departmentID}
                                                        internalUsers={users}
                                                        deps={departments}
                                                        groupId={groupId}
                                                        holidays={holidays}

                                                    />
                                                ) : (
                                                    <AddrerssingPopupForHeads
                                                        roleName={roleId}
                                                        onManagerAdded={refreshCaseManagers}
                                                        caseManagers={caseManagers}
                                                        caseDataDays={caseData.days}
                                                        departmentId={departmentID}
                                                        internalUsers={users}
                                                        deps={departments}
                                                        groupId={groupId}
                                                        holidays={holidays}

                                                    />
                                                )}
                                            </>
                                        ) :
                                        (
                                            <AddressingPopup
                                                roleName={roleId}
                                                onManagerAdded={refreshCaseManagers}
                                                caseManagers={caseManagers}
                                                caseDataDays={caseData.days}
                                                departmentId={departmentID}
                                                internalUsers={users}
                                                deps={departments}
                                                groupId={groupId}
                                                holidays={holidays}
                                                cancelDocExists={!cancelDocExists}

                                            />
                                        )}
                                </>)}


                            {caseManagers.length > 1 && caseData && users.length > 0 && roleId && userId && caseIsActive && (
                                <ReturnCaseManagerButton
                                    caseManagers={caseManagers}
                                    caseViewerManagers={caseViewerManagers}
                                    onManagerAdded={refreshCaseManagers}
                                    onCaseStatusChange={refreshCaseDataOnFileUpload}
                                    caseStatus={caseData.status}
                                    allUsers={users}
                                    role={roleId}
                                    userId={userId}
                                />)}
                        </div>

                    )}
                    {roleId && users && roleId === "HEADOFDEPARTMENT" && caseMustBeActiveForViewer && departmentID && holidays.length !== 0 && (
                        <AddressingPopupHeadOFDepartment
                            roleName={roleId}
                            onManagerAdded={refreshCaseManagers}
                            caseManagers={caseManagers}
                            caseDataDays={caseData.days}
                            departmentId={departmentID}
                            internalUsers={users}
                            deps={departments}
                            groupId={groupId}
                            holidays={holidays}

                        />)}

                    {caseData && caseFiles.length !== 0 && visagedFileIdString && (
                        <VisagedFilesPopup open={isVisagersFilesPopupIsOpen} onClose={handleCloseVisagersFilesPopup}
                                           fileIds={visagedFileIdString}
                                           caseFiles={caseFiles} deletedCaseFiles={deletedFiles}/>
                    )}

                    <div className="dashboard-table-border-managers">

                        {users.length > 0 && activeUserFullData && departmentID && (
                            <table>
                                <thead>
                                <tr>
                                    <th style={{
                                        textAlign: 'center', width: 20
                                    }}><TiFlowSwitch/></th>
                                    <th className="dashboard-table-status">დაამატა</th>
                                    <th className="dashboard-table-status">მენეჯერი</th>
                                    <th className="dashboard-table-status">დამატების თარიღი</th>
                                    <th className="dashboard-table-status">დღეების რაოდეობა</th>
                                    <th className="dashboard-table-status">უკან დაბრუნების მიზეზი</th>
                                    {roleId !== "EXPERT" && (
                                        <th className="dashboard-table-status">ქმედება</th>
                                    )}
                                    {roleId === "EXPERT" && (
                                        <th className="dashboard-table-status"></th>
                                    )}
                                </tr>
                                </thead>
                                <tbody>
                                {caseManagers.map((manager, index) => {
                                    const isActiveManager = isManagerActive(manager);
                                    let backgroundColor = isActiveManager ? "#add8e6" : manager.isReturned ? "" : "";  // Medium Teal for active manager

                                    if (index === caseManagers.length - 1 && !foundActiveManager) {
                                        backgroundColor = "#add8e6";
                                    }


                                    return (
                                        <tr key={manager.id}>
                                            <td style={{
                                                textAlign: 'center', backgroundColor, width: 20
                                            }}>
                                                {manager.status === 0 ? <FaArrowDown/> : <FaArrowUp/>}
                                            </td>
                                            <td style={{
                                                backgroundColor,
                                                width: 250
                                            }}>{!manager.addedBySystem ? manager.fromUserName : "დაემატა სისტემურად"}</td>
                                            <td style={{
                                                backgroundColor,
                                                width: 250,
                                                height: 30
                                            }}>{manager.toUserName}</td>
                                            <td style={{backgroundColor, width: 250}}>
                                                {manager.createdAt ? formatDate(manager.createdAt) : ""}
                                            </td>
                                            <td style={{backgroundColor, width: 250}}>
                                                {manager.dedlineDays && !manager.addedBySystem
                                                    ? manager.dedlineDays < 0
                                                        ? "ვადაგადაცილებული"
                                                        : manager.dedlineDays + " დღე"
                                                    : ""}
                                            </td>

                                            <td style={{backgroundColor, width: 400}}
                                                title={manager.returnComment || ''}>
                                                {manager.returnComment && manager.returnComment.length > 60 ? `${manager.returnComment.substring(0, 60)}...` : manager.returnComment}
                                            </td>


                                            {roleId !== "EXPERT" && canDeleteManager(manager.toUserId) && index === caseManagers.length - 1 && index !== 1 && (activeUserFullData.departmentId === departmentID || roleId === "HEADOFAGENCY" || roleId === "DEPUTYHEADOFAGENCY") ? (
                                                <td style={{backgroundColor}} className="caseUser-icon-container">
                                                    <Tooltip title={"შემსრულებლის წაშლა"}>
                                                        <div>
                                                            <IoPersonRemoveSharp
                                                                className="caseUser-icon caseUser-icon-remove"
                                                                onClick={() => {
                                                                    setCaseUserDeleteModalOpen(true);
                                                                    setCurrentFileCaseUserId(manager)
                                                                }}
                                                            />
                                                        </div>
                                                    </Tooltip>
                                                    <Tooltip title={"შემსრულებლის შეცვლა"}>
                                                        <div>
                                                            <AiOutlineUserSwitch
                                                                className="caseUser-icon caseUser-icon-switch"
                                                                onClick={() => {
                                                                    handleClickOpenCaseUserPopup()
                                                                    setManagerToEdit(manager);
                                                                }}
                                                            />
                                                        </div>
                                                    </Tooltip>
                                                </td>
                                            ) : (
                                                <td style={{backgroundColor, width: 250}}>
                                                </td>
                                            )}


                                        </tr>);
                                })}

                                </tbody>
                            </table>
                        )}

                        {caseViewerManagers.length > 0 && caseFiles && <div>
                            <h4>მეორადი შემსრულებლები</h4>
                            <table>
                                <thead>
                                <tr>
                                    <th>დაამატა</th>
                                    <th>მენეჯერი</th>
                                    <th>დამატების თარიღი</th>
                                    <th>დოკუმენტი</th>
                                    <th style={{width: 20}}>დავიზებული დოკუმენტები</th>
                                    <th>როლი</th>
                                    <th>ქმედება</th>
                                </tr>
                                </thead>
                                <tbody>
                                {caseViewerManagers.map((manager) => (
                                    <tr key={manager.id}>
                                        <td>{manager.fromUserName}</td>
                                        <td>{manager.toUserName}</td>
                                        <td>
                                            {manager.createdAt ? formatDate(manager.createdAt) : ""}
                                        </td>
                                        <td>
                                            {manager.caseFileId ? getFileNameById(manager.caseFileId) : ""}
                                        </td>

                                        <td style={{width: 20, alignItems: "center", textAlign: "center"}}>
                                            {manager.approverDetalis && (
                                                <Tooltip title={"დოკუმენტების ნახვა"}>
                                                    <span>
                                                        <FaFileAlt
                                                            onClick={() => {
                                                                handleOpenVisagersFilesPopup()
                                                                setVisagedFileIdString(manager.approverDetalis);
                                                            }}

                                                            className="caseUser-icon caseUser-icon-switch"
                                                        />
                                                    </span>

                                                </Tooltip>
                                            )}

                                        </td>
                                        <td>
                                            {
                                                manager.approver ? "ვიზატორი" :
                                                    manager.approverStatus === approverStatusEnum.worker && !manager.approver ? "შემსრულებელი" :
                                                        manager.approverStatus === approverStatusEnum.worker ? "ვიზატორი" :
                                                            manager.approverStatus === 4 ? "დაავიზა" :
                                                                manager.approverStatus === approverStatusEnum.visager ? "ვიზატორი" :
                                                                    manager.approverStatus === approverStatusEnum.viewer ? "მეორადი შემსრულებელი" :
                                                                        caseViewerIsHeadOfDepartmentAndHasInternalFlowDocument(manager) ? "ვიზატორი" :
                                                                            "მეორადი შემსრულებელი"
                                            }
                                        </td>
                                        {canDeleteCaseViewer(manager.toUserId) ? (
                                            <td className="caseUser-icon-container">
                                                <Tooltip title={"შემსრულებლის წაშლა"}>
                                                    <div>
                                                        <IoPersonRemoveSharp
                                                            className="caseUser-icon caseUser-icon-remove"
                                                            onClick={() => {
                                                                setCaseUserDeleteModalOpen(true);
                                                                setCurrentFileCaseUserId(manager)
                                                            }}
                                                        />
                                                    </div>
                                                </Tooltip>
                                                <Tooltip title={"შემსრულებლის შეცვლა"}>
                                                    <div>
                                                        <AiOutlineUserSwitch
                                                            className="caseUser-icon caseUser-icon-switch"
                                                            onClick={() => {
                                                                handleClickViewerOpenCaseUserPopup()
                                                                setManagerToEdit(manager);
                                                            }}
                                                        />
                                                    </div>
                                                </Tooltip>
                                            </td>
                                        ) : (
                                            <td style={{width: 250}}>
                                            </td>
                                        )}
                                    </tr>))}

                                </tbody>
                            </table>
                        </div>}
                    </div>
                </div>
            </>


        ), "დამატებითი ინფორმაცია": (<>


            {caseData && orderDepartment && roleId && caseDetails && caseFiles && caseDataForDocument && isObjectInRegistery !== null && (

                <>
                    {caseData.status === CaseStatus.CaseCreatedWithoutFiles.id && roleId === "USER" ? (
                        <CaseDetailsForUser role={roleId}
                                            caseFinished={caseData.finished}
                                            caseInfo={caseData}
                                            isCadastralCodeRejected={caseData.cadastralCodeDenclinedStatus}
                                            permitTypeId={caseData.permitTypeId}
                                            caseMustBeActive={caseMustBeActive}
                                            caseDetails={caseDetails}
                                            onDetailChange={refreshCaseDetails}
                                            caseFiles={caseFiles}
                                            onFileAdded={refreshCaseFiles}
                                            onCaseStatusChange={refreshCaseDataOnFileUpload}
                                            isButtonVisible={isReuploadble}
                                            caseGeography={caseGeography}
                                            isObjectInRegistery={isObjectInRegistery}
                                            geoIds={geoIds}
                                            caseParentId={caseData.caseParentId}
                                            isCaseParentIdRejected={caseData.isRejectedCaseParentId}
                                            onCaseParentIdRejection={refreshCaseDataOnFileUpload}
                                            caseData={caseDataForDocument}
                                            users={users}
                                            isAddressRejected={caseData.addressDeclinedStatus}
                                            orderDepartment={orderDepartment}
                        />
                    ) : (
                        <CaseDetails role={roleId}
                                     caseFinished={caseData.finished}
                                     caseInfo={caseData}
                                     isCadastralCodeRejected={caseData.cadastralCodeDenclinedStatus}
                                     permitTypeId={caseData.permitTypeId}
                                     caseMustBeActive={caseMustBeActive}
                                     caseDetails={caseDetails}
                                     onDetailChange={refreshCaseDetails}
                                     caseFiles={caseFiles}
                                     onFileAdded={refreshCaseFiles}
                                     onCaseStatusChange={refreshCaseDataOnFileUpload}
                                     isButtonVisible={isReuploadble}
                                     caseGeography={caseGeography}
                                     isObjectInRegistery={isObjectInRegistery}
                                     geoIds={geoIds}
                                     caseParentId={caseData.caseParentId}
                                     isCaseParentIdRejected={caseData.isRejectedCaseParentId}
                                     onCaseParentIdRejection={refreshCaseDataOnFileUpload}
                                     caseData={caseDataForDocument}
                                     users={users}
                                     isAddressRejected={caseData.addressDeclinedStatus}
                                     orderDepartment={orderDepartment}
                                     objectsOfRegistery={objectsOfRegistery}
                        />
                    )}


                </>


            )}
        </>), "შიდა მიმოწერა": (
            <></>
        ),
        "განაცხადის ისტორია": (
            <>
                {users.length !== 0 && caseData && (
                    <CaseHistory deletedFiles={deletedFiles}
                                 geoIds={geoIds}
                                 caseFiles={caseFiles}
                                 users={users}
                                 caseData={caseData}
                    />
                )}

            </>
        )
    };


    const handleOptionChange = (option) => {
        setSelectedOption(option);
    };


    if (isLoadingMergeProcess || isMerging || (roleId && roleId !== "USER" && caseManager === null)) {
        return (
            <div
                className={"initial-loader-container"}

            >
                <DescriptionOutlined
                    sx={{
                        fontSize: 80,
                        color: 'rgba(255, 255, 255, 0.9)',
                        mb: 2,
                        animation: 'pulseIcon 1.5s ease-in-out infinite',
                    }}
                />
                <Typography
                    sx={{
                        fontSize: 20,
                        fontWeight: 'bold',
                        color: 'rgba(255, 255, 255, 0.9)',
                        mb: 3,
                    }}
                >
                    გთხოვთ დაელოდოთ...
                </Typography>
                <CircularProgress sx={{color: 'rgba(255, 255, 255, 0.8)'}}/>
            </div>
        );
    }

    if (initialLoading ||
        isLoadingCaseFilesForInitialLoading ||
        isLoadingCaseDataInitial ||
        initialLoadingForDocTypes ||
        docTypesAreLoading
    ) {
        return (
            <div
                className={"initial-loader-container"}

            >
                <DescriptionOutlined
                    sx={{
                        fontSize: 80,
                        color: 'rgba(255, 255, 255, 0.9)',
                        mb: 2,
                        animation: 'pulseIcon 1.5s ease-in-out infinite',
                    }}
                />
                <Typography
                    sx={{
                        fontSize: 20,
                        fontWeight: 'bold',
                        color: 'rgba(255, 255, 255, 0.9)',
                        mb: 3,
                    }}
                >
                    განაცხადი იტვირთება...
                </Typography>
                <CircularProgress sx={{color: 'rgba(255, 255, 255, 0.8)'}}/>
            </div>
        );
    }


    return (

        <div className={'gejadze-table-background'}>

            <Snackbar
                open={showSuccessAlert}
                autoHideDuration={6000}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                sx={{top: {xs: '1%', sm: '1%'}}}
            >
                <Alert
                    severity="success"
                    sx={{width: '100%', fontSize: '1.25rem'}}
                >
                    ოპერაცია წარმატებით დასრულდა!
                </Alert>
            </Snackbar>
            <Snackbar
                open={showSuccessAlertMergeRequest}
                autoHideDuration={6000}
                anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                sx={{top: {xs: '1%', sm: '1%'}}}
            >
                <Alert
                    severity="success"
                    sx={{width: '100%', fontSize: '1.25rem'}}
                >
                    ოპერაცია წარმატებით დასრულდა!
                </Alert>
            </Snackbar>
            {latestNotification.length !== 0 && caseFiles.length !== 0 && (
                <div className="notification-popup">
                    <div className={"notification-content"}>
                        <FaBell className="notification-popup-icon"/>
                        <div
                            className="notification-popup-header">ვისგან: {latestNotification.lastStepUserFullName}</div>
                        <div className="notification-popup-header">ვის: {latestNotification.nextStepUserFullName}</div>
                        {findCaseFileById(latestNotification.documentId) && (
                            <div className="notification-popup-body">
                                დოკუმენტი:{' '}
                                <a href={findCaseFileById(latestNotification.documentId).path} target="_blank"
                                   rel="noopener noreferrer" className="notification-popup-document-url">
                                    {findCaseFileById(latestNotification.documentId).name ? findCaseFileById(latestNotification.documentId).name : "დოკუმენტი წაშლილია"}
                                </a>
                            </div>
                        )}
                        <div className="notification-popup-body">
                            ქმედება: {CaseNotificationEnum[Object.keys(CaseNotificationEnum).find(key => CaseNotificationEnum[key].id === latestNotification.action)].title}
                        </div>
                    </div>
                    <div
                        className="notification-popup-footer">თარიღი: {formatDateNotification(latestNotification.createAt)}</div>
                    <div className={"close-notification"} onClick={handleClosNotification}>
                        <FaTimes className="close-notification-icon"/>
                        ჩაკეცვა
                    </div>
                </div>

            )}
            <div className="gejadze-dashboard-table-container">

                <div>

                    <div className="case-change-buttons">
                        {groupId && (
                            <ChatComponent open={isChatOpen}
                                           onClose={handleCloseChat}
                                           isCaseChat={true}
                                           mainGroup={groupId}
                                           groupId={groupId.id}
                                           groupUsers={groupId.chatUsersIds}
                                           chatName={groupId.chatName}
                                           onCaseChatUpdate={refreshChat}/>
                        )}
                        {roleId !== "USER" && caseData && (
                            <CreateDateEditPopup open={isCaseCreateDatePopupOpen}
                                                 onClose={() => setIsCaseCreateDatePopupOpen(false)}
                                                 createDate={caseData.createDate} caseId={caseData.id}
                                                 onUpdate={refreshCaseDataOnFileUpload} users={users} role={roleId}/>
                        )}


                        {caseDetails && caseData && (
                            <div style={{marginBottom: 20}}>
                                <Button variant="contained"
                                        color="primary"
                                        endIcon={<FaExchangeAlt/>}
                                        onClick={handleClickOpenBoundCases}>
                                    დაკავშირებული განაცადების ნახვა
                                </Button>

                                <BoundCases open={openBoundCases}
                                            handleClose={handleCloseBoundCases}
                                            caseDetails={caseDetails}
                                            roleId={roleId}
                                            id={caseData.permitTypeId}
                                />
                            </div>
                        )}
                        {users.length > 0 && managerToEditForInternalFlow && departmentID && (
                            <ChangeCaseUserPopup
                                open={openChangeCaseUserPopupInternalFlow}
                                handleClose={handleCloseCaseUserPopupInternalFlow}
                                users={users}
                                caseManager={managerToEditForInternalFlow}
                                caseManagers={caseManagers}
                                onUpdate={fetchCaseManagersData}
                                caseFiles={caseFiles}
                                onFileUpdate={refreshCaseFiles}
                                departmentId={departmentID}
                                internalFileToEditManager={internalFileToEditManager}
                                isInternalFlowPopup={true}
                                addNewCaseUser={addNewCaseUser}
                            />
                        )}
                        {caseData && roleId === "USER" && caseData.status !== CaseStatus.FinishedDenied.id && (
                            <div style={{marginBottom: 20}}>
                                <Button variant="contained"
                                        color="primary"

                                        endIcon={<FaExchangeAlt/>}
                                        onClick={handleClickOpen}>
                                    ობიქეტზე განხორციელებული ცვლილების შესახებ განცხადება
                                </Button>
                                <ChildrenCaseRegistration open={open} handleClose={handleClose} caseData={caseData}
                                                          onFileAdded={refreshCaseFiles}/>
                            </div>)}
                        {conditioalFilesPopup && (<UploadConditionalDocumentPopup
                            caseFiles={caseFiles}
                            permitTypeId={caseData.permitTypeId}
                            onClose={toggleUploadConditionFiles}
                            onFileAdded={refreshCaseFiles}
                            onCaseStatusChange={refreshCaseDataOnFileUpload}
                        />)}
                    </div>
                </div>

                {caseData && objectsOfRegistery && (
                    <PermitTypeDisplay id={caseData.permitTypeId} caseId={caseData.id}
                                       caseData={caseData}
                                       caseIsSectert={secretFileExist}
                                       canEdit={orderDepartment === NomenclatureEnum.registery}
                                       permitTypeList={objectsOfRegistery}
                                       onEdit={refreshCaseDataOnFileUpload}
                    />
                )}
                {roleId && roleId !== "USER" && (<PDFAlert/>)}
                {geoIds.regionId !== null && caseData && (
                    <table className="gejadze-table">
                        <thead>
                        <tr>
                            <th>განაცხადის
                                ნომერი
                            </th>
                            <th>რეგისტრაციის
                                თარიღი
                            </th>
                            {caseData && !caseData.creteByExpert && (
                                <th>ბოლო
                                    ვადა
                                </th>
                            )}
                            {caseData.objectRegistryID && caseData.moveCaseToAgencyRegisterByExpert && (

                                <th>
                                    <div>უწყებრივ რეესტრში რეგისტრაციის ნომერი</div>
                                    {roleId && roleId !== "USER" && (
                                        <Tooltip title={"ველის რედაქტირება"}>
                                            <div>
                                                <IconButton onClick={() => setOpenObjectRegistryIdDialog(true)}>
                                                    <FaEdit/>
                                                </IconButton>
                                            </div>
                                        </Tooltip>
                                    )}
                                </th>

                            )}
                            {objectOwner && (
                                <>
                                    {orderDepartment === NomenclatureEnum.building && (
                                        <th>დამკვეთი</th>
                                    )}
                                    {orderDepartment === NomenclatureEnum.explosion && (
                                        <th>დამკვეთი</th>
                                    )}
                                    {orderDepartment === NomenclatureEnum.registery && (
                                        <th>ობიექტის მფლობელის დასახელება</th>
                                    )}
                                    {orderDepartment === null && (
                                        <th>დამკვეთი</th>
                                    )}
                                </>

                            )}


                            {caseData && caseData.creteByExpert ? (
                                <th>განაცხადის
                                    შემქმნელი</th>
                            ) : (
                                <th>განმცხადებელი</th>
                            )}

                            <th>სრული მისამართი
                            </th>
                            {caseData && caseData.address && (
                                <th>ობიექტის
                                    მისამართი</th>
                            )}

                            {caseData && caseData.request && (
                                <th>მოთხოვნა</th>
                            )}

                            <th>სტატუსი</th>

                            {caseData && !caseData.creteByExpert && (
                                <th>დაჩქარებული</th>
                            )}


                            {caseData && caseData.declineReasonFromUser && (
                                <th>განუხილველად
                                    დატოვების კომენტარი</th>
                            )}
                            {caseData.caseParentId && (
                                <th>წინა
                                    სტადიის
                                    განაცხადის ნომერი</th>)}


                            {objectsOfRegistery.length !== 0 &&
                                caseData &&
                                checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId) && (
                                    <th>ობიექტი
                                        შეყვანილია უწყებრივ რეესტრში</th>)}

                            {caseData && caseData.inspectionDocumentCheckingDate && (
                                <th>
                                    გადამოწმების თარიღი
                                </th>
                            )}
                            {caseData && caseData.inspectionDocumentmplementation && (
                                <th>
                                    განხორციელების თარიღი
                                </th>
                            )}
                            {caseData && caseData.inspectionSertificatValidityPeriodDate && (
                                <th>
                                    მოქმედების ვადა
                                </th>
                            )}

                            {
                                caseData &&
                                caseData.oldCaseNumber && (
                                    <th>
                                        ძველი განაცხადის ნომერი
                                    </th>
                                )
                            }

                            {caseData && caseData.finishDate && (
                                <th>
                                    დასრულების თარიღი
                                </th>)}
                            {caseData && caseData.finishedWithCondition && (
                                <th>
                                    პირობიანი დოკუმენტების ატვირთვის ვადა
                                </th>)}
                            {caseData && caseData.termOfPermitDate && (
                                <th>
                                    ნებართვბის ვადა
                                </th>)}
                        </tr>
                        </thead>
                        <tbody>

                        {caseData ? (<tr className={"case-inside-table-casedata"}>
                            {caseData && caseData.creteByExpert && !caseData.moveCaseToAgencyRegisterByExpert ? (
                                <td style={{textAlign: "center"}}>{caseData.id}</td>

                            ) : (<td style={{textAlign: "center"}}>{caseData.caseNumber}</td>)}

                            <td onClick={() => setIsCaseCreateDatePopupOpen(true)} style={{textAlign: "center"}}>
                                {roleId !== "USER" ? (
                                    <div onClick={() => setIsCaseCreateDatePopupOpen(true)} style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "8px"
                                    }}>
                                        {formatDateAndTime(caseData.createDate, 'USER')}
                                        <FaEdit
                                            onClick={() => console.log("Edit clicked", caseData.id)}
                                            style={{
                                                cursor: "pointer",
                                                transition: "color 0.2s ease",
                                            }}
                                            className="hover:text-blue-500 active:text-blue-700"
                                        />
                                    </div>
                                ) : (
                                    <>
                                        {formatDateAndTime(caseData.createDate, 'USER')}
                                    </>
                                )}
                            </td>


                            {caseData && !caseData.creteByExpert && (
                                <td style={{textAlign: "center"}}>
                                    {caseData ? formatDateAndTime(caseData.dedline, "USER") : 'იტვირთება...'}
                                </td>
                            )}

                            {caseData.objectRegistryID && caseData.moveCaseToAgencyRegisterByExpert && (
                                <td style={{textAlign: "center"}}>
                                    {caseData.objectRegistryID}

                                </td>
                            )}
                            {objectOwner && (
                                <td style={{textAlign: "center"}}>
                                    {objectOwner}
                                </td>
                            )}
                            <td style={{textAlign: "center"}}>
                                <span className="user-info-container">

                      {caseData.requesterName !== "   " ? caseData.requesterName : requester.orgName}

                                    {roleId && roleId !== "USER" && caseData && requesterId && (
                                        <FaInfoCircle
                                            className="user-info-icon"
                                            onClick={handleOpenUserDialog}
                                        />
                                    )}

                                </span>
                            </td>


                            <td style={{textAlign: 'center', cursor: 'help', width: "200px !important"}}>
                                <Tooltip
                                    title={
                                        <div>
                                            {caseData.regionsNames && (
                                                <div>&bull; <strong>რეგიონი:</strong> {caseData.regionsNames}</div>
                                            )}
                                            {caseData.citysNames && (
                                                <div>&bull; <strong>მუნიციპალიტეტი:</strong> {caseData.citysNames}</div>
                                            )}
                                            {caseData.councilsNames && (
                                                <div>&bull; <strong>საკრებულო:</strong> {caseData.councilsNames}</div>
                                            )}
                                            {caseData.populatedAreasNames && (
                                                <div>&bull; <strong>დასახლებული
                                                    პუნქტი:</strong> {caseData.populatedAreasNames}
                                                </div>
                                            )}
                                        </div>
                                    }
                                    arrow
                                >
                                    <div>
                                        {(() => {
                                            const concatenatedArray = [
                                                caseData.regionsNames,
                                                caseData.citysNames,
                                                caseData.councilsNames,
                                                caseData.populatedAreasNames,
                                            ].filter(Boolean); // Filter out empty or falsy values

                                            const concatenatedString = concatenatedArray.join(', ');

                                            return concatenatedString.length > 50
                                                ? `${concatenatedString.substring(0, 50)}...`
                                                : concatenatedString;
                                        })()}
                                    </div>
                                </Tooltip>
                            </td>
                            {caseData && caseData.address && (
                                <td style={{textAlign: "center"}}>{caseData.address}</td>
                            )}


                            {caseData && caseData.request && (
                                <td style={{textAlign: "center"}}>{caseData.request}</td>
                            )}


                            {roleId === "USER" ? (<td style={{textAlign: "center"}}>
                                    {findStatusTitleById(caseData.status, isObjectInRegistery)}
                                </td>) :

                                caseData && caseData.creteByExpert && caseData.moveCaseToAgencyRegisterByExpert ? (
                                        <td style={{textAlign: "center"}}>
                                            რეგისტრირებული ობიექტი
                                        </td>
                                    ) :
                                    caseData && caseData.creteByExpert ? (
                                        <td style={{textAlign: "center"}}>`
                                            არარეგისტრირებული განაცხადი
                                        </td>
                                    ) : (
                                        <td style={{textAlign: 'center'}}>
                                            <Tooltip
                                                title={
                                                    <React.Fragment>
                                                        <ul style={{padding: 10, margin: 0}}>
                                                            {caseHistory.map((item, index) => (
                                                                <li key={index}>
                                                                    {index + 1}. {findStatusTitleByIdForInternalUser(item.caseStatusId, isObjectInRegistery)} - {formatDateAndTime(item.statusChangeDate, "aaa")}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </React.Fragment>
                                                }
                                                arrow
                                            >
                                                <div style={{cursor: 'help'}}>
                                                    {roleId !== 'USER' ? findStatusTitleByIdForInternalUser(caseData.status, isObjectInRegistery) : findStatusTitleById(caseData.status, isObjectInRegistery)}
                                                </div>
                                            </Tooltip>
                                        </td>
                                    )}


                            {caseData && !caseData.creteByExpert && (
                                <td style={{textAlign: "center"}}>{caseData.acceleration ? "კი" : "არა"}</td>
                            )}



                            {caseData && caseData.declineReasonFromUser && (
                                <td style={{textAlign: 'center', cursor: 'help'}}>
                                    <Tooltip title={caseData.declineReasonFromUser} arrow>
                                        <div>
                                            {caseData.declineReasonFromUser.length > 30 ? `${caseData.declineReasonFromUser.substring(0, 30)}...` : caseData.declineReasonFromUser}
                                        </div>
                                    </Tooltip>
                                </td>
                            )}

                            {caseData.caseParentId && (
                                <td onClick={() => handleCaseNumberClick(caseData.caseParentId)} style={{
                                    textAlign: "center", cursor: 'pointer', fontFamily: 'FiraGO-SemiBold', color: 'blue'
                                }}>{caseData.caseParentId}</td>)}

                            {objectsOfRegistery.length !== 0 &&
                                caseData &&
                                checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId) && (
                                    <td style={{textAlign: "center"}}>
                                        {caseData.moveCaseToAgencyRegisterByExpert ? "კი" : "არა"}
                                    </td>
                                )}
                            {caseData && caseData.finishDate && (<td style={{textAlign: "center"}}>
                                {caseData ? formatDateAndTime(caseData.finishDate, "USER") : 'იტვირთება...'}
                            </td>)}
                            {caseData && caseData.finishedWithCondition && (<td style={{textAlign: "center"}}>
                                {caseData ? formatDateAndTime(caseData.conditionDeadline, "USER") : 'იტვირთება...'}
                            </td>)}
                            {caseData && caseData.termOfPermitDate && (<td style={{textAlign: "center"}}>
                                {caseData ? formatDateAndTime(caseData.termOfPermitDate, "USER") : 'იტვირთება...'}
                            </td>)}

                            {caseData && caseData.inspectionDocumentCheckingDate && (<td style={{textAlign: "center"}}>
                                {caseData ? formatDateAndTime(caseData.inspectionDocumentCheckingDate, "USER") : 'იტვირთება...'}
                            </td>)}
                            {caseData && caseData.inspectionDocumentmplementation && (<td style={{textAlign: "center"}}>
                                {caseData ? formatDateAndTime(caseData.inspectionDocumentmplementation, "USER") : 'იტვირთება...'}
                            </td>)}
                            {caseData && caseData.inspectionSertificatValidityPeriodDate && (
                                <td style={{textAlign: "center"}}>
                                    {caseData ? formatDateAndTime(caseData.inspectionSertificatValidityPeriodDate, "USER") : 'იტვირთება...'}
                                </td>)}

                            {
                                caseData &&
                                caseData.oldCaseNumber && (
                                    <td>{caseData.oldCaseNumber}</td>
                                )
                            }


                        </tr>) : (<tr>
                            <td colSpan="15"><LoaderCustomFixed/></td>
                        </tr>)}
                        </tbody>

                    </table>)}

                <div className={"box-switch-container"}>
                    <div className="switch-container">
                        <div className="switch-indicator"/>
                        {options.map((option, index) => {
                            const isRestrictedOption = option === "განაცხადის მენეჯერები" || option === "შიდა მიმოწერა" || option === "განაცხადის ისტორია";
                            const shouldHideOption = (option === "განაცხადის მენეჯერები" && caseData && caseData.creteByExpert);
                            const isChatOption = option === "შიდა მიმოწერა";

                            if ((roleId !== 'USER' || !isRestrictedOption) && !shouldHideOption) {
                                if (isChatOption && !checkIfUserIsInChat(userId)) {
                                    return null;
                                }

                                return (
                                    <div
                                        key={option}
                                        className={`switch-option ${selectedOption === option ? "selected" : ""}`}
                                        onClick={isChatOption ? handleOpenChat : () => handleOptionChange(option, index)}
                                    >
                                        {option}
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                    <Dialog open={openObjectRegistryIdDialog} onClose={() => setOpenObjectRegistryIdDialog(false)}>
                        <DialogContent>
                            <TextField
                                label="ახალი ნომერი"
                                value={newObjectRegistryId}
                                onChange={(e) => {
                                    const val = e.target.value;
                                    if (/^\d*$/.test(val)) setNewObjectRegistryId(val);
                                }}
                                fullWidth
                                inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
                            />

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenObjectRegistryIdDialog(false)}>გაუქმება</Button>
                            <Tooltip title={newObjectRegistryId === "" && "შეიყვანეთ ახალი ნომერი!"}>
                                <span style={{cursor: newObjectRegistryId === "" ? "not-allowed" : "pointer"}}>
                                    <Button disabled={newObjectRegistryId === ""} onClick={handleUpdateObjectRegistryId}
                                            variant="contained">შენახვა</Button>
                                </span>
                            </Tooltip>

                        </DialogActions>
                    </Dialog>


                    {caseData && !caseData.creteByExpert && roleId !== "USER" && !hasDeclinedAndSharedFile && caseData && !caseIsCompleted && caseData.status !== caseStatus.Declined.id && (
                        <ColorChangingBox
                            title={"დახარვეზებისთვის დარჩენილია"}
                            startNumber={10}
                            number={caseData.declinationDays}/>)}

                    {caseData && !caseData.creteByExpert && caseFiles && caseData && caseData.status === CaseStatus.Declined.id && (
                        <ColorChangingBox
                            title={"დახარვეზებული დოკუმენტბის ატვირთვისთვის დარჩენილია"}
                            hasNumber={false}
                            date={formatPureDate(caseData.userFixDeclinationDate)}
                        />
                    )}
                    {caseData && !caseData.creteByExpert && roleId !== "USER" && caseData && !areDatesEqualByDay(caseData.dedline, dateTime) && caseData.status !== caseStatus.Declined.id && (
                        <ColorChangingBox hasNumber={!caseIsCompleted} isFinished={caseIsCompleted}
                                          isFinishedTitle={findStatusTitleById(caseData.status, isObjectInRegistery)}
                                          startNumber={15} number={caseData.days}/>)}
                    {caseData && caseData.status === caseStatus.Declined.id && (
                        <DeclineBox/>
                    )}


                    {caseData && !caseData.creteByExpert && caseData && dateTime && areDatesEqualByDay(caseData.dedline, dateTime) && roleId !== "USER" && ((() => {
                        const {hours, minutes} = timeLeftUntilEndOfWorkingDay(dateTime);
                        return <ColorChangingBox isFinished={caseIsCompleted}
                                                 isFinishedTitle={findStatusTitleById(caseData.status, isObjectInRegistery)}
                                                 noDaysLeft={true}
                                                 minutes={minutes} hours={hours} hasNumber={false}/>;
                    })())}
                    {caseData && !caseData.creteByExpert && roleId === "USER" && caseData && caseData.status !== caseStatus.Declined.id && (
                        <ColorChangingBox dateText={"წარმოება სრულდება:"} date={formatPureDate(caseData.dedline)}
                                          hasNumber={false} isFinished={caseIsCompleted}
                                          isFinishedTitle={findStatusTitleByIdForInternalUser(caseData.status, isObjectInRegistery)}
                                          startNumber={2}
                                          number={2}/>)}

                </div>
                <div className={containerClass}>
                    {contentMap[selectedOption]}
                </div>
                {showUploadPopup && caseData && caseDataForDocument && users.length !== 0 &&
                    <UploadSingleFile onClose={toggleUploadPopup} onFileUpload={refreshCaseFiles}
                                      caseData={caseDataForDocument} users={users}/>}
                {showUploadInsideFilePopup && roleId && caseData && caseDataForDocument && users.length !== 0 &&
                    <UploadInsideFile onClose={toggleUploadInsideFilePopup} onFileUpload={refreshCaseFiles}
                                      caseData={caseDataForDocument} users={users} roleId={roleId}/>}
                {showUploadExplosionPopup && caseData && caseDataForDocument && users.length !== 0 &&
                    <UploadExplosionFile onClose={toggleExplosionUploadPopup} onFileUpload={refreshCaseFiles}
                                         caseData={caseDataForDocument} users={users}/>}
                {showUploadPopupInspection &&
                    inspectFileDepartmentId &&
                    users.length !== 0 &&
                    caseData &&
                    checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId) &&

                    <UploadInspectionFile onClose={toggleUploadPopupInspection} onFileUpload={uploadCertificate}
                                          users={users} caseData={caseData}
                                          inspectFileDepartmentId={inspectFileDepartmentId}/>}


                {showEditPopupInspection &&
                    inspectFileDepartmentId &&
                    users.length !== 0 &&
                    inspectFileData &&
                    caseData &&

                    <EditInspectFile onClose={toggleEditPopupInspection} onFileUpload={uploadCertificate}
                                     users={users} caseData={caseData} inspectFileData={inspectFileData}
                                     inspectFileDepartmentId={inspectFileDepartmentId}/>}
                {showUploadPopupAdmin &&
                    inspectFileDepartmentId &&
                    users.length !== 0 &&
                    caseData &&
                    checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId) &&

                    <AdministrationFilePopup onClose={toggleUploadPopupAdmin} onFileUpload={uploadCertificate}
                                             users={users} caseData={caseData}
                                             inspectFileDepartmentId={inspectFileDepartmentId}/>}
                {showUploadPopupCertificate &&
                    caseData &&
                    users.length !== 0 &&
                    checkIfObjectIsInRegistery(objectsOfRegistery, caseData.permitTypeId) &&

                    <UploadCertificateFile onClose={toggleUploadPopupCertificate} onFileUpload={uploadCertificate}
                                           caseData={caseData} users={users}/>}


                {showEditPopupCertificate &&
                    caseData &&
                    users.length !== 0 &&

                    <EditCertificateFile certificateFileData={certificateFileData} onClose={toggleEditPopupCertificate}
                                         onFileUpload={uploadCertificate}
                                         caseData={caseData} users={users}/>}

                {isSendAllConfirmationModalOpen && (<ConfirmationModal
                    isOpen={isSendAllConfirmationModalOpen}
                    onRequestClose={() => setIsSendAllConfirmationModalOpen(false)}
                    onConfirm={checkAndHandleDocumentSubmission}
                />)}
                <ConfirmationModal
                    isOpen={isCancelModalOpen}
                    onRequestClose={() => setIsCancelModalOpen(false)}
                    onConfirm={handleCancelCaseConfirm}
                    modalText={"დარწმუნებული ხართ, რომ გსურთ განაცხადის გაუქმება?"}
                />

                {showAlert && (<CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setShowAlert(false)}
                />)}

                {isUpdateModalOpen && (<ConfirmationModal
                    isOpen={isUpdateModalOpen}
                    onRequestClose={() => setIsUpdateModalOpen(false)}
                    onConfirm={handleUpdateCaseStatus}
                />)}
                {isApproveModalOn && (<ConfirmationModal
                    isOpen={isApproveModalOn}
                    onRequestClose={() => setIsApproveModalOn(false)}
                    onConfirm={approveDoc}
                />)}
                {caseUserDeleteModalOpen && (<ConfirmationModal
                    isOpen={caseUserDeleteModalOpen}
                    onRequestClose={() => setCaseUserDeleteModalOpen(false)}
                    onConfirm={handleDeleteCaseUser}
                />)}
                {isApproveModalOnInternal && (<ConfirmationModal
                    isOpen={isApproveModalOnInternal}
                    onRequestClose={() => setIsApproveModalOnInternal(false)}
                    onConfirm={approveDocInternal}
                />)}
                {isUpdateModalOpenForCondition && (<ConfirmationModal
                    isOpen={isUpdateModalOpenForCondition}
                    onRequestClose={() => setIsUpdateModalOpenForCondition(false)}
                    onConfirm={handleUpdateCaseStatusCondition}
                />)}

                {isConditionalDeadlineOpen && (<ConfirmationModal
                    isOpen={isConditionalDeadlineOpen}
                    onRequestClose={() => setIsConditionalDeadlineOpen(false)}
                    onConfirm={handleUpdateCaseStatus}
                />)}

                {isUpdateModalOpenPostPone && (<ConfirmationModal
                    isOpen={isUpdateModalOpenPostPone}
                    onRequestClose={() => setIsUpdateModalOpenPostPone(false)}
                    onConfirm={handleUpdatePostPone}

                />)}

                {caseDeleteModalOpen && (<ConfirmationModal
                    isOpen={caseDeleteModalOpen}
                    onRequestClose={() => setCaseDeleteModalOpen(false)}
                    onConfirm={handleDeleteCase}

                />)}
                {isUpdateModalOpenToApprove && (<ConfirmationModal
                    isOpen={isUpdateModalOpenToApprove}
                    onRequestClose={() => setIsUpdateModalOpenToApprove(false)}
                    onConfirm={handleUpdateCaseStatusApprove}
                />)}

                {isConfirmModalOpenForSendingToAnotherDep && (
                    <ConfirmationModal
                        isOpen={isConfirmModalOpenForSendingToAnotherDep}
                        onRequestClose={() => setIsConfirmModalOpenForSendingToAnotherDep(false)}
                        onConfirm={() => {
                            void sendCaseViewerRequest(currentFileForInternalVisage);
                            setIsConfirmModalOpenForSendingToAnotherDep(false);
                        }}
                    />
                )}

                <ConfirmationModal
                    isOpen={isDeleteConfirmModalOpen}
                    onRequestClose={() => setIsDeleteConfirmModalOpen(false)}
                    onConfirm={() => {
                        if (fileToDelete) {
                            void deleteDocument(fileToDelete.id);
                            setIsDeleteConfirmModalOpen(false);
                            setFileToDelete(null);
                        }
                    }}
                />

                <ConfirmationModal
                    isOpen={isConfirmationModalVisible}
                    onRequestClose={() => setIsConfirmationModalVisible(false)}
                    onConfirm={() => {
                        void UndeclineCaseFile(fileDataToProcess);
                        setIsConfirmationModalVisible(false);
                    }}
                />
                <ConfirmationModal
                    isOpen={isConfirmationModalVisibleExpert}
                    onRequestClose={() => setIsConfirmationModalVisibleExpert(false)}
                    onConfirm={() => {
                        void UndeclineCaseFileExpert(fileDataToProcessExpert);
                        setIsConfirmationModalVisibleExpert(false);
                    }}
                />
                <ConfirmationModal
                    isOpen={isEndDeclinationModalOpen}
                    onRequestClose={() => setIsEndDeclinationModalOpen(false)}
                    onConfirm={handleEndDeclinationConfirm}
                />
                <ConfirmationModal
                    isOpen={isModalOpenedToSendCaseToHeadInternalFlow}
                    onRequestClose={() => setIsModalOpenedToSendCaseToHeadInternalFlow(false)}
                    onConfirm={sendToVisageInternalFlow}
                />
                <ConfirmationModal
                    isOpen={isModalToAnswerAnotherDepartment}
                    onRequestClose={() => setIsModalToAnswerAnotherDepartment(false)}
                    onConfirm={sendToVisageInternalFlowBack}
                />
                <ConfirmationModal
                    isOpen={isAddDocumentModalOpen}
                    onRequestClose={() => setIsAddDocumentModalOpen(false)}
                    onConfirm={makeAdditionalDocumentsUploadeble}
                />
                <ConfirmationModal
                    isOpen={isCaseCancellationModalOpen}
                    onRequestClose={() => setIsCaseCancellationModalOpen(false)}
                    onConfirm={denyCancellation}
                />
                <ConfirmationModal
                    isOpen={isModalOpen}
                    onRequestClose={() => setIsModalOpen(false)}
                    onConfirm={() => handleConfirmAction(true)}
                />


                <ConfirmationModal
                    previewHtml={objectHtml}
                    dateTime={new Date().toLocaleDateString('en-GB')}
                    fullName={objectOwner}
                    isOpen={isUpdateCaseRegisterModalOpen}
                    onRequestClose={() => setIsUpdateCaseRegisterModalOpen(false)}
                    onConfirm={MoveCaseToRegisterByExpert}
                />

                <ConfirmationModal
                    isOpen={showRemoveFromObjectRegisteryPopup}
                    onRequestClose={() => setShowRemoveFromObjectRegisteryPopup(false)}
                    onConfirm={removeCaseFromRegistery}
                    modalText={"დარწმუნებული ხართ რომ გსურთ ობიექტის ამოღება უწყებრივი რეესტრიდან?"}
                />
                <ConfirmationModal
                    isOpen={isModalOpenDeny}
                    onRequestClose={() => setIsModalOpenDeny(false)}
                    onConfirm={() => handleConfirmAction(false)}
                />
            </div>
        </div>);

};
export default CaseInsideTable;
// ბოდიში
